import enLocale from '@one/one-vue/dist/locale/en.mjs'
import { no } from 'element-plus/es/locales.mjs'

export default {
  cmr_draft: {
    new: {
      origin_place: 'Place of origin',
      destination_place: 'Destination place',
      title: 'New transport document draft',
      btn_create: 'Create',
      cmrNumber: 'Transport document number',
      cmrNumber_required: 'The transport document number is required',
      sendDate: 'Send date',
      sendDate_future: 'The send date must be equal to or after the current date',
      vehiclePlate: 'Vehicle plate',
      trailerPlate: 'Trailer plate',
      nameTransportist: 'Carrier company',
      observations: 'Observations',
      save_ok: 'Draft created successfully',
      step_header: 'Header',
      step_lines: 'Lines',
      authorization_section: 'Authorization',
      authorizationNumber: 'Authorization number',
      senderAgency: 'Issuing authority',
      validityPeriod: 'Validity period',
      cargo_general_data: 'General cargo data',
      nature: 'Nature',
      weight: 'Weight',
      unitOfMeasure: 'Unit of measure',
      validityDateFrom: 'Validity period from',
      validityDateTo: 'Validity period to',
      validityDateTo_future: 'The "to" date must be after the current date',
      origin_place_seller_centres_exclusive: 'If you fill place of origin, you cannot add seller centres',
      destination_place_seller_centres_exclusive: 'If you fill destination place, you cannot add seller centres',
      destination_place_buyer_centres_exclusive: 'If you fill destination place, you cannot add buyer centres'
    },
    stops: {
      title: 'Stops',
      no_stops: 'No stops',
      add_stop: 'Add stop',
      add_stop_title: 'Add stop',
      delete_stop: 'Delete stop',
      ship_from: 'Origin',
      final_destination: 'Stop for final destination',
      stop_place: 'Destination',
      stop_place_destination: 'Destination/Stop',
      stops_required_without_origin_destination: 'If the origin place and the destination place are not provided, at least one stop is required.',
      final_destination_required: 'No final destination stop has been created. You must create the stop for that destination, and its value must exactly match the data entered in the Destination place field (commas, periods, other characters, etc.). Review the data and add the stop for the final destination.',
      lines_required_for_stops: 'If there are one or more stops:<br>- There must be one or more lines<br>- There cannot be lines without a stop reference<br>- There must be at least one line referring to each defined stop',
      creation_date: 'Creation date',
      confirm_delete_stop: 'Do you want to delete this stop?',
      stop_added: 'Stop added successfully',
      stop_deleted: 'Stop deleted successfully'
    },
    buttons: {
      delete_draft_tooltip: 'Delete draft',
      duplicate_tooltip: 'Copy draft'
    },
    messages: {
      duplicate_confirm: 'Do you want to copy this draft?',
      duplicate_ok: 'Draft copied successfully'
    }
  },
  cmr_lines: {
    table: {
      line_number: 'Line number',
      description: 'Description/Nature',
      article_code: 'Article code',
      article_code_seller: 'Seller code',
      quantity: 'Quantity',
      weight: 'Weight',
      unit_of_measure: 'Unit of measure'
    },
    form: {
      title: 'Transport document line',
      description: 'Description',
      article_code: 'Article code',
      article_code_seller: 'Seller code',
      quantity: 'Quantity',
      weight: 'Weight',
      unit_of_measure: 'Unit of measure'
    },
    buttons: {
      add_line: 'Add line',
      add_line_tooltip: 'Add a new line to the document',
      update_line: 'Update line',
      update_line_tooltip: 'Update the selected line',
      delete: 'Delete',
      delete_tooltip: 'Delete selected lines',
      submit_for_acceptance: 'Process for acceptance',
      delete_draft_tooltip: 'Delete the draft transport document'
    },
    confirm_delete_line: 'Are you sure you want to delete this line?',
    confirm_delete_lines: 'Are you sure you want to delete {count} lines?',
    line_added: 'Line added successfully',
    line_updated: 'Line updated successfully',
    line_deleted: 'Line deleted successfully',
    lines_deleted: 'Lines deleted successfully',
    no_lines_warning: 'You must add at least one line',
    confirm_pending_status: 'The draft will change to pending status for processing from the Transport Document screen',
    confirm_pending_status_transportist: 'The complete transport information is not included (mandatory transporter and license plate data). You can provide it later, but always before sending. Click Confirm to continue and you can fill in the missing data from the Transport Document screen or Cancel if you prefer to add the information from drafts.'
  },
  new_coacsu: {
    title: 'New commercial account summary',
    seller: 'Seller',
    buyer: 'Buyer',
    summary_number: 'Commercial account summary number',
    issue_date: 'Issue date',
    delivery_date: 'Delivery date',
    additional_data: 'Additional data',
    select_seller: 'Select seller',
    select_buyer: 'Select buyer',
    payment_method: 'Payment method',
    select_payment_method: 'Select payment method',
    payment_date: 'Due date',
    currency: 'Currency',
    registration_date: 'Registration date',
    code: 'Code',
    role: 'Role',
    steps: {
      header: 'Header',
      lines: 'Lines'
    },
    seller_code: 'Seller code',
    seller_role: 'Seller role',
    buyer_code: 'Buyer code',
    buyer_role: 'Buyer role',
    lines: {
      title: 'Lines',
      insert: 'Add',
      insert_tooltip: 'Add line',
      line_number: 'Line No.',
      document_number: 'Document No.',
      issue_date: 'Issue date',
      payment_date: 'Due date',
      total: 'Total',
      currency: 'Currency',
      status: 'Status',
      delete_tooltip: 'Delete line',
      back: 'Back',
      save: 'Save',
      save_tooltip: 'Save changes without sending to Editrack',
      generate: 'Create',
      generate_tooltip: 'Save and send COACSU to Editrack',
      generating: 'Sending to Editrack...',
      generate_ok: 'COACSU sent to Editrack successfully.',
      cancel: 'Cancel',
      dialog_title: 'Select invoices',
      loading_invoices: 'Loading invoices...',
      no_invoices: 'No invoices available with the current COACSU filters.',
      add: 'Add ({count})',
      delete_confirm: 'Do you want to delete this COACSU line?',
      delete_confirm_button: 'Confirm',
      lines_saved: 'Lines saved successfully.'
    },
    duplicate: {
      title: 'Invoice already included',
      message: 'Invoice {invoiceNumber} already belongs to an existing commercial account summary (ID: {coacsuId}). Do you want to create a new one anyway?',
      confirm: 'Create anyway',
      cancel: 'Cancel'
    },
    errors: {
      summary_number_required: 'The commercial account summary number is required',
      issue_date_required: 'The issue date is required',
      payment_date_required: 'The due date is required',
      payment_method_required: 'The payment method is required',
      save_error: 'Could not save the COACSU.',
      load_error: 'Could not load the COACSU detail.',
      update_error: 'Could not update the COACSU.',
      create_error: 'Could not create the COACSU.',
      load_invoices: 'Could not load the invoice list.',
      save_lines: 'Could not save the lines.',
      generate_error: 'Could not send the COACSU to Editrack.'
    }
  },
  ...enLocale,
  label: 'English',

  date_format: 'MM/DD/YYYY',
  date_format_long: 'MM/DD/YYYY HH:mm:ss',
  date_format_calendar: 'MM/DD/YYYY',
  date_format_month: 'MM/YYYY',
  date_format_long_calendar: '@:date_format_calendar - HH:mm',
  date_format_long_datepicker: '@:date_format_calendar - HH:mm:ss',
  buttons: {
    btnRecovery: 'Recovery password',
    btnEnter: 'Enter',
    btnNext: 'Next',
    btnSend: 'Send',
    btnFinish: 'Finish',
    btnDelete: 'Delete',
    btnDeleteAll: 'Delete all',
    btnDeleteSelected: 'Delete selection',
    btnAdd: 'Add',
    btnSave: 'Save',
    btnBack: 'Go back',
    btnSaveChanges: 'Save',
    btnCancelChanges: 'Reset',
    btnCancelChanges_tooltip: 'Cancel changes',
    btnSaveChanges_tooltip: 'Save changes',
    btnSendSaveChanges_tooltip: 'Save and send',
    btnCancel: 'Cancel',
    btnCancel_tooltip: 'Cancel changes',
    btnOk: 'Accept',
    btnConfirm: 'Confirm',
    btnContinue: 'Continue',
    btnSign: 'Sign',
    btnBiometricSign: 'Biometric Sign',
    btnClear: 'Clear',
    btnDownloadXSL: 'View XSL',
    btnViewMetadata: 'Download metadata',
    btnDownloadLabels: 'Download labels',
    btnDownload: 'Download',
    btnDownloadPdf: 'Download PDF',
    btnDownloadOrderRsp: 'Download order response',
    btnReSend: 'Resend',
    btnCreateInvoice: 'Create rectificative invoice',
    btnShow: 'Show',
    btnShow_tooltip: 'Show results',
    refresh_tooltip: 'Update results',
    inicialize_tooltip: 'Recalculate',
    btnChangestatus: 'Change status',
    btnCoacsu: 'Coacsu',
    btnCoacsu_error_different_parties: 'Cannot create COACSU: selected invoices must have the same buyer and the same seller',
    btnCoacsu_success: 'COACSU successfully created',
    btnClose: 'Close',
    error_rules_tooltip: 'Validation report',
    btnUpdate: 'Update'
  },
  dialog_error_rules: {
    title: 'Informe de Validación',
    code: 'Campo',
    description: 'Descripción',
    location: 'Ruta'
  }, 
  msg_generics: {
    no: 'No',
    yes: 'Yes',
    deleting: 'Deleting...',
    sending: 'Sending...',
    send_ok: 'Enviado correctamente',
    request_success: 'Request successfully executed',
    actual_version: 'Current version',
    error_not_found: 'The file / s could not be found',
    error_download_not_found: 'Error in the download. The file / s could not be found',
    error_download_pdf: 'The PDF download could not be made. Check with your administrator',
    no_match: 'No results',
    delveryNoteLines_selected: 'The selected lines are the lines that will be sent on the delivery note',
    field_required: 'Required field',
    element_selected: 'You must select an item',
    min_three_letters: 'Minimum 3 letters',
    number_required: 'It must be a number',
    min_num_character: 'Minimum {min} characters',
    max_num_character: 'Maximum {max} characters',
    max_value: 'Should be less than {max}',
    no_file_selected: 'File not selected',
    format_invalid: 'Format invalid',
    format_invalid_req_csv: 'Invalid format,must contain CSV extension',
    quantity_exceded: 'Exceeded maximum quantity of {max}',
    character_invalid: 'Character invalid ',
    max_decimals: 'Maximum {max} decimals',
    max_numeric: 'Maximum {max} digits',
    format_goods_code_invalid: 'Format must be XXXX XX XX (4 digts,space,2 digits,space and 2 digits).',
    filter_selected: 'Adding the selected filter to the search ...',
    filter_no_selected: 'You must select a filter for the search',
    filter_date_required: 'You cannot delete it. A range date is required',
    filter_date: 'Changing the search dates ...',
    filter_delete: 'Removing filter and loading data ...',
    filter_delete_all: 'Removing all search filters ...',
    filter_table_menu: 'What do you want to see in the table?',
    order_table: 'Sorting Table ...',
    size_table: 'Changing table size ...',
    pagination_table: 'Changing pagination of the table ...',
    table_select_rows: 'You have selected {num} elements',
    load_init: 'Loading initial data ...',
    loading: 'Loading...',
    success: 'Success',
    saving: 'Saving changes…',
    warning: 'Warning',
    no_date: 'No date',
    no_quantity: 'No quantity',
    no_price: 'No price',
    information: 'Information',
    invoiceDetails: 'Invoice details ',
    download_pdf: 'Download PDF...',
    download_csv: 'Download CSV...',
    load_download: 'Downloading document...',
    document_downloaded: 'Document downloaded',
    download_file_ok: 'The file download {filename} was correct',
    download_files_ok: 'The files have been downloaded correctly',
    download_metadata_ok: 'The metadata file have been downloaded correctly.',
    success_download: 'The file {file} has been downloaded successfully',
    error_download: 'Error downloading the file',
    error_invalid_link: 'The provided link is not valid',
    error_load_data: 'Error loading data',
    error_unauthorized: 'You do not have access to the requested information. The link has expired.',
    order_response_ok: 'Sending the order response was successful for order {order}.',
    update_party: 'Updating parties...',
    update_party_ok: 'Business update successful',
    delete_file_ok: 'The file has been deleted correctly',
    download_ok: 'Download ok',
    date_required: 'Select a date',
    date_range_required: 'Select a range date',
    date_diff_error: 'You cannot select a range greater than one year',
    date_last_connection: 'Last connection date:',
    download_invoice_original: 'Download....',
    processing: 'Processing....',
    download_invoice_formatted: 'Download guarded formatted....',
    download_metadata: 'Download metadata....',
    upload_invoice: 'Upload invoice ...',
    upload_attachment: 'Upload Attachment ...',
    upload_parties_massive: 'Processing companies ...',
    upload_centres_massive: 'Processing centres ...',
    upload_centre_approval_flow_massive: 'Processing centre approval flows ...',
    upload_attachment_ok: 'The rise was correct.',
    upload_issue: 'Upload issue...',
    upload_issue_ok: 'Issue created successfully.',
    issues_load_delete: 'Deleting issue...',
    redigitize: 'Sending invoice redigitalize request...',
    redigitize_ok: 'The redigitalization request was sent successfully.',
    invoice_access_denied: 'Invoice access not possible',
    load_document: 'Add',
    upload_attachment_interlocutor: 'Attachment not visible to your interlocutor.',
    add_all_projects: 'For all services',
    all_centres: 'Any society / centre',
    file_selected: 'Select a file',
    iban: 'The Iban field is required',
    ibanKo: 'The Iban introduced is not a correct',
    bic: 'The Bic field is mandatory',
    accountTitular: 'The Account Holder field is required',
    email: 'Email field is required',
    emailKo: 'The email entered is not correct',
    donwloadModelo: 'Download model data change request',
    popover_clean_filters: 'Remove all filters',
    no_pending_task_status: 'No configurated states were found for the selected service.',
    what_show: 'What do you want to view?',
    alter_configuration: 'Este cambio puede alterar las configuraciones del servicio.',
    placeholder: {
      datepicker: 'Select a date'
    },
    date_filter: 'Date',
    date: 'Date of resolution',
    datepicker: {
      start_placeholder: 'Since',
      separator: '',
      separator_empty: '',
      end_placeholder: 'Until',
      last_week: 'Last week',
      last_month: 'Last month',
      last_three_months: 'Last three months',
      last_year: 'Last year',
      today: 'Today',
      last_two_year: 'Last two year'
    },
    advanced_search: 'Advanced search',
    question: {
      yes: 'Yes',
      no: 'No'
    },
    validating_data: 'Validating data',
    all: 'All',
    onlyUserAdmin: 'Only a SuperAdmin user can select all services.',
    nameDuplicate: 'Duplicated Profile Name',
    taxDuplicate: 'Duplicated tax',
    tax_legal_text_used: 'There are invoice lines with the legal text removed from the tax',
    hostDuplicate: 'Duplicated host',
    detail: 'Detail',
    global: 'Global'
  },

  lateral_menu: {
    invoices: {
      title: 'Invoices',
      emitted: 'Sent',
      received: 'Received',
      third: 'Third',
      drafts: 'Draft invoices',
      accounting_closes: 'Accounting closes',
      draft_accounting_closes: 'Draft accounting closes',
      pending_tasks: 'Pending tasks'
    },
    receptions: {
      title: 'Receptions',
      emitted: 'Sent',
      received: 'Received'
    },
    carta: {
      title: 'Transport document',
      emitted: 'Transport document'
    },
    delivery: {
      title: 'Delivery notes',
      emitted: 'Sent',
      received: 'Received'
    },
    orders: {
      title: 'Orders',
      emitted: 'Sent',
      received: 'Received'
    },
    genrals: {
      title: 'Genrals',
      emitted: 'Sent',
      received: 'Received'
    },
    auditory: {
      title: 'Auditory',
      documents: 'Documents',
      actions: 'Actions'
    },
    administration: {
      title: 'Administration',
      projects: 'Services',
      parties: 'Parties,',
      users: 'Users',
      plannedProcesses: 'Planned processes',
      mailTemplates: 'Mail templates',
      profiles: 'Profiles',
      taxes: 'Taxes',
      mailServer: 'Email servers',
      communication_method: 'Communication method',
      articles: 'Articles'
    },
    sales_report: {
      title: 'Sales report',
      view: 'View report'
    },
    inventory_report: {
      title: 'Inventory report',
      view: 'View report'
    },
    remadv: {
      title: 'Remittance advice notice',
      view: 'View remittance advice notice'
    },
    coacsu: {
      title: 'Commercial account summary message',
      view: 'View commercial account summary message'
    }
  },

  breadcrumb: {
    empty: '',
    details: 'Detail',

    // PERFIL
    profile_init: 'Profile',
    profile_general_data: 'General data',
    profile_password: 'Password',
    profile_media_contact: 'Contact',
    profile_parties: 'Parties',
    profile_signature: 'Signature Delegation',

    // FACTURAS
    invoices_init: 'Invoices',
    invoices_emitted: '@:breadcrumb.invoices_init - Sent',
    invoices_received: '@:breadcrumb.invoices_init - Received',
    invoices_third: '@:breadcrumb.invoices_init - Third',
    invoices_drafts: '@:breadcrumb.invoices_init - Draft invoices',
    invoices_ocr: '@:breadcrumb.invoices_init - Awaiting validation',
    invoices_new_invoice: 'New invoice',
    invoices_accounting_closes: '@:breadcrumb.invoices_init - Accounting closes',
    reports_init: 'Reports',
    reports_emitted: '@:breadcrumb.reports_init - Sent',
    reports_received: '@:breadcrumb.reports_init - Received',
    invoices_draft_accounting_closes: '@:breadcrumb.invoices_init - Draft accounting closes',
    invoices_pending_tasks_title: '@:breadcrumb.invoices_init - Pending tasks',
    invoices_pending_tasks_cover: 'Create cover',
    invoices_new_draft_accounting_closes: 'New accounting close',
    cmr_draft_edit: 'New transport document',

    // RECEPCIONES
    receptions_init: 'Receptions',
    receptions_emitted: '@:breadcrumb.receptions_init - Sent',
    receptions_received: '@:breadcrumb.receptions_init - Received',
    receptions_new_invoice: 'New invoice',

    // ALBARANES
    delivery_notes_init: 'Delivery notes',
    delivery_notes_emitted: '@:breadcrumb.delivery_notes_init - Sent',
    delivery_notes_received: '@:breadcrumb.delivery_notes_init - Received',
    deliverynote_new_invoice: 'New invoice',

    // CMR
    cmr_init: 'Transport document',
    cmr_draft_init: 'Draft transport document',
    cmr_draft_new: 'New draft',

    // PEDIDOS
    orders_init: 'Orders',
    orders_emitted: '@:breadcrumb.orders_init - Sent',
    orders_received: '@:breadcrumb.orders_init - Received',
    orders_new_invoice: 'New invoice',
    orders_new_deliveryNote: 'New delivery note',

    // GENRALS
    genrals_init: 'Genrals',
    genrals_emitted: '@:breadcrumb.genrals_init - Sent',
    genrals_received: '@:breadcrumb.genrals_init - Received',

    // AUDITORIA
    auditory_init: 'Auditory',
    auditory_documents: '@:breadcrumb.auditory_init - Documents',
    auditory_actions: '@:breadcrumb.auditory_init - Actions',

    // ADMINISTRACION
    administration_init: 'Administration',
    administration_project_projects: '@:breadcrumb.administration_init - Services',
    administration_party_parties: '@:breadcrumb.administration_init - Parties',
    administration_project_add_project: 'Add service',
    administration_project_projectparties: 'Service parties',
    administration_project_add_party: 'Add party',
    administration_project_admin_channels: 'Commercial relation',
    administration_project_admin_channels_detail: 'Detail',
    administration_project_admin_centres: 'Centres',
    administration_project_admin_centresOfBuyer: 'Buyer centres',
    administration_project_admin_centresOfSeller: 'Seller centres',
    administration_project_admin_centresbuyer: 'Buyer centre',
    administration_project_admin_centresdelivery: 'Delivery centre',
    administration_project_admin_centresinvoicee: 'Invoicee centre',
    administration_users: '@:breadcrumb.administration_init - Users',
    administration_users_add_user: 'Add user',
    administration_project_add_centre: 'Add centre',
    administration_plannedProcesses: '@:breadcrumb.administration_init - Planned processes',
    administration_mailTemplates: '@:breadcrumb.administration_init - Mail templates',
    administration_profiles: '@:breadcrumb.administration_init - Profiles',
    administration_taxes: '@:breadcrumb.administration_init - Taxes',
    administration_mailServer: '@:breadcrumb.administration_init - Email servers',
    administration_user_information: '@:breadcrumb.administration_init - Information message',
    administration_mailServer_add_new: 'Create configuration',
    administration_new: 'New',
    administration_communication_method: '@:breadcrumb.administration_init - Communication method',
    administration_articles: '@:breadcrumb.administration_init - Articles',

    // ISSUES
    issues_init: 'Issues',
    issues_issues: '@:breadcrumb.issues_init',
    issues_add_issue: 'Create issue',

    // DOCUMENTACION
    documentation_init: 'Documentation',
    documentation_documents: '@:breadcrumb.documentation_init',

    // ESTADISTICAS
    statistic_init: 'Statistics',
    statistic_emitted: '@:breadcrumb.statistic_init - Volume of invoices issued',
    statistic_received: '@:breadcrumb.statistic_init - Volume of invoices received',
    statistic_other: '@:breadcrumb.statistic_init - Invoices generated from another document, order, receipt or delivery note',
    statistic_topseller: '@:breadcrumb.statistic_init - Top 20 suppliers by economic volume and number of invoices',
    statistic_parties: '@:breadcrumb.statistic_init - Volume of parties registered',
    statistic_rejected: '@:breadcrumb.statistic_init - Invoices: Types of rejections and reasons for redigitization',

    // SALESREPORT
    salesreport_init: 'Sales report',
    salesreport_view: '@:breadcrumb.salesreport_init - Sales report',

    // INVENTORY REPORT
    inventory_init: 'Inventory report',
    inventory_view: '@:breadcrumb.inventory_init - Inventory report',

    // REMADV
    remadv_init: 'Remittance advice message',
    remadv_view: '@:breadcrumb.remadv_init',

    // COACSU
    coacsu_init: 'Commercial account statement',
    coacsu_emitted: '@:breadcrumb.coacsu_init - Emitted',
    coacsu_received: '@:breadcrumb.coacsu_init - Received',
    coacsu_view: '@breadcrumb.coacsu_init',
    coacsu_detail: 'Commercial account summary message detail',
    new_coacsu: {
      title: 'New commercial account statement'
    }
  },

  nav_header: {
    profile: 'Profile',
    logout: 'Logout'
  },

  login: {
    welcome: 'Log In',
    twoFactorAuth: 'Two-factor authentication',
    cautext: 'USER SUPPORT (PHONE)',
    cautelephone: '91 191 00 00',
    canalcautext: 'Customer support: 900 365 365',
    titlevocento: 'Portal for sending and consulting invoices...',
    textvocento: 'Vocento provides its suppliers and clients with an online platform...',
    titlevocento2: 'TECHNICAL SUPPORT',
    horariovocento: 'Customer Service Hours',
    horario2vocento: 'Monday to Friday: 9:00 AM - 7:00 PM',
    horario3vocento: 'Spain time (UTC/GMT + 1 hour).',
    horario4vocento: 'Service is not provided on national holidays',
    avisolegal: 'Legal Notice',
    politica: 'Privacy Policy',
    cookies: 'Cookie Policy',
    userLabel: 'User',
    passLabel: 'Password',
    codeLabel: 'Enter the verification code received in your email',
    contratLabel: 'If you aren`t yet familiar with the benefits of this service,please',
    contratLabelRef: 'Consult us...',
    helpLabelRef: 'Do you need help?',
    labelRef1: 'Basic data protection information:',
    labelRef2: 'Redeia will process the data to manage the registration and use of your account. You can exercise your data protection rights by writing an email to the following email address digame@redeia.com and access all the information about the treatment in our Privacy Policy.',
    labelRef3: 'By pressing “Enter” you declare that you have read and understand the ',
    labelRef4: 'Privacy Policy and General Conditions.',
    rules: {
      username: 'Please,type an user name',
      password: 'Please,type a password',
      email: 'Please,type an email',
      code: {
        required: 'Please enter the 5 digit code',
        pattern: 'The code must be 5 alphanumeric digits'
      }
    },
    logging: 'Loading...',
    title_new_pass: 'Reset password',
    message_new_pass: 'Type your account\'s email to proceed',
    emailLabel: 'Email',
    sending: 'Sending...',
    questionLabel: 'Question',
    answerLabel: 'Answer',
    passRecovery: 'Recovery password',
    backLoginForm: 'Go back',
    error: {
      invalid_user: 'Invalid user or wrong password',
      user_not_found: 'User not found.',
      email_without_account: 'We can\'t find any account with this email',
      email_sended: 'We send you an email with the new password',
      bad_final_form: 'Reported data aren\'t correct. Try again!',
      invalid_code: 'The code has been used or has expired',
      reeProv_2: 'DNIe error',
      reeProv_3: 'Smartcard error',
      reeProv_1: 'The user don´t exists',
      reeProv_4: 'Certificate error',
      reeProv_5: 'User or password invalid',
      reeProv_locked: 'Locked user',
      reeProv_renew: 'Expired credentials',
      reeProv_exceptionTranslationFilter: 'ExceptionTranslationFilter',
      reeProv_expired: 'Expired session'
    },
    messageMail: 'If the data entered is correct, your email address will receive your new password.',
    reeClientes: 'Access e-Factura clients',
    reeCliText: 'If you are already a registered customer you can access the electronic billing service using your username and password',
    reeProveedores: 'Access e-Factura providers',
    reeProvText: 'If you are already a registered provider,you can access the electronic billing service using your username and password',
    logout_correct: 'Session finished correctly',
    infoBrowser: 'Optimized for Firefox v.67 / Chrome v.74 / Edge v.18'
  },

  // Perfil
  profile: {
    tabs: {
      general_data: 'General data',
      password: 'Password',
      contact_data: 'Contact data',
      parties: 'Parties',
      signature_delegation: 'Signature delegation'
    },

    general_data: {
      username: 'Username',
      profile_form: {
        name: {
          label: 'Name',
          placeholder: 'Name'
        },
        first_surname: {
          label: 'First surname',
          placeholder: 'Surname'
        },
        second_surname: {
          label: 'Second surname',
          placeholder: 'Surname'
        },
        identification_tax_number: {
          label: 'No identification tax',
          placeholder: 'No identification tax'
        },
        creation_date: {
          label: 'Creation date'
        },
        last_connection_date: {
          label: 'Last connection'
        },
        departament: {
          label: 'Departament'
        }
      },
      load: {
        updating: 'Updating profile ...'
      }
    },

    password: {
      change_password: 'Change password',
      change_first_password: 'You must update your password to continue',
      change_password_form: {
        old_password: {
          label: 'Current password',
          placeholder: 'Current password'
        },
        new_password: {
          label: 'New password',
          placeholder: 'New password'
        },
        confirm_password: {
          label: 'Confirmation of the new password',
          placeholder: 'New password'
        },
        secret_question: {
          label: 'Secret question',
          placeholder: 'Secret question'
        },
        current_secret_answer: {
          label: 'Current secret answer',
          placeholder: 'Current secret answer'
        },
        new_secret_answer: {
          label: 'New secret answer',
          placeholder: 'New secret answer'
        },
        confirm_secret_answer: {
          label: 'Confirmation of the new secret answer',
          placeholder: 'New secret answer'
        }
      },
      rules_form: {
        pattern: "Password must have a digit, an upper case letter, a lower case letter and a special character at least (!{'@'}#$%^&*_=+-/).",
        pass_eqaul_newpass: 'New password can\'t be equals to current password',
        fobidden_words: 'New password contains forbidden words',
        pass_equal_user: 'New password can\'t be equals to username',
        newpass_not_equals_confirmation: 'Passwords aren\'t equals',
        response_equal_newresponse: 'New secret answer can\'t be equals to current secret answer',
        newresponse_not_equals_confirmation: 'Secret answers aren\'t equals',
        validation_error: 'Validation errors. Check the form'
      }
    },
    error: {
      password: {
        required: {
          actual: 'Mandatory field: Current password',
          nueva: 'Mandatory field: New password',
          repetida: 'Mandatory field: Confirmation of the new password',
          pregunta_secreta: 'Mandatory field: Secret question',
          oldSecretAnswer: 'Mandatory field: Current secret answer',
          newSecretAnswer: 'Mandatory field: New secret answer',
          renewSecretAnswer: 'Mandatory field: Confirmation of the new secret answer'
        },
        wrongPassword: 'The current password entered is not correct.',
        format_ko: 'Incorrect password. The new password must be between 12 and 64 characters and must contain at least one number,a lowercase letter,a capital letter and an alternative symbol like %_.@',
        forbidden_word: 'Change the password. You can not use that value for the password.',
        sameAsToday: 'The new password entered is the same as the current one.',
        sameAsOne: 'The new password you entered has already been used before.',
        sameAsUsername: 'The new password entered is the same as the username.',
        wrongConfirmation: 'The confirmation of new password must be equal to the new password.',
        secretAnswer_wrongSecretAnswer: 'The current secret answer entered is not correct.',
        secretAnswer_wrongConfirmation: 'The secret answer confirmation does not match the one previously entered.',
        maxLength_nueva: 'Maximum length of the field "New password": 64 characters',
        minLength_nueva: 'Minimum length of the field "New password": 12 characters',
        maxLength_repetida: 'Maximum length of the field "Confirmation of the new password": 64 characters',
        minLength_repetida: 'Minimum length of the field "Confirmation of the new password": 12 characters',
        maxLength_secretQuestion: 'Maximum length of the field "Secret question": 255 characters',
        maxLength_oldAnswer: 'Maximum length of the field "Current secret response": 64 characters',
        maxLength_newSecretAnswer: 'Maximum length of the field "New secret answer": 64 characters',
        maxLength_renewSecretAnswer: 'Maximum length of the field "Confirmation of the new secret answer": 64 characters'
      },
      contact_data: {
        format_email: 'The format of the email is not correct.',
        format_phone: 'The format of the phone is not correct.',
        user_media_exist: 'The selected media already exists for the user.',
        user_media_not_found: 'The selected user media was not found',
        required_id: 'The userMediaId parameter is required',
        required_type: 'The type of the parameter is required',
        required_value: 'The value of the parameter is required'
      },
      general_data: {
        required: {
          name: 'Mandatory field: Name',
          first_surname: 'Mandatory field: First surname'
        },
        validation: {
          maxLength: {
            name: 'Maximum length of the field "Name": 50 characters',
            first_surname: 'Maximum length of the field "First surname": 50 characters',
            second_surname: 'Maximum length of the field "Second surname": 50 characters',
            id_number: 'Maximum length of the field "Tax identification number": 20 characters'
          }
        }
      },
      parties: {
        validation: {
          maxLength_TaxID: 'Maximum length of the field "ID identification tax": 50 characters',
          maxLength_tradeName: 'Maximum length of the field "Name": 150 characters',
          maxLength_gln: 'Maximum length of the field "GLN": 15 characters',
          date: "'Registration date'must be before the indicated"
        }
      },
      tamanominimo_name: 'Name: the minimum size is 3 characters.',
      tamanominimo_id: 'ID: the minimum size is 3 characters.',
      global: 'An error has occurred. Contact your administrator.'
    },
    contact: {
      contact_data_form: {
        type: {
          placeholder: 'Select a type...'
        }
      },
      rules_form: {
        phone_format: 'Not phone number format',
        email_format: 'Not email format',
        contact_media_exist: 'Contact media already exist for this user',
        no_contact_media_exist: 'The email type contact information is required'
      },
      load: {
        add_user_media: 'Adding contact data ...'
      }
    },

    signature: {
      presentation_title: 'INFORMATION',
      presentation_text: 'The electronic signature authorization granted to Indra Soluciones Tecnologías de la Información SL (ESB88018098) allows you to apply an electronic signature to invoices issued and generated by your company. This electronic signature guarantees the origin and ensures the integrity of the content for your clients, in accordance with Article 2 of the Order',
      presentation_text2: 'EHA / 962/2007,of April 10.',
      instructions_title: 'INSTRUCTIONS',
      instructions_text1: 'Once the fields in this manual entry have been completed, a PDF document will be generated that must be electronically signed with the certificate of the company issuing the invoices.',
      instructions_text2: 'Once signed you can upload this PDF document in this ',
      instructions_text2_link: 'link',
      instructions_text2_dir: 'https://servicedesk-onesait.atlassian.net/servicedesk/customer/portal/68',
      instructions_text2b: ' to activate the signature delegation without incurring any cost for the issuer.',
      instructions_text4: 'If electronic invoices are delivered to this service with an electronic signature in the required format,this delegation of signature is not required.',
      dialog_add_pdf: {
        title: 'Upload signed PDF document',
        select_file: 'Select document',
      },
      profile_signature_form: {
        valueNif: {
          placeholder: 'Enter 3 characters'
        },
        cargoFir: {
          placeholder: 'Choose signatory position'
        },
        valueFechaDD: {
          placeholder: 'Day - Format DD'
        },
        valueFechaMM: {
          placeholder: 'Month - Format MM'
        },
        valueFechaAAAA: {
          placeholder: 'Year - Format AAAA'
        },
        resolucion: {
          placeholder: 'Optional'
        }
      },
      cFirman: {
        adm: 'Administrator',
        apo: 'Attorney',
        con: 'CEO',
        dir: 'Director',
        ger: 'Manager',
        rep: 'Legal representative',
        tit: 'Holder (autonomous)'
      },
      taxIdentificationNumber: {
        label: 'COMPANY VAT NUMBER',
        placeholder: 'taxIdentificationNumber'
      },
      corporateName: {
        label: 'COMPANY NAME',
        placeholder: 'corporateName'
      },
      cargoFirmante: {
        label: 'POSITION OF THE PERSON SIGNING',
        placeholder: 'cargoFirmante'
      },
      name: {
        label: 'NAME OF SIGNATORY',
        placeholder: 'Nombre'
      },
      first_surname: {
        label: 'FIRST SURNAME',
        placeholder: 'Apellido'
      },
      second_surname: {
        label: 'SECOND SURNAME',
        placeholder: 'Apellido'
      },
      dni: {
        label: 'SIGNER\'S ID',
        placeholder: 'ID Number of the signer'
      },
      resolucion: {
        label: 'RESOLUTION',
        placeholder: 'resolucion'
      },
      fecha: {
        label: 'DATE',
        placeholder: 'fecha'
      },
      poblacionFirma: {
        label: 'TOWN WHERE THE SIGNATURE WILL BE MADE',
        placeholder: 'poblacionFirma'
      },
      address: {
        label: 'STREET / AVENUE OF THE COMPANY',
        placeholder: 'address'
      },
      town: {
        label: 'COMPANY TOWN',
        placeholder: 'town'
      },
      postcode: {
        label: 'COMPANY POSTCODE',
        placeholder: 'postcode'
      },
      province: {
        label: 'COMPANY CITY',
        placeholder: 'city'
      },
      countryName: {
        label: 'COMPANY COUNTRY',
        placeholder: 'countryName'
      },
      countryNameUser: {
        label: 'SIGNER COUNTRY',
        placeholder: 'countryName'
      },
      dniError: 'Incorrect data,please check the signer\'s ID'
    },

    parties: {
      filters: {
        country: {
          value: 'Country',
          placeholder: 'Country'
        },
        enabled: {
          value: 'Enabled/Disabled',
          placeholder: 'Select...',
          enabled: 'Enabled',
          disabled: 'Disabled'
        },
        person: {
          value: 'Person type',
          placeholder: 'Type',
          physical: 'Physical',
          legal: 'Legal'
        },
        project: {
          value: 'Service',
          placeholder: 'Service'
        },
        name: {
          value: 'Name',
          placeholder: 'Name'
        },
        tax_identification_number: {
          value: 'ID identification tax',
          placeholder: 'ID identification'
        }
      },
      entity_table: {
        name: 'Name',
        tax_identification_number: 'ID ident. tax',
        gln: 'GLN',
        enabled: 'Active',
        country: 'Country',
        province: 'Province',
        creation_date: 'Creation d.',
        business_register: 'Business Reg.',
        project: 'Service'
      }
    },

    notify: {
      changes_ok: 'Changes saved successfully'
    }
  },
  // Incidencias
  issues: {
    filters: {
      creation_date: {
        value: 'Registration date-hour',
        placeholder: ''
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Enter 3 characters'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Enter 3 characters'
      },
      issue_date: {
        value: 'Issue date range',
        placeholder: 'Issue date'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      issue_type: {
        value: 'Issue type',
        placeholder: 'Type'
      },
      subject: {
        value: 'Subject',
        placeholder: 'Subject'
      },
      priority: {
        value: 'Priority',
        placeholder: 'Priority'
      },
      description: {
        value: 'Description',
        placeholder: 'Description'
      }
    },
    historic: {
      title: 'State history',
      no_data: 'There are no states',
      creationDateTime: 'Date',
      status: 'Status',
      comment: 'Comment',
      user: 'User',
      addStatus_tooltip: 'Load new status',
      addStatus: 'Upload'
    },
    confirm: {
      title_delete: 'Are you sure you want to delete this issue?',
      confirm_button_delete: 'Delete',
      title_add_status: 'Create new status',
      confirm_button_add_status: 'OK'
    },
    notify: {
      delete_ok: 'The issue has been deleted successfully.',
      add_status_ok: 'The state was created successfully.'
    },
    load: {
      delete: 'Deleting incident ...',
      add_status: 'Creating state ...'
    },
    dialog_add_issue: {
      title: 'Create incident',
      form_add: {
        type: 'Type',
        priority: 'Priority',
        project: 'Service',
        buyer: 'Buyer',
        seller: 'Seller',
        subject: 'Subject',
        description: 'Description'
      },
      notify: {
        error_issue_unique: 'There is already an issue with that data'
      },
      button_add: 'Upload',
      button_add_tooltip: 'Upload issue'
    },
    dialog_add_status: {
      status: 'Status',
      comment: 'Comment',
      load_status: 'Create state'
    }
  },
  // Facturas emitidas y recibidas
  invoices: {
    filters: {
      creation_date: {
        value: 'Registration date-hour',
        placeholder: ''
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Enter 3 characters'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Enter 3 characters'
      },
      third: {
        value: 'Third',
        placeholder: 'Enter 3 characters'
      },
      issue_date: {
        value: 'Issue date range',
        placeholder: 'Issue date'
      },
      operation_date: {
        value: 'Operation date range',
        placeholder: 'Operation date'
      },
      modification_date: {
        value: 'Last status date range',
        placeholder: 'Status date'
      },
      invoice_number: {
        value: 'Invoice number',
        placeholder: 'Invoice number'
      },
      client_invoice_number: {
        value: 'Nº/Client invoice data',
        placeholder: 'Nº/Client invoice data'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      document_class: {
        value: 'Invoice class',
        placeholder: 'Invoice class'
      },
      communication_method: {
        send: {
          value: 'Send method',
          placeholder: 'Method'
        },
        reception: {
          value: 'Rec. method',
          placeholder: 'Method'
        }
      },
      tax_type: {
        value: 'Tax type',
        placeholder: 'Tax'
      },
      currency: {
        value: 'Currency',
        placeholder: 'Currency'
      },
      order_number: {
        value: 'Order number',
        placeholder: 'Order'
      },
      contract_number: {
        value: 'Contract number',
        placeholder: 'Contract'
      },
      delivery_note: {
        value: 'Delivery note',
        placeholder: 'Note'
      },
      file_number: {
        value: 'Case file',
        placeholder: 'File'
      },
      invoice_series_code: {
        value: 'Series code',
        placeholder: 'Code'
      },
      corrective_invoice_number: {
        value: 'Correct. invoice number',
        placeholder: 'Invoice number'
      },
      channel: {
        value: 'Channel',
        placeholder: 'Channel'
      },
      register_number: {
        value: 'Register number',
        placeholder: 'Register number'
      },
      id_invoice: {
        value: 'Intern Id',
        placeholder: 'Intern Id'
      },
      no_error_status: {
        value: 'Excluded status',
        placeholder: 'Excluded status',
        rejected: 'Rejected status',
        final: 'Final status'
      },
      invoice_type: {
        value: 'Invoice subtype',
        placeholder: 'Subtype'
      },
      invoice_type_document: {
        value: 'Invoice type',
        placeholder: 'Type'
      },
      total_executable_amount_from: {
        value: 'Amount from',
        placeholder: 'Amount'
      },
      total_executable_amount_to: {
        value: 'Amount to',
        placeholder: 'Amount'
      },
      attachments: {
        value: 'Attachments',
        placeholder: 'Select...'
      },
      sent: {
        value: 'Sent',
        placeholder: 'Select...'
      },
      rate: {
        value: 'Rate',
        placeholder: 'Rate'
      },
      cancellationRequest: {
        value: 'Cancellation Authority',
        placeholder: 'Select...'
      }
    },
    dialog_add_invoice: {
      title: 'Load invoice',
      project: {
        label: 'Service',
        placeholder: 'Select a service'
      },
      format: {
        label: 'Format',
        placeholder: 'Select a format'
      },
      communication_method: {
        label: 'Communication method',
        placeholder: 'Select method'
      },
      attachments: {
        label: 'Select attachment',
        error_attachment_extension: 'Unsupported file format',
        error_attachment_extension_values: 'The format must be: ',
        error_attachment_size: 'Size not allowed. The maximum size is {argumento}',
        error_attachment_empty: 'The attachment is empty, it has size 0',
        error_attachment_duplicated: 'An attachment with the same name already exists'
      },
      button_select_invoice: 'Select invoice',
      button_upload: 'Upload'
    },
    attachment: {
      error_attachment_not_found: 'The attachment does not exist.'
    },
    invoices_entity_table: {
      buyer: 'Buyer',
      seller: 'Seller',
      thirdParty: 'Third',
      invoice_class: 'Invoice class',
      invoice_number: 'Inv. number',
      issue_date: 'Issue date',
      creation_date: 'Creation date',
      amount: 'Amount',
      status: 'Status',
      reception_method: 'Input method',
      communication_method: 'Send method',
      currency: 'Currency',
      register_number: 'Regist. number',
      series_code: 'Serial number',
      buyer_generic_centre: 'Buyer centre',
      buyer_delivery_centre: 'Delivery point',
      buyer_invoicee_centre: 'Invoicee centre',
      buyer_centre: 'Buyer centre',
      seller_centre: 'Seller centre',
      cancellation: 'Cancellation',
      project: 'Service',
      channel: 'Channel',
      id_invoice: 'Internal id',
      accountingDate: 'Accounting date',
      paymentDate: 'Payment date',
      paymentMethod: 'Payment method',
      clientInvoiceNumber: 'Nº/Customer invoice data',
      csv_title: 'Export to CSV. Information',
      csv_message: 'Cannot export more than 180,000 records,please narrow your search'
      // csv_message: 'When exporting large volumes of records,the time and / or size limits may be exceeded and the file cannot be generated. In this case,try again with fewer results'

    },
    tooltip: {
      attachments: 'Attachments',
      events: 'Events',
      detail: 'Detail',
      downloadPDF: 'Download PDF',
      addBuyerCenter: 'Add buyer center',
      original: 'Download guarded',
      viewCSV: 'View XSL',
      sent: 'Sent',
      withTaxes: 'With taxes',
      withoutTaxes: 'Without output taxes',
      adminApprovalFlow: 'Approval flow'
    },
    buttons: {
      upload_invoice: 'Load',
      upload_invoice_tooltip: 'Load invoice',
      upload_profile_tooltip: 'Create profile',
      download_invoices: 'PDF',
      download_invoices_tooltip: 'Download invoice PDF',
      download_invoice_signed: 'Download guarded',
      download_invoice_signed_tooltip: 'Download guarded',
      download_csv_tooltip: 'Download CSV',
      download_csv_details_tooltip: 'Download CSV detail',
      download_csv_details: 'CSV detail',
      refresh_tooltip: 'Update',
      refresh_invoice: 'Update invoices'
    },
    loading: {
      download_invoices: 'Downloading invoice/s in PDF ...',
      download_invoices_original: 'Downloading guarded ...',
      upload_wait: 'Updating ...'
    },
    error: {
      validation: {
        upload_file_formatoinvalido: 'The format of the document is not valid. The format allowed is EDI,XML or XSIG.',
        parametro_obligatorio_invoice: 'The invoice file is mandatory.',
        parametro_obligatorio_projectId: 'The service ID is mandatory.',
        valor_no_en_lista: 'Wrong format; possible values: {argumento}',
        parametro_obligatorio_format: 'The format is mandatory.',
        proyecto_noexiste_noasociado: 'The service with ID {argumento} does not exist or is not associated with the user.'
      },
      auditoryEventsSearch_event_code_invalidFormat: 'The invoice does not comply with the selected format.',
      notSupported: 'Version 1.0 of the extension is not supported'
    }
  },
  invoice_related_documents_table: {
    date: 'Relation date',
    destinationDocument: 'Document Nº',
    destinationDocumentType: 'Document type'
  },
  invoice_detail: {
    related_documents_no_data: 'This invoice note does not have related documents',
    source_related_documents: 'Related documents',
    info_message: 'Some fields are editable. Remind to push "Save" button to store modifications',
    info_message_download: 'Remember that it is necessary to download the model to send and / or save the changes',
    buttons: {
      download_invoice: 'PDF',
      download_labels: 'Labels',
      download_original_signed: 'Guarded',
      download_invoice_tooltip: 'Download PDF',
      download_original_signed_tooltip: 'Download guarded',
      download_original_formatted: 'Formatted',
      download_original_formatted_tooltip: 'Download guarded formatted',
      download_metadata: 'Metadata',
      resend_invoice: 'Resend',
      add_attachment: 'Add',
      cancel_invoice: 'Cancel invoice',
      visualize_with_xsl: 'XSL',
      redigitize_invoice: 'Redigitize',
      download_metadata_tooltip: 'Download metadata',
      generate_metadata_tooltip: 'Generate metadata',
      download_PDF: 'GENERATE PDF WITH THE DATA INTRODUCED',
      resend_invoice_tooltip: 'Resend invoice',
      add_attachment_tooltip: 'Add attachment',
      cancel_invoice_tooltip: 'Cancel invoice',
      visualize_with_xsl_tooltip: 'View XSL',
      visualize_with_xml: 'File',
      visualize_with_xml_tooltip: 'Electronic invoice',
      redigitize_invoice_tooltip: 'Send invoice redigitize request',
      check_status: 'Status',
      check_status_tooltip: 'Check status',
      check_payment_emit: 'Collection',
      check_payment_emit_tooltip: 'Collection details',
      check_payment: 'Payment',
      check_payment_tooltip: 'Payment details',
      accept_order: 'Accept',
      accept_order_tooltip: 'Accept order'
    },
    dialog_add_buyer_center: {
      title: 'Add buyer center',
      centres: {
        label: 'Center',
        placeholder: 'Select a buyer center',
        required: 'Buyer centre required'
      }
    },
    dialog_resend_invoice: {
      title: 'Resend invoice',
      communication_method: {
        label: 'Communication method',
        placeholder: 'Select a sent method'
      },
      get_emails: 'Getting emails...',
      new_emails: 'Emails to send to (separate by ;)',
      max_emails: 'Maximum 5 emails',
      no_emails: 'Enter at least one email',
      email_format: 'Incorrect format of the entered emails (use ; as separator, the last email must not end in ; )',
      multiple_emails: 'If no email is entered, it will be forwarded to the associated default emails. If emails are entered, they will be sent to the newly entered emails.'
    },
    dialog_redigitize: {
      title: 'Invoice redigitalize request',
      checkboxes: {
        label: 'Reason for the error',
        field_bad_captured: 'Field miscaptured',
        field_no_captured: 'Field not captured',
        field_incorrect: 'Field captured incorrect (has another position in the PDF)',
        field_others: 'Others'
      },
      commentary: 'Comment for scanning'
    },
    dialog_cancel_invoice: {
      title: 'Request for invoice cancellation',
      motive: 'Reason for the request for cancellation'
    },
    dialog_status_data: {
      title: 'Status data',
      status: 'Status',
      motive: 'Motive',
      description: 'Description',
      date: 'Date',
      registrationCode: 'Registration code'
    },
    error_code: {
      ERROR_PARTY: 'Mandatory company data is missing or does not meet the expected validation.',
      ERROR_LINE_DESCRIPTION: 'The mandatory description is missing in some line.',
      ERROR_DIR_CODE: 'The DIR3 code of the recipient organization is missing.',
      ERROR_PARTY_ENABLE: 'The company is disabled.',
      ERROR_SELLER_ADDRESS: 'The seller\'s address is not consistent with its country.',
      ERROR_BUYER_ADDRESS: 'The buyer\'s address is not consistent with its country.',
      ERROR_PROJECT_PARTY_ENABLE: 'The company-project relationship is disabled.',
      ERROR_COMMERCIAL_RELATION: 'There is no valid commercial relationship between both companies.',
      ERROR_SPONSOR: 'None of the companies has a valid sponsor configuration.',
      ERROR_CENTRE: 'The required centre is missing or the one provided is not valid.',
      ERROR_UNIQUE_CENTRE: 'The provided centres are not unique.',
      ERROR_DUPLICATE_INVOICE: 'A duplicate invoice already exists.',
      ERROR_DUPLICATE_RECADV: 'A duplicate receipt already exists.',
      ERROR_DUPLICATE_ORDER: 'A duplicate order already exists.',
      ERROR_DUPLICATE_ORDER_RSP: 'A duplicate order response already exists.',
      ERROR_DUPLICATE_DELIVERY: 'A duplicate delivery note already exists.',
      ERROR_DUPLICATE_CMR: 'A duplicate transport document already exists.',
      ERROR_DELIVERY_LINE_BATCH: 'The batch is missing in some delivery note line.',
      ERROR_DELIVERY_LINE_SERIAL_NUMBER: 'The serial number is missing in some delivery note line.',
      ERROR_DELIVERY_LINE_EXPIRATION_DATE: 'The expiration date is missing in some delivery note line.',
      ERROR_SEND_DATE: 'The send date cannot be earlier than today.',
      ERROR_DELIVERY_LINE_DATES: 'The expiration date is not consistent with the delivery date.',
      ERROR_DELIVERY_LINE_QUANTITY: 'The quantity of the sublines does not match the parent line.',
      ERROR_DELIVERY_LINE_SUBLINE_REQUIRED: 'Each line must have at least one subline.',
      ERROR_DELIVERY_LINE_PACKAGE_GTIN14: 'The lines of the same package must share the same GTIN14.',
      ERROR_DOCUMENT_SIGN: 'The document must come signed or with a valid delegated signature.',
      ERROR_ORDER: 'The mandatory order is missing.',
      ERROR_UNIQUE_ORDER: 'The order must be unique.',
      ERROR_ORDER_FORMAT: 'The order format is not valid.',
      ERROR_ISSUER_ORDER: 'The issuer\'s order is missing.',
      ERROR_ISSUER_UNIQUE_ORDER: 'The issuer\'s order must be unique.',
      ERROR_ISSUER_ORDER_FORMAT: 'The issuer\'s order format is not valid.',
      ERROR_INVOICE_NUMBER_FORMAT: 'The invoice number does not have a valid format.',
      ERROR_EXP: 'The mandatory file is missing.',
      ERROR_UNIQUE_EXP: 'The file must be unique.',
      ERROR_EXP_FORMAT: 'The file format is not valid.',
      ERROR_CONTRACT: 'The mandatory contract is missing.',
      ERROR_UNIQUE_CONTRACT: 'The contract must be unique.',
      ERROR_CONTRACT_FORMAT: 'The contract format is not valid.',
      ERROR_INVOICE_DATE: 'The invoice date is not valid.',
      ERROR_OPERATION_DATE: 'The operation date does not meet the validation.',
      ERROR_INVOICING_PERIOD: 'The invoicing period is not consistent.',
      ERROR_CORRECTIVE_INVOICE: 'The corrective invoice does not meet the basic conditions.',
      ERROR_CORRECTIVE_INVOICE_MANDATORY: 'The mandatory corrective block is missing.',
      ERROR_ISSUER_TYPE: 'The issuer type is not valid for the document.',
      ERROR_MODALITY_TYPE: 'The invoice modality is not valid.',
      ERROR_PROJECT: 'The project is missing or the one provided is not valid.',
      ERROR_INVOICE_PROJECT: 'The invoice project is not valid.',
      ERROR_INTRASTAT_REQUIRED: 'The mandatory Intrastat data is missing.',
      ERROR_INVOICE_COMMUNICATION_METHOD: 'The invoice communication method is not valid.',
      ERROR_SPANISH_TAX_IDENTIFICATION_NUMBER: 'The Spanish NIF or CIF is not valid.',
      ERROR_ISSUE_DATE_FUTURE: 'The issue date cannot be later than the registration or creation date.',
      ERROR_ISSUE_DATE_PAST: 'The issue date cannot be earlier than the registration or creation date.',
      ERROR_SIGN: 'The document must be signed.',
      ERROR_PROJECT_ATTACHMENT_DIRECTORY: 'The project attachment directory does not exist for the indicated date.',
      ERROR_NUMBER_EXP_FIRST_LINE: 'The file number can only be provided in the first line or in the header.',
      ERROR_NUMBER_CONTRACT_FIRST_LINE: 'The contract number can only be provided in the first line or in the header.',
      ERROR_NUMBER_TRANSACTION_FIRST_LINE: 'The transaction number can only be provided in the first line or in the header.',
      ERROR_CHANNEL: 'The channel or channel document is not valid.',
      ERROR_TOTAL_LINES_WITHOUT_TAXES: 'The total of lines without taxes does not match.',
      ERROR_TOTAL_LINES_DISCOUNTS_AND_CHARGES: 'The total of lines with discounts and charges does not match.',
      ERROR_TOTAL_INVOICE: 'The total of the invoice does not match.',
      ERROR_TOTAL_INVOICE_WITH_DISCOUNTS_AND_CHARGES: 'The total of the invoice with discounts and charges does not match.',
      ERROR_TOTAL_INVOICE_WITH_DISCOUNTS_CHARGES_AND_TAXES: 'The total of the invoice with discounts, charges, and taxes does not match.',
      ERROR_TOTAL_EXECUTABLE_INVOICE: 'The total executable amount of the invoice does not match.',
      ERROR_TOTAL_INVOICE_TAXES: 'The total taxes of the invoice do not match.',
      ERROR_CENTRE_ROLE_TYPE: 'The reported centre role is not valid.',
      ERROR_CENTRE_ROLE_TYPE_BY_VALUES: 'The centre does not meet the allowed values for the reported role.',
      ERROR_DRAFT_CENTRE_ROLE_TYPE_BY_VALUES: 'The draft centre does not meet the allowed values for the reported role.',
      ERROR_CENTRE_ROLE_TYPE_MANDATORY: 'The centre with the mandatory role is missing.',
      ERROR_LINE: 'The document must include at least one line.',
      ERROR_LINE_CODE: 'The item or line code is missing.',
      ERROR_LINE_ORDER_EXIST: 'Some line does not have an associated order.',
      ERROR_PERIOD_DATE_INVOICE: 'The invoice period dates are not consistent.',
      ERROR_SIGNATURE: 'The document signature is not valid or does not exist.',
      ERROR_LINE_TRANSACTION_REFERENCE: 'The order number or transaction reference is missing in some line.',
      ERROR_RECEIVER_TRANSACTION_REFERENCE: 'The receiver order reference is missing in the header or lines.',
      ERROR_CENTRE_VOCENTO_WS: 'The centre validation against the Vocento service failed.',
      ERROR_CURRENCY_EXCHANGE: 'The currency exchange is not valid or is missing.',
      ERROR_IBAN: 'The IBAN is not valid.',
      ERROR_VALID_IBAN: 'The IBAN does not pass the formal validation.',
      ERROR_LINE_SEQUENCE_NUMBER: 'The line sequence number is not valid.',
      ERROR_PAYMENT_MEAN: 'The payment method is not allowed.',
      ERROR_FILE_SIZE: 'The total file size exceeds the maximum allowed.',
      ERROR_REGISTRATION_DATA: 'The registration data is not valid or is incomplete.',
      ERROR_REGISTRATION_DATA_INDRAFE: 'The Indrafe registration data is not valid or is incomplete.',
      ERROR_SEQUENCE_NUMBER: 'The sequence number is not valid.',
      ERROR_INVOICE_BUYER_CENTRE: 'The buyer centre is not valid.',
      ERROR_INVOICE_CENTRE_MASK: 'The invoice centre mask is not valid.',
      ERROR_INVOICE_CENTRE_ROL: 'The invoice centre role is not valid.',
      ERROR_EIFFAGE_VALIDATION_INVOICE_SERVICE: 'The call to the external Eiffage validation service failed.',
      ERROR_INVOICE_BUYER_DIRE: 'The buyer DIR3 code is missing or invalid.',
      ERROR_CORRECTIVE_SIGN: 'The corrective invoice signature is not valid.',
      ERROR_PARTY_NAME: 'The company name is not valid or does not meet the format.',
      ERROR_LINE_DOCUMENT_CANAL: 'The line channel document is not valid.',
      ERROR_INVOICE_CORRECTIVE_METHOD: 'The corrective invoice method is not valid.',
      ERROR_NIF_CODPAIS: 'The NIF must include the country prefix.',
      ERROR_WITHHOLDING_AMOUNT_WITH_TAXABLE_BASE: 'The withholding amount does not match the taxable base.',
      ERROR_NON_SIMULTANEOUS_TRANSACTION_AND_CONTRACT: 'Order and contract cannot be reported simultaneously.',
      ERROR_CONTRACT_AND_TRANSACTION_IN_RECADV: 'The order and the contract do not match the recorded receipt.',
      ERROR_EUR_CURRENCY: 'The currency must be euros.',
      ERROR_CENTRE_PERMANENT_ESTABLISHMENT: 'The permanent centre does not comply with the territorial configuration.',
      ERROR_IGIC_FROM_CANARY_ISLANDS: 'The IGIC for the Canary Islands is missing or not applicable.',
      ERROR_IPSI_FROM_CEUTA: 'The IPSI for Ceuta is missing or not applicable.',
      ERROR_NUMBER_OF_ATTACHED_FILES: 'The number of attached files is not valid.',
      ERROR_ATTACHED_FILES_EXTENSION: 'The extension of the attached files is not allowed.',
      ERROR_TAXES_IN_PROJECT: 'The reported taxes are not allowed for the project.',
      ERROR_FILE_FORMAT: 'The file format is not valid.',
      ERROR_TAX_CERO_LEGAL_TEXT: 'An operation with a 0 rate must include legal text.',
      ERROR_CORRECTIVE_INVOICE_ORDER_OR_CONTRACT: 'The corrective invoice must report an order or contract.',
      ERROR_CORRECTIVE_REQUIRED: 'The mandatory corrective block is missing in the corrective invoice.',
      ERROR_PARTY_BUYER_ADDRESS_VALUE: 'The value of the buyer\'s address is not valid.',
      ERROR_SPECIFIC_CANARY: 'The invoice does not comply with the specific validations for the Canary Islands.',
      ERROR_SPECIFIC_CEUTA: 'The invoice does not comply with the specific validations for Ceuta.',
      ERROR_PHYSICAL_GLN_REQUIRED: 'The mandatory physical GLN is missing.',
      ERROR_NO_IGIC_IVA: 'IGIC and VAT cannot be reported at the same time.',
      ERROR_EXITS_PAYMENT_DETAILS: 'Payment details information is missing.',
      ERROR_LINE_FROM_RECADV_PRICE_QUANTITITY_POSITIVE: 'In invoices from receipt, quantity and price must be positive.',
      ERROR_INVOICE_LINES_NO_NEGATIVE: 'In manual invoices, quantity and price cannot be negative.',
      ERROR_LINE_CORRECTIVE_PRICE_NEGATIVE: 'In corrective invoices, the price must be negative.',
      ERROR_LINE_NO_SAME_TAX: 'The same line cannot repeat the same tax.',
      ERROR_INVOICE_FROM_RECADV: 'There is no matching receipt for the invoice.',
      ERROR_INVOICE_ADDITIONAL_INFO_FROM_RECADV: 'The invoice does not match the additional information from the receipt.',
      ERROR_INVOICE_DOCUMENT_VALUES_FROM_RECADV: 'The invoice does not match the document values from the receipt.',
      ERROR_INVOICE_LINE_DATA_FROM_RECADV: 'The invoice does not match the line data from the receipt.',
      ERROR_INVOICE_ISSUE_DATE_REJECTED: 'The invoice already exists with a different issue date.',
      ERROR_GENERIC: 'Generic error'
    },
    invoice_detail_edit_form: {
      status: 'Invoice status',
      internalStatus: 'Invoice internal status',
      invoice_number: 'Invoice number',
      buyer: 'Buyer',
      issue_date: 'Issue date',
      communication_send_method: 'Sent method',
      change_state: {
        label: 'Change status',
        placeholder: 'Select invoice status'
      },
      change_internal_state: {
        label: 'Change internal status',
        placeholder: 'Select invoice internal status'
      },
      change_sent_flag: {
        label: 'Invoice sent flag',
        placeholder: 'Select invoice sent flag'
      },
      total_executable_amount: 'Amount',
      seller: 'Seller',
      creation_date_time: 'Register date',
      communication_reception_method: 'Input method',
      observations: 'Reason change of state',
      internal_observations: 'Reason change of internal state',
      pending_task: 'Pending task',
      internal_notes: 'Internal notes',
      registerNumber: 'Register number'
    },
    error: {
      validation: {
        id_invoice_empty: 'Invoice identifier can not be null',
        field_category_empty: 'Category can not be empty',
        field_category_incorrect: 'Indicated category incorrect'
      }
    },
    attachment: 'Attachments',
    no_attachment: 'You don\'t have any associated attachment',
    attachments_table: {
      filename: 'Name',
      category: 'Category',
      size: 'Size',
      compressed_size: 'Comp. Size',
      creation_date: 'Creation',
      author: 'Author'
    },
    payment_table: {
      remasa: 'Remittance',
      invoice_number: 'N. invoice',
      banco: 'Bank',
      desBanco: 'Bank description',
      viaPago: 'Payment method',
      desViaPago: 'Payment method description',
      fechaAcept: 'Acceptance date',
      fechaVenc: 'Expiration date',
      fechaValor: 'Value date',
      moneda: 'Currency',
      importeDivisa: 'Amount',
      importeComDivi: 'Cleared amount',
      situacion: 'State',
      codigoFianza: 'Bail code',
      numeroDocumento: 'Document',
      importe: 'Amount EUR',
      receptorAlternativo: 'Alternative receiver',
      detalleCompensacion: 'Detalle de compensación',
      detalleCompensacionPago: 'Documento/s pago',
      detalleCompensacionCobro: 'Documento/s cobro'

    },
    dialog_add_invoice_attachment: {
      title: 'Add attachment',
      load_document: 'Add',
      file_selected: 'Select attachment'
    },
    events: {
      title: 'Events',
      code: {
        SIGNED: 'Signed',
        description: {
          SIGNED: 'Electronic signed'
        },
        REJECTED: 'Rejected',
        VALIDATE_SIGNATURE: 'Signature verification',
        reject: 'Rejected',
        DISAGREEMENT: 'Not compliant',
        PENDING_OF_SIGNING: 'Pending of signing',
        PENDING_OF_SEND: 'Pending of send',
        UPDATE_STATUS: 'Status updating',
        UPDATE_INTERNAL_STATUS: 'Internal status updating',
        ADD_ATTACHMENT: 'Add attachment',
        DELETE_ATTACHMENT: 'Delete attachment',
        RECEIVED: 'Received',
        SEND_INVOICE: 'Invoice sending',
        SEND_INVOICE_ORIGIN: 'Invoice Shipment to origin',
        SEND_STATE: 'State shipment',
        SEND_CANCELINVOICE: 'Cancellation request',
        PENDING_OF_VERIFYING: 'Pending verification',
        PENDING_OF_VALIDATION: 'Pending validation',
        PENDING_OF_GENERATE: 'Pending generation',
        FORWARD_INVOICE: 'Invoice forwarding',
        CHECK_STATUS_ONLINE: 'Consult status online',
        NOTIFICATION: 'Notification',
        RECEPTION_INVOICE: 'Invoice reception',
        RECEPTION_ORIGINAL_INVOICE: 'Original invoice reception',
        YIELDED: 'Yielded',
        COMPENSATED: 'Compensated',
        PENDING_OF_COMPENSATION: 'Pending of compensation',
        PENDING_OF_CONFIRM: 'Pending of confirm',
        COLLECTED: 'Collected',
        PENDING: 'Pending',
        RETAINED_PAYMENT: 'Retained payment'
      },
      property: {
        FILE_NAME: 'File name',
        REASON: 'Reason',
        ORIGINAL_STATUS: 'Original status',
        FINAL_STATUS: 'Final status',
        SIGNATURE_DATE: 'Signature date',
        DATE: 'Pending validation date',
        DISAGREEMENT: 'Not compliant',
        PENDING_OF_SIGNING_DATE: 'Pending of signing date',
        PENDING_OF_VERIFYING_DATE: 'Pending of verifying date',
        RECEPTION_DATE: 'Reception date',
        REJECT_DATE: 'Reject date',
        MOTIVE: 'Reason',
        INTERNAL_MOTIVE: 'Internal reason',
        STATUS_BEFORE: 'Initial status',
        LAST_STATUS: 'Final status',
        INTERNAL_STATUS_BEFORE: 'Initial internal status',
        LAST_INTERNAL_STATUS: 'Final internal status',
        MESSAGE_RESULT: 'Response message',
        ERROR_CODE: 'Error code',
        ERROR_DESCRIPTION: 'Error description',
        ENDPOINT_STATUS: 'Client status',
        EDICOM_CDR_POSITIVE: 'CDR positive',
        EDICOM_CDR_NEGATIVE: 'CDR negative',
        DOCUMENT_INTEGRATED: 'Integrated document',
        INVOICE_ACCEPTED: 'Invoice accepted',
        INVOICE_OPENED: 'Invoice opened',
        REJECT_CODE: 'Reject code',
        REJECT_DESCRIPTION: 'Reject description',
        REGISTRATION_CODE_PROPERTY: 'Registration code',
        REGISTRATION_DATE_PROPERTY: 'Registration date',
        ERROR_DOWNLOAD_PROPERTY: 'Error motive',
        DOWNLOAD_PROPERTY: 'Download',
        DELETE_DIR: 'Deleted',
        REJECT: 'Reject',
        reject: 'Reject',
        USER: 'User',
        USER_NAME: 'User',
        signature: {
          no: {
            such: {
              algorithm: {
                exception: {
                  creating: {
                    signature: 'Sign error'
                  }
                }
              }
            }
          }
        },
        PROPERTY_REJECT_CODE: 'Reject code',
        PROPERTY_ERROR_CODE: 'Error code',
        PROPERTY_REJECT_DESCRIPTION: 'Reject description',
        PROPERTY_ERROR_DESCRIPTION: 'Error description',
        SIGNATURE_ERROR: 'Signature error',
        MESSAGE: 'Message',
        RECEPTION_DATE_PLATFORM: 'Receipt date in platform',
        RECEPTION_ORIGINAL_DATE_PLATFORM: 'Original receipt date in platform',
        SEND_DATE: 'Invoice sent. Send date'
      },
      no_events: 'You don\'t have any associated event'
    },
    eventsbpm: {
      title: 'Approval flow events'
    },
    load: {
      update_invoice: 'Updatind invoice data ...',
      resend_invoice: 'Resending this invoice ...',
      collecting_buyer_center: 'Collecting centers ...',
      add_buyer_center: 'Adding buyer center ...',
      download_attachment: 'Downloading attachment ...',
      delete_attachment: 'Deleting attachment ...',
      checking: 'Checking ...'
    },
    notification: {
      resend_invoice_ok: 'Invoice has been resent correctly',
      resend_invoice_warn_suffix: ' but an error was returned during sending',
      add_buyer_center_ok: 'Buyer center has been added correctly',
      cancel_invoice_ok: 'Invoice has been cancel correctly',
      submit_edit_invoice_ok: 'Invoice has been edited correctly',
      resend_invoice_ko_retained: 'The invoice was not sent because it was in retained state',
      check_status_invoice_ok: 'The status of the invoice has been checked correctly',
      resend_same_project: 'All the invoices must be in the same service	',
      resend_same_country: 'The invoices must have the same recipient country',
      resend_same_emission: 'All the invoices must be or emitted or received',
      resend_invoices_ok: 'Forward succesfully',
      resend_not_all: 'Not al the invoices can be forwarded',
      resend_any: 'None of the invoicescan be forwarded',
      submit_edit_invoices_ok: 'Invoice statuses updated correctly',
      no_results_payment: 'No data found for this invoice'
    }
  },

  // Documentos OCR
  ocr: {
    filters: {
      creation_date: {
        value: 'Registration date',
        placeholder: ''
      },
      ocr_process_date: {
        value: 'OCR process date',
        placeholder: ''
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Seller'
      },
      document_name: {
        value: 'Document name',
        placeholder: 'Document name'
      },
      document_number: {
        value: 'Document number',
        placeholder: 'Document number'
      },
      email: {
        value: 'Sender mail',
        placeholder: 'Sender mail'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      documenttype: {
        value: 'Document type',
        placeholder: 'Document type'
      },
      mail_server: {
        value: 'Receiver mail',
        placeholder: 'Receiver mail'
      }
    },
    documents_entity_table: {
      locked_icon: 'Locked',
      document_name: 'Document name',
      document_number: 'Document number',
      email_from: 'Email from',
      status_document: 'Status',
      project: 'Service',
      seller: 'Seller',
      mail_server: 'Receiver mail',
      document_type: 'Document type',
      message_status: 'Message status',
      creation_date: 'Creation date',
      ocr_process_date: 'OCR process date',
      locked_at: 'Locked at',
      locked_by: 'Locked by',
      attachments: 'Adjuntos'
    },
    attachments_table: {
      filename: 'Name',
      size: 'Size',
      compressed_size: 'Compressed size',
      creation_date: 'F. Creación'
    },
    select_placeholder: 'Select...',
    title_ocr_document_validation_page: 'Document validation',
    document_block_label_info: 'You are in view mode. Document locked by another user.',
    block_tooltip: 'Locked',
    no_ocr_attachment_data: 'There are no associated attachments',
    ocr_attachment: 'Attachments',
    no_ocr_lines_data: 'There are no lines associated with the document',
    ocr_lines: 'Document lines',
    buttons: {
      reject: 'Reject',
      approve: 'Approve',
      permanent_lock: 'Lock',
      permanent_unlock: 'Unlock'
    },
    permanent_lock: {
      confirm_lock: 'Are you sure you want to activate permanent lock on this document?',
      confirm_unlock: 'Are you sure you want to deactivate permanent lock on this document?',
      locking: 'Locking document...',
      unlocking: 'Unlocking document...',
      locked_success: 'Document permanently locked',
      unlocked_success: 'Document unlocked successfully'
    },
    // Formulario de pantalla de validación de documentos
    detail_form: {
      // Información de bloques
      general_data: 'Header information',
      supplier_data: 'Supplier information',
      receiver_data: 'Buyer information',
      total_data: 'Totals',
      taxes: 'Tax information',
      // Campos información de cabecera
      invoiceNumber: 'Invoice number',
      invoiceSeriesCode: 'Series code',
      invoiceDate: 'Invoice date',
      invoiceType: 'Invoice type',
      invoiceType_ocrValue: 'Recognized value: ',
      correctiveInvoiceId: 'Corrective invoice number',
      deliveryDate: 'Delivery date',
      purchaseOrder: 'Purchase order',
      // Campos información del proveedor
      nif_tooltip: 'Tax ID is normalized, it may not match the format indicated in the PDF',
      supplierTaxId: 'Tax ID',
      supplierName: 'Name',
      supplierAddress: 'Address',
      supplierIban: 'Bank account',
      supplierEmail: 'Email',
      // Campos información del cliente
      receiverTaxId: 'Tax ID',
      receiverName: 'Name',
      receiverAddress: 'Address',
      buyerCentreCode: 'Buyer centre code',
      // Campos totales
      netAmount: 'Tax base',
      totalTaxAmount: 'Total taxes',
      totalAmount: 'Total invoice',
      totalDisbursements: 'Total disbursements',
      currency: 'Currency'
    },
    taxes_table: {
      // Campos impuestos
      amount: 'Tax base',
      taxRate: 'Rate(%)',
      taxAmount: 'Tax',
      categoryCode: 'Category code'
    },
    lines_table: {
      // Campos líneas
      productCode: 'Code',
      amount: 'Amount',
      description: 'Description',
      quantity: 'Quantity',
      unit: 'Measure unit',
      unitPrice: 'Unit price',
      purchaseOrder: 'Order'
    },
    document_class: {
      ORIGINAL: 'Original',
      RECTIFICATIVA: 'Corrective'
    },
    send_ocr_document: {
      confirm: {
        params_required: 'Required params not found',
        title_approve: 'Do you want to approve the invoice?',
        title_reject: 'Do you want to reject the invoice?',
        confirm_button_send_document: 'Confirm',
        approving: 'Approving invoice ...',
        rejecting: 'Rejecting invoice ...',
        nextDocumentInfo: 'Next document has been uploaded for validation',
        approve_notification: 'Document approved correctly',
        form_notification_error: 'Validate incorrect form fields',
        reject_notification: 'Document successfully rejected'
      }
    }
  },

  // Borradores
  drafts: {
    filters: {
      creation_date: {
        value: 'Registration date',
        placeholder: ''
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Enter 3 characters'
      },
      buyer_centre: {
        value: 'Buyer centre',
        placeholder: 'Buyer centre'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Enter 3 characters'
      },
      seller_centre: {
        value: 'Seller centre',
        placeholder: 'Seller centre'
      },
      invoice_number: {
        value: 'Invoice number',
        placeholder: 'Invoice number'
      },
      invoice_series_code: {
        value: 'Series code',
        placeholder: 'Code'
      },
      currency: {
        value: 'Currency',
        placeholder: 'Currency'
      },
      issue_date: {
        value: 'Issue date range',
        placeholder: 'Issue date'
      },
      operation_date: {
        value: 'Operation date range',
        placeholder: 'Operation date'
      }
    },
    drafts_entity_table: {
      project: 'Service',
      buyer: 'Buyer',
      seller: 'Seller',
      issue_date: 'Issue date',
      invoice_number: 'Invoice number',
      operation_date: 'operation date',
      creation_date: 'Creation date',
      total_outstanding_amount: 'Total outst. amount',
      total_executable_amount: 'Total executable',
      currency: 'Currency'
    },
    buttons: {
      create_invoice: 'Create invoice'
    }
  },

  draft_detail: {
    info_draft: 'Information',
    info_message: 'Some fields are editable. Remind to push "Save" button to store modifications',
    copy_draft: 'Copy',
    edit_draft: 'Edit',
    copy_draft_tooltip: 'Copy invoice draft',
    edit_draft_tooltip: 'Edit invoice draft',
    delete_draft: 'Delete',
    delete_draft_tooltip: 'Delete invoice draft',
    csv_message: 'Cannot export more than {argumento} records, please narrow your search',
    csv_title: 'Export to CSV. Information',
    draft_detail_edit_form: {
      invoice_number: 'Invoice number: ',
      buyer: 'Buyer: ',
      issue_date: 'Issue date: ',
      total_executable_amount: 'Total amount ({code}): ',
      seller: 'Seller: ',
      creation_date_time: 'Creation date: ',
      invoice_additional_information: 'Observations: ',
      other_additional_information: 'Other observations: '
    },
    attachment: 'Attachments',
    no_attachment: 'You don\'t have any associated attachment',
    add_attachment: 'Add',
    add_attachment_tooltip: 'Add attachment',
    attachments_table: {
      filename: 'Name',
      category: 'Category',
      size: 'Size',
      compressedSize: 'Comp. Size',
      creationDate: 'Creation',
      author: 'Author'
    },
    dialog_copy_draft: {
      title: 'Copy invoice',
      invoice_number: 'Invoice number',
      issue_date: 'Issue date',
      copy_documents: 'Copy attachments',
      button_copy: 'Copy invoice'
    },
    dialog_add_attachment: {
      title: 'Add a new attachment',
      form_dialog_add_attachment: {
        select_file: 'SELECT ATTACHMENT'
      },
      button_upload: 'Upload',
      button_upload_tooltip: 'Upload attachment'
    },
    confirm: {
      title_delete_draft: 'Are you sure to delete this invoice draft?',
      confirm_button_delete_draft: 'Delete',
      title_delete_attachment: 'Are you sure to delete this attachment?',
      confirm_button_delete_attachment: 'Delete',
      delete_draft: 'Deleting draft ...'
    },
    load: {
      init_draft_data: 'Loading draft data ...',
      cancel_edit_draft_data: 'Ressenting draft data ...',
      copy_draft: 'Copying draft ...',
      delete_draft: 'Deleting invoice draft ...',
      delete_attachment: 'Deleting attachment ...',
      download_attachment: 'Downloading attachment ...'
    },
    notify: {
      copy_draft_ok: 'Draft has been copied correctly.',
      copy_draft_partial_one: 'Draft has been copied, but 1 attachment could not be copied.',
      copy_draft_partial_many: 'Draft has been copied, but {count} attachments could not be copied.',
      delete_draft_ok: 'Invoice draft deleted correctly.',
      download_attachment_ok: 'File "{filename}" has been downloaded correctly.',
      download_attachment_error: 'The attachment could not be downloaded.',
      delete_attachment_ok: 'Attachment deleted correctly.',
      create_cmr_ok: 'Transport document has been created correctly.',
      create_draft_ok: 'Draft has been created correctly.',
    }
  },

  new_invoice: {
    title: 'New Invoice',
    steps: {
      header: 'Header',
      extension: 'Extension',
      lines: 'Lines',
      totals: 'Totals'
    },
    new_invoice_form: {
      select_placeholder: 'Enter 3 characters',
      format: 'Format',
      document_class: {
        title: 'Document class',
        COPY: 'Copy',
        ORIGINAL: 'Original',
        DUPLICATE: 'Duplicate',
        ADDITIONAL_TRANSMISSION: 'Additional',
        REPLACE: 'Replace',
        ADDITION: 'Addition'
      },
      seller: 'Seller',
      table_centre: {
        code: 'Code',
        role: 'Role'
      },
      invoice_number: 'Invoice number',
      issue_date: 'Issue date',
      invoicing_date_from: 'Start date of the invoicing period',
      invoicing_date_from_pickerAll: 'Billing period date',
      currency: 'Currency',
      exchange_rate: "Exchange rate to buyer's currency",
      exchange_rate_date: 'Exchange Rate Date',
      extension_type: 'Add extension',

      document_type: 'Document type',
      service: 'Service',
      buyer: 'Buyer',
      invoice_series_code: 'Serial number',
      operation_date: 'Operation date',
      invoicing_date_to: 'End date of the invoicing period',
      communication_method: {
        title: 'Communication method',
        placeholder: ''
      },

      additional_data: 'Remarks',
      other_additional_data: 'Previous document data',
      place_issue_description: 'Description of the place expedition',
      pc_issue: 'Postal code of the expedition place',

      corrective_number: 'Corrective Invoice Number',
      corrective_tax_period_from: 'Start date of the tax period',
      corrective_tax_period_from_pickerAll: 'Tax period date',
      corrective_method: {
        title: 'Correction method',
        '01': 'Full rectification',
        '02': 'Rectification based on differences',
        '03': 'Rectification by trading volume discount over a period',
        '04': 'Authorized by the Tax Agency'
      },

      corrective_series_code: 'Serie number',
      corrective_tax_period_to: 'End of the tax period',
      corrective_reason: {
        title: 'Correction reason',
        '01': 'Invoice number',
        '02': 'Invoice series',
        '03': 'Issue date',
        '04': 'Name and surname/Business name-Sender',
        '05': 'Name and surname/Business name-Receiver',
        '06': 'Tax identification Sender/Mandatory',
        '07': 'Tax identification Receiver',
        '08': 'Address Sender/Mandatory',
        '09': 'Address Receiver',
        '10': 'Operation detail',
        '11': 'Taxation rate to apply',
        '12': 'Tax to apply',
        '13': 'Date / Period to apply',
        '14': 'Invoice class',
        '15': 'Legal literals',
        '16': 'Taxable',
        '80': 'Calculation of passed on fees',
        '81': 'Calculation of retained fees',
        '82': 'Taxable modified for container / packages return',
        '83': 'Taxable modified for discounts and bonuses',
        '84': 'Taxable modified for firm,judicial or administrative decision',
        '85': 'Taxable modified unmet passed on fees. Auto declaration contest'
      },
      corrective_invoice: 'Amendment invoice',
      dialog_add_centre: {
        title: 'Add centre',
        form_add_centre: {
          centre: {
            label: 'Centre',
            placeholder: 'Select centre'
          },
          role: {
            label: 'Role',
            placeholder: 'Select role'
          }
        },
        button_add_centre: 'Add centre'
      },
      detail_centre: {
        name: 'Name',
        country: 'Country',
        province: 'Province',
        town: 'Town',
        address: 'Address',
        postcode: 'Postcode'
      },
      rules_form: {
        select_project_first: 'Must be select a service first',
        select_seller_first: 'Must be select a seller first',
        issue_date: 'Field "issue date" cannot be after current date',
        operation_date_vs_actual_date: 'Field "operation date" cannot be after current date',
        operation_date_lower_issue_date: '"Operation date" must be less than the "Issue date"',
        field_required_corrective_invoice: 'Field required for corrective invoices',
        select_cp_first: 'You must insert a CP to insert a description of the place of issue',
        select_cpDescription: 'You must insert a CP description if you have entered a CP',
        cp_error: 'The field "CP place of dispatch" is not valid. Must be a 5 digit value'
      },
      load: {
        text_load_data: 'Loading data ...',
        text_load_parties: 'Loading sellers and buyers parties ...',
        text_load_communications_method: 'Loading communications method ...',
        text_save_invoice_data: 'Saving invoice information ...',
        text_load_init_data: 'Loading init data ...'
      },
      error: {
        validation: {
          iban: 'The IBAN is not valid',
          swift: 'The SWIFT code is not valid'
        },
        required: {
          formatDocumentId: 'The format ID parameter is required.',
          invoiceId: 'The invoice ID is required.',
          swift_code: 'The SWIFT code is required.',
          country: 'The country is required.'
        },
        not_found: {
          invoice: 'Invoice does not exist.',
          invoiceExtension: 'The extension associated with this invoice does not exist.'
        },
        recadv_rejected: 'Unable to invoice the reception because it is rejected',
        duplicated_invoice_error_recadv: 'An invoice already exists for the selected reception',
        duplicated_line_invoice_status_error: 'One of the lines is already invoiced or can not be billed'
      }
    },
    extension: {
      title: 'Add extension',
      faceb2b: {
        general_data: 'General data',
        public_sector_information: {
          public_organism_code: 'Public organism code - DIR3',
          contract_reference: 'Contract reference of the Public Administration'
        },
        buyer_data: 'Buyer detail',
        receiver_administrative_centre: {
          code: 'Receiver centre code - DIRe',
          name: 'Receiver centre name'
        },
        seller_data: 'Seller detail',
        dialog_add_centre: {
          buyer_title: 'Add buyer centre',
          seller_title: 'Add seller centre',
          code: {
            label: 'Code',
            placeholder: 'Code'
          },
          name: {
            label: 'Name',
            placeholder: 'Name'
          },
          role: {
            label: 'Role',
            placeholder: 'Select a role'
          },
          address: {
            label: 'Address'
          }
        },
        roles: {
          FISCAL: 'Fiscal',
          PAYER: 'Payer',
          BUYER: 'Buyer',
          COLLECTOR: 'Collector',
          SELLER: 'Seller',
          PAYMENT_RECEIVER: 'Payment receiver',
          COLLECTION_RECEIVER: 'Collection receiver',
          ISSUER: 'Issuer'
        },
        validations: {
          public_organism_code_required: 'This field is mandatory when the contract reference is specified.'
        },
        add_centre_button: 'Add centre',
        load: {
          saving_data: 'Saving extension data'
        }
      }
    },
    new_line_invoice: {
      title: 'New line invoice',
      delivery_title: 'New line delivery note',
      buttons: {
        add_line: 'Add',
        update_line: 'Update',
        add_line_tooltip: 'Add line',
        update_line_tooltip: 'Update line'
      },
      new_line_invoice_table: {
        concept: 'Concept description',
        article_code: 'Article code',
        article_code_seller: 'Seller code',
        article_code_buyer: 'Buyer code',
        quantity: 'Quantity',
        quantityTradeUnit: 'Quantity trade unit',
        unitOfMeasure: 'Unit of measure',
        measureTradeUnit: 'Unit of measure trade unit',
        net_price: 'Net price',
        total_cost: 'Total cost',
        batch: 'Batch',
        serial: 'Serial number',
        bestbefore: 'Best before date',
        gtin14: 'Gtin14 code',
        grossAmount: 'Gross amount',
        grossAmount_tooltip: 'Total cost with charges and discounts'
      },
      new_line_invoice_form: {
        description: 'Description',
        article_code: 'Article code',
        quantity: 'Quantity',
        quantityShipped: 'Quantity shipped',
        quantityPending: 'Quantity pending',
        net_price: 'Net price',
        unit_of_measure: {
          title: 'Unit of measure',
          '01': 'Units',
          '02': 'Hours',
          '03': 'Kilograms',
          '04': 'Liters',
          '05': 'Other',
          '06': 'Boxes',
          '07': 'Trays',
          '08': 'Barrels',
          '09': 'Drums',
          '10': 'Bags',
          '11': 'Cylinders',
          '12': 'Bottles',
          '13': 'Botes',
          '14': 'Briks',
          '15': 'Centilitros',
          '16': 'Centimeters',
          '17': 'Buckets',
          '18': 'Dozens',
          '19': 'Cases',
          '20': 'Carafes',
          '21': 'Grams',
          '22': 'Kilometers',
          '23': 'Cans',
          '24': 'Bundles',
          '25': 'Meters',
          '26': 'Milimeters',
          '27': '6-Packs',
          '28': 'Packages',
          '29': 'Servings',
          '30': 'Rolls',
          '31': 'Envelopes',
          '32': 'Spindle',
          '33': 'Cubic meter-MTQ',
          '34': 'Second-SEC',
          '35': 'Watt-WTT',
          PCE: 'Pieces',
          KGM: 'Kilograms',
          MTR: 'Lineal meter',
          TNE: 'Ton',
          LTR: 'Liter',
          MTQ: 'Cubic meter',
          DMQ: 'Cubic decimeter',
          CENT: 'Hundreds',
          MILL: 'Thousands',
          MTK: 'M. squares',
          BOX: 'Box',
          BOTL: 'Botella',
          NTBK: 'Notebook',
          GRM: 'Gram',
          GRSA: 'Gross',
          SHEE: 'Sheet',
          GAME: 'Game',
          PAR: 'Pair',
          OVLL: 'Ball',
          CARR: 'Reel',
          PACK: 'Package',
          DOCE: 'Dozen',
          K: 'K',
          R: 'R',
          B: 'B',
          C62: 'Piece',
          UN: 'Units'
        },
        additional_data: 'Observations',
        goods_code: 'Goods code',
        goods_code_placeholder: 'Enter 3 characters',
        weight: 'Weight'
      },
      documents: {
        title: 'Documents',
        no_documents: 'You don\'t have any associated documents',
        button_add_document: 'Add',
        button_add_document_tooltip: 'Add associated document'
      },
      documents_table: {
        name: 'Documents',
        seller_receiver: 'Seller/Receiver',
        value: 'Value',
        date: 'Date',
        line_number: 'Line no.'
      },
      dialog_add_document: {
        title: 'Add document',
        form_add: {
          invoice_document: {
            label: 'Document',
            CONTRACT: 'Contract / reception',
            TRANSACTION: 'Order',
            DELIVERY_NOTE: 'Delivery note',
            FILE: 'File',
            ORDER_LINE: 'Sequence / line no.',
            DESADV_LINE: 'Delivery note line'
          },
          seller: 'Seller/Receiver',
          value: 'Value',
          date: 'Date'
        },
        notify: {
          error_type_document_uniqueER: 'The selected type of document must be the only for sender / receiver',
          error_type_document_unique: 'The selected type of document must be the only'
        },
        button_add: 'Add',
        button_add_tooltip: 'Add document'
      },
      taxes: {
        title: 'Taxes',
        no_taxes: 'You don\'t have any associated tax. You must associate at least one.',
        button_add_tax: 'Add',
        button_add_tax_tooltip: 'Add tax'
      },
      chargeDiscount: {
        title: 'Add Charges and Discounts',
        table: {
          bi: 'Taxable Base',
          type: 'Type',
          description: 'Description',
          rate: 'Rate (in %)',
          amount: 'Amount'
        },
        form_add: {
          base_amount: 'Taxable Base',
          indicator: 'Charge or Discount Indicator',
          type: 'Type',
          rate: 'Rate %',
          amount: 'Amount'
        },
        no_chargeDiscount: 'You don\'t have any associated charges or discounts.',
        button_add_chargeDiscount: 'Add',
        button_add_chargeDiscount_tooltip: 'Add charge or discount',
        types: {
          TD: "Commercial discount",
          DPPROPAGO: "Early payment discount",
          DRAPPEL: "Volume or rebate discount",
          CCANSGAE: "Authors' society fee (SGAE)"
        },
        indicator: {
          charge: "Charge",
          discount: "Discount"
        }

      },
      taxes_table: {
        tax_type: 'Tax',
        rate: 'Rate (in %)',
        bi: 'Tax base',
        amount: 'Taxable amount',
        type_exemption: {
          title: 'Exemption type',
          SUBJECT_AND_EXEMPT: 'Subject and exempt',
          NOT_SUBJECT: 'Not subject',
          SUBJECT_AND_NOT_EXEMPT: 'Subject and not exempt'
        },
        legal_text: 'Motive'
      },
      dialog_add_tax: {
        title: 'Add tax',
        response: 'The lines have been updated successfully',
        responsewithtax: 'The lines have been updated successfully. Some lines already had the tax selected.',
        form_add: {
          tax: 'Tax',
          rate: 'Rate (in %)',
          bi: 'Tax base',
          amount: 'Taxable amount',
          type_exemption: 'Exemption type',
          legal_text: 'Motive',
          motive: 'Motive',
          legaltextlong: 'Reason or legal text (Optional field, select only for exempt, non-taxable or special regime operations)'
        },
        validations: {
          no_quantity_no_net_price: 'You must introduce quantity and net price first',
          quantity_net_price_incorrect: 'You must introduce quantity and net price correctly'
        },
        notify: {
          invoice_line_tax_already_added: 'The selected tax is already included'
        },
        button_add: 'Add',
        button_add_tooltip: 'Add tax'
      },
      load: {
        text_go_detail: 'Loading invoice line data ...',
        text_go_deliveryNote_detail: 'Loading line data ...',
        text_add_invoice_line: 'Saving a new invoice line ...',
        text_add_deliveryNote_line: 'Saving a new line ...',
        text_update_deliveryNote_line: 'Updating line ...',
        text_update_invoice_line: 'Updating invoice line ...',
        text_deliveryNote_lines: 'Loading lines ...',
        text_invoice_lines: 'Loading invoice lines ...',
        text_delete_invoice_line: 'Deleting invoice line ...',
        text_delete_deliveryNote_line: 'Deleting delivery note line ...',
        text_add_article: 'Loading article data ...'
      },
      notify: {
        no_lines_added: 'The invoice must have at least one line',
        update_deliveryNote_line: 'The line quantity has been updated'
      },
      lines: {
        button_delete_tooltip: 'Delete selected lines',
        button_delete: 'Delete'
      },
      confirm: {
        title_delete_invoice_line: 'Are you sure of removing this invoice/s line/s?',
        confirm_button_delete_invoice_line: 'Confirm',
        title_delete_deliveryNote_line: 'Are you sure of removing this delivery note line?',
        confirm_button_delete_deliveryNote_line: 'Confirm',
        pending_changes_title: 'Confirmation',
        pending_changes_message: 'There are pending changes to save. Do you want to continue without saving?',
        pending_changes_confirm: 'Yes',
        pending_changes_cancel: 'No'
      }
    },
    invoice_totals: {
      title: 'Invoice totals',
      invoice_totals_form: {
        total_gross_amount: 'Gross amount',
        total_gross_amount_invoice: 'Total gross invoice amount',
        total_general_discounts: 'Total global discounts',
        total_general_surcharges: 'Total global surcharges',
        total_gross_amount_before_taxes: 'Gross amount B.T.',
        total_tax_outputs: 'Total tax outputs',
        total_taxes_withheld: 'Total taxes withheld',
        invoice_total: 'Invoice total',
        total_payments_on_account: 'Total payments on account',
        irpf: '% IRPF',
        total_irpf: 'Total IRPF',
        payments_on_account_date: 'Payment date',
        subsidies_total: 'Total subsidies',
        total_outstanding_amount: 'Total outstanding amount',
        withholding_amount: 'Withholding amount',
        withholding_amount_tooltip: 'Amounts retained by the payer until the transaction is completed.',
        withholding_reason: 'Reason',
        total_reimbursable_expenses: 'Total reimbursable expenses',
        total_financial_expenses: 'Total financial expenses',
        total_executable_amount: 'Total executable amount',
        currency: 'Currency'
      },
      dialog_global_discounts: {
        title: 'Total global discounts',
        add_title: 'Add global discount',
        button_add: 'Add',
        load: {
          text_add_discount: 'Saving global discount ...'
        }
      },
      dialog_global_surcharges: {
        title: 'Total global surcharges',
        add_title: 'Add global surcharge',
        button_add: 'Add',
        text_add_surcharge: 'Saving global surcharge ...'
      },
      dialog_tax_outputs: {
        title: 'Output tax',
        title_with_held: 'Withholding tax',
        bi: 'Taxable',
        tax_type: 'Type of tax',
        tax_rate: 'Tax(%)',
        tax_output: 'Output tax',
        tax_with_held: 'Withholding tax'
      },
      installments: {
        title: 'Installment data',
        no_installments: 'You don\'t have any associated installment data.',
        button_add_tax: 'Add',
        button_add_tax_tooltip: 'Add installment',
        no_rate: 'No rate selected'
      },
      table_installments: {
        due_date: 'Due date',
        amount: 'Amount',
        payment_means: 'Payment means',
        iban: 'IBAN',
        bic: 'SWIFT'
      },
      dialog_add_installment: {
        title: 'Add installment data',
        form_add_installment: {
          due_date: 'Due date',
          amount: 'Amount',
          payment_means: {
            title: 'Payment means',
            '01': 'In cash',
            '02': 'Direct debit',
            '03': 'Receipt',
            '04': 'Credit transfer',
            '05': 'Accepted invoice of exchange',
            '06': 'Documentary credit',
            '07': 'Contract award',
            '08': 'Invoice of exchange',
            '09': 'Transferable promissory note',
            '10': 'Non transferable promissory note',
            '11': 'Check',
            '12': 'Open account reimbursement',
            '13': 'Special payment',
            '14': 'Set-off by reciprocal credits',
            '15': 'Payment by postgiro',
            '16': 'Certified cheque',
            '17': 'Banker\'s draft',
            '18': 'Cash on delivery',
            '19': 'Payment by card',
            '20': 'Pagaré',
            '21': 'Pago a cuenta bancaria',
            '22': 'Efectivo',
            '23': 'Confirming'
          },
          iban: 'IBAN',
          bic: 'SWIFT'
        },
        load: {
          text_add_installment: 'Saving invoice installment ...',
          text_delete_installment: 'Deleting invoice installment ...'
        },
        notify: {
          error_add_installment: 'Select amount can not be larger than the executable total',
          error_add_installment_0: 'Select amount can not be 0',
          error_add_installment_sepa_no_swift: 'Country code of IBAN not is SEPA country,you must introduce SWIFT code',
          error_add_installment_sepa_no_correct_lenght: 'Country with code "{code}" not is a country SEPA which SWIFT code has a length of "{swift_length}". It\'s lower than 8 or 11 required',
          error_add_installment_no_correct_country: 'The country code of the IBAN introduced is not correct',
          error_add_installment_incorrect_iban: 'The IBAN introduced is not correct',
          error_character_incorrect_iban: 'The IBAN introduced is not correct. No underscore or special characters allowed'
        },
        button_add: 'Add',
        button_add_tooltip: 'Add installment'
      },
      button_finish: 'Send',
      button_recalculate: 'Recalculate',
      button_finish_tooltip: 'Send draft',
      button_recalculate_tooltip: 'Recalculate totals',
      send_invoice: {
        confirm: {
          title_send_invoice: 'Are you sure of sending invoice?',
          confirm_button_send_invoice: 'Confirm'
        },
        add_attachments: {
          tittle_add_attachments: 'Before sending the invoice,do you want to add attachments?',
          confirm_button_add_attachments: 'Add'
        },
        error_no_taxes: 'You can\'t continue if you haven\'t added an output tax at least',
        load: {
          sending_invoice: 'Sending invoice ...'
        },
        sendOK: 'The shipment was successful'
      },
      send_delivery: {
        confirm: {
          title_send_delivery: 'Are you sure of sending delivery note?',
          confirm_button_send_delivery: 'Confirm'
        },
        load: {
          sending_delivery: 'Sending delivery note ...'
        },
        sendOK: 'The shipment was successful'
      },
      tooltip: {
        tax_output: 'See table of output taxes',
        tax_with_held: 'See table of taxes withheld',
        preview_pdf_title: 'Preview of PDF',
        preview_xsl_title: 'Preview of XSL',
        preview_xml_title: 'Metadata file',
        preview_label_title: 'Label preview',
        global_discounts: 'Detalle de los descuentos globales aplicados',
        global_surcharges: 'Detalle de los cargos globales aplicados'
      },
      dialog_general_discounts: {
        title: 'Descuentos globales',
        description: 'Descripción',
        amount: 'Importe'
      },
      dialog_general_surcharges: {
        title: 'Cargos globales',
        description: 'Descripción',
        amount: 'Importe'
      },
      load: {
        text_invoice_totals: 'Loading invoice totals ...',
        text_recalculate_totals: 'Recalculating totals ...'
      },
      notify: {
        recalculate_totals_ok: 'Totals have been recalculated correctly'
      },
      error_no_withholding_amount_when_withholding_reason: 'This field is required if a retention is applied',
      error_no_payments_on_account_date: 'This field is mandatory if a payment is applied'
    }
  },
  new_deliveryNote: {
    title: 'New delivery note',
    generate_line: 'Generate line',
    delete_line: 'Remove line',
    steps: {
      header: 'Header',
      lines: 'Lines'
    },
    new_deliveryNote_form: {
      select_placeholder: 'Enter 3 characters',
      format: 'Format',
      document_class: {
        title: 'Document class',
        COPY: 'Copy',
        ORIGINAL: 'Original',
        DUPLICATE: 'Duplicate',
        ADDITIONAL_TRANSMISSION: 'Additional',
        REPLACE: 'Replace',
        ADDITION: 'Addition'
      },
      seller: 'Seller',
      table_centre: {
        code: 'Code',
        role: 'Role'
      },
      deliveryNote_number: 'Delivery note number',
      issue_date: 'Issue date',
      delivery_date: 'Delivery date',
      invoicing_date_from: 'Start date of the invoicing period',
      invoicing_date_from_pickerAll: 'Billing period date',
      currency: 'Currency',
      exchange_rate: "Exchange rate to buyer's currency",
      exchange_rate_date: 'Exchange Rate Date',
      extension_type: 'Add extension',

      document_type: 'Document type',
      deliveryNote_type: 'Delivery note type',
      service: 'Service',
      buyer: 'Buyer',
      deliveryNote_series_code: 'Serial number',
      operation_date: 'Operation date',
      invoicing_date_to: 'End date of the invoicing period',
      communication_method: {
        title: 'Communication method',
        placeholder: ''
      },

      additional_data: 'Remarks',
      other_additional_data: 'Previous document data',

      place_issue_description: 'Description of the place expedition',
      pc_issue: 'Postal code of the expedition place',
      dialog_add_package: {
        title: 'Add package',
        load_registration: 'Generating SSCC code',
        form_add_package: {
          package_type: {
            label: 'Package type',
            placeholder: 'Select package type'
          },
          sscc: {
            label: {
              seller: 'Provider-generated SSCC code. Optional',
              auto: 'SSCC code generated by the platform'
            },
            placeholder: 'SSCC',
            noexist: 'You can\'t add a new package because the company code and initial package number haven\'t been set up. Check with your administrator.'
          }
        }
      },
      buttons: {
        add_package_tooltip: 'Add new package',
        delete_package_tooltip: 'Delete package',
        show_package_lines_tooltip: 'Show lines associated with the packaging',
        show_all_lines: {
          label: 'Show lines',
          tooltip: 'Show all lines of the delivery note'
        }
      },
      dialog_add_centre: {
        title: 'Add centre',
        form_add_centre: {
          centre: {
            label: 'Centre',
            placeholder: 'Select centre'
          },
          role: {
            label: 'Role',
            placeholder: 'Select role'
          }
        },
        button_add_centre: 'Add centre'
      },
      detail_centre: {
        name: 'Name',
        country: 'Country',
        province: 'Province',
        town: 'Town',
        address: 'Address',
        postcode: 'Postcode'
      },
      rules_form: {
        select_project_first: 'Must be select a service first',
        select_seller_first: 'Must be select a seller first',
        issue_date: 'Field "issue date" cannot be after current date',
        operation_date_vs_actual_date: 'Field "operation date" cannot be after current date',
        operation_date_lower_issue_date: '"Operation date" must be less than the "Issue date"',
        select_cp_first: 'You must insert a CP to insert a description of the place of issue',
        select_cpDescription: 'You must insert a CP description if you have entered a CP',
        cp_error: 'The field "CP place of dispatch" is not valid. Must be a 5 digit value',
        select_centre_delivery_point: 'You must select a delivery point to view the lines'
      },
      load: {
        text_load_data: 'Loading data ...',
        text_load_parties: 'Loading sellers and buyers parties ...',
        text_load_communications_method: 'Loading communications method ...',
        text_save_deliveryNote_data: 'Saving delivery note information ...',
        text_load_init_data: 'Loading init data ...',
        delete_load_deliveryNote: 'Deleting delivery note ...'
      },
      notify: {
        deliverynote_data_saved: 'The delivery note data has been saved correctly',
        delete_deliveryNote: 'Delete delivery note?',
        delete_tooltip: 'Delete delivery note',
        confirm_delete_deliveryNote: 'Delete',
        delete_deliveryNote_ok: 'Delete draft successfully.'
      },
      error: {
        validation: {
          iban: 'The IBAN is not valid',
          swift: 'The SWIFT code is not valid'
        },
        required: {
          formatDocumentId: 'The format ID parameter is required.',
          deliveryNoteId: 'The delivery note ID is required.',
          swift_code: 'The SWIFT code is required.',
          country: 'The country is required.'
        },
        not_found: {
          deliveryNote: 'Delivery Note does not exist.',
          deliveryNoteExtension: 'The extension associated with this delivery note does not exist.'
        },
        recadv_rejected: 'Unable to delivery note the reception because it is rejected',
        duplicated_deliveryNote_error_recadv: 'An delivery note already exists for the selected reception',
        duplicated_line_deliveryNote_error_recadv: 'One of the lines is already invoiced or can not be billed'
      }
    },
    deliveryNote_package: {
      title: 'Packages',
      form_package: 'Package',
      popover: {
        all_packages_has_subpackages: 'All second level package must have internal package',
        all_packages_has_lines: 'All last level package must have at least one associated line',
        all_lines_has_package: 'All lines must have assigned package'
      },
      dialog_move_line_package: {
        title: 'Assign package to the lines',
        buttons: {
          move_line_package: {
            label: 'Assign package',
            tooltip: 'Assign package to the lines'
          }
        }
      },
      load: {
        get_all_lines: 'Loading all lines ...',
        remove_package: 'Removing packages ...',
        get_package_lines: 'Loading the package lines ...',
        new_package: 'Adding package ...',
        move_line_package: 'Assigning package to the lines ...'
      },
      notify: {
        remove_package: 'Do you want to remove the package?'
      }
    }
  },

  // Cierres contables y borradores de cierres contables
  accounting_closes: {
    filters: {
      close_date: {
        value: 'Close date'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Enter 3 characters'
      },
      invoice_number: {
        value: 'Invoice number',
        placeholder: 'Invoice number'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      name: {
        value: 'Name',
        placeholder: 'Name'
      },
      accounting_close_name: {
        value: 'Dependent accounting close name',
        placeholder: 'Accounting name'
      },
      start_date: {
        value: 'Start date',
        placeholder: 'Date'
      },
      end_date: {
        value: 'End date',
        placeholder: 'Date'
      }
    },
    entity_table: {
      project: 'Service',
      buyer: 'Buyer',
      name: 'Name',
      close_date_time: 'Close date',
      status: 'Status',
      start_date: 'Start date',
      end_date: 'End date',
      child_accounting_close_name: 'Dependent acco. close',
      date_info: 'Informative date',
      description: 'Description',
      add: 'Add accounting close',
      close_accounting: 'Close accounting close'
    },
    notify: {
      save_changes: 'The accounting close has been created successfully',
      update_changes: 'The accounting close has been updated successfully',
      invoices_added: 'Invoices added correctly',
      verification_ok: 'The closing signature is correct',
      verification_ko: 'The closing signature is not correct',
      result_exceded: 'Not allowed. You must narrow the search to at least 1000 results'
    },
    add_invoices: 'Add invoices',
    add_selected: 'Add selection',
    add_all_invoices: 'Add all invoices',
    new_accounting: 'New accounting close',
    new_accounting_tooltip: 'Create new accounting close',
    validate_signature: 'Signature verification'
  },
  accounting_closes_detail: {
    invoices: {
      title: 'Invoices list',
      no_data: 'There aren\'t exist invoices associated to this accounting close',
      buyer: 'Buyer',
      seller: 'Seller',
      invoice_number: 'Invoice number',
      issue_date: 'Issue date',
      creation_date_time: 'Registration D.',
      total_executable_amount: 'amount',
      currency: 'Currency',
      status: 'Status',
      project: 'Service',
      reception_method: 'Reception method'
    },
    confirm: {
      title_delete_draft: 'Are you sure to delete this draft accounting close?',
      title_close_draft: 'Are you sure to close this draft accounting close?',
      close_ok: 'Draft closed properly',
      close_ko: 'The draft could not be closed. Contact your administrator'
    },
    notify: {
      delete_draft_ok: 'Draft deleted'
    }
  },
  issue: {
    type: {
      ERROR_PORTAL: 'Portal error',
      PRICE_ERROR: 'Price error',
      QUANTITY_ERROR: 'Quantity error'
    },
    status: {
      OPEN: 'Open',
      IN_PROGRESS: 'In progress',
      RESOLVED: 'Resolver'
    },
    priority: {
      value_0: 'None',
      value_1: 'Low',
      value_2: 'Average',
      value_3: 'High'
    }
  },
  // Tareas pendientes
  pendingtask: {
    error: {
      reject_action: 'It is not possible to reject the invoice to the supplier if it has not been previously rejected in the management system.'
    },
    filters: {
      creation_date: {
        value: 'Registration date-hour'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Enter 3 characters'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Enter 3 characters'
      },
      invoice_number: {
        value: 'Invoice number',
        placeholder: 'Invoice number'
      },
      invoice_series_code: {
        value: 'Serie code',
        placeholder: 'Code'
      },
      corrective_invoice_number: {
        value: 'Corrective invoice number',
        placeholder: 'Invoice number'
      },
      total_executable_amount_from: {
        value: 'Amount from',
        placeholder: 'Amount'
      },
      total_executable_amount_to: {
        value: 'Amount to',
        placeholder: 'Amount'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      document_class: {
        value: 'Invoice class',
        placeholder: 'Invoice class'
      },
      registration_number: {
        value: 'Registration number',
        placeholder: 'Number'
      },
      reception_method: {
        value: 'Input method',
        placeholder: 'Method'
      },
      attachments: {
        value: 'Attachments',
        placeholder: 'Select...'
      },
      internal_status: {
        value: 'Internal status',
        placeholder: 'Status'
      },
      pending_task: {
        value: 'Pending task',
        placeholder: 'Select...'
      },
      invoice_type: {
        value: 'Invoice type',
        placeholder: 'Type'
      },
      tax_type: {
        value: 'Tax type',
        placeholder: 'Tax'
      },
      rate: {
        value: 'Rate',
        placeholder: 'Rate'
      },
      currency_type: {
        value: 'Currency type',
        placeholder: 'Currency'
      },
      order_number: {
        value: 'Order number',
        placeholder: 'Order'
      },
      contract_number: {
        value: 'Contract number',
        placeholder: 'Contract'
      },
      delivery_note: {
        value: 'Delivery note',
        placeholder: 'Note'
      },
      file_number: {
        value: 'Case file',
        placeholder: 'File'
      },
      issue_date: {
        value: 'Issue date range',
        placeholder: 'Issue date'
      },
      operation_date: {
        value: 'Operation date range',
        placeholder: 'Operation date'
      }
    },

    buttons: {
      btnDownloadPdf: 'PDF',
      btnDownloadOriginal: 'Guarded',
      btnDownloadOriginal_tooltip: 'guarded',
      btnDownloadMetadata: 'Metadata',
      btnSendInvoice: 'Send invoice',
      btnPaymentProposal: 'Send proposal',
      btnDownloadPdf_tooltip: 'Download invoice PDF',
      btnDownloadMetadata_tooltip: 'Download metadata',
      btnSendInvoice_tooltip: 'Send invoice',
      btnPaymentProposal_tooltip: 'Send payment proposal status',
      btnApprove: 'Approve',
      btnSend: 'Send',
      btnCreate: 'Create/Restart',
      btnRejected: 'Rejected'
    },

    createcover: {
      noCoverPP: 'There is no cover page for the payment proposal for invoice ',
      noSendCoverPP: '. Unable to submit the status of the payment proposal.',
      createcover_multiple_ko: 'The following invoices must be in pending status: ',
      title: 'Document approval flow',
      rbInvoice: 'Invoice Cover',
      rbPaymentProposal: 'Cover proposed payment',
      cover: {
        steps: {
          creation: 'Creation',
          send: 'Send'
        },
        titleaux: '1. Select Document: ',
        title: '1. Document: ',
        create_ok: 'The cover (s) have been created correctly',
        create: 'Creating cover',
        btnCover: 'Create cover',
        send_ok: 'The invoice / s have been sent correctly',
        send_multiple_ko: 'Se ha enviado correctamente el estado de la propuesta de pago ',
        send_multiple_ko_all: 'No se ha enviado el estado de las propuesta de pago. Revise los errores',

        aprroval: {
          btnAprroval: 'Send to approval',
          notify: 'Sending to approval'
        },

        signature: {
          btnSignature: 'Send to signature',
          notify: 'Sending to signature'
        },
        user: {
          title: '2. User: ',
          placeholder: 'Enter a user',
          user_required: 'Select user'
        }
      }
    },

    pendingtask_entity_table: {
      buyer: 'Buyer',
      buyer_centres: 'Buying centers',
      seller: 'Seller',
      num_pendingtask: 'N.Invoice',
      issue_date: 'Issue d.',
      creation_date: 'Register d.',
      import: 'Import',
      divisa: 'Currency',
      status: 'Status',
      reception_method: 'Input method',
      pendingtask: 'Pending task',
      internal_status: 'Internal status',
      internal_notes: 'Internal notes',
      register_number: 'Register number',
      level_approval: 'Approval level'
    },

    pendingtask_entity_table_detail: {
      code: 'Item code',
      description: 'Description',
      order: 'order',
      despatch_quantity: 'Advertised quantity',
      received_quantity: 'Received amount',
      accepted_quantity: 'Accepted quantity',
      measure: 'Unit of measurement',
      price: 'Unit price',
      currency: 'Currency',
      status: 'Status'
    },
    pendingtask_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Download PDF',
      download_pdfmultiple_buttons: 'PDF/s',
      download_originalmultiple_buttons: 'Guarded/s',
      download_createrestar_buttons: 'Create/Restart',
      download_sendinvoice_buttons: 'Send invoice',
      download_sendstatus_buttons: 'Send proposal',

      event_table: {
        events: 'Events',
        action: 'Action',
        date: 'Date event',
        category: 'Categoy',
        user_origin: 'User origin',
        user_destiny: 'User destination',
        observations: 'Observations',
        no_date: 'Esta factura no tiene eventos'
      },

      attachments_table: {
        attachments: 'Attachments',
        fiename: 'Name',
        category: 'Category',
        size: 'Size',
        compressedSize: 'S.Compressed',
        hidden: 'Hidden',
        creationDate: 'D.Creation',
        author: 'Creator',
        no_date: 'This invoice has no attached document',
        load: 'Add',
        load_tooltip: 'Add attachment',
        download: 'Downloading Attached Document of the Invoice ...',
        delete: 'Deleting Document Attached from the Invoice ...',
        delete_ok: 'The file has been successfully deleted.',
        fileselected: 'Select file.'
      },

      sap: {
        send: 'Sending invoice',
        send_ok: 'Sent bill',
        send_multiple_ko: 'La factura {fact} debe estar en estado pendiente y no haber sido enviadas previamente.',
        send_multiple_ko_all: 'No se han enviado las facturas. Revise los errores',
        maxselected: 'No puede realizar el envío de más de 10 facturas a la vez.'

      },

      paymentproposal: {
        send: 'Sending proposed payment status',
        send_ok: 'Invoice sent to payment proposal',
        name: 'Proposed name payment',
        invoicenumber: 'Invoice number',
        status: 'Status',
        description: 'Desccription',
        title: 'Payment proposal',
        btnsend: 'Submit'
      },

      rejectedinvoice: {
        title: 'Reject invoice',
        status: 'Actual state',
        statusnext: 'Next status',
        category: 'Category',
        motive: 'Reason for rejection',
        motive_required: 'Mandatory reason',
        categoryselected: 'Select category',
        rejected: 'Rejecting the bill',
        rejected_ok: 'The invoice has been rejected correctly ',
        statusrejected: 'Rejected'
      },

      approveinvoice: {
        title1: 'Approve invoice',
        title2: 'Send invoice',
        status: 'Current level',
        statusnext: 'Next level',
        category: 'Category',
        motive: 'Comment',
        motive_required: 'Mandatory comment',
        categoryselected: 'Select',
        approved: 'Approving the invoice',
        approved_ok: 'Invoice has been approved successfully',
        send: 'Sending invoice',
        send_ok: 'The invoice has been sent successfully',
        fiekd: 'Field',
        value: 'Value'
      },

      internal_notes: {
        title: 'Internal notes'
      },

      notify: {
        save: 'Updating invoice data',
        download: 'The file download {file} was correct.',
        download_multiple: 'The download was successful.',
        selected_service: 'Select a service',
        save_field: 'Saving fields...',
        save_field_ok: 'Fields saved successfully.',
        delete_fields: 'Deleting fields...',
        delete_fields_ok: 'The fields have been successfully removed.'
      }
    }
  },

  auditory: {
    filters: {
      input_date: {
        value: 'Input date-hour'
      },
      sender: {
        value: 'Sender',
        placeholder: 'Sender'
      },
      receiver: {
        value: 'Receiver',
        placeholder: 'Receiver'
      },
      filename: {
        value: 'Filename',
        placeholder: 'Filename'
      },
      document_number: {
        value: 'Document number',
        placeholder: 'Document number'
      },
      document_type: {
        value: 'Document type',
        placeholder: 'Type'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      batch: {
        value: 'Batch',
        placeholder: 'Select...'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      inFormat: {
        value: 'Input Format',
        placeholder: 'Input Format'
      },
      outFormat: {
        value: 'Output Format',
        placeholder: 'Output Format'
      },
      visible: {
        value: 'Visible',
        placeholder: 'Choose...'
      },
      sonFrom: {
        value: 'N. docs. children from',
        placeholder: 'N. docs. children from'
      },
      sonTo: {
        value: 'N. docs. children up',
        placeholder: 'N. docs. children up'
      },
      processingTimeFrom: {
        value: 'Processing time from',
        placeholder: 'Processing time from'
      },
      processingTimeTo: {
        value: 'Processing time to',
        placeholder: 'Processing time to'
      },
      communication_protocol: {
        value: 'Communication protocol',
        placeholder: 'Protocol'
      },
      audit_document_module: {
        value: 'Module',
        placeholder: 'Module'
      },
      user: {
        value: 'User',
        placeholder: 'User'
      },
      action: {
        value: 'Action',
        placeholder: 'Action'
      },
      group: {
        value: 'Functional group',
        placeholder: 'Functional group'
      },
      value: {
        value: 'Value',
        placeholder: 'Value'
      }
    },

    parent: 'Access the parent file',
    son: 'Access generated files',
    auditory_entity_table: {
      project: 'Service',
      sender: 'Sender',
      receiver: 'Receiver',
      date: 'Date',
      filename: 'Filename',
      document_number: 'Document N.',
      document_type: 'Document T.',
      status: 'Status',
      communication_protocol: 'Communication',
      audit_document_module: 'Module',
      batch: 'Batch',
      processingTime: 'Processing time',
      group: 'Group',
      user: 'User',
      action: 'Action',
      value: 'Value',
      csv_title: 'Export to CSV. Information',
      csv_message: 'Cannot export more than {argumento} records, please narrow your search'
    },
    download_multiple: {
      multiple_ko: 'The following audits can not be downloaded'
    },

    load: {
      download_request_file: 'Descargando ficheros de entrada ...',
      download_response_file: 'Descargando ficheros de salida ...',
      download_incoming_file: 'Descargando ficheros de entrada ...',
      download_integrated_file: 'Descargando Ficheros integrados ...'
    },

    buttons: {
      btn_request: 'Request',
      btn_response: 'Response',
      btn_incoming_file: 'Incoming file',
      btn_integrated_file: 'Integrated file',
      btn_request_tooltip: 'Download request',
      btn_response_tooltip: 'Download response',
      btn_incoming_file_tooltip: 'Download incoming file',
      btn_integrated_file_tooltip: 'Download integrated file'
    }
  },

  auditory_detail: {
    info_auditory: 'Events',

    buttons: {
      request: 'Request',
      response: 'Response',
      incoming_file: 'Incoming file',
      integrated_file: 'Integrated file',
      request_tooltip: 'Download request',
      response_tooltip: 'Download response',
      incoming_file_tooltip: 'Download incoming file',
      integrated_file_tooltip: 'Download integrated file'

    },

    load: {
      download_request_file: 'Downloading request file ...',
      download_response_file: 'Downloading response file ...',
      download_original_file: 'Downloading guarded file ...',
      download_incoming_file: 'Downloading incoming file ...',
      download_integrated_file: 'Downloading integrated file ...'
    },

    notify: {
      error_download_not_found: 'Download error. File not found'
    },

    events: {
      code: {
        RECEPTION_INVOICE: 'Reception of invoice',
        RECEPTION_ORIGINAL_INVOICE: 'Reception of original invoice',
        SUMMARY_ALTCLI: 'Summary of registered clients',
        SUMMARY_ALTPRO: 'Summary of registered providers',
        ERROR_LINE_LENGTH: 'Incorrect line',
        DELETE_DIR: 'Deleted',
        invalidFormat: 'The invoice file doesn\'t follow the specified "Schema Version"',
        FILE_BASE64_ERROR: 'Unexpected error reading invoice format',
        'VALIDATION.DUPLICATION': 'The invoice has not passed the validation of invoice duplication',
        'VALIDATION.DUPLICATION.ISSUEYEAR': 'The invoice has not passed the validation of invoice duplicantion last year',
        SIGNED: 'Signed',
        EDICOM_CDR_NEGATIVE: 'CDR negative',
        EDICOM_CDR_POSITIVE: 'CDR positive',
        DISAGREEMENT: 'Not compliant',
        PENDING_OF_SIGNING: 'Pending of signing',
        UPDATE_STATUS: 'Update status',
        UPDATE_INTERNAL_STATUS: 'Update internal status',
        CHECK_STATUS_ONLINE: 'Online status request',
        DOCUMENT_INTEGRATED: 'Integrated Document',
        INVOICE_INTEGRATED: 'Integrated invoice correctly',
        INVOICE_INTEGRATED_WS: 'Integrated invoice by Web Service',
        INVOICE_INTEGRATED_REST: 'Integrated invoice by Rest',
        VALIDATION_INVOICE_DIGITIZED_WS: 'Validated digitized Invoice by Web Service',
        RECOGNITION: 'Recognition',
        VALIDATE_SIGNATURE: 'Signature verification',
        TRANSFORMATION: 'Transformation',
        SIGNATURE: 'Signature',
        DELIVERY: 'Delivery',
        CHANGE_STATUS_RECADV_WS: 'Web service reception change status',
        CHECK_STATUS_RECADV_WS: 'Check status of web service receptions',
        INTEGRATION_RECADV_WS: 'Web service reception integration',
        ERROR: 'Error',
        FACTURAE_INVALID: 'Invoice malformed',
        PARTY_SENDER_NOTFOUND: 'Party sender not found',
        CENTRE_SELLER_NOTFOUND: 'Center seller not found',
        PARTY_RECEIVER_NOTFOUND: 'Party receiver not found',
        CENTRE_BUYER_NOTFOUND: 'Center buyer party not found',
        CURRENCY_NOTFOUND: 'Currency  not Found',
        TAXTYPE_NOTFOUND: 'Tax type not found',
        COUNTRY_BUYER_NOTFOUND: 'Country buyer party not found',
        COUNTRY_BUYER_CIFPREFIX_NOTFOUND: 'The country indicated in the cif prefix does not exist',
        COUNTRY_SELLER_CIFPREFIX_NOTFOUND: 'Prefix cif seller not found',
        COUNTRY_CENTRE_NOTFOUND: 'Center country not found',
        MEDIA_TYPE_NOTFOUND: 'Media type not found',
        CONTRACT_BUYER_ERROR: 'Unexpected error in hiring the buyer party',
        CONTRACT_PARTYMEDIA_ERROR: 'Error in hiring party_media',
        DB_ERROR: 'Unexpected error in connection to database',
        REPOSITORY_FENIX_INVOICE_ERROR: 'Error copying file repository fenix',
        REPOSITORY_FENIX_ATTACHMENT_ERROR: 'Failed to unzip attachments in temporary',
        REPOSITORY_FENIX_RECEIVED_INVOICE_ERROR: 'Failed to copy the file in the repository received fenix',
        REPOSITORY_UNZIP_FILE_ERROR: 'Error occurred when obtaining or decompress the file repository ediTRACK',
        NOTE_INVOICE_ERROR: 'Unexpected error registrating the invoice',
        AUDIT_DOCUMENT_ERROR: 'Unexpected error inserting information in audit',
        GETFORMAT_ERROR: 'Unexpected error in determining the format of the document to integrate',
        SEND_MAIL_ERROR: 'Error occurred sending mail',
        RETRY_MAIL_ERROR: 'Failed to save information to retry sending email',
        UNEXPECTED_ERROR: 'Unexpected error',
        REQUEST_EMPTY: 'Request empty',
        DOCUMENT_CLASS_NOTFOUND: 'Document type not gound',
        STATUS_DOCUMENT_NOTFOUND: 'Status document not found',
        INVOICE_DOCUMENT_TYPE_NOTFOUND: 'Invoice document type not found',
        INVOICE_TYPE_NOTFOUND: 'Invoice type not found',
        INSTANCES_REQUEST_EMPTY: 'Document instances can not be empty',
        DOCUMENT_FORMAT_EMPTY: 'The element Documentformat can not be empty or null',
        DOCUMENT_FORMAT_UNRECOGNIZED: 'Unrecognized document format',
        REPOSITORYLOCATOR_ATTACHMENT_EMPTY: 'The element Repositorylocator of the ATTACHMENT instance can not be null or empty',
        ORIGINALFILENAME_ATTACHMENT_EMPTY: 'The element OriginalFileName of the ATTACHMENT instance can not be null or empty',
        DOCUMENT_FORMAT_ERROR: 'The format of the document to integrate (contained in the request) is not correct',
        PROJECT_PARTY_SPONSOR_NOTFOUND: 'Sponsor not found among the parties of the invoice',
        PROJECT_PARTY_SPONSOR_ERROR: 'Unexpected error when looking for the sponsor parties between supplier/client invoice',
        VALIDITY_DOCUMENT_NOTFOUND: 'No valid document for the document type and country of the invoice',
        STATUS_AUDIT_NOTFOUND: 'Status audit not found',
        SEMANTICDOCUMENTID_EMPTY: 'The element semanticdocumentid can not be null or empty',
        REPOSITORYLOCATOR_RECEIVED_EMPTY: 'The element Repositorylocator of the RECEIVED instance can not be null or empty',
        INCOMINGDATETIME_EMPTY: 'The element incomingdatetime can not be null or empty',
        RECEIVERID_NOTFOUND: 'The party whose cif is indicated in the item receiverid does not exist',
        SENDERID_NOTFOUND: 'The party whose cif is indicated in the item senderid does not exist',
        DOCUMENT_TYPE_NOTFOUND: 'Document type not found',
        DOCUMENT_PARENT_NOTFOUND: 'Parent document not found',
        COMMUNICATION_PROTOCOL_EMPTY: 'Communication protocol can not be null or empty',
        COMMUNICATION_PROTOCOL_NOTFOUND: 'Communication protocol not found',
        REPOSITORY_ERROR: 'Error getting file repository',
        CONNECTION_ERROR: 'Unexpected error connecting to database',
        PROJECT_COMMUNITYID_NOTFOUND: 'Service with code CommunityID not found',
        DOCUMENT_FORMAT_NOTFOUND: 'Document format not found',
        INPUTDATETIME_EMPTY: 'The element inputdatetime can not be null or empty',
        DELIVERYCHECK: 'Delivery confirmation',
        DUPLICATED_INVOICE_ERROR: 'Duplicate invoice error',
        CORRECTIVE_NUMBER_REQUIRED: 'The number of corrective invoice is mandatory for rectification method 01 or 02',
        DIR_ATTACHMENT_NOTFOUND: 'No attachments directory to integrate invoice',
        996: '996',
        CIF_REQUIRED: 'The cif is a required field',
        ACTION_REQUIRED: 'The action is a required field',
        DESCRIPTION_REQUIRED: 'The description  is a required field',
        CANAL_REQUIRED: 'The channel is a required field',
        EMAIL_REQUIRED: 'The email is a required field',
        PARTY_BUYER_NOTFOUND: 'The buyer party does not exist',
        PROJECT_PARTY_DISABLED: 'The party is disabled for the indicated service',
        PROJECT_PARTY_BUYER_NOTFOUND: 'The buyer party is not associated or is disabled for the service indicated',
        PROJECT_PARTY_SELLER_NOTFOUND: 'The seller party is not associated or is disabled for the service indicated',
        COMMUNICATION_METHOD_NOTFOUND: 'Communication method does not exist',
        EMAIL_INVALID: 'The email is incorrect',
        ACTION_UNEXPECTED: 'The action is incorrect',
        READ_FILE_BUYERS_ERROR: 'Unexpected error reading recuitment file of buyer parties',
        UPDATE_PARTY_ERROR: 'Failed to update the data of the company',
        CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Error creating delivery method associated with the party',
        CREATE_PARTY_MEDIA_ERROR: 'Error creating the email associated with the buyer party',
        CREATE_USER_PARTY_ERROR: 'Error creating the user associated with the buyer party',
        CREATE_USER_ERROR: 'Error creating the usuer',
        CREATE_PARTY_ERROR: 'Error creating the party',
        CREATE_PROJECT_PARTY_ERROR: 'Error creating the relation between the service and the party',
        CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Error creating the business relationship between the buyer party and the sponsor party',
        CREATION_PARTY_WS: 'Party creation',
        UPDATE_PARTY_WS: 'Update parties',
        CREATION_USER_WS: 'Party users',
        REMOVE_USER_WS: 'Delete users',
        UPDATE_USER_WS: 'Update users',
        UNLOCK_USER_WS: 'Unlock users',
        RESET_USER_WS: 'User Reset',
        PROJECT_NOSENDER: 'Error delivery method. service isn\'t sender',
        SELLER_NOSPONSOR: 'Error delivery method. Party isn\'t sponsor.',
        PROJECT_NO_DELIVERY_METHOD: 'Delivery method not found in the service',
        NO_LINES: 'Reception without lines',
        ITEM_PRICE_NOTFOUND: 'Line without price',
        ITEM_NOTFOUND: 'Line without item',
        INVALID_MEASURE: 'Wrong unit of measure',
        RECADV_ERROR: 'Error',
        DUPLICATED_RECADV: 'Duplicated reception',
        INVOICE_VALIDATION: 'Error in the invoice validation',
        UPDATE_PARTY: 'Update party',
        SIGN: 'Signature',
        hermes: {
          integration: {
            invoice: 'Successful integrated invoice'
          },
          download: {
            invoice: 'Invoice download'
          }
        },

        // Categorías

        CARATULA_FACTURA: 'Invoice cover',
        CARATULA_PROPUESTA_PAGO: 'Cover of the payment proposal',
        PROPUESTA_PAGO: 'Proposal for payment',
        DISPLAY_INVOICE: 'PDF of the invoice',
        APPROVAL_FLOW: 'Approval flow',

        // Acciones

        SEND_SIGNED: 'Shipping to Firm',
        SEND_APPROVAL: 'I send it okay',
        CREATE_COVER: 'Creation of cover',
        RESTART_CREATE_COVER: 'Cover Reset',
        ACCEPTED: 'Accepted',
        REJECTED: 'Rejected',
        SEND_INVOICE: 'Invoice Shipment',
        SEND_INVOICE_ORIGIN: 'Invoice Shipment to origin',
        SEND_STATE: 'State Shipment',
        SEND_PROPOSED_STATE: 'Send proposed state',
        INVOICE_SIGNATURE: 'Invoice signature',
        PROPOSALS_SIGNATURE: 'Proposals signature',

        // Códigos para eventos de auditorías de webservices
        unexpected: {
          error: 'Unexpected error while processing the request or its document'
        },
        document: {
          integration: {
            error: 'Integration error of the request\'s document'
          }
        },
        repository: {
          error: 'Error while trying to save or get the request document'
        },
        validation: {
          error: 'Validation error of the request\'s document',
          retry: 'Validation retry'
        },
        invoice: {
          integrated: {
            b2bintegration: 'Successful B2B invoice integration',
            ws: 'Successful webservice invoice integration',
            upload: 'Successful invoice integration'
          },
          format: {
            error: 'Invoice format error'
          },
          schema: {
            error: 'XML invoice\'s schema error'
          }
        },
        recadv: {
          integrated: {
            b2bintegration: 'Successful B2B receipt advice integration'
          },
          format: {
            error: 'Recepit advice format error'
          },
          schema: {
            error: 'XML receipt advice\'s schema error'
          }
        },
        csvparties: {
          integrated: {
            b2bintegration: 'CSV of parties integrated successfully'
          },
          format: {
            error: 'Error in the CSV format of parties'
          },
          schema: {
            error: 'Error in the content of the CSV of parties'
          }
        }
      },

      property: {
        NUMLINES_TOTAL: 'Number of lines contained',
        NUMLINES_ERROR: 'Number of lines with errors',
        NUMLINES_OK: 'Number of correct lines',
        UPDATE_PARTY: 'Update party',
        UPDATED_PARTY: 'Updated',
        SEND_FILE: 'Send file',
        ERROR_LINE_LENGTH: 'Incorrect line',
        DELETE_DIR: 'Deleted',
        REASON: 'Reason',
        ORIGINAL_STATUS: 'Original status',
        FINAL_STATUS: 'Final status',
        SEND_MAIL_ERROR: 'Error occurred sending mail',
        NOTE_INVOICE_ERROR: 'Unexpected error inserting the invoice',
        DOCUMENT_INTEGRATED: 'Number of integrated document',
        DIGITIZEDINVOICE_VALIDATED: 'Validated invoice',
        ATTACHMENT_INTEGRATED: 'Name of attachments file',
        INVOICE_INTEGRATED_WS: 'Number integrated invoice',
        INVOICE_INTEGRATED: 'Number integrated invoice',
        VALIDATION_INVOICE_DIGITIZED_WS: 'Validated digitized Invoice by Web Service',
        documentinstance: {
          filename: 'Filename'
        },
        MOTIVE: 'Reason',
        STATUS_BEFORE: 'Initial status',
        LAST_STATUS: 'Final status',
        USER_NAME: 'User',
        INTERNAL_MOTIVE: 'Internal reason',
        INTERNAL_STATUS_BEFORE: 'Initial internal status',
        LAST_INTERNAL_STATUS: 'Final internal status',
        MESSAGE_RESULT: 'Response message',
        CHANGE_STATUS_RECADV_WS: 'Status change',
        FACTURAE_INVALID: 'Invoice malformed',
        PARTY_SENDER_NOTFOUND: 'Sender party not found',
        CENTRE_SELLER_NOTFOUND: 'Center seller not found',
        PARTY_RECEIVER_NOTFOUND: 'Receiving party not found',
        CENTRE_BUYER_NOTFOUND: 'Buyer party center not found',
        CURRENCY_NOTFOUND: 'Currency not Found',
        TAXTYPE_NOTFOUND: 'Tax type not found',
        COUNTRY_BUYER_NOTFOUND: 'Buyer party country not found',
        COUNTRY_BUYER_CIFPREFIX_NOTFOUND: 'Buyer cif prefix not found',
        COUNTRY_SELLER_CIFPREFIX_NOTFOUND: 'Seller cif prefix not found',
        COUNTRY_CENTRE_NOTFOUND: 'Center country not found',
        MEDIA_TYPE_NOTFOUND: 'Media type not found',
        CONTRACT_BUYER_ERROR: 'Unexpected error in hiring the buyer party',
        CONTRACT_PARTYMEDIA_ERROR: 'Error in hiring party_media',
        DB_ERROR: 'Unexpected error in connection to databases',
        REPOSITORY_FENIX_INVOICE_ERROR: 'Error copying file repository fenix',
        REPOSITORY_FENIX_ATTACHMENT_ERROR: 'Failed to unzip attachments in temporary',
        REPOSITORY_FENIX_RECEIVED_INVOICE_ERROR: 'Failed to copy the file in the repository received fenix',
        REPOSITORY_UNZIP_FILE_ERROR: 'Error occurred when obtaining or decompress the file repository ediTRACK',
        AUDIT_DOCUMENT_ERROR: 'Unexpected error inserting information in audit',
        RETRY_MAIL_ERROR: 'Failed to save information to retry sending email',
        UNEXPECTED_ERROR: 'Unexpected error',
        REQUEST_EMPTY: 'Request empty',
        CORRECTIVE_NUMBER_REQUIRED: 'The number of corrective invoice method is mandatory for rectification 01 or 02',
        DOCUMENT_CLASS_NOTFOUND: 'Document type not found',
        STATUS_DOCUMENT_NOTFOUND: 'Status document not found',
        INVOICE_DOCUMENT_TYPE_NOTFOUND: 'Invoice document type not found',
        INVOICE_TYPE_NOTFOUND: 'Invoice type not found',
        INSTANCES_REQUEST_EMPTY: 'Document instances can not be empty',
        DOCUMENT_FORMAT_EMPTY: 'The element Documentformat can not be empty or null',
        REPOSITORYLOCATOR_ATTACHMENT_EMPTY: 'The element Repositorylocator of the ATTACHMENT instance can not be null or empty',
        ORIGINALFILENAME_ATTACHMENT_EMPTY: 'The element OriginalFileName of the ATTACHMENT instance can not be null or empty',
        DOCUMENT_FORMAT_ERROR: 'Unrecognized document format',
        PROJECT_PARTY_SPONSOR_NOTFOUND: 'Sponsor not found among the parties of the invoice',
        PROJECT_PARTY_SPONSOR_ERROR: 'Unexpected error when looking for the sponsor between the supplier/buyer parties of the invoice',
        VALIDITY_DOCUMENT_NOTFOUND: 'No valid document for the document type and country of the invoice',
        STATUS_AUDIT_NOTFOUND: 'Status audit not found',
        SEMANTICDOCUMENTID_EMPTY: 'The element semanticdocumentid can not be null or empty',
        REPOSITORYLOCATOR_RECEIVED_EMPTY: 'The element Repositorylocator of the RECEIVED instance can not be null or empty',
        INCOMINGDATETIME_EMPTY: 'The element incomingdatetime can not be null or empty',
        RECEIVERID_NOTFOUND: 'The party whose cif is indicated in the item receiverid does not exist',
        SENDERID_NOTFOUND: 'The party whose cif is indicated in the item senderid does not exist',
        DOCUMENT_TYPE_NOTFOUND: 'Document type not found',
        DOCUMENT_PARENT_NOTFOUND: 'Parent document not found',
        COMMUNICATION_PROTOCOL_EMPTY: 'Communication protocol can not be null or empty',
        COMMUNICATION_PROTOCOL_NOTFOUND: 'Communication protocol not found',
        REPOSITORY_ERROR: 'Error getting file repository',
        CONNECTION_ERROR: 'Unexpected error connecting to  database',
        PROJECT_COMMUNITYID_NOTFOUND: 'Service not found with code CommunityID',
        DOCUMENT_FORMAT_NOTFOUND: 'Document format not found',
        INPUTDATETIME_EMPTY: 'The element inputdatetime can not be null or emptyo',
        TRANSFORMATION: 'Stage of transformation of the invoice',
        EXTRACTION: 'Stage of extraction of the invoice',
        ATTACHMENT: 'Stage of extraction of the invoice attachment',
        DELIVERY: 'File delivery stage',
        DIR_ATTACHMENT_NOTFOUND: 'Directory attachments of the invoice to integrate not found',
        VALIDATION_ERROR: 'Validation error',
        translation: {
          instances: {
            added: 'Added translation of instances'
          },
          processingtime: 'Duration in complete the translation'
        },
        error: {
          document: {
            entrieszip: {
              '': 'Failed to unpack the zip',
              format: {
                invalid: 'Uncorrect input file structure/format'
              }
            },
            attachments: {
              directory: {
                name: {
                  invalid: 'The attachments directory name is invalid'
                }
              }
            },
            file: {
              name: {
                invalid: 'The name of one of the input files is invalid'
              },
              format: 'Error in the input file format'
            },
            read: {
              country: 'Error reading the file,you can not determine the country'
            }
          },
          ai: {
            translationfail: 'Error translating file with AI'
          },
          ruleinformation: {
            notfound: 'Rule not found'
          }
        },
        EXTRACTION_INVOICE: {
          ERROR: 'Error occurred when extracting invoice from compressed file'
        },
        EXTRACTION_ATTACHMENT: {
          ERROR: 'Error occurred when extracting attachments from compressed file'
        },
        TRANSLATION_MAP: {
          ERROR: 'Error occurred when applying the map to the invoice'
        },
        SIGNATURE: {
          '': 'Stage of signature of the file',
          ERROR: 'Error occurred when signing the invoice'
        },
        signature: {
          sax: {
            exception: {
              parsing: {
                document: 'Error occurred when signing the invoice,incorrect format'
              }
            }
          },
          signature: {
            exception: {
              signing: 'Error occurred when signing the invoice'
            }
          }
        },
        RECOGNITION: {
          '': 'Stage of recognition of the input file',
          ERROR: 'Error occurred when recognizing the file'
        },
        vltrader: {
          senddt: 'Sending date',
          sender: {
            host: 'Host',
            mailbox: 'Mailbox'
          },
          sendid: 'Sending identifier',
          totalattempts: 'Attempts number',
          transfer: {
            enddt: 'End of sending date',
            resulttext: 'Sending result',
            startdt: 'Start sending date',
            status: 'Sending result status',
            transferid: 'Delivery identifier'
          }
        },
        wsserver: {
          profile: 'Profile',
          requestid: 'Request identifier'
        },
        DUPLICATED_INVOICE_ERROR: 'Error for duplicate invoice',
        EDICOM_CDR_NEGATIVE: 'CDR negative',
        996: '996',
        CIF_REQUIRED: 'Error for duplicate invoice',
        ACTION_REQUIRED: 'The action is a required field',
        DESCRIPTION_REQUIRED: 'The description is a required field',
        CANAL_REQUIRED: 'The channel is a required field',
        EMAIL_REQUIRED: 'The email is a required field',
        PARTY_BUYER_NOTFOUND: 'The buyer party does not exist',
        PROJECT_PARTY_DISABLED: 'The party is disabled for the indicated service',
        PARTY_DISABLED: 'The party is disabled',
        COMMUNICATION_METHOD_NOTFOUND: 'The communication method of does not exist',
        EMAIL_INVALID: 'The email is incorrect',
        ACTION_UNEXPECTED: 'The action is incorrect',
        READ_FILE_BUYERS_ERROR: 'Unexpected error reading recruitment file of buyer parties',
        UPDATE_PARTY_ERROR: 'Failed to update the data of the party',
        CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Error creating delivery method associated with the party',
        CREATE_PARTY_MEDIA_ERROR: 'Error creating the email associated with the buyer party',
        CREATE_USER_PARTY_ERROR: 'Error creating the user associated with the buyer party',
        CREATE_PARTY_ERROR: 'Failed to create the client company',
        CREATE_USER_ERROR: 'Failed to create the user',
        CREATE_PROJECT_PARTY_ERROR: 'Error creating the relation between the service and the party',
        CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Error creating the business relationship between the sponsor party and the client party',
        EDICOM_ACK_NEGATIVE: 'ACK negative',
        NO_PERSON_CODE_VALID: 'Person code is not valid',
        PARTY_NIF_EXIST: 'Party NIF already exists',
        PARTY_GLN_EXIST: 'Party GLN already exists',
        WITHOUT_DATA_REQUIRED: 'Missing required data',
        LOGO_ERROR: 'Logo error',
        MIME_TYPE_LOGO_ERROR: 'Logo type error',
        FILE_BASE64_ERROR: 'Error in Base64 file',
        NO_COUNTRY_CODE_VALID: 'The country code is not valid',
        CENTRE_ERROR: 'Centre error',
        COMMUNICATION_METHOD_ERROR: 'Communication method error',
        EMAIL_ERROR: 'Email error',
        PARTY_USER_ERROR: 'Party user error',
        PROJECT_PARTY_NIF_NOT_EXIST: 'There is no party with this NIF',
        CREATED: 'Created',
        DELETED: 'Deleted',
        UPDATED: 'Updated',
        EDICOM_CDR_POSITIVE: 'CDR positive',
        CENTRE_NOT_EXIST: 'There is no center',
        USER_EXIST: 'User already exists',
        USER_NOT_EXIST: 'User does not exist',
        USER_NOT_LOCKED: 'User not locked',
        USER_NOT_REMOVED: 'User not removed',
        USER_NOT_PROJECT: 'The user is not from the service',
        USER_NIF_EXIST: 'User NIF already exists',
        PROJECT_NOSENDER: 'Error delivery method. service isn\'t sender',
        SELLER_NOSPONSOR: 'Error delivery method. Party isn\'t sponsor.',
        PROJECT_NO_DELIVERY_METHOD: 'Delivery method not found in the service.',
        REGISTRATION_CODE_PROPERTY: 'Registration code',
        REGISTRATION_DATE_PROPERTY: 'Registration date',
        CHANGE_STATUS: 'Status change',
        CHANGE_STATUS_PROPERTY: 'Status change',
        DOWNLOAD_PROPERTY: 'Download',

        // Códigos para propiedades de auditorías
        invoice: {
          integrated: {
            b2bintegration: 'Number of integrated B2B invoice',
            ws: 'Number of integrated webservice invoice',
            upload: 'Number of integrated invoice'
          },
          note: {
            media: {
              type: {
                not: {
                  found: 'Invoice media type not found'
                }
              },
              invalid: {
                email: {
                  format: 'Invoice media email invalid'
                }
              }
            },
            document: {
              not: {
                found: 'Invoice note document not found'
              }
            },
            recadv: {
              not: {
                found: 'Invoice note receipt advice not found'
              }
            },
            attachment: {
              category: {
                not: {
                  found: 'Invoice note attachment category not found'
                }
              },
              user: {
                not: {
                  found: 'Invoice note attachment user not found'
                }
              }
            }
          },
          project: {
            not: {
              found: 'Invoice service not found'
            },
            category: {
              not: {
                found: 'Invoice service category not found'
              }
            }
          },
          sender: {
            not: {
              found: 'Invoice party sender not found'
            }
          },
          receiver: {
            not: {
              found: 'Invoice party receiver not found'
            }
          },
          thirdparty: {
            not: {
              found: 'Invoice third party not found'
            }
          },
          status: {
            not: {
              found: 'Invoice status not found'
            }
          },
          currency: {
            not: {
              found: 'Invoice currency not found'
            }
          },
          document: {
            format: {
              not: {
                found: 'Invoice document format not found'
              }
            },
            class: {
              not: {
                found: 'Invoice document class not found'
              }
            },
            type: {
              not: {
                found: 'Invoice document type not found'
              }
            }
          },
          type: {
            not: {
              found: 'Invoice type not found'
            }
          },
          validity: {
            document: {
              not: {
                found: 'Invoice validity document not found'
              }
            }
          },
          communication: {
            method: {
              not: {
                found: 'Invoice communication method not found'
              }
            }
          },
          auditdocument: {
            not: {
              found: 'Invoice audit document not found'
            }
          },
          accounting: {
            close: {
              not: {
                found: 'Invoice ccounting close not found'
              }
            }
          },
          recept: {
            comm: {
              method: {
                not: {
                  found: 'Invoice reception communication method not found'
                }
              }
            }
          },
          internal: {
            status: {
              not: {
                found: 'Invoice internal status not found'
              }
            }
          },
          batch: {
            not: {
              found: 'Invoice batch not found'
            }
          },
          channel: {
            not: {
              found: 'Invoice channel not found'
            }
          },
          seller: {
            centre: {
              not: {
                found: 'Seller centre not found'
              },
              roletype: {
                not: {
                  found: 'Seller centre role type not found'
                }
              }
            }
          },
          buyer: {
            centre: {
              not: {
                found: 'Buyer centre not found'
              },
              roletype: {
                not: {
                  found: 'Buyer centre role type not found'
                }
              }
            }
          },
          tax: {
            type: {
              not: {
                found: 'Invoice tax type not found'
              }
            },
            currency: {
              not: {
                found: 'Invoice tax currency not found'
              }
            }
          },
          user: {
            does: {
              not: {
                belong: {
                  to: {
                    party: 'he user from the request does not belong to the party of its seller tax id'
                  }
                }
              }
            }
          }
        },
        recadv: {
          integrated: {
            b2bintegration: 'Number of integrated B2B receipt advice'
          },
          status: {
            not: {
              found: 'Receipt advice status not found'
            }
          },
          validity: {
            document: {
              not: {
                found: 'Receipt advice validity document not found'
              }
            }
          },
          document: {
            format: {
              not: {
                found: 'Receipt advice document format not found'
              }
            }
          },
          centre: {
            not: {
              found: 'Receipt advice centre not found'
            }
          }
        },
        unexpected: {
          error: 'Unexpected error while processing the request or its document'
        },
        validation: {
          noDocumentType: 'Document type must be set',
          retry: 'Validations must be retried',
          invoicePeriodDates: 'The start date of the billing period must be before the end date',
          invoiceCorrectivePeriodDates: 'The start date of the rectification period must be before the end date',
          signature: 'The invoice is not signed',
          nif: 'Invalid cif',
          attachmentformat: 'Attachment type not allowed,only extensions are supported: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx, .zip, .msg',
          attachmentformat321: 'Attachment type not allowed,only extensions are supported: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx',
          error: 'Incorrect file format',
          party: {
            noTaxId: 'Tax Identification number must be set',
            noProject: 'service must be set',
            buyer: {
              notInProject: 'Buyer party does not exist in service or it is disable'
            },
            seller: {
              notInProject: 'Seller party does not exist in service or it is disable'
            },
            noSeller: 'Seller tax identification number must be set',
            noBuyer: 'Buyer tax identification number must be set',
            noRelation: 'There is not commercial relation between seller party and buyer party in service',
            noSponsor: 'The party is not sponsor in service',
            disabled: 'Party is disable',
            disabledInProject: 'Party is disable in service'
          },
          parties: {
            noSponsor: 'None of the parties are sponsor in service'
          },
          centre: {
            role: {
              type: 'The centre rol type is not valid in the invoice format'
            },
            noCentreCode: 'Centre code must be set',
            noParty: 'Party must be set',
            buyer: {
              notInParty: 'At least one of the buyer centers do not exist in party or they are disable'
            },
            seller: {
              notInParty: 'At least one of the seller centers do not exist in party or they are disable'
            },
            noCentreUnique: 'Centers must be unique'
          },
          document: {
            noDocument: 'Document must be set'
          },
          invoice: {
            currency: 'Exchange must be set',
            currencyExchange: 'Exchange rate must be set',
            currencyExchangeDate: 'Exchange rate date must be set',
            iban: 'The IBAN format is incorrect',
            ibanNull: 'IBAN must be set',
            registrationData: 'The commercial register data included in the invoice does not match the data registered in B2B',
            sequenceNumber: 'The order position is mandatory for the indicated orders',
            correctiveSign01pos: 'Corrective invoice of type Rectification Integra must be positive',
            correctiveSign02pos: 'Corrective invoice of type Rectification for differences must be positive',
            correctiveSign03pos: 'Corrective invoice of type Partial rectification due to discount for volume of operations must be positive',
            correctiveSign04pos: 'Corrective invoice of type Rectification authorized by the Tax Agency must be positive',
            correctiveSign01neg: 'Corrective invoice of type Rectification Integra must be negative',
            correctiveSign02neg: 'Corrective invoice of type Rectification for differences must be negative',
            correctiveSign03neg: 'Corrective invoice of type Partial rectification due to discount for volume of operations must be negative',
            correctiveSign04neg: 'Corrective invoice of type Rectification authorized by the Tax Agency must be negative',
            noInvoice: 'Invoices must be set',
            noInvoiceLine: 'Invoice lines empty',
            noInvoiceNumber: 'Invoice number must be set',
            noParty: 'Party must be set',
            noProject: 'service must be set',
            duplicate: 'Duplicate invoice',
            issuedate: 'The invoice date does not match the previous invoice received with the issue date {argumento}',
            dates: 'Operation date cannot be after issue date',
            noIssueDate: 'Issue date must be set',
            noOperationDate: 'Operation date must be set',
            noIssuerType: 'Sender type must be set',
            issuerType: 'Invalid sender type',
            issuerTypeError: 'There are needed more data to validate',
            noModalityType: 'The invoice modality does not correspond to one of the accepted values',
            modalityType: 'Invoice type must be individual',
            modalityTypeError: 'There are needed more data to validate',
            project: {
              notSender: 'The service lacks the emission role set for the invoice',
              notReceiver: 'The service lacks the reception role set for the invoice'
            },
            noRole: 'The invoice role (emission or reception) must be set',
            communication: {
              method: 'The invoice communication method is not set in its service'
            },
            lines: {
              total: {
                error: 'The total line without taxes does not match the product of the quantity per unit price',
                discountscharges: {
                  error: 'The total line with charges and discounts does not match the gross amount of the line'
                }
              }
            },
            total: {
              error: 'The total invoice without charges or general discounts does not match the sum of the total lines with discounts and charges',
              discountscharges: {
                error: 'The total invoice with general charges and discounts does not match the total invoice before taxes',
                taxes: {
                  error: 'The total of the invoice does not match the total of the invoice before taxes plus total taxes passed and less total taxes withheld'
                }
              }
            },
            totalexecutable: {
              error: 'The executable total of the invoice does not match the total to be paid less subsidies,advances and withholdings and more supplies and financial expenses'
            },
            accounting: {
              error: 'The invoice does not meet any of the accounting validations'
            }
          },
          recadv: {
            noRecadv: 'Recadv must be set',
            noRecadvNumber: 'Receipt advice number must be set',
            noSeller: 'Seller party must be set',
            noBuyer: 'Buyer party must be set',
            duplicate: 'Duplicate recadv'
          },
          cmr: {
            noCmr: 'Transport document must be set',
            noCmrNumber: 'Transport document number must be set',
            noSeller: 'Seller party must be set',
            noBuyer: 'Buyer party must be set',
            noshipfrom: 'Origin location must be set',
            noshipto: 'Destination location must be set',
            duplicate: {
              '': 'A transport document with the same number already exists in a correct state',
              issueyear: 'A transport document with the same number already exists in a correct state in the current year'
            },
          },
          sign: {
            noParty: 'Party must be set',
            noSign: 'Sender party has not sign document'
          },
          order: {
            noOrder: 'Order number must be set',
            noUnique: 'Order number must be unique',
            noOrderIssuer: 'The order issuer number is required',
            noUniqueIssuer: 'The issuer\'s order number must be unique on the invoice',
            invalidPatternIssuer: 'Issuer order number format is invalid',
            noPattern: 'The pattern is not configured',
            invalidPattern: 'The included order number does not comply with the format required by the recipient',
            error: 'There are needed more data to validate order number'
          },
          expediente: {
            noExp: 'Case number is required',
            noUnique: 'Case number must be unique',
            noPattern: 'The pattern is not configured',
            invalidPattern: 'The file number included does not comply with the format required by the recipient',
            error: 'There are needed more data to validate file number'
          },
          contract: {
            noContract: 'Contract number is required',
            invalidPattern: 'The contract number included does not comply with the format required by the recipient',
            noUnique: 'Contract number must be unique',
            noPattern: 'The pattern is not configured',
            error: 'There are needed more data to validate contract number'
          },
          transaction: {
            noTransaction: 'Receiver transaction number is required'
          },

          invoiceCorrective: {
            dates: 'Initial date and end date of tax period are invalid',
            number: 'Invoice number is required for invoices of type "Rectification complete" and "Rectification for differences',
            noNumber: 'Invoice number is required for rectification invoices',
            invalidPattern: 'The format of the rectified invoice number is not valid',
            noValue: 'No document with any value has been attached',
            noOrderValue: 'Must indicate the recipient s order',
			required: 'The corrective block is mandatory for a corrective invoice'
          },

          project: {
            disabled: 'service does not exist or it is disable',
            noProject: 'service must be set',
            attachment: {
              notfound: 'The attachments directory of the service\'s invoice to integrate does not exist'
            }
          },
          issue: {
            date: {
              future: 'The issue date is after its creation date',
              past: 'The issue date is before its creation date'
            }
          },
          commercial: {
            relation: {
              channel: 'The commercial relation between the seller,buyer and the channel does not exist'
            }
          },
          channel: {
            not: {
              found: 'The channel does not exist'
            }
          },
          invoiceNumber: {
            error: 'Invoice Number format validation could not be achieved: missing required data',
            noPattern: 'No Invoice Number pattern configured',
            invalidPattern: 'Invalid Invoice Number format'
          },
          b2bvalidationws: {
            nourl: 'The URL couldn\'t be found or it is invalid',
            metadataerror: 'An error occurred attempting to get the invoice\'s metadata file',
            connectionerror: 'An error occurred during the conversation with client\'s web service.',
            wrongresponse: 'The client\'s web service returned a wrong response.',
            errorresponse: 'The client\'s web service returned an ERROR response.'
          }
        },
        invalid: {
          validation: {
            code: {
              exception: 'One or more validation codes lack a linked validation method'
            }
          },
          persontypecode: 'An error ocurred creating the party. Invalid person type code',
          name: {
            format: 'Invalid party name,characters must be in utf8'
          },
          facturae32: {
            xml: {
              format: 'The format of the Facturae 3.2 invoice file is not correct or .xml'
            },
            schema: 'The Facturae 3.2 invoice has fields which doesn\'t pass its schema validation: {0}'
          },
          facturae321: {
            xml: {
              format: 'The format of the Facturae 3.2.1 invoice file is not correct or .xml'
            },
            schema: 'The Facturae 3.2.1 invoice has fields which doesn\'t pass its schema validation: {0}'
          },
          facturae322: {
            xml: {
              format: 'The format of the Facturae 3.2.2 invoice file is not correct or .xml'
            },
            schema: 'The Facturae 3.2.2 invoice has fields which doesn\'t pass its schema validation: {0}'
          },
          facturapdf: {
            xml: {
              format: 'The format of the PDF invoice file is not correct or .xml'
            },
            schema: 'The PDF invoice has fields which doesn\'t pass its schema validation: {0}'
          },
          edi: {
            date: {
              format: 'El formato de la fecha no es correcto'
            }
          },
          facturad01b: {
            edi: {
              format: 'The format of the invoice file is not correct or .edi'
            }
          },
          facturad93a: {
            edi: {
              format: 'The format of the invoice file is not correct or .edi'
            }
          },
          facturad96a: {
            edi: {
              format: 'The format of the invoice file is not correct or .edi'
            }
          },
          facturad97a: {
            edi: {
              format: 'The format of the invoice file is not correct or .edi'
            }
          },
          fatturapa12: {
            xml: {
              format: 'The format of the fatturapa12 file is not correct or .xml'
            },
            schema: 'The fatturapa12 invoice has fields which doesn\'t pass its schema validation: '
          },
          recadv: {
            xml: {
              format: 'The format of the receipt advice file is not correct or .xml'
            },
            schema: 'The receipt advice has fields which doesn\'t pass its schema validation: '
          },
          fatturapaSemplificata1: {
            xml: {
              format: 'The format of the fatturapa simplify invoice file is not correct or .xml'
            },
            schema: 'The fatturapa simplify invoice has fields which doesn\'t pass its schema validation: '
          },
          fatturapa12cades: {
            xml: {
              format: 'The format of the fatturapa12 cades invoice file is not correct or .xml'
            },
            schema: 'The fatturapa12 cades invoice has fields which doesn\'t pass its schema validation: '
          },
          fatturapaSemplificatacades: {
            xml: {
              format: 'The format of the fatturapa simplify cades invoice file is not correct or .xml'
            },
            schema: 'The fatturapa simplify cades invoice has fields which doesn\'t pass its schema validation: '
          }
        },
        unable: {
          to: {
            save: {
              file: {
                in: {
                  repository: 'File cannot be save'
                }
              }
            },
            get: {
              repository: {
                file: 'An error occurred getting the file'
              }
            },
            delete: {
              repository: {
                file: 'File cannot be deleted'
              }
            }
          }
        },
        no: {
          repository: {
            date: 'It is needed a date to save the file',
            project: {
              name: 'It is needed a service name to save the file'
            },
            file: 'File must be set to save it',
            subpath: 'Subpath must be set to save the file'
          },
          file: {
            to: {
              save: {
                extension: 'File extension must be set to save the file'
              }
            }
          },
          pathcomplete: {
            flag: 'Path complete must be set to save the file'
          }
        },
        repository: {
          path: {
            not: {
              found: 'Path not found to save the file'
            }
          }
        },
        missing: {
          required: {
            party: {
              data: 'An error ocurred creating the party. Party data must be set (CIF,name and country)',
              commercial: {
                relation: {
                  data: 'Party commercial relation data missing'
                }
              },
              media: {
                value: 'Party media value must be set',
                type: 'Party media type must be set',
                to: {
                  delete: 'An error ocurred deleting party media. Party media missing'
                }
              }
            },
            partyproject: 'An error ocurred creating the party. service must be set',
            projectparty: {
              data: 'service party data missing',
              role: 'Party roles must be set',
              role_required: 'Party roles are required to be set',
              enable: 'service active flag must be set'
            },
            communicationmethod: {
              data: 'arty communication method data missing'
            },
            partycentre: {
              roletype: {
                data: 'Centre rol data missing'
              }
            },
            centre: {
              role: 'Centre roles missing',
              data: 'Centre data missing',
              media: {
                value: 'Centre media value must be set',
                type: 'Centre media type must be set',
                to: {
                  delete: 'An error ocurred deleting centre media. Centre media missing'
                }
              }
            },
            invoice: {
              note: {
                media: {
                  value: 'Invoice media value must be set',
                  type: 'Invoice media type must be set',
                  default: {
                    flag: 'Invoice media value default must be set'
                  },
                  role: 'Invoice media role must be set'
                },
                issue: {
                  date: 'Missing required invoice issue date'
                },
                document: {
                  name: 'Missing required invoice note document name',
                  format: 'Missing required invoice note document format',
                  type: 'Missing required invoice note docuyment type'
                },
                recadv: {
                  data: 'Missing required invoice note receipt advice data'
                }
              },
              integration: {
                file: {
                  '': 'Invoice file missing',
                  extension: 'Missing required invoice integration file extension',
                  size: 'Missing required invoice integration file size'
                }
              },
              project: 'Invoice service missing',
              seller: {
                '': 'Invoice seller party not found',
                centre: {
                  code: 'Missing required invoice seller centre code'
                }
              },
              buyer: {
                '': 'Invoice buyer party not found',
                centre: {
                  code: 'Missing required invoice buyer centre code'
                }
              },
              number: 'Invoice number missing',
              sender: 'Invoice sender party missing',
              receiver: 'Invoice receiver party missing',
              status: 'Invoice status missing',
              document: {
                format: 'Missing required invoice document format',
                class: 'Missing required invoice document class',
                type: 'Missing required invoice document type'
              },
              validity: {
                document: 'Missing required invoice validity document'
              },
              correctedflag: 'Missing required invoice corrected flag',
              metadata: {
                file: {
                  extension: 'Missing required invoice metadata file extension'
                }
              },
              attachment: {
                extension: 'Missing required invoice attachment extension'
              },
              tax: {
                type: 'Missing required invoice tax tyoe',
                baseamount: 'Missing required invoice tax base amount',
                currency: 'Missing required invoice tax currency'
              },
              event: 'Missing required invoice event',
              property: {
                '': 'Missing required invoice property',
                value: 'Missing required invoice property value'
              },
              outstanding: {
                amount: 'Missing required invoice outstanding amount'
              },
              executable: {
                amount: 'Missing required invoice executable amount'
              },
              communication: {
                reception: {
                  name: 'Missing required communication reception name'
                }
              }
            },
            media: {
              type: 'Media type must be set'
            },
            centremedia: {
              project: 'Centre service must be set',
              role: 'Centre media rol must be set'
            },
            partymedia: {
              role: 'Party media role must be set'
            },
            request: {
              compressed: {
                invoice: {
                  flag: 'No se ha indicado si el fichero de la factura de la petición está comprimido o no'
                }
              },
              invoice: {
                file: 'No se ha incluido un fichero de factura en la petición'
              }
            }
          },
          update: {
            party: {
              taxid: 'An error ocurred updating the party. Tax identification number must be set'
            }
          },
          search: {
            party: {
              taxid: 'An error ocurred searching the party. Tax identification number must be set'
            }
          },
          commercial: {
            relation: {
              partytaxid: 'Tax identification number must be set',
              role: 'Party role must be set'
            }
          },
          recadv: {
            integration: {
              file: {
                '': 'Missing required receipt advice integration file',
                extension: 'Missing required receipt advice file extension'
              }
            },
            status: 'Missing required receipt advice status',
            number: {
              exception: 'Missing required receipt advice number'
            },
            receiving: {
              date: {
                time: {
                  extension: 'Missing required receipt advice receiving date'
                }
              }
            },
            validity: {
              document: 'Missing required receipt advice validity document'
            },
            document: {
              format: 'Missing required receipt advice document format'
            },
            centre: 'Missing required receipt advice centre'
          },
          request: {
            compressed: {
              invoice: {
                flag: 'Missing required request compressed invoice flag'
              }
            },
            invoice: {
              file: 'Missing required request invoice file'
            }
          }
        },
        party: {
          not: {
            found: 'Party not found'
          },
          project: {
            not: {
              found: 'Service not found or it is disable'
            }
          },
          to: {
            delete: {
              not: {
                found: 'Party not found'
              }
            }
          },
          commercial: {
            relation: {
              channel: {
                not: {
                  found: 'Party channel not found'
                }
              }
            }
          },
          deletion: 'An error ocurred deleting the party',
          country: {
            not: {
              found: 'Party country not found'
            }
          },
          media: {
            type: {
              not: {
                found: 'Party media type not found'
              }
            },
            deletion: 'An error ocurred deleting party media',
            to: {
              delete: {
                not: {
                  found: 'An error ocurred deleting party media. Party media not found'
                }
              }
            },
            invalid: {
              email: {
                format: 'Party media email invalid'
              }
            }
          }
        },
        commercial: {
          relation: {
            party: {
              not: {
                found: 'Party commercial relation not found or it is disable'
              }
            }
          }
        },
        incompatible: {
          integrated: {
            party: {
              for: {
                commercial: {
                  relation: 'Invalid party,missing valid role'
                }
              }
            }
          },
          centre: {
            role: 'Invalid centre rol',
            media: {
              data: {
                role: 'Invalid centre role'
              }
            }
          },
          party: {
            media: {
              data: {
                role: 'Invalid party role'
              }
            }
          }
        },
        communication: {
          method: {
            not: {
              found: 'Party communication method not found'
            }
          }
        },
        centre: {
          role: {
            type: {
              not: {
                found: 'Centre rol not found'
              }
            }
          },
          to: {
            delete: {
              not: {
                found: 'Centre not found'
              }
            }
          },
          deletion: 'An error ocurred deleting the centre',
          party: {
            not: {
              found: 'Centre party not found'
            }
          },
          not: {
            found: 'Centre not found'
          },
          country: {
            not: {
              found: 'Centre country not found'
            }
          },
          media: {
            type: {
              not: {
                found: 'Centre media type not found'
              }
            },
            deletion: 'An error ocurred deleting centre media',
            to: {
              delete: {
                not: {
                  found: 'An error ocurred deleting centre media. Centre media not found'
                }
              }
            },
            invalid: {
              email: {
                format: 'Centre media email invalid'
              }
            }
          }
        },
        media: {
          type: {
            not: {
              found: 'No se encontró el canal de contacto especificado'
            }
          }
        },
        centremedia: {
          project: {
            not: {
              found: 'Centre service not found'
            }
          }
        },
        duplicate: {
          partymedia: {
            value: 'Duplicate party media'
          },
          centremedia: {
            value: 'Duplcate centre media'
          }
        },
        recadvLine: {
          currency: {
            not: {
              found: 'Receipt advice line currency not found'
            }
          },
          unitOfMeasure: {
            notFound: 'Receipt advice line unit of measure not found'
          }
        },
        document: {
          generation: {
            format: {
              class: {
                not: {
                  found: 'Mapping class of the document format not found'
                }
              }
            }
          }
        },
        unzipped: {
          request: {
            invoice: {
              file: 'The invoice request is configured to carry only one zipped invoice file,but it has an unzipped one'
            },
            attachments: 'The invoice request is configured to carry only zipped attachments,but it has only an unzipped one'
          }
        },
        zipped: {
          request: {
            invoice: {
              file: 'The invoice request is configured to carry only one unzipped invoice file,but it has a zipped one'
            },
            attachments: 'The invoice request is configured to carry only one unzipped attachment,but the request has one or more zipped'
          }
        },
        different: {
          invoice: {
            number: 'The invoice number from the request is different of the one extracted from the attached invoice file'
          },
          seller: {
            tax: {
              identification: {
                number: 'The seller tax id from the request is different of the one extracted from the attatached invoice file'
              }
            }
          }
        }
      }
    }
  },
  // Errores/mensajes en Integración de factura

  translation: {
    instances: {
      added: 'Added translation of instances'
    },
    processingtime: 'Duration in complete the translation'
  },
  error_code: {
    document: {
      entrieszip: {
        '': 'Failed to unpack the zip',
        format: {
          invalid: 'Uncorrect input file structure/format'
        }
      },
      attachments: {
        directory: {
          name: {
            invalid: 'The attachments directory name is invalid'
          }
        }
      },
      file: {
        name: {
          invalid: 'The name of one of the input files is invalid'
        },
        format: 'Error in the input file format'
      },
      read: {
        country: 'Error reading the file,you can not determine the country'
      }
    },
    ai: {
      translationfail: 'Error translating file with AI'
    },
    ruleinformation: {
      notfound: 'Rule not found'
    }
  },
  EXTRACTION_INVOICE: {
    ERROR: 'Error occurred when extracting invoice from compressed file'
  },
  EXTRACTION_ATTACHMENT: {
    ERROR: 'Error occurred when extracting attachments from compressed file'
  },
  TRANSLATION_MAP: {
    ERROR: 'Error occurred when applying the map to the invoice'
  },
  SIGNATURE: {
    '': 'Stage of signature of the file',
    ERROR: 'Error occurred when signing the invoice'
  },
  signature: {
    sax: {
      exception: {
        parsing: {
          document: 'Error occurred when signing the invoice,incorrect format'
        }
      }
    },
    signature: {
      exception: {
        signing: 'Error occurred when signing the invoice'
      }
    }
  },
  RECOGNITION: {
    '': 'Stage of recognition of the input file',
    ERROR: 'Error occurred when recognizing the file'
  },
  vltrader: {
    senddt: 'Sending date',
    sender: {
      host: 'Host',
      mailbox: 'Mailbox'
    },
    sendid: 'Sending identifier',
    totalattempts: 'Attempts number',
    transfer: {
      enddt: 'End of sending date',
      resulttext: 'Sending result',
      startdt: 'Start sending date',
      status: 'Sending result status',
      transferid: 'Delivery identifier'
    }
  },
  wsserver: {
    profile: 'Profile',
    requestid: 'Request identifier'
  },
  DUPLICATED_INVOICE_ERROR: 'Error for duplicate invoice',
  EDICOM_CDR_NEGATIVE: 'CDR negative',
  996: '996',
  CIF_REQUIRED: 'Error for duplicate invoice',
  ACTION_REQUIRED: 'The action is a required field',
  DESCRIPTION_REQUIRED: 'The description is a required field',
  CANAL_REQUIRED: 'The channel is a required field',
  EMAIL_REQUIRED: 'The email is a required field',
  PARTY_BUYER_NOTFOUND: 'The buyer party does not exist',
  PROJECT_PARTY_DISABLED: 'The party is disabled for the indicated service',
  PARTY_DISABLED: 'The party is disabled',
  COMMUNICATION_METHOD_NOTFOUND: 'The communication method of does not exist',
  EMAIL_INVALID: 'The email is incorrect',
  ACTION_UNEXPECTED: 'The action is incorrect',
  READ_FILE_BUYERS_ERROR: 'Unexpected error reading recruitment file of buyer parties',
  UPDATE_PARTY_ERROR: 'Failed to update the data of the party',
  CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Error creating delivery method associated with the party',
  CREATE_PARTY_MEDIA_ERROR: 'Error creating the email associated with the buyer party',
  CREATE_USER_PARTY_ERROR: 'Error creating the user associated with the buyer party',
  CREATE_PARTY_ERROR: 'Failed to create the client company',
  CREATE_USER_ERROR: 'Failed to create the user',
  CREATE_PROJECT_PARTY_ERROR: 'Error creating the relation between the service and the party',
  CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Error al crear la relación comercial entre la empresa sponsor y la empresa cliente',
  EDICOM_ACK_NEGATIVE: 'ACK negative',
  NO_PERSON_CODE_VALID: 'Person code is not valid',
  PARTY_NIF_EXIST: 'Party NIF already exists',
  PARTY_GLN_EXIST: 'Party GLN already exists',
  WITHOUT_DATA_REQUIRED: 'Missing required data',
  WITHOUT_DATA_REQUIRED_INVALID: 'Missing required data or invalid data',
  LOGO_ERROR: 'Logo error',
  MIME_TYPE_LOGO_ERROR: 'Logo type error',
  FILE_BASE64_ERROR: 'Error in Base64 file',
  NO_COUNTRY_CODE_VALID: 'The country code is not valid',
  CENTRE_ERROR: 'Centre error',
  COMMUNICATION_METHOD_ERROR: 'Communication method error',
  EMAIL_ERROR: 'Email error',
  PARTY_USER_ERROR: 'Party user error',
  PROJECT_PARTY_NIF_NOT_EXIST: 'There is no company with this NIF',
  CREATED: 'Created',
  DELETED: 'Deleted',
  UPDATED: 'Updated',
  EDICOM_CDR_POSITIVE: 'CDR positive',
  CENTRE_NOT_EXIST: 'There is no center',
  USER_EXIST: 'User already exists',
  USER_NOT_EXIST: 'User does not exist',
  USER_NOT_LOCKED: 'User not locked',
  USER_NOT_REMOVED: 'User not removed',
  USER_NOT_PROJECT: 'The user is not from the service',
  USER_NIF_EXIST: 'User NIF already exists',
  PROJECT_NOSENDER: 'Error delivery method. Service isn\'t sender',
  SELLER_NOSPONSOR: 'Error delivery method. Party isn\'t sponsor.',
  PROJECT_NO_DELIVERY_METHOD: 'Delivery method not found in the service.',

  // Códigos para propiedades de auditorías
  invoice: {
    integrated: {
      b2bintegration: 'Number of integrated B2B invoice',
      ws: 'Number of integrated webservice invoice',
      upload: 'Number of integrated invoice'
    },
    note: {
      media: {
        type: {
          not: {
            found: 'Invoice media type not found'
          }
        },
        invalid: {
          email: {
            format: 'Invoice media email invalid'
          }
        }
      },
      document: {
        not: {
          found: 'Invoice note document not found'
        }
      },
      recadv: {
        not: {
          found: 'Invoice note receipt advice not found'
        }
      },
      attachment: {
        category: {
          not: {
            found: 'Invoice note attachment category not found'
          }
        },
        user: {
          not: {
            found: 'Invoice note attachment user not found'
          }
        }
      }
    },
    project: {
      not: {
        found: 'Invoice service not found'
      },
      category: {
        not: {
          found: 'Invoice service category not found'
        }
      }
    },
    sender: {
      not: {
        found: 'Invoice party sender not found'
      }
    },
    receiver: {
      not: {
        found: 'Invoice party receiver not found'
      }
    },
    thirdparty: {
      not: {
        found: 'Invoice third party not found'
      }
    },
    status: {
      not: {
        found: 'Invoice status not found'
      }
    },
    currency: {
      not: {
        found: 'Invoice currency not found'
      }
    },
    document: {
      format: {
        not: {
          found: 'Invoice document format not found'
        }
      },
      class: {
        not: {
          found: 'Invoice document class not found'
        }
      },
      type: {
        not: {
          found: 'Invoice document type not found'
        }
      }
    },
    type: {
      not: {
        found: 'Invoice type not found'
      }
    },
    validity: {
      document: {
        not: {
          found: 'Invoice validity document not found'
        }
      }
    },
    communication: {
      method: {
        not: {
          found: 'Invoice communication method not found'
        }
      }
    },
    auditdocument: {
      not: {
        found: 'Invoice audit document not found'
      }
    },
    accounting: {
      close: {
        not: {
          found: 'Invoice ccounting close not found'
        }
      }
    },
    recept: {
      comm: {
        method: {
          not: {
            found: 'Invoice reception communication method not found'
          }
        }
      }
    },
    internal: {
      status: {
        not: {
          found: 'Invoice internal status not found'
        }
      }
    },
    batch: {
      not: {
        found: 'Invoice batch not found'
      }
    },
    channel: {
      not: {
        found: 'Invoice channel not found'
      }
    },
    seller: {
      centre: {
        not: {
          found: 'Seller centre not found'
        },
        roletype: {
          not: {
            found: 'Seller centre role type not found'
          }
        }
      }
    },
    buyer: {
      centre: {
        not: {
          found: 'Buyer centre not found'
        },
        roletype: {
          not: {
            found: 'Buyer centre role type not found'
          }
        }
      }
    },
    tax: {
      type: {
        not: {
          found: 'Invoice tax type not found'
        }
      },
      currency: {
        not: {
          found: 'Invoice tax currency not found'
        }
      }
    },
    user: {
      does: {
        not: {
          belong: {
            to: {
              party: 'The user from the request does not belong to the party of its seller'
            }
          }
        }
      }
    }
  },
  recadv_code: {
    integrated: {
      b2bintegration: 'Number of integrated B2B receipt advice'
    },
    status: {
      not: {
        found: 'Receipt advice status not found'
      }
    },
    validity: {
      document: {
        not: {
          found: 'Receipt advice validity document not found'
        }
      }
    },
    document: {
      format: {
        not: {
          found: 'Receipt advice document format not found'
        }
      }
    },
    centre: {
      not: {
        found: 'Receipt advice centre not found'
      }
    }
  },
  unexpected: {
    error: 'Unexpected error while processing the request or its document'
  },
  FACTURAE_INVALID: 'Invoice malformed',
  validation: {
    noDocumentType: 'Document type must be set',
    retry: 'Validations must be retried',
    invoicePeriodDates: 'The start date of the billing period must be before the end date',
    invoiceCorrectivePeriodDates: 'The start date of the rectification period must be before the end date',
    signature: 'The invoice is not signed',
    nif: 'Invalid cif',
    attachmentformat: 'Attachment type not allowed,only extensions are supported: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx, .zip, .msg',
    attachmentformat321: 'Attachment type not allowed,only extensions are supported: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx',
    error: 'Incorrect file format',
    invoicedocument: 'The "value" field of the document type "Sequence number / line" must be of numeric type',
    ep: {
      errorclientnoepcanarias: 'To bill for services in the Canary Islands, check both permanent establishment indicators.',
      errorclientnoepceuta: 'To bill for services in the Ceuta, check both permanent establishment indicators.',
      clientepproveedorpencanarias: 'To bill services in the Peninsula, uncheck the indicator for your permanent establishment in the Canary Islands.',
      clientepproveedorpenceuta: 'To bill services in the Peninsula, uncheck the indicator for your permanent establishment in Ceuta.',
      clientepproveedornocanarias: 'To bill services in the Canary Islands, check the indicator of your permanent establishment.',
      clientepproveedornoceuta: 'To bill services in the Ceuta, check the indicator of your permanent establishment.',
      clientecanariasceuta: 'To invoice services in the Canary Islands, uncheck the box for your permanent establishment in Ceuta.',
      errorclientnoepceutacanarias: 'To invoice services in Ceuta, uncheck the box for your permanent establishment in the Canary Islands.'
    },
    buyer: {
      address: "The residence type identification is not correct for the buyer company.",
      noAddress: 'There is no address for the buyer company',
      noCountry: 'There is no country for the buyer company',
      noPostCode: 'There is no postal code for the buyer company',
      invalidPostCode: 'The postal code assigned to the buyer company must not have less than 5 digits',
      noProvince: 'There is no province for the buyer company',
      noTown: 'There is no town for the buyer company',
      centres: {
        rol: 'No buyer party\'s centre have been included for the required role type: {argumento}',
        rolbyvalues: 'No buyer party\'s centre have been included for the required role type: {argumento}',
        roletype: {
          notfound: 'The centre role type to validate for the buyer party\'s does not exist: {argumento}'
        }
      }
    },
    buyerCentre: {
      noAddress: 'There is no address for the buyer centre.',
      noCountry: 'There is no country for the buyer centre',
      noPostCode: 'There is no postal code for the buyer centre',
      invalidPostCode: 'The postal code assigned to the buyer centre must not have less than 5 digits',
      noProvince: 'There is no province for the buyer centre',
      noTown: 'There is no town for the buyer centre'
    },
    seller: {
      address: "The residence type identification is not correct for the seller company.",
      noAddress: 'There is no address for the seller company',
      noCountry: 'There is no country for the seller company',
      noPostCode: 'There is no postal code for the seller company',
      invalidPostCode: 'The postal code assigned to the seller company must not have less than 5 digits',
      noProvince: 'There is no province for the seller company',
      noTown: 'There is no town for the seller company',
      centres: {
        rol: 'No seller party\'s centre have been included for the required role type: {argumento}',
        rolbyvalues: 'No seller party\'s centre have been included for the required role type: {argumento}',
        roletype: {
          notfound: 'The centre role type to validate for the seller party\'s does not exist: {argumento}'
        }
      }
    },
    sellerCentre: {
      noAddress: 'There is no address for the seller centre.',
      noCountry: 'There is no country for the seller centre',
      noPostCode: 'There is no postal code for the seller centre',
      invalidPostCode: 'The postal code assigned to the seller centre must not have less than 5 digits',
      noProvince: 'There is no province for the seller centre',
      noTown: 'There is no town for the seller centre'
    },
    party: {
      noTaxId: 'Tax Identification number must be set',
      noProject: 'Service must be set',
      buyer: {
        notInProject: 'Buyer party does not exist in service or it is disable',
        invalidName: 'The name of the buyer party is incorrect, it must match the regular expression {argumento}\nIt should be {argumento1}',
        addressvalue: 'The address of the recipient of the invoice is not valid, it must be Paseo Conde de los Gaitanes n 177 for invoices from the peninsula, or Calle Juan de Quesada n 9 for invoices from the Canary Islands.'
      },
      seller: {
        notInProject: 'Seller party does not exist in service or it is disable',
        invalidName: 'The name of the seller party is incorrect, it must match the regular expression {argumento}\nIt should be {argumento1}'
      },
      noSeller: 'Seller tax identification number must be set',
      noBuyer: 'Buyer tax identification number must be set',
      noRelation: 'There is not commercial relation between seller party and buyer party in service',
      noSponsor: 'The party is not sponsor in service',
      disabled: 'Party is disable',
      disabledInProject: 'Party is disable in service',
      invalidExpresion: 'The regular expression to validate the company name with NIF {argumento} is not correct'
    },
    parties: {
      noSponsor: 'None of the parties are sponsor in service'
    },
    centre: {
      role: {
        type: 'The centre role type is not valid in the invoice format'
      },
      roletype: {
        notfound: 'The selected centre role type does not exist'
      },
      noCentreCode: 'Centre code must be set',
      noParty: 'Party must be set',
      buyer: {
        notInParty: 'At least one of the buyer centers do not exist in party or they are disable'
      },
      seller: {
        notInParty: 'At least one of the seller centers do not exist in party or they are disable'
      },
      noCentreUnique: 'Centers must be unique'
    },
    document: {
      noDocument: 'Document must be set'
    },
    phisical: {
      gln: 'Physical mailbox required'
    },
    schematron: {
      error: 'Error in invoice validation: {argumento}'
    },
    kosit: {
      error: 'Error in invoice validation: {argumento}'
    },
    invoice: {
      currency: 'Exchange must be set',
      currencyExchange: 'Exchange rate must be set',
      currencyExchangeDate: 'Exchange rate date must be set',
      iban: 'The IBAN format isincorrect',
      ibanNull: 'IBAN must be set',
      registrationData: 'The commercial register data included in the invoice does not match the data registered in B2B',
      sequenceNumber: 'The order position is mandatory for the indicated order{argumento}',
      correctiveSign01pos: 'Corrective invoice of type Rectification Integra must be positive',
      correctiveSign02pos: 'Corrective invoice of type Rectification for differences must be positive',
      correctiveSign03pos: 'Corrective invoice of type Partial rectification due to discount for volume of operations must be positive',
      correctiveSign04pos: 'Corrective invoice of type Rectification authorized by the Tax Agency must be positive',
      correctiveSign01neg: 'Corrective invoice of type Rectification Integra must be negative',
      correctiveSign02neg: 'Corrective invoice of type Rectification for differences must be negative',
      correctiveSign03neg: 'Corrective invoice of type Partial rectification due to discount for volume of operations must be negative',
      correctiveSign04neg: 'Corrective invoice of type Rectification authorized by the Tax Agency must be negative',
      noInvoice: 'Invoices must be set',
      noInvoiceLine: 'Invoice lines empty',
      noInvoiceNumber: 'Invoice number must be set',
      noParty: 'Party must be set',
      noProject: 'Service must be set',
      duplicate: 'Duplicate invoice {argumento}',
      issuedate: 'The invoice date does not match the previous invoice received with the issue date {argumento}',
      dates: 'Operation date cannot be after issue date',
      invalidOperationDate: 'The operation date cannot be later than day {argumento} ({argumento1} days and {argumento2} months from the date of issue)',
      invalidOperationDateEnd: 'The operation date cannot be later than day {argumento} (Last day of the month {argumento2} from the date of issue)',
      invalidInvoicingPeriod: 'The final date of the billing period cannot be later than {argumento} ({argumento1} days and {argumento2} months from the date of issue)',
      invalidInvoicingPeriodEnd: 'The final date of the billing period cannot be later than {argumento} (Last day of the month {argumento2} from the date of issue)',
      invalidWithholdingAmount: 'The warranty retention should be {argumento}',
      invalidNegativeWithholdingAmount: 'The withholding in guarantee must be positive',
      simultaneousTransactionAndContract: 'The invoice cannot indicate both contract and transaction at the same time; it must indicate exactly one of the two',
      contractNotFoundRecadv: 'No certification/receipt with number has been found {argumento}, status {argumento1} for supplier, customer and order specified in the invoice  ',
      recadvNotFound: 'The receipt {argumento} for line {argumento1} is not published by the buyer, or is not in a billable state.',
      contractNotFound: 'Must indicate certification/reception, line {argumento}',
      duplicateContractFoundRecadv: 'More than one reception has been found.',
      orderNotFound: 'Must indicate order, line {argumento}',
      orderContractNotFound: 'Must indicate order and certification/receipt, line {argumento}',
      differentOrder: 'The order indicated in the file ({argumento}) does not correspond to the registered one ({argumento1})',
      currencyNotEur: 'Only invoices in euros are accepted',
      igicNotInCanary: 'The invoice includes IGIC tax: \n {argumento} \n {argumento1}',
      ipsiNotInCeuta: 'The invoice includes IPSI tax: \n {argumento} \n {argumento1}',
      tooMuchAttachments: 'The invoice exceeds the maximum configured attachment files ({argumento} file/s)',
      notAllowedAttachedExtension: 'The attachment extension is not allowed. Extensions allowed: {argumento}',
      taxesNotInProject: 'The following taxes are not included in the service: {argumento}',
      taxRateNotRegistered: 'For the tax {argumento}, only the following rates (%) are allowed: {argumento1} ',
      notAllowedFileFormat: 'The file format ({argumento}) is not allowed. Allowed formats: {argumento1}',
      noIssueDate: 'Issue date must be set',
      noOperationDate: 'Operation date must be set',
      noIssuerType: 'Sender type must be set',
      issuerType: 'Invalid sender type',
      issuerTypeError: 'There are needed more data to validate',
      noModalityType: 'The invoice modality does not correspond to one of the accepted values',
      modalityType: 'Invoice type must be individual',
      modalityTypeError: 'There are needed more data to validate',
      taxCeroLegalText: 'For tax 0 you must inform a legal text',
      specificCanary: 'Specific validation of the Canary Islands, positive VAT',
      specificCeuta: 'Specific validation of Ceuta, positive VAT',
      noIgicIva: 'The invoice cannot have IGIC, IPSI or VAT as taxes at the same time',
      exitsPaymentDetails: 'The invoice does not contain a payment method',
      receiverTransactionReferenceNotFound: 'The invoice {argumento} does not contain an order number in either the header or the lines',
      documentValuesRecadv: 'Line {argumento}. The {argumento1} \'{argumento2}\' does not match the one indicated at reception',
      documentValuesRecadvDeliveryNote: 'Line {argumento}. The {argumento1} \'{argumento2}\' on the receipt does not match the ones indicated on the invoice',
      lineDataFromRecadv: 'Line {argumento}. The order line: {argumento1} does not match any line on the receipt',
      lineDataFromRecadvValue: 'Line {argumento}. {argumento1}: {argumento2}, does not correspond to the line received',
      lineDataFromRecadvTax: 'Line {argumento}. The tax with type {argumento1} and percentage {argumento2} does not match the line on the receipt',
      project: {
        notSender: 'The service lacks the emission role set for the invoice',
        notReceiver: 'The service lacks the reception role set for the invoice'
      },
      noRole: 'The invoice role (emission or reception) must be set',
      communication: {
        method: 'The invoice communication method is not set in its service'
      },
      lines: {
        invalidOperationDate: 'Line number {argumento3}. The operation date cannot be later than day {argumento} ({argumento1} days and {argumento2} months from the date of issue)',
        invalidOperationDateEnd: 'Line number {argumento3}. The operation date cannot be later than day {argumento} (Last day of the month {argumento2} from the date of issue)',
        invalidInvoicingPeriod: 'Line number {argumento3}. The final date of the billing period cannot be later than {argumento} ({argumento1} days and {argumento2} months from the date of issue)',
        invalidInvoicingPeriodEnd: 'Line number {argumento3}. The final date of the billing period cannot be later than {argumento} (Last day of the month {argumento2} from the date of issue)',
        total: {
          error: 'The total line without taxes does not match the product of the quantity per unit price',
          discountscharges: {
            error: 'The total line with charges and discounts does not match the gross amount of the line'
          }
        },
        positive: 'Prices and quantities must be positive',
        negative: 'All prices must be negative and quantities positive',
        sametax: 'The invoice cannot contain the same tax on the same line',
        totalPositive: 'The total amount of the invoice must be positive'
      },
      total: {
        error: 'The total invoice without charges or general discounts does not match the sum of the total lines with discounts and charges',
        discountscharges: {
          error: 'The total invoice with general charges and discounts does not match the total invoice before taxes',
          taxes: {
            error: 'The total of the invoice does not match the total of the invoice before taxes plus total taxes passed and less total taxes withheld'
          }
        },
        taxes: {
          error: 'The total of taxes reported does not match the sum of the taxes'
        }
      },
      totalexecutable: {
        error: 'The executable total of the invoice does not match the total to be paid less subsidies,advances and withholdings and more supplies and financial expenses'
      },
      accounting: {
        error: 'The invoice does not meet any of the accounting validations'
      },
      centre: {
        mask: 'Invalid center mask',
        rol: 'Invalid center role'
      },
      corrective: {
        method: 'Correction method {argumento} not supported by the recipient of the corrective invoice'
      },
      buyer: {
        centre: 'Buyer center not informed'
      },
      noOrder: 'Order number must be set in the reception line',
      order: {
        noLine: 'Order {argumento} included in the reception line not found',
        missingData: 'Mandatory data is missing on one or more lines of the order {argumento}'
      },
      recadv: {
        additionalInfo: 'The value {argumento} of the property {argumento1} is not found in the additional information on the invoice.',
        noAdditionalInfo: 'The invoice does not contain the additional information from the receipt {argumento}',
        additionalInfoNoProperty: 'The property {argumento1} has not been included in the additional information for the reception {argumento}.',
        noData: 'No information has been included in the reception {argumento}'
      }
    },
    recadv: {
      noRecadv: 'Recadv must be set',
      noRecadvNumber: 'Receipt advice number must be set',
      noSeller: 'Seller party must be set',
      noBuyer: 'Buyer party must be set',
      duplicate: 'Duplicate recadv'
    },
    sign: {
      noParty: 'Party must be set',
      noSign: 'Sender party has not sign document'
    },
    order: {
      noOrder: 'Order number must be set',
      noUnique: 'Order number must be unique',
      noOrderIssuer: 'The order issuer number is required',
      noUniqueIssuer: 'The issuer\'s order number must be unique on the invoice',
      invalidPatternIssuer: 'Issuer order number format is invalid',
      noPattern: 'The pattern is not configured',
      invalidPattern: 'The included order number does not comply with the format required by the recipient',
      error: 'There are needed more data to validate order number'
    },
    documentCycle: {
      noOrder: 'Insufficient order information included',
      orderResponseRequired: 'You cannot generate the delivery note if the order is not previously accepted',
      order: {
        type: {
          noParams: 'The cycle class is incorrect, you must indicate additional parameters indicating the type and subtype to validate'
        },
        invalid: {
          type: 'Cannot create an invoice from this order, it must have the type "{argumento}"',
          subtype: 'Cannot create an invoice from this order, it must have the subtype "{argumento}"'
        }
      }
    },
    expediente: {
      noExp: 'Case number is required',
      noUnique: 'Case number must be unique',
      noPattern: 'The pattern is not configured',
      invalidPattern: 'The file number included does not comply with the format required by the recipient',
      error: 'There are needed more data to validate file number'
    },
    contract: {
      noContract: 'Contract number is required',
      invalidPattern: 'The contract number included does not comply with the format required by the recipient',
      noUnique: 'Contract number must be unique',
      noPattern: 'The pattern is not configured',
      error: 'There are needed more data to validate contract number'
    },
    transaction: {
      noTransaction: 'Receiver transaction number is required'
    },
    invoiceCorrective: {
      dates: 'Initial date and end date of tax period are invalid',
      number: 'Invoice number is required for invoices of type "Rectification complete" and "Rectification for differences',
      noNumber: 'Invoice number is required for rectification invoices',
      invalidPattern: 'The format of the rectified invoice number is not valid',
      noValue: 'No document with any value has been attached',
      noOrderValue: 'Must indicate the recipient s order',
	  required: 'The corrective block is mandatory for a corrective invoice'
    },
    project: {
      disabled: 'Service does not exist or it is disable',
      noProject: 'Service must be set',
      attachment: {
        notfound: 'The attachments directory of the service\'s invoice to integrate does not exist'
      }
    },
    issue: {
      date: {
        future: 'The issue date is later than its registration date by {argumento} days. The maximum allowed issue date is: {argumento1}',
        past: 'The issue date is earlier than its registration date by {argumento} days. The minimum allowed issue date is: {argumento1}'
      }
    },
    commercial: {
      relation: {
        channel: 'The commercial relation between the seller,buyer and the channel does not exist'
      }
    },
    channel: {
      not: {
        found: 'The channel does not exist'
      }
    },
    invoiceNumber: {
      error: 'Invoice number format validation could not be achieved: missing required data',
      noPattern: 'No Invoice Number pattern configured',
      invalidPattern: 'Invalid Invoice Number format'
    },
    b2bvalidationws: {
      nourl: 'The URL couldn\'t be found or it is invalid',
      metadataerror: 'An error occurred attempting to get the invoice\'s metadata file',
      connectionerror: 'An error occurred during the conversation with client\'s web service.',
      wrongresponse: 'The client\'s web service returned a wrong response.',
      errorresponse: 'The client\'s web service returned an ERROR response.'
    },
    valid: {
      iban: 'Invoice\'s IBAN is not correct.'
    },
    payment: {
      mean: 'Error: Invoice does not contain supported payment methods.'
    },
    file: {
      size: 'Error: invoice and attachments exceed the maximum size.'
    },
    nif: {
      codpais: 'Validation error in country code in NIF {argumento}. Country must be indicated in front of the NIF.'
    },
    line: {
      noDescription: 'Some of the lines have no description',
      transactionReference: 'All lines must contain IssuerTransactionReference and/or ReceiverTransactionReference',
      sequence: {
        number: 'All lines must have the same sequence number'
      }
    },
    noPublicOrganismCode: 'The Proposing Public Organization has not been informed – DIR3',
    delivery: {
      noDeliveryDate: 'The delivery date is required',
      duplicate: {
        '': 'A delivery note in correct status with this delivery note number already exists',
        issueyear: 'A delivery note in correct status for the current year with this delivery note number already exists'
      },
      lines: {
        noBatch: 'Some of the lines have no batch',
        noSerialNumber: 'Some of the lines have no serial number',
        noExpirationDate: 'Some of the lines have no best before date',
        invalidDate: 'Some of the lines have a best before date which is before the date of delivery',
        noQuantity: 'The sum of the amounts of the sublines are not equal to the amount of the parent line',
        noSubline: 'Some of the delivery note lines do not have any sub-lines',
        package: {
          invalidGtin14: 'Lines with different GTIN14 codes cannot be associated with the same packaging. The lines associated with the packaging with SSCC {argumento} have different GTIN14 codes.'
        }
      }
    }
  },
  invalid: {
    validation: {
      code: {
        exception: 'One or more validation codes lack a linked validation method'
      }
    },
    persontypecode: 'An error ocurred creating the party. Invalid person type code',
    name: {
      format: 'Invalid party name,characters must be in utf8'
    },
    facturae32: {
      xml: {
        format: 'The format of the Facturae 3.2 invoice file is not correct or .xml'
      },
      schema: 'The Facturae 3.2 invoice has fields which doesn\'t pass its schema validation: {argumento}'
    },
    facturae321: {
      xml: {
        format: 'The format of the Facturae 3.2.1 invoice file is not correct or .xml'
      },
      schema: 'The Facturae 3.2.1 invoice has fields which doesn\'t pass its schema validation: {argumento}'
    },
    facturae322: {
      xml: {
        format: 'The format of the Facturae 3.2.2 invoice file is not correct or .xml'
      },
      schema: 'The Facturae 3.2.2 invoice has fields which doesn\'t pass its schema validation: {argumento}'
    },
    facturapdf: {
      xml: {
        format: 'The format of the PDF invoice file is not correct or .xml'
      },
      schema: 'The PDF invoice has fields which doesn\'t pass its schema validation: {argumento}'
    },
    edi: {
      date: {
        format: 'El formato de la fecha no es correcto'
      }
    },
    facturad01b: {
      edi: {
        format: 'The format of the invoice file is not correct or .edi'
      }
    },
    facturad93a: {
      edi: {
        format: 'The format of the invoice file is not correct or .edi'
      }
    },
    facturad96a: {
      edi: {
        format: 'The format of the invoice file is not correct or .edi'
      }
    },
    facturad97a: {
      edi: {
        format: 'The format of the invoice file is not correct or .edi'
      }
    },
    fatturapa12: {
      xml: {
        format: 'The format of the fatturapa12 file is not correct or .xml'
      },
      schema: 'The fatturapa12 invoice has fields which doesn\'t pass its schema validation: '
    },
    recadv: {
      xml: {
        format: 'The format of the receipt advice file is not correct or .xml'
      },
      schema: 'The receipt advice has fields which doesn\'t pass its schema validation: '
    },
    fatturapaSemplificata1: {
      xml: {
        format: 'The format of the fatturapa simplify invoice file is not correct or .xml'
      },
      schema: 'The fatturapa simplify invoice has fields which doesn\'t pass its schema validation: '
    },
    fatturapa12cades: {
      xml: {
        format: 'The format of the fatturapa12 cades invoice file is not correct or .xml'
      },
      schema: 'The fatturapa12 cades invoice has fields which doesn\'t pass its schema validation: '
    },
    fatturapaSemplificatacades: {
      xml: {
        format: 'The format of the fatturapa simplify cades invoice file is not correct or .xml'
      },
      schema: 'The fatturapa simplify cades invoice has fields which doesn\'t pass its schema validation: '
    }
  },
  unable: {
    to: {
      save: {
        file: {
          in: {
            repository: 'File cannot be save'
          }
        }
      },
      get: {
        repository: {
          file: 'An error occurred getting the file'
        }
      },
      delete: {
        repository: {
          file: 'File cannot be deleted'
        }
      }
    }
  },
  no: {
    repository: {
      date: 'It is needed a date to save the file',
      project: {
        name: 'It is needed a service name to save the file'
      },
      file: 'File must be set to save it',
      subpath: 'Subpath must be set to save the file'
    },
    file: {
      to: {
        save: {
          extension: 'File extension must be set to save the file'
        }
      }
    },
    pathcomplete: {
      flag: 'Path complete must be set to save the file'
    }
  },
  repository: {
    path: {
      not: {
        found: 'Path not found to save the file'
      }
    }
  },
  missing: {
    required: {
      party: {
        data: 'An error ocurred creating the party. Party data must be set (CIF,name and country)',
        commercial: {
          relation: {
            data: 'Party commercial relation data missing'
          }
        },
        media: {
          value: 'Party media value must be set',
          type: 'Party media type must be set',
          to: {
            delete: 'An error ocurred deleting party media. Party media missing'
          }
        },
        documentcycle: {
          buyer: 'Document cycle party buyer missing',
          sourcetype: 'Document cycle source document type missing',
          destinationtype: 'Document cycle destination document type missing',
          class: {
            source: 'Document cycle class direction missing'
          }
        }
      },
      partyproject: 'An error ocurred creating the party. Service must be set',
      projectparty: {
        data: 'Service party data missing',
        role: 'Party roles must be set',
        enable: 'Service active flag must be set'
      },
      communicationmethod: {
        data: 'arty communication method data missing'
      },
      partycentre: {
        roletype: {
          data: 'Centre rol data missing'
        }
      },
      centre: {
        role: 'Centre roles missing',
        data: 'Centre data missing',
        media: {
          value: 'Centre media value must be set',
          type: 'Centre media type must be set',
          to: {
            delete: 'An error ocurred deleting centre media. Centre media missing'
          }
        }
      },
      invoice: {
        note: {
          media: {
            value: 'Invoice media value must be set',
            type: 'Invoice media type must be set',
            default: {
              flag: 'Invoice media value default must be set'
            },
            role: 'Invoice media role must be set'
          },
          issue: {
            date: 'Missing required invoice issue date'
          },
          document: {
            name: 'Missing required invoice note document name',
            format: 'Missing required invoice note document format',
            type: 'Missing required invoice note docuyment type'
          },
          recadv: {
            data: 'Missing required invoice note receipt advice data'
          }
        },
        integration: {
          file: {
            '': 'Invoice file missing',
            extension: 'Missing required invoice integration file extension',
            size: 'Missing required invoice integration file size'
          }
        },
        project: 'Invoice service missing',
        seller: {
          '': 'Invoice seller party not found',
          centre: {
            code: 'Missing required invoice seller centre code'
          }
        },
        buyer: {
          '': 'Invoice buyer party not found',
          centre: {
            code: 'Missing required invoice buyer centre code'
          }
        },
        number: 'Invoice number missing',
        sender: 'Invoice sender party missing',
        receiver: 'Invoice receiver party missing',
        status: 'Invoice status missing',
        document: {
          format: 'Missing required invoice document format',
          class: 'Missing required invoice document class',
          type: 'Missing required invoice document type'
        },
        validity: {
          document: 'Missing required invoice validity document'
        },
        correctedflag: 'Missing required invoice corrected flag',
        metadata: {
          file: {
            extension: 'Missing required invoice metadata file extension'
          }
        },
        attachment: {
          extension: 'Missing required invoice attachment extension'
        },
        tax: {
          type: 'Missing required invoice tax tyoe',
          baseamount: 'Missing required invoice tax base amount',
          currency: 'Missing required invoice tax currency'
        },
        event: 'Missing required invoice event',
        property: {
          '': 'Missing required invoice property',
          value: 'Missing required invoice property value'
        },
        outstanding: {
          amount: 'Missing required invoice outstanding amount'
        },
        executable: {
          amount: 'Missing required invoice executable amount'
        },
        communication: {
          reception: {
            name: 'Missing required communication reception name'
          }
        }
      },
      media: {
        type: 'Media type must be set'
      },
      centremedia: {
        project: 'Centre service must be set',
        role: 'Centre media rol must be set'
      },
      partymedia: {
        role: 'Party media role must be set'
      }
    },
    update: {
      party: {
        taxid: 'An error ocurred updating the party. Tax identification number must be set'
      }
    },
    search: {
      party: {
        taxid: 'An error ocurred searching the party. Tax identification number must be set'
      }
    },
    commercial: {
      relation: {
        partytaxid: 'Tax identification number must be set',
        role: 'Party role must be set'
      }
    },
    recadv: {
      integration: {
        file: {
          '': 'Missing required receipt advice integration file',
          extension: 'Missing required receipt advice file extension'
        }
      },
      status: 'Missing required receipt advice status',
      number: {
        exception: 'Missing required receipt advice number'
      },
      receiving: {
        date: {
          time: {
            extension: 'Missing required receipt advice receiving date'
          }
        }
      },
      validity: {
        document: 'Missing required receipt advice validity document'
      },
      document: {
        format: 'Missing required receipt advice document format'
      },
      centre: 'Missing required receipt advice centre'
    },
    request: {
      compressed: {
        invoice: {
          flag: 'Missing required request compressed invoice flag'
        }
      },
      invoice: {
        file: 'Missing required request invoice file'
      }
    }
  },
  party: {
    not: {
      found: 'Party not found'
    },
    project: {
      not: {
        found: 'Service not found or it is disable'
      }
    },
    to: {
      delete: {
        not: {
          found: 'Party not found'
        }
      }
    },
    commercial: {
      relation: {
        channel: {
          not: {
            found: 'Party channel not found'
          }
        }
      }
    },
    deletion: 'An error ocurred deleting the party',
    country: {
      not: {
        found: 'Party country not found'
      }
    },
    media: {
      type: {
        not: {
          found: 'Party media type not found'
        }
      },
      deletion: 'An error ocurred deleting party media',
      to: {
        delete: {
          not: {
            found: 'An error ocurred deleting party media. Party media not found'
          }
        }
      },
      invalid: {
        email: {
          format: 'Party media email invalid'
        }
      }
    }
  },
  commercial: {
    relation: {
      party: {
        not: {
          found: 'Party commercial relation not found or it is disable'
        }
      }
    }
  },
  incompatible: {
    integrated: {
      party: {
        for: {
          commercial: {
            relation: 'Invalid party,missing valid role'
          }
        }
      }
    },
    centre: {
      role: 'Invalid centre rol',
      media: {
        data: {
          role: 'Invalid centre role'
        }
      }
    },
    party: {
      media: {
        data: {
          role: 'Invalid party role'
        }
      }
    }
  },
  communication: {
    method: {
      not: {
        found: 'Party communication method not found'
      }
    }
  },
  centre: {
    role: {
      type: {
        not: {
          found: 'Centre rol not found'
        }
      }
    },
    to: {
      delete: {
        not: {
          found: 'Centre not found'
        }
      }
    },
    deletion: 'An error ocurred deleting the centre',
    party: {
      not: {
        found: 'Centre party not found'
      }
    },
    not: {
      found: 'Centre not found'
    },
    country: {
      not: {
        found: 'Centre country not found'
      }
    },
    media: {
      type: {
        not: {
          found: 'Centre media type not found'
        }
      },
      deletion: 'An error ocurred deleting centre media',
      to: {
        delete: {
          not: {
            found: 'An error ocurred deleting centre media. Centre media not found'
          }
        }
      },
      invalid: {
        email: {
          format: 'Centre media email invalid'
        }
      }
    }
  },
  media: {
    type: {
      not: {
        found: 'No se encontró el canal de contacto especificado'
      }
    }
  },
  centremedia: {
    project: {
      not: {
        found: 'Centre service not found'
      }
    }
  },
  duplicate: {
    partymedia: {
      value: 'Duplicate party media'
    },
    centremedia: {
      value: 'Duplcate centre media'
    }
  },
  recadvLine: {
    currency: {
      not: {
        found: 'Receipt advice line currency not found'
      }
    },
    unitOfMeasure: {
      notFound: 'Receipt advice line unit of measure not found'
    }
  },
  document_code: {
    generation: {
      format: {
        class: {
          not: {
            found: 'Mapping class of the document format not found'
          }
        }
      }
    }
  },
  unzipped: {
    request: {
      invoice: {
        file: 'The invoice request is configured to carry only one zipped invoice file,but it has an unzipped one'
      },
      attachments: 'The invoice request is configured to carry only zipped attachments,but it has only an unzipped one'
    }
  },
  zipped: {
    request: {
      invoice: {
        file: 'The invoice request is configured to carry only one unzipped invoice file,but it has a zipped one'
      },
      attachments: 'The invoice request is configured to carry only one unzipped attachment,but the request has one or more zipped'
    }
  },
  different: {
    invoice: {
      number: 'The invoice number from the request is different of the one extracted from the attached invoice file'
    },
    seller: {
      tax: {
        identification: {
          number: 'The seller tax id from the request is different of the one extracted from the attatached invoice file'
        }
      }
    }
  },
  // Fin errores/mensajes en Integración de factura
  projects: {
    filters: {
      creation_date: {
        value: 'Date'
      },
      name: {
        value: 'Service name',
        placeholder: 'Name'
      },
      code: {
        value: 'Service code',
        placeholder: 'Code'
      },
      security_code: {
        value: 'Security code',
        placeholder: 'Code'
      },
      enabled: {
        value: 'Enabled',
        placeholder: 'Select...'
      },
      issuing: {
        value: 'Issuing',
        placeholder: 'Select...'
      },
      reception: {
        value: 'Reception',
        placeholder: 'Select...'
      },
      party_nif: {
        value: 'Party identification',
        placeholder: 'NIF'
      },
      party_name: {
        value: 'Party name',
        placeholder: 'Name'
      }
    },
    entity_table: {
      name: 'Service',
      code: 'Code',
      security_code: 'Security code',
      issuing: 'Issuing',
      reception: 'Reception',
      creation_date: 'Date',
      enabled: 'Enabled'
    },
    buttons: {
      new_project: 'New service'
    },
    error: {
      tamanomaximo: {
        code: "Maximum length of the field 'Service code': 50 characters",
        name: "Maximum length of the field 'Service name': 40 characters",
        security_code: "Maximum length of the field 'Security code': 64 characters",
        new_name: "Maximum length of the field 'Name': 40 characters"
      },
      required: {
        name: 'Required field: Name',
        code: 'Required field: Code',
        enable: 'Required field: Active',
        isSender: 'Required field: Emission',
        isReceiver: 'Required field: Reception'
      },
      exist: 'The chosen delivery method is already inserted',
      validityexist: 'There are already valid data in the service for that type and that role. You must delete the existing validity if you want to add another one.',
      validationexist: 'Validation data already exists in the service for that type, format and role. You will need to delete the existing validation if you want to add another one.',
      statusexist: 'There is already the status to display the service associated with the service',
      statuschangeexist: 'The status for the status change associated with the service already exists',
      categoryexist: 'The category associated to the service already exists',
      mimeexist: 'The mime configuration associated with the service already exists',
      mime: {
        invalidMimeFrom: 'The mime from email entered is not valid',
        invalidMimeSender: 'The mime sender email entered is not valid',
        invalidMimeReplyTo: 'The mime reply to email entered is not valid'
      },
      wrongLogoSize: 'The size of the image exceeds the maximum allowed: 256 KBs',
      wrongLogoExtension: 'Only images in JPG / JPEG and PNG are allowed',
      adminParties_name_exist: 'There was an error. A service already exists with that name or code',
      format_email: 'The format of the email is not correct.',
      format_phone: 'The format of the phone is not correct.',
      partyTypeAndProject: 'The type of company does not correspond to the role of the service',
      signDocument_fileNull: 'A file must be attached',
      signDocument_wrongExtension: 'The extension of the attachment must be PDF',
      signDocument_invalidPdf: 'The document content is not a valid PDF',
      roleOfParte_isEmpty: 'You must have at least one role for the party',
      commercialrelation_insert: 'Indicate only the buyer or the seller.',
      existRelation: 'Operation not completed. The relationship already exists.',
      partyCountryNotEqual: 'The identifier already exists on the platform for another country',
      partydisabled: 'You can not add the company,it exists but it is disabled',
      partyAlreadyAdded: 'The company is already assigned,please check the data',
      noMediaCorrect: 'The contact data is not correct,check the type of company of the data.',
      email_empty: 'You must enter a contact information',
      contact_duplicado: 'The "email" for that service already exists',
      contact_noMore: 'You can not add more contacts with this type',
      adminparties: {
        required: {
          userType: 'The field "Person type" is required',
          name: 'The field "Name" is required',
          firstSurname: 'The field "First surname" is required',
          corporateName: 'The field "Business name" is required',
          country: 'The field "Country" is required',
          postcode: 'The field "Postal Code" is required',
          address: 'The field "Address" is required',
          town: 'The field "Town" is required',
          province: 'The field "Province" is required',
          nif: 'The field "Person type" is required'
        },
        invalid: {
          name: 'The field "Name" is not valid',
          firstSurname: 'The field "First surname" is not valid',
          secondSurname: 'The field "Second surname" is not valid',
          postcode: 'The field "Postal Code" is not valid',
          postcode_max: 'The length of the "Postal Code" field is not correct',
          nif: 'The field "Financial ID" does not have a valid format',
          nif_max: 'The length of the field "Financial ID" is not correct',
          email: 'The email entered is not valid',
          phoneNumber: "The contact's phone number is not valid"
        }
      }
    },
    validations: {
      name: 'Validation',
      value: 'Value',
      role: 'Meaning of the document',
      document_type: 'Document type',
      emission: 'Emission',
      reception: 'Reception',
      country: 'Country',
      document_format: 'Document format',
      comm_method: 'Communication method'
    },
    validities: {
      validity: 'Validity (days)',
      country: 'Country',
      role: 'Meaning of the document',
      document_type: 'Document type',
      emission: 'Emission',
      reception: 'Reception'
    },
    pendingtasks: {
      status: 'Status',
      module: 'Module'
    },
    rejectionCategories: {
      name: 'Name',
      visible: 'Visible'
    },
    emailType: {
      type: 'Email typology',
      value: 'Email'
    },
    visualization: {
      name: 'Visualization'
    }
  },

  new_project: {
    title: 'Create service',
    new_project_form: {
      name: {
        label: 'Name',
        placeholder: ''
      },
      code: {
        label: 'Code',
        placeholder: ''
      },
      issuing: {
        label: 'Issuing',
        placeholder: 'Select...'
      },
      enable: {
        label: 'Enable',
        placeholder: 'Select...'
      },
      reception: {
        label: 'Reception',
        placeholder: 'Select...'
      },
      indra_project: {
        label: 'Contractor',
        placeholder: 'Select...'
      }
    },
    load: {
      upload_logo: 'Uploading logo',
      save_changes: 'Saving service data'
    },
    notify: {
      upload_logo: 'Logo has been uploaded correctly. Remember to push "Save changes"',
      save_changes: 'service created correctly'
    }
  },

  project_detail: {
    info_message: 'Some fields are editable. Remind to push "Save" button to store modifications',
    title_delete_communication: 'Some service company has credentials for that method, check if you should delete them before continuing, do you want to continue anyway?',
    expand_all_accordion: 'Expand all',
    collapse_all_accordion: 'Collapse all',
    buttons: {
      management_services_parties: 'Management of services parties',
      add_logo: 'Add',
      add_configuration_data: 'Add',
      add_delivery_methods: 'Add',
      add_logo_tooltip: 'Add logo',
      add_configuration_data_tooltip: 'Add configuration data',
      add_mime_configuration: 'Add',
      add_mime_configuration_tooltip: 'Add mime configuration',
      add_delivery_methods_tooltip: 'Add delivery method',
      add_validity_document: 'Add',
      add_validity_document_tooltip: 'Add validity',
      add_validation_tooltip: 'Add validation',
      add_visualization_tooltip: 'Add visualizatión',
      add_pendingtask: 'Add',
      add_pendingtask_tooltip: 'Add pending task status',
      add_rejectionCategory: 'Add',
      add_rejectionCategory_tooltip: 'Add category',
      add_emailype_tooltip: 'Add email typology',
      add_documentFormat_data_tooltip: 'Upload a document format'
    },
    project_detail_edit_form: {
      name: 'Service name',
      code: 'Service code',
      enable: 'Enabled/Disabled',
      security_code: 'Security code',
      issuing: 'Issuing',
      reception: 'Reception',
      is_indra_project: 'Contractor'
    },
    validation: {
      error_code: 'El código no cumple con el formato requerido {0}'
    },
    facturar: 'Invoice',
    configuration_data: 'Configuration data',
    no_configuration_data: 'This service doesn\'t have any configuration data',
    configuration_data_table: {
      code: 'Configuration',
      project_type: 'Service type'
    },
    mime_required: 'You must enter at least one of the values',
    mime_configuration_data: 'Mime configuration data',
    mime_configuration: 'Mime configuration data',
    no_mime_configuration_data: 'This service doesn\'t have any mime configuration',
    mime_configuration_table: {
      mime_from: 'From',
      mime_sender: 'Sender',
      mime_reply_to: 'Reply to'
    },

    delivery_methods: 'Delivery methods',
    delivery_methods_credentials: 'Credentials delivery methods',
    no_delivery_methods: 'This service doesn\'t have any delivery method',
    validations: 'Validations',
    addCharge_or_discount: 'Charges and discounts',
    no_chargeDiscount: 'The service has no charges or discounts',
    visualize_pdf: 'PDF visualization',
    no_active_validations: 'This service doesn\'have any active validations',
    validity_document: 'Validity documents',
    no_validity_document: 'This service does not have valid documents',
    rejectionCategories: 'Rejection categories',
    no_rejectionCategories: 'This service does not have rejection categories',
    rejectionCategory_table: {
      category: 'Category',
      visible: 'Visible'
    },
    emailType: 'Mail typology',
    no_emailType: 'This service doesn\'t have any active email typology',
    pendingtasks: 'Status settings',
    no_pendingtasks: 'This service has no configured states',
    pendingtask_table: {
      status: 'Status to display in pending tasks',
      statuschange: 'Status change',
      statusplaceholder: 'Status'
    },
    emailTypePlaceholder: 'Tipo email',
    validity_document_table: {
      days: 'Validity (days)',
      country: 'Country',
      document_type: 'Document type',
      role: 'Role'
    },

    dialog_add_logo: {
      title: 'Upload logo'
    },
    dialog_add_configuration_data: {
      title: 'Add configuration data',
      configuration: {
        label: 'Configuration',
        placeholder: 'Select a configuration'
      },
      type: {
        label: 'Type',
        placeholder: 'Select a type'
      }
    },
    dialog_add_mime_configuration: {
      title: 'Add mimne configuration data',
      mime_from: {
        label: 'From',
        placeholder: 'From mail'
      },
      mime_sender: {
        label: 'Sender',
        placeholder: 'Sender mail'
      },
      mime_reply_to: {
        label: 'Reply to',
        placeholder: 'Reply to mail'
      }
    },

    // Documentos y formatos
    document_format: 'Documents and formats',
    no_document_format: 'This service does not have documents and formats',
    dialog_add_document_format: {
      title: 'Choose a new document and format',
      format: {
        labelType: 'Type of document',
        labelFormat: 'Document Format',
        placeholder: 'Choose...'
      }
    },
    document_format_table: {
      name: 'Name',
      sender: 'Issue/Receive',
      priority: 'Priority',
      user: 'User',
      password: 'Password',
      party: 'Entity',
      format: 'Format',
      documentType: 'Document type'
    },

    dialog_add_delivery_method: {
      title: 'Select a new delivery method',
      method: {
        label: 'Method',
        placeholder: 'Select a method'
      }
    },
    dialog_add_validations: {
      title: 'Select a new validation',
      validation: {
        title: 'Validation',
        placeholder: 'Select a validation'
      }
    },
    dialog_add_visualization: {
      title: 'Select a new visualization',
      visualization: {
        title: 'PDF visualization',
        placeholder: 'Select a visualization'
      }
    },
    dialog_add_validities: {
      title: 'Select a new validaty',
      validity: {
        title: 'Validity',
        placeholder: 'Select a validaty'
      }
    },
    dialog_add_pendingtask: {
      title: 'Status configuration',
      pendingtask: {
        title: 'Pending task',
        placeholder: 'Select a pending task'
      }
    },
    dialog_add_emailType: {
      title: 'Select an email type',
      emailType: {
        title: 'Email type',
        placeholder: 'Select email type'
      }
    },
    dialog_add_rejectionCategory: {
      title: 'Select a new category',
      rejectionCategory: {
        title: 'Rejection category',
        placeholder: 'Select a category'
      }
    },
    dialog_add_charge_or_discount: {
      title: 'Add charge or discount',
      type: 'Type',
      description: 'Description'
    },
    load: {
      upload_logo: 'Uploading logo',
      delete_logo: 'Removing logo',
      download_logo: 'Downloading logo',
      save_changes: 'Saving service data',
      cancel: 'Canceling',
      add_configuration: 'Adding configuration',
      delete_configuration: 'Deleting configuration',
      add_delivery_method: 'Adding delivery method',
      delete_delivery_method: 'Deleting delivery method',
      delete_validation: 'Deleting validation',
      add_validation: 'Adding validation',
      delete_validity: 'Deleting validity',
      add_validity: 'Adding validity',
      delete_PDFVisualization: 'Deleting PDF visualization',
      add_visualization: 'Adding PDF visualization',
      delete_pendingtask: 'Deleting pending task',
      add_pendingtask: 'Adding pending task',
      delete_rejectionCategory: 'Deleting rejection category',
      add_rejectionCategory: 'Adding  rejection category',
      delete_emailType: 'Deleting email typology',
      add_emailType: 'Adding email typology',
      delete_project_document_format: 'Deleting document and format',
      add_document_format: 'Adding document format',
      add_delivery_note_config: 'Adding license plate for issued delivery notes',
      add_project_delivery_note_type: 'Adding delivery note type',
      delete_project_delivery_note_type: 'Removing delivery note type'
    },
    notify: {
      delete_logo: 'Logo deleted correctly',
      save_changes: 'Service updated corectly',
      add_configuration: 'Configuration data added correctly',
      delete_configuration: 'Configuration deleted correctly',
      add_delivery_method: 'Delivery method added correctly',
      delete_delivery_method: 'Delivery method deleted correctly',
      delete_validation: 'Validation deleted correctly',
      add_validation: 'Validation added correctly',
      delete_validity: 'Validity deleted correctly',
      add_validity: 'Validity added correctly',
      delete_PDFVisualization: 'Visualization deleted correctly',
      add_PDFVisualization: 'Visualization added correctly',
      noDisplayDocuments: 'There is not any validation for this document type',
      delete_pendingtask: 'Pending task deleted correctly',
      add_pendingtask: 'Pending task added correctly',
      delete_rejectionCategory: 'Rrejection category deleted correctly',
      add_rejectionCategory: 'Rejection category added correctly',
      delete_emailType: 'Email typology deleted correctly',
      add_emailType: 'Email typology added correctly',
      delete_project_document_format: 'The document has been deleted and formatted correctly',
      add_document_format: 'The document format has been added successfully',
      add_delivery_note_config: 'License plate has been added correctly',
      delete_project_delivery_note_type: 'Delivery note type has been removed correctly',
      add_project_delivery_note_type: 'Delivery note type has been added correctly',
      add_project_delivery_note_exist: 'The relationship between the service and the type of delivery note already exists',
      document_format_duplicate: 'Failed to insert document and format, document and format repeated.'
    },
    error: {
      duplicated: 'The chosen validation is already inserted',
      document_type: {
        required: 'Document type is required'
      },
      validation_id: {
        required: 'Validation is required',
        duplicated: 'Duplicated validation'
      },
      validity: {
        required: 'Validity days are required'
      },
      sender: {
        required: 'Role is required'
      },
      visualization_id: {
        required: 'Visualization is required',
        duplicated: 'Duplicated visualization'
      },
      statusconfig: {
        required: 'Any status is required'
      },
      emailType: {
        required: 'Any email type is required'
      },
      emailValue: {
        required: 'Any email address is required',
        duplicated: 'Duplicated email address',
        invalid: 'Email address does not have a valid format'
      },
      category: {
        required: 'Any category is required'
      },
      visible: {
        required: 'A visible option is required'
      }
    }
  },

  parties: {
    filters: {
      party_name: {
        value: 'Party name',
        placeholder: 'Name'
      },
      identification_tax_number: {
        value: 'Tax identification',
        placeholder: 'Number'
      },
      gln: {
        value: 'GLN',
        placeholder: 'GLN'
      },
      registerDate: {
        value: 'Register Date',
        placeholder: 'Register Date'
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Buyer'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Seller'
      },
      propietary: {
        value: 'Sponsor',
        placeholder: 'Sponsor'
      },
      active: {
        value: 'Enable',
        placeholder: 'Enable'
      },
      country: {
        value: 'Country',
        placeholder: 'Country'
      }
    },
    notify: {
      not_buyer_sponsor: 'All companies must be buyers and sponsor / non-sponsor',
      modify_all: 'All selected companies will be modified. Do you want to continue?',
      parties_updated: 'Updated companies',
      loadmassive_timeout: 'The company upload is being processed, once finished you can see the result in the document audit',
      loadmassive_numlinesOK: 'Number of lines successfully processed:'
    },
    entity_table: {
      name: 'Name',
      identification_tax_number: 'Tax identification',
      country: 'Country',
      province: 'Province',
      creation_date: 'D. assignment',
      seller: 'Seller',
      buyer: 'Buyer',
      third: 'Third',
      sponsor: 'Sponsor',
      register_location_company: 'Reg. company',
      enable: 'Active',
      permanentEstablishment: 'Permanent establishment'
    },
    buttons: {
      add_party: 'Add',
      add_party_tooltip: 'Add party',
      mass_partycharge_tooltip: 'Mass parties load',
      mass_partycharge: 'Parties charge',
      mass_partyupdate_tooltip: 'Mass update of corporate social reasons',
      mass_upload: 'Mass upload',
      mass_partyupdate: 'Mass update'

    },
    mass_party_chargemsg: 'Mass parties load. The file must contain the CSV extension.'
  },

  new_party: {
    country_nif: {
      title: 'Add party',
      info: 'Type tax identification and party country to continue',
      form: {
        country: {
          label: 'Country',
          placeholder: 'Select...'
        },
        identification_number: {
          label: 'Tax identification'
        }
      }
    }
  },

  party_detail: {
    confirm_clean: 'Remember: if you modify the data you will have to regenerate the data change request model',
    title: 'Party data',
    info_message: 'Some fields are editable. Remind to push "Save" button to store modifications',
    info_address: 'To save the tax address information, it is necessary to fill in all the fields in the section',
    buttons: {
      admin_channels: 'Admin business relationships',
      admin_centres: 'Admin centres',
      upload_centre: 'Update center',
      upload_centre_ok: 'Center updated successfully',
      add_contact_data: 'Add',
      add_delivery_method: 'Add',
      add_sign_document: 'Add',
      add_contact_data_tooltip: 'Add contact data',
      add_gln_data: 'Add',
      add_gln_data_tooltip: 'Add Gln',
      add_delivery_method_tooltip: 'Add delivery method',
      add_document_format_tooltip: 'Add document format',
      add_delivery_note_type_tooltip: 'Add delivery note type',
      add_label_tooltip: 'Load label',
      add_registration_tooltip: 'Add registration',
      add_sign_document_tooltip: 'Add delegated sign document',
      add_validations_tooltip: 'Add validation',
      mass_partyupdate: 'Update party name',
      add_shipping_configuration: 'Add',
      add_shipping_configuration_tooltip: 'Add shipping configuration',
      add_paymentMeans_tooltip: 'Add payment method',
      add_document_cycle_tooltip: 'Add document cycle'
    },

    dialog_add_payments: {
      title: 'Add payment data'
    },

    party_detail_edit_form: {
      person_type: {
        label: 'Person type',
        placeholder: 'Select a type'
      },
      corporate_name: 'Business name',
      name: 'Name',
      gln: 'GLN',
      identification_tax_number: 'Financial ID',
      enable: 'Active',
      first_surname: 'First surname',
      second_surname: 'Second surname',

      // Registro mercantil
      book: 'Book',
      folio: 'Folio',
      volume: 'Volume',
      sheet: 'Sheet',
      section: 'Section',
      additional_data: 'Additional data',
      registerOrCompaniesLocation: 'Commercial register',
      taxDataCertificate: 'Upload fiscal data certificate from the tax agency',

      // Direccion
      address: 'Address',
      province: 'Province',
      postcode: 'Postal code',
      town: 'Town',
      country: {
        label: 'Country',
        placeholder: 'Country'
      },

      // Datos Bancarios
      iban: 'IBAN',
      bic: 'BIC Swift',
      accountTitular: 'Account holder',
      email: 'Payment communication email',
      ficheroCertificado: 'Loading certificate of ownership of bank account',
      donwloadModelo: 'Download model change data request',
      ficheroDatos: 'Upload request for data change (Must be digitally signed)',
      sendProject: {
        label: 'Services to send documentation',
        placeholder: 'Choose service / s'
      },
      legalNif: 'Nif of the legal representative/attorney',
      legalName: 'Surname and name of the legal representative/attorney',
      legalCountry: {
        label: 'Country',
        placeholder: 'Country'
      },
      contactName: 'Surname and name of the contact person',
      contactRole: 'Position held by the contact person in the entity',
      contactEmail: 'Email of the contact person',
      contactEmailEmi: 'Email to issue communications related to electronic invoicing',
      contactPhones: 'Phone/s of the contact person',

      // Rol por servicio
      buyer: 'Buyer',
      seller: 'Seller',
      sponsor: 'Sponsor'
    },
    subtitle: {
      commercial_register: 'Commercial register',
      address: 'Fiscal address',
      project_role: 'Service role',
      bank: 'Bank data',
      bank_legal_data: 'Data of the legal representative/attorney',
      bank_contact_data: 'Data of the contact person in relation to this form'
    },

    // Carga de logo
    dialog_add_logo: {
      title: 'Upload logo'
    },

    no_active_validations: 'This party doesn\'t have any active validations',
    // Proyectos relacionados
    project_related: 'Related services',
    no_project_data: 'This party doesn\'t have any service',
    // Datos de contacto
    contact_data: 'Contact data',
    no_contact_data: 'This party doesn\'t have any contact data',
    party_media_table: {
      project: 'Service',
      media_type: 'Media type',
      contact_data: 'Contact data',
      party_type: 'Party type',
      profile_info: '>>  If you want to modify the contact information,you must contact your client.'
    },
    dialog_add_contact_data: {
      title: 'Add contact data',
      media_type: {
        label: 'Contact data',
        placeholder: 'Contact type'
      },
      party_type: {
        label: 'Party type',
        placeholder: 'Party type'
      },
      contact_data: {
        label: 'Contact data'
      }

    },
    // Buzones
    gln_data: 'Identifiers',
    no_gln_data: 'This company has no data',
    party_gln_table: {
      physical_gln: 'Identifier',
	  physical_gln_type: 'Type'
    },
    dialog_add_gln_data: {
      title: 'Add identifier',
      physical_gln: {
        label: 'Identifier',
		type: 'Type'
      }
    },

    // Metodos de entrega
    delivery_methods: 'Delivery methods',
    no_delivery_methods: 'This party doesn\'t have any delivery method',
    delivery_methods_table: {
      name: 'Name',
      sender: 'Emission/Reception',
      priority: 'Priority',
      user: 'User',
      password: 'Password',
      party: 'Party',
      countryEmission: 'Country emission',
      countryReception: 'Country reception',
    },
    dialog_add_delivery_methods: {
      title: 'Select a new delivery method',
      method: {
        label: 'Delivery method',
        placeholder: 'Select...'
      }
    },
    dialog_add_delivery_methods_credentials: {
      title: 'Shipping Method Credentials'
    },

    dialog_add_party_label: {
      title: 'Choose a new label'
    },

    // Formato de documento
    document_format: 'Document formats',
    no_document_format: 'This service has no document formats',
    dialog_add_document_format: {
      title: 'Choose a new document format',
      method: {
        labelType: 'Type of document',
        labelFormat: 'Document Format',
        placeholder: 'Choose...'
      }
    },
    document_format_table: {
      name: 'Name',
      sender: 'Issue/Receive',
      priority: 'Priority',
      user: 'User',
      password: 'Password',
      party: 'Entity',
      format: 'Format',
      documentType: 'Document type'
    },

    // Documento de firma delegada
    sign_document: 'Delegated sign files',
    no_sign_document: 'This party doesn\'t have any delegated sign file',
    sign_document_table: {
      project: 'Type/Service',
      filename: 'Filename',
      creation_date: 'Creation date'
    },
    // Documento de datos fiscales
    aeat_document: 'Fiscal data files',
    no_aeat_document: 'This party doesn\'t have any fiscal data file',
    aeat_document_table: {
      documentname: 'Document',
      user: 'User',
      creation_date: 'Upload date'
    },
    dialog_add_sign_document: {
      title: 'Sign document upload'
    },
    // Datos de pago
    paymentMeans: 'Payment methods',
    no_payment_data: 'This company does not have payment methods',
    payments_table: {
      paymentMeans: 'Payment method',
      iban: 'IBAN',
      swift: 'SWIFT'
    },
    // Ciclos de documentos
    no_party_document_cycle: 'No document cycles',
    document_cycle_table: {
      title: 'Document cycles',
      sourceDocumentType: 'Source document type',
      destinationDocumentType: 'Destination document type',
      buyer_centre: 'Buyer center',
      seller: 'Seller party',
      class: 'Source document class',
      additional: 'Additional parameter of source document class'
    },
    document_cycle_class_source_options: {
      source: 'Source document',
      destination: 'Destination document'
    },
    dialog_add_document_cycle: {
      title: 'Add a new document cycle',
      source_document_type: {
        label: 'Source document type',
        placeholder: 'Choose...'
      },
      destination_document_type: {
        label: 'Destination document type',
        placeholder: 'Choose...'
      },
      seller: {
        label: 'Selling company',
        placeholder: 'Enter 3 characters'
      },
      centre_buyer: {
        label: 'Buyer company center',
        placeholder: 'Choose...'
      },
      document_cycle: {
        label: 'Document class',
        placeholder: 'Choose...'
      },
      document_cycle_class_source: {
        label: 'Document direction',
        placeholder: 'Choose the document to add the class...'
      },
      additional_class_value: {
        title: 'Additional parameter of document class'
      }
    },

    load: {
      add_document_format: 'Adding document format',
      delete_party_document_format: 'Deleting document format',
      delete_party_emission_deliverynote_config: 'Eliminating License Plate for Issued Delivery Notes',
      upload_logo: 'Uploading logo',
      delete_logo: 'Removing logo',
      download_logo: 'Downloading logo',
      save_changes: 'Saving changes',
      cancel: 'Canceling',
      add_contact_data: 'Adding contact data',
      delete_contact_data: 'Removing contact data',
      add_approval_amount: 'Adding approval flow to centre',
      modify_approval_amount: 'Updating approval flow',
      delete_approval_amount: 'Removing approval flow',
      add_approval_level: 'Adding approval level',
      delete_approval_level: 'Removing approval level',
      add_gln_data: 'Adding identifier',
      delete_gln_data: 'Removing identifier',
      add_party_label: 'Adding tag',
      delete_party_label: 'Removing tag',
      add_delivery_method: 'Adding delivery method',
      delete_delivery_method: 'Removing elivery method',
      upload_sign_document: 'Uploading delegated sign file',
      download_sign_document: 'Downloading delegated sign file',
      delete_sign_document: 'Removing delegated sign file',
      download_aeat_document: 'Downloading fiscal data file',
      add_shipping_configuration: 'Adding shipping configuration',
      delete_shipping_configuration: 'Removing shipping configuration',
      add_party_delivery_note_type: 'Adding delivery note type',
      delete_party_delivery_note_type: 'Removing delivery note type',
      delete_paymentMeans: 'Removing payment method',
      add_paymentMeans: 'Adding payment method',
      delete_document_cycle: 'Deleting document cycle',
      add_party_document_cycle: 'Adding document cycle'
    },
    notify: {
      add_document_format: 'The document format has been added successfully',
      delete_party_document_format: 'Successfully deleted document format',
      delete_party_emission_deliverynote_config: 'License plate has been successfully removed',
      upload_logo: 'Logo has been uploaded correctly. Remember to push "Save changes"',
      delete_logo: 'Logo has been deleted correctly',
      save_changes: 'Party has been updated correctly',
      created: 'Party has been created correctly',
      save_changes_to_service: 'Data has been reported to the service ',
      add_contact_data: 'Contact data has been added correctly',
      delete_contact_data: 'Contact data has been removed correctly',
      add_approval_amount_data: 'Approval flow data added successfully',
      modify_approval_amount_data: 'Approval flow data modified successfully',
      delete_approval_amount_data: 'Removed centre approval flow',
      add_approval_level_data: 'Approval level added successfully',
      delete_approval_level_data: 'Approval level removed',
      add_gln_data: 'GLN has been added correctly',
      delete_gln_data: 'GLN has been removed correctly',
      add_party_label: 'The tag has been added successfully',
      delete_party_label: 'The tag has been successfully removed',
      noLabels: 'There are no labels for that type of document',
      existLabels: 'The tag is already associated with the company',
      add_delivery_method: 'Delivery method has been added correctly',
      delete_delivery_method: 'Delivery method has been removed correctly',
      delete_sign_document: 'Delegated sign document has been removed correctly',
      typePersonTaxIden: 'The type of person must match a correct tax id in Spain',
      document_format_duplicate: 'Failed to insert document format, repeated format.',
      add_shipping_configuration: 'Shipping configuration has been added correctly',
      delete_shipping_configuration: 'Shipping configuration has been removed correctly',
      add_shipping_configuration_duplicate: 'Failed to insert shipping configuration, repeated format for that GLN.',
      add_party_delivery_note_type: 'Delivery note type has been added correctly',
      add_party_delivery_note_exist: 'The relationship between the company and the type of delivery note already exists',
      delete_party_delivery_note_type: 'Delivery note type has been removed correctly',
      add_shipping_configuration_duplicate: 'No se ha podido insertar la configuración de envío, formato para ese GLN repetido',
      add_paymentMeans: 'Payment method added successfully',
      delete_paymentMeans: 'Payment method was successfully deleted',
      payment_means_duplicate: 'Payment data already exists for the same method, delete the existing payment data first',
      document_cycle_duplicate: 'The document cycle for the party already exists, please remove the existing document cycle first',
      delete_document_cycle: 'The document cycle has been deleted successfully',
      add_document_cycle: 'The document cycle has been added successfully'
    },

    // Administrar canales
    channels: {
      filters: {
        name: {
          value: 'Party name',
          placeholder: 'Nombre'
        },
        buyer: {
          value: 'Buyer',
          placeholder: 'Select...'
        },
        seller: {
          value: 'Seller',
          placeholder: 'Select...'
        }
      },
      entity_table: {
        sellers: 'Seller parties',
        buyers: 'Buyer parties',
        channels: 'Channels',
        seller: 'Seller party',
        buyer: 'Buyer party',
        communicationsMethod: 'Communications Method'
      },
      buttons: {
        add_commercial_relation: 'Add commercial relation'
      },
      dialog_add_commercial_relation: {
        title: 'New commercial relation',
        party: 'Party',
        buyer: {
          label: 'Buyer',
          placeholder: 'Select...',
          write_placeholder: 'Enter 3 characters'
        },
        seller: {
          label: 'Seller',
          placeholder: 'Select...',
          write_placeholder: 'Enter 3 characters'
        }
      },
      dialog_users: {
        title: 'Users',
        userName: 'Username'
      },
      notify: {
        add_commercial_relation: 'the commercial relation has been created correctly',
        delete_commercial_relation: 'Business relationship deleted correctly.'
      },
      confirm: {
        delete_commercial_relation: 'Are you sure to delete the commercial relationship?'
      },
      load: {
        add_commercial_relation: 'Adding commercial relation ...',
        delete_commercial_relation: 'Removing business relationship ...'
      },
      channels_data: 'Company channels',
      no_channels_data: 'The company does not have channels'
    },

    commercial_relation: {
      filters: {
        party_name: {
          value: 'Party name',
          placeholder: 'Party'
        },
        buyer: {
          value: 'Buyer',
          placeholder: 'Select...'
        },
        seller: {
          value: 'Seller',
          placeholder: 'Select...'
        }
      }
    },

    // Configuración de emisión de albaranes
    emission_delivery_note_config: 'Configuration of license plates for delivery notes issued',
    no_emission_delivery_note_config: 'This company does not have configuration of license plates for issued delivery notes',
    emission_delivery_note_config_table: {
      platformCode: 'Platform code',
      partyPrefix: 'Party code',
      packSequenceNumber: 'Sequence number'
    },

    // Configuración de tipos de albaranes recibidos
    reception_delivery_note_config: 'Configuring types of received delivery notes',
    no_party_reception_delivery_note_config: 'This company does not have configuration of types of received packing slips',
    no_project_reception_delivery_note_config: 'This service does not have configuration of types of received packing slips',
    reception_delivery_note_config_table: {
      delivery_note_type: 'Delivery note type'
    },

    dialog_add_party_delivery_note_config: {
      title: 'New registration',
      method: {
        platformCode: 'Platform code',
        partyPrefix: {
          title: 'Party code',
          tooltip: 'Enter country code (2 digits) + official body code (5 to 9 digits)'
        },
        packSequenceNumber: {
          title: 'Sequence number',
          tooltip: 'Enter initial sequence number to number packages'
        },
        rules: {
          partyPrefix_pattern: 'The company code only supports between 7 and 11 digits',
          packSequenceNumber_pattern: 'Sequence number only supports digits'
        }
      }
    },
    dialog_add_party_delivery_note_type: {
      title: 'Choose a new delivery note type',
      method: {
        deliveyNoteType: 'Delivery note type'
      }
    },

    // Configuración de etiquetas para empresa compradora
    party_label_config: 'Configuration of labels for received delivery notes',
    no_party_label_config: 'This company does not have labels set up for received delivery notes',
    party_label_config_table: {
      name: 'Name',
      description: 'Description',
      document_type: 'Document type',
      class: 'Implementation class'
    },

    dialog_add_party_label_config: {
      title: 'New Label',
      method: {
        label: {
          title: 'Label',
          placeholder: 'Choose a label'
        },
        description: 'Description',
        document_type: 'Document type',
        class: 'Implementation class'
      }
    },

    // CONFIGURACIÓN DE ENVÍO DE LA EMPRESA
    shipping_configuration: 'Shipping configuration',
    no_shipping_configuration: 'This party doesn\'t have any shipping configuration',
    shipping_configuration_table: {
      documentType: 'Document type',
      documentFormat: 'Format',
      partySeller: 'Seller',
      deliveryPoint: 'Delivery point',
      sellerGLN: 'Seller mailbox',
      buyerGLN: 'Buyer mailbox'
    },

    dialog_add_shipping_configuration: {
      title: 'New shipping configuration',
      document_type: {
        label: 'Document type',
        placeholder: 'Select...'
      },
      document_format: {
        label: 'Document format',
        placeholder: 'Select...'
      },
      gln_buyer: {
        label: 'Buyer physical mailbox',
        placeholder: 'Enter 3 characters'
      },
      gln_seller: {
        label: 'Seller physical mailbox',
        placeholder: 'Enter 3 characters'
      },
      seller: {
        label: 'Seller',
        placeholder: 'Enter 3 characters'
      },
      delivery_centre: {
        label: 'Delivery point',
        placeholder: 'Enter 3 characters'
      }
    }
  },

  centres: {
    filters: {
      name: {
        value: 'Name',
        placeholder: 'Name'
      },
      gln: {
        value: 'Gln',
        placeholder: 'Gln'
      },
      province: {
        value: 'Province',
        placeholder: 'Province'
      },
      code: {
        value: 'Code',
        placeholder: 'Code'
      },
      mailbox: {
        value: 'Mailbox',
        placeholder: 'Mailbox'
      },
      centre_type: {
        value: 'Centre type',
        placeholder: 'Type',
        buyer: 'Buyer',
        seller: 'Seller',
        both: 'Both'
      }
    },
    entity_table: {
      name: 'Name',
      dateCreationTime: 'Creation date',
      code: 'Code',
      gln: 'GLN',
      town: 'Code',
      province: 'Province',
      country: 'Country',
      nameCentre: 'Name Centre',
      mailbox: 'Mailbox',
      siret: 'International identifier',
      siret_tooltip: 'For France, the SIRET must be entered (14 characters)',
      address: 'Address',
      postcode: 'C.P',
      centreType: 'Centre Type'
    },
    save_changes_notify: 'The center has been updated correctly',
    save_changes_load: 'Saving the data of the center',
    no_contact_data: 'This center does not have contact information',
    no_aproval_flow_data: 'This center does not have users assigned for the approval flow',
    save_changes_insert_notify: 'The center has been added correctly',
    data_contact_ko: 'No more contacts of this type can be added',
    data_contact_repeat: ' The contact data entered is not valid,it is repeated',
    title_delete_user: 'Do you want to delete the center?',
    delete_user_ok: 'The center has been successfully deleted',
    approval_flow: 'Approval levels',
    title_admin_approval_flow: 'Approval flow',
    title_admin_approval_flows: 'Approval flows',
    delete_approval_flow: 'Delete flow',
    confirm_delete_approval_flow: 'Are you sure you want to delete the approval flow?',
    cannot_delete_flow_has_levels: 'Cannot delete the flow. You must first delete the associated levels',
    confirm_delete_approval_level: 'Are you sure you want to delete this approval level?',
    centre_approval_level_table: {
      level: 'Level',
      user: 'Approver user',
      notification: 'Approver user notification'
    },
    data_approval_level_repeat: 'The approval level entered already exists for the user',
    data_approval_level_not_valid: 'An unassigned lower approval level exists',
    data_approval_level_empty: 'Review required form fields',
    approval_level_delete_not_allowed: 'There are higher levels. If you want to delete the item, register a new one for this level beforehand.',
    approval_amount_empty: 'The minimum amount is mandatory and must be greater than or equal to 0',

    // Role Centro
    centre_roles: 'Centre role',
    no_centre_role: 'This centre doesn\'t have any role',
    centre_roles_table: {
      name: 'Role'
    },

    buttons: {
      mass_upload: 'Massive upload',
      add_centre_role: {
        label: 'Add',
        content: 'Add role centre'
      },
      download_csv_approval_flow_tooltip: 'Download CSV file for approval flows and levels',
      download_csv_approval_flow: 'CSV approval flows',
      massive_upload_tooltip: 'Mass upload of approval flows',
      massive_upload_button: 'Load flows',
      centre_massive_charge: 'Massive charge',
      centre_massive_tooltip: 'Massive charge of centres'
    },

    dialog_add_centre_role: {
      title: 'Add role centre',
      role_type: {
        label: 'Role centre',
        placeholder: 'Role type'
      }
    },

    approval_flow_data: {
      amount: 'Minimum amount',
      code: 'Centre code',
      description: 'Approval flow description',
      purchase_order: 'Take the order into account',
      amountTo: 'Maximum amount'
    },
    centre_massive_charge: {
      title: 'Massive charge of centres',
      message: 'File must contain the CSV extension.'
    },
    dialog_add_approval_level: {
      title: 'Add approval level',
      level: {
        label: 'Approval level',
        placeholder: 'Approval level'
      },
      user: {
        label: 'Approver user',
        placeholder: 'User'
      },
      notification: {
        label: 'Send notification pending approval?',
        placeholder: 'Yes / No'
      }
    },

    load: {
      add_centre_role: 'Adding role centre ...',
      delete_centre_role: 'Deleting role centre ...',
      text_load_data: 'Loading data ...',
      text_load_init_data: 'Loading init data ...'
    },

    notify: {
      loadmassive_numlinesOK: 'NNumber of lines processed successfully:',
      add_centre_role: 'The centre role was added succesfully',
      delete_centre_role: 'The centre role was deleted succesfully',
      error_duplicate_role: 'The selected role is already assigned to that centre'
    }
  },

  users: {
    filters: {
      registration_date: {
        value: 'Reg. date-hour'
      },
      username: {
        value: 'Username',
        placeholder: 'Username'
      },
      complete_name: {
        value: 'Name/Surname',
        placeholder: 'Name',
        placeholder_first_surname: 'Surname 1',
        placeholder_second_surname: 'Surname 2'
      },
      trial: {
        value: 'Attempts',
        placeholder: 'Attempts number'
      },
      active: {
        value: 'Active',
        placeholder: 'Select...'
      },
      service_account: {
        value: 'Service Account',
        placeholder: 'Select...'
      },
      last_connection_date: {
        value: 'Last connection date',
        placeholder: 'Last connection date'
      },
      identification_number: {
        value: 'Identification number',
        placeholder: 'Identification number'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      party: {
        value: 'Party',
        placeholder: 'Party'
      },
      party_type: {
        value: 'Party type',
        placeholder: 'Type'
      },
      is_party_sponsor: {
        value: 'Party sponsor',
        placeholder: 'Select...'
      },
      email: {
        value: 'Email',
        placeholder: 'Email'
      }
    },
    error: {
      usuarioKo: 'The user {argumento} does not exist'
    },
    // - CREATE USER
    createuser: {
      steps: {
        user: 'User',
        data: 'Data',
        entity: 'Entities',
        profile: 'Profiles'
      },
      newuser: {
        title: 'New User ',
        username: 'Username',
        email: 'Email',
        success: 'User created successfully'
      },
      datauser: {
        title: ' General user information {username}',
        name: 'Name',
        firstSurname: 'First Surname',
        secondSurname: 'Second Surname',
        taxIdentificationNumber: 'Tax Identification Number'
      },
      party: {
        partyTaxIdentificationNumber: 'Tax identification number party '
      },
      entitiesuser: {
        title: 'Assigning entities to the user {username}'
      },
      profilesuser: {
        title: 'User profiles of {username}'
      },
      error: {
        userExistsWithDifferentMail: 'The user already exists and is associated with another email address. Check the email address or request another user.',
        usernameExists: 'The username already exists in the system.',
        validation: {
          required: {
            username: 'Mandatory field: User',
            mail: 'Mandatory field: Email',
            name: 'Mandatory field: Name',
            first_surname: 'Mandatory field: First surname',
            partyId: 'The partyId parameter is required',
            projectId: 'The projectId parameter is required',
            userId: 'The userId parameter is required',
            userMediaId: 'The userMediaId parameter is required',
            userentities: 'It is mandatory to assign some entity',
            rolesAuthorities: 'It is mandatory to assign some profile/authoritie'
          },
          maxLength_username: 'Maximum length of the field "User": 64 characters',
          minLength_username: 'Minimum length of the field "User": 3 characters',
          forbidden_word: "Change the 'User'field,you can not use that value as a user",
          format_mail: "'Email'does not have a valid format",
          maxLength_mail: 'Maximum length of the field "Email": 255 characters',
          maxLength_name: 'Maximum length of the field "Name": 50 characters',
          invalid_name: 'The "Name" field is not valid',
          maxLength_first_surname: 'Maximum length of the field "First surname": 50 characters',
          invalid_first_surname: 'The "First surname" field is not valid',
          maxLength_TaxID: 'Maximum length of the field "ID identification tax": 20 characters',
          exist_TaxID: 'There is already a user with that NIF',
          maxLength_second_surname: 'Maximum length of the field "Second surname": 50 characters',
          invalid_second_surname: 'The "Second surname" field is not valid',
          not_asociated_project: 'The service does not exist or is not associated with the user.',
          not_asociated_user: 'The User does not exist or is not associated with the user',
          not_asociated_rol: 'Role does not exist or is not associated with the user',
          not_asociated_permission: 'The Permission does not exist or is not associated with the user.',
          not_asociated_party: 'The Party does not exist or is not associated with the user.',
          not_exist: 'There is no relationship between the service and the party',
          userEntity_notfound: 'The user does not exist or does not have privileges to see their entities.'
        }
      },
      created: 'The user has been created correctly'
    },

    users_entity_table: {
      username: 'User',
      complete_name: 'Name/Surname',
      creation_datetime: 'Registration date',
      trail: 'Attempts',
      last_connection_date: 'Last connection',
      password_expiration_date: 'Password expiration date',
      id_number: 'Identification number',
      enable: 'Enable',
      service_account: 'Service Account',
      email: 'Email',
      what_show: 'What do you want to view?',
	  service_account_tooltip: 'Checked: This user is for integration.<br>Unchecked: This user is for portal',
      enable_tooltip: 'Checked: This user is active.<br>Unchecked: This user is inactive'
    },
    users_pagination: {
      csv: 'CSV',
      showing: 'Showing'
    },
    users_multiple_selection: {
      csv: 'CSV',
      massive_reset: 'Massive reset',
      confirm_massive_reset_title: 'Massive reset of users',
      confirm_massive_reset_message: 'All selected users are going to be reset, are you sure?'
    },
    users_filters: {
      button_new_user: 'New user',
      button_reset_users: 'Mass reset',
      button_reset_users_tt: 'Reset',
      button_mass_usercharge: 'Mass charge',
      username_placeholder: 'Username',
      filter_form: {
        no_match: 'Without results',
        placeholder_first_value: 'Select a filter',
        button_add_filter: 'Add'
      }
    },
    user_reset_tooltip: 'Separate usernames with semicolons (;)',
    user_mass_userchargemsg: 'Mass user load. The file must contain the CSV extension.',
    user_upload: 'Select a file',
    no_date: 'Without date',
    load: {
      reset_password: 'Reseting password ...'
    },
    notify: {
      reset_ok: 'Reset has been ok.'
    },
    massive_upload: {
      username: {
        required: 'The field User is mandatory',
        maxLength: 'Username exceeds the maximum allowed length',
        forbidden_word: 'You cannot use that value for user'
      },
      mail: {
        required: 'The email field is mandatory',
        novalid: 'Invalid Email Format',
        maxLength: 'The email exceeds the maximum allowed length',
        emailKO: 'The user\'s email cannot be modified. The user exists in other services'
      },
      firstSurname: {
        maxLength: 'The first surname exceeds the maximum length allowed',
        invalid: 'The First Last Name field is not valid',
        required: 'The First Surname field is required'
      },
      name: {
        maxLength: 'The name exceeds the maximum allowed length',
        invalid: 'Invalid Name field',
        required: 'The Name field is mandatory'
      },
      nif: {
        maxLength: 'The NIF exceeds the maximum allowed length',
        exist: 'A user with the same NIF already exists'
      },
      entities: {
        invalid: 'The format of the entities field is incorrect'
      },
      enabled: {
        invalid: 'The Enabled field is no valid'
      },
      parties: {
        required: 'The Companies field is mandatory',
        noexist: 'The company does not exist'
      },
      error: {
        projectParty: 'The company does not belong to the service',
        centreParty: 'The center does not belong to the company'
      },
      centre: {
        noexist: 'The center does not exist'
      },
      rol: {
        required: 'The Profiles field is mandatory',
        noexist: 'The role does not exist'
      }
    }
  },
  plannedProcesses: {
    filters: {
      group: {
        value: 'Group',
        placeholder: 'Group'
      },
      name: {
        value: 'Name',
        placeholder: 'Name'
      },
      description: {
        value: 'Description',
        placeholder: 'Description'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      jobclass: {
        value: 'Job class',
        placeholder: 'Job class'
      }
    },
    plannedProcesses_table: {
      group: 'Group',
      name: 'Name',
      description: 'Description',
      status: 'Status',
      jobclass: 'Job class',
      triggerCron: 'Planning'
    },
    plannedProcesses_button: {
      pause: 'Pause',
      resume: 'Resume',
      interrupt: 'Interrupt',
      pauseAll: 'Pause',
      resumeAll: 'Resume',
      standby: 'Standby',
      shutdown: 'Shutdown',
      start: 'Start',
      pauseAll_tooltip: 'Stop all tasks',
      resumeAll_tooltip: 'Start all tasks',
      standby_tooltip: 'Stop the whole quartz',
      shutdown_tooltip: 'Turn off the quartz, cannot be started later, only rebooting',
      start_tooltip: 'Start the quart, after a STANDBY'
    },
    text1: 'Meaning of each field: [Seconds] [Minutes] [Hours] [Day of the month Month] [Day of the week] [Year (optional field)]',
    text2: 'Individual subexpressions can contain ranges (-) and / or lists (,).',
    text3: 'The character "*": "all" possible values ​​of this field.',
    text4: 'The "/" character: specify increments in values. For example, if you put "0/15" in the Minutes field, it means "every 15 minutes of the hour".',
    text5: 'The "?": for the day of the month and day of the week fields, indicates "no specific value".'
  },
  mailTemplates: {
    editor: {
      toolbar: {
        bold_tooltip: 'Bold',
        italic_tooltip: 'Italic',
        underline_tooltip: 'Underline',
        orderedList_tooltip: 'Numbered list',
        bulletList_tooltip: 'Bulleted list',
        link_tooltip: 'Insert link',
        image_tooltip: 'Insert image',
        showHtml_tooltip: 'View/edit HTML',
        undo_tooltip: 'Undo',
        redo_tooltip: 'Redo',
        alignLeft_tooltip: 'Align left',
        alignCenter_tooltip: 'Align center',
        alignRight_tooltip: 'Align right',
        justify_tooltip: 'Justify',
        outdent_tooltip: 'Decrease indent',
        indent_tooltip: 'Increase indent',
        sourceCode_tooltip: 'Source code',
        preview_tooltip: 'Preview',
        table_tooltip: 'Table',
        removeFormat_tooltip: 'Clear formatting',
        fontFamily_tooltip: 'Font family',
        fontSize_tooltip: 'Font size'
      },
      source: {
        code: 'Code',
        preview: 'Preview'
      }
    },
    filters: {
      mailType: {
        value: 'Mail type',
        placeholder: 'Mail type'
      },
      language: {
        value: 'Language',
        placeholder: 'Language'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      userHostServer: {
        value: 'Host server mail (user/from/host)',
        placeholder: 'Host server mail (user/from/host)'
      }
    },
    mailTemplates_table: {
      userHostServer: 'Host server mail (user/from/host)',
      mailType: 'Mail type',
      language: 'Language',
      project: 'Service'
    },
    detail: {
      subject: 'Subject',
      body: 'Body',
      delete_template: 'Delete mail template',
      delete_template_ok: 'Mail template deleted correctly',
      save_changes: 'Mail template updated correctly',
      create_template_ok: 'Mail template created correctly',
      confirm: {
        title_delete_template: '¿Are you sure to delete this mail template?'
      }
    },
    new_template: 'New template',
    create_template: 'Create template',
    add_template: 'Adding mail template',
    clone: {
      title: 'Clone template',
      label: 'Clone'
    },
    error: {
      duplicated: 'Already exists a template with the same,mail type,service and language',
      notFound: 'Any required field has not been filled'
    }
  },
  communicationm: {
    filters: {
      id: {
        value: 'Id',
        placeholder: 'Id'
      },
      name: {
        value: 'Name',
        placeholder: 'Name'
      },
      docTypeName: {
        value: 'Document type',
        placeholder: 'Document type'
      },
      enabled: {
        value: 'Active',
        placeholder: 'Select...',
        enabled: 'Enabled',
        disabled: 'Disabled'
      },
      description: {
        value: 'Description',
        placeholder: 'Description'
      },
      creationDateTimeFrom: {
        value: 'Creation date from',
        placeholder: 'Creation date from'
      },
      creationDateTimeTo: {
        value: 'Creation date to',
        placeholder: 'Creation date to'
      }
    },
    communicationm_table: {
      id: 'Id',
      name: 'Name',
      countryReception: 'Reception country',
      docTypeName: 'Document type',
      description: 'Description',
      creationDateTime: 'Creation date',
      enable: 'Active',
      disabled: 'Inactive',
      byCountryEmission: 'Emission by country',
    },
    msg_generics: {
      saving: 'Saving the communication data',
      enable: 'Enabled',
      disable: 'Disabled',
      no_match: 'No matches found',
      advanced_search: 'Advanced search',
      search: 'Search',
      popover_clean_filters: 'Clear filters'
    },
    notify: {
      save_changes: 'The status has been updated',
      error_save_changes: 'The status has not been updated'
    }
  },
  articles: {
    filters: {
      id: { value: 'Article ID', placeholder: 'Enter the article ID' },
      seller: { value: 'Seller', placeholder: 'Select sellers' },
      buyer: { value: 'Buyer', placeholder: 'Select buyers' },
      itemCode: { value: 'Item code (exact)', placeholder: 'Enter the exact code' },
      itemCodeLike: { value: 'Item code (like)', placeholder: 'Enter the code (wildcards allowed)' },
      startIndexOfLikeCharacters: { value: 'Minimum like index', placeholder: 'Enter the minimum index' },
      description: { value: 'Description (like)', placeholder: 'Enter the description' },
      creationDateTimeFrom: { value: 'Creation date from', placeholder: 'Select start date' },
      creationDateTimeTo: { value: 'Creation date to', placeholder: 'Select end date' },
      futureGrossPriceDate: { value: 'Range future price update', placeholder: 'Select range date' },
      pendingUpdate: { value: 'Pending update', placeholder: 'Select an option' },
      enabled: { value: 'Active', placeholder: 'Select status' }
    },
    table: {
      seller: 'Seller',
      buyer: 'Buyer',
      itemCode: 'Item code',
      itemDescription: 'Description',
      grossPrice: 'Gross price',
      futureGrossPriceDate: 'Next price change',
      futureGrossPrice: 'New price',
      creationDateTime: 'Creation date',
      enable: 'Active'
    },
    msg_generics: {
      enabled: 'Enabled',
      filter_table_menu: 'Column menu',
      popover_clean_filters: 'Clear filters',
      load_init: 'Loading results…',
      order_table: 'Sorting table…',
      size_table: 'Updating page size…',
      pagination_table: 'Changing page…',
      saving: 'Saving changes…',
      filter_date: 'Filtering by date…',
      filter_delete: 'Removing filter…',
      filter_delete_all: 'Removing all filters…',
      no_match: 'No matches',
      advanced_search: 'Advanced search',
      disabled: 'Disabled'
    },
    notify: {
      save_changes: 'Changes saved successfully',
      error_save_changes: 'Error saving changes',
      no_articles_found: 'No articles found with the specified filters',
      updating: 'Updating..',
      updated: 'Updated successfully',
      error_updating: 'Error updating articles'
    },
    buttons: {
      add_article: 'Add',
      article_created: 'Article created successfully',
      cancel_new_article: 'Cancel'
    }
  },
  profiles: {
    new: 'New profile',
    filters: {
      name: {
        value: 'Profile',
        placeholder: 'Profile name'
      },
      description: {
        value: 'Description',
        placeholder: 'Description'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      }
    },
    notify: {
      add_profile: 'Profile created correctly',
      delete_profile: 'Profile deleted correctly.',
      save_changes: 'Profile updated corectly'
    },
    confirm: {
      delete_profile: 'Are you sure to delete the profile?'
    },
    load: {
      add_profile: 'Adding profile ...',
      delete_profile: 'Removing profile ...'
    },
    profiles_table: {
      name: 'Profile',
      description: 'Description',
      project: 'Service'
    },
    profiles_auth: {
      name: 'Name',
      description: 'Description',
      module: 'Module'
    }
  },
  form_new_role: {
    new_role: 'Create new profile',
    service: 'Service',
    role: 'Profile',
    delete: 'Erasable',
    description: 'Description',
    submit: 'Send',
    permisos: 'Permissions',
    dialog: {
      delete: 'Is it erasable?',
      service: 'Choose the service',
      permisos: 'Choose the permissions'
    }
  },
  taxes: {
    new: 'New tax',
    filters: {
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      type: {
        value: 'Tax type',
        placeholder: 'Tax type'
      },
      rate: {
        value: 'Rate',
        placeholder: 'Tax rate'
      },
      enabled: {
        value: 'Enabled',
        placeholder: 'Select...'
      },
      country: {
        value: 'Country',
        placeholder: 'Country'
      },
      validity_date_from: {
        value: 'Validity date from',
        placeholder: 'Validity date from'
      },
      validity_date_to: {
        value: 'Validity date to',
        placeholder: 'Validity date to'
      },
      legal_text: {
        value: 'Motive',
        placeholder: 'Motive'
      },
      taxable_event: {
        value: 'Taxable event'
      }
    },
    notify: {
      add_tax: 'Tax created correctly',
      delete_tax: 'Tax deleted correctly.',
      save_changes: 'Tax updated corectly'
    },
    confirm: {
      delete_tax: 'Are you sure to delete the tax?'
    },
    load: {
      add_tax: 'Adding tax ...',
      delete_tax: 'Removing tax ...'
    },
    taxes_table: {
      type: 'Type',
      rate: 'Rate',
      country: 'Country',
      validity_date_from: 'Validity date from',
      validity_date_to: 'Validity date to',
      enable: 'Enable',
      project: 'Service'
    },
    rules_form: {
      validity_date_msg: 'The validity date from cannot be later than the validity date until',
      duplicated_text: 'Duplicate value. The legal text associated with the tax already exists.'
    },
    validity_date: 'Validity date',
    delete_tax: 'Delete',
    delete_tax_tooltip: 'Delete tax',
    no_legalTex: 'Tax without legal texts',
    add_legalText_tooltip: 'Load legal text'
  },
  userInformation: {
    title: 'Information',
    validity_date: 'Validity period',
    message: 'Message',
    message_placeholder: 'Write the message to display',
    close: 'Close',
    dont_show_again: 'Do not show this message again',
    rules: {
      message_required: 'A message is required',
      date_range: 'The start date cannot be later than the end date'
    },
    notify: {
      warning: 'Warning',
      error: 'Error',
      saved_title: 'Saved',
      deleted_title: 'Deleted',
      created: 'Message created successfully',
      updated: 'Message updated successfully',
      deleted: 'Message deleted successfully',
      load_error: 'The information message could not be loaded',
      save_error: 'The information message could not be saved',
      delete_error: 'The information message could not be deleted'
    }
  },
  mailServer: {
    new: 'New mail server',
    notify: {
      add_mailServer: 'Mail server created correctly',
      delete_mailServer: 'Mail server deleted correctly.',
      save_changes: 'Mail server updated corectly'
    },
    confirm: {
      delete_mailServer: 'Are you sure to delete the mail server?'
    },
    load: {
      add_mailServer: 'Adding mail server ...',
      delete_mailServer: 'Removing mail server ...'
    },
    mailServer_table: {
      host: 'Host',
      user: 'User',
      password: 'Password',
      mailfrom: 'Mail address from',
      port: 'Port',
      auth: 'Auth',
      protocol: 'Protocol',
      idClient: 'Client ID',
      idTenant: 'Organization ID',
      clientSecret: 'Client Secret',
      validityDateTo: 'Access validity date',
      saveToSentItems: 'Save Sent Emails'
    },
    test_error: 'Connection with mail server failed',
    test_ok: 'Connection with mail server ok',
    auth_error: 'Authentication failed',
    delete_mailServer: 'Delete',
    delete_mailServer_tooltip: 'Delete mail server',
    test_tooltip: 'Test connection',
    test: 'Test',
    duplicate_error: 'There is already a mail server with this data'
  },
  user_detail: {
    info_user: 'User information',
    new_role: 'Create profile',
    user_detail_edit_form: {
      name: 'Name',
      first_surname: 'First surname',
      second_surname: 'Second surname',
      id_number: 'Identification tax number',
      department: 'Department',
      enable: 'Disabled/Enabled status',
      service_account: 'Service Account',
      reset_otp: 'Reset OTP'
    },
    delete_user: 'Delete',
    delete_user_tooltip: 'Delete user',
    duplicate_user: 'Duplicate',
    duplicate_user_tooltip: 'Duplicate user',
    reset_pass_user: 'Reset password',
    user_media: 'User media',
    no_user_media: 'This user has not any contact data',
    add_user_media: 'Add',
    add_user_media_tooltip: 'Add user media',
    user_media_table: {
      media_type_name: 'Contact type',
      value: 'Contact'
    },
    dialog_add_user_media: {
      title: 'User media',
      media_type_name: 'Contact type',
      value: 'Contact',
      button_add: 'Add'
    },
    dialog_change_user_email: {
      title: 'New user email',
      old_email: 'Current email',
      new_email: 'New email',
      button_add: 'Update'
    },
    user_entity: 'User entities',
    no_user_entity: 'Este usuario no tiene ninguna entidad de usuario',
    add_user_entity: 'Add',
    add_user_entity_tooltip: 'Add user entity',
    user_entity_table: {
      project_name: 'Name service',
      party_tax_identification_number: 'Party/Tax Id Number',
      centre_code: 'Code/centre'
    },
    dialog_add_user_entity: {
      title: 'User entities',
      project_name: 'Name service',
      option_all_project: 'All',
      party_tax_identification_number: 'Party/Tax Id Number',
      option_all_party: 'All',
      centre_code: 'Code/centre',
      option_all_centre: 'All',
      button_add: 'Add'
    },
    roles_authorities: 'Profiles/Authorities',
    no_user_authorities: 'This user does not have permissions',
	no_user_authorities_sign: 'This user does not have permissions for this party',
    option_all_project_roles_authorities: 'All',
    roles: 'Profiles',
    authorities: 'Authorities',
    add_new_role: 'Add',
    save_roles_authorities: 'Save',
    add_new_role_tooltip: 'Add new profile',
    save_roles_authorities_tooltip: 'Save changes',
    cancel_roles_authorities: 'Cancel',
    cancel_roles_authorities_tooltip: 'Cancel changes',
    load: {
      delete_user_media: 'Deleting user media ...',
      add_user_media: 'Adding user media ...',
      add_user_entity: 'Adding user entity ...',
      delete_user_entity: 'Deleting user entity ...',
      change_roles_user: 'Changing user authorities ...',
      init_user_data: 'Loading user data ...',
      change_user_email: 'Updating user email ...'
    },
    notify: {
      reset_password_ok: 'New password has been sent to email',
      delete_user_media: 'User media deleted correctly.',
      add_user_media: 'User media added correctly.',
      add_role: 'The profile was created successfully.',
      add_user_entity: 'User entity added correctly.',
      add_user_entity_repeat: 'User has already assigned this entity',
      add_user_entity_validateko: 'This entity has been contemplated before',
      delete_user_entity: 'User entity deleted correctly.',
      delete_user_entityko: 'User must have an entity at least',
      delete_user_ok: 'User deleted correctly',
      save_user_entityko: 'User must have an entity at least',
      change_user_email: 'User email updated successfully.',
      reset_otp_ok: 'OTP reset successfully. The user will need to configure their two-factor authentication on next login.'
    },
    confirm: {
      title_delete_user: 'Are you sure to delete this user?',
      message_delete_user: 'This action will delete all information related to the user. It is recommended to deactivate the user.',
      confirm_button_delete_user: 'Delete',
      title_reset_password: 'Are you sure you want to change this user\'s password?',
      confirm_button_reset_password: 'Reset',
      title_delete_user_media: 'Are you sure to delete this user media?',
      confirm_button_delete_user_media: 'Delete',
      title_delete_user_entity: 'Are you sure to delete this user entity?',
      confirm_button_delete_user_entity: 'Delete',
      change_user_email: 'The user must have an email as user media. To delete the current email you must enter a new email.',
      reset_otp_title: 'Are you sure you want to reset this user\'s OTP?',
      reset_otp_message: 'This action will force the user to reconfigure their two-factor authentication the next time they log in.',
      confirm_button_reset_otp: 'Reset OTP',
	  service_account_title: 'Access via service',
	  service_account_ok_message: 'This user can only access via integration channels.',
	  service_account_ko_message: 'This user can only access via the portal.',
	  service_account_ok: 'Access by updated service'
    }
  },

  // Recepciones emitidas y recibidas
  recadv: {
    number: {
      max: 'The maximum number of characters is 20'
    },
    filters: {
      creation_date: {
        value: 'Registration date-hour'
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Enter 3 characters'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Enter 3 characters'
      },
      delivery_date: {
        value: 'Delivery dates range',
        placeholder: 'Delivery dates'
      },
      reception_date: {
        value: 'Reception dates range',
        placeholder: 'Reception dates'
      },
      recadv_number: {
        value: 'Receipt advice number',
        placeholder: 'Receipt advice number'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      order_number: {
        value: 'Order number',
        placeholder: 'Order'
      },
      delivery_number: {
        value: 'Delivery note number',
        placeholder: 'Delivery note'
      },
      invoice_recadv: {
        value: 'Invoice number',
        placeholder: 'Invoice'
      }
    },
    recadv_entity_table: {
      buyer: 'Buyer',
      seller: 'Seller',
      num_recadv: 'N. recadv',
      date_receiving: 'Receiving D.',
      date_creation: 'Registration D.',
      status: 'Status',
      services: 'Service',
      invoice_recadv: 'N. invoice',
      buyer_centre: 'Buyer centre',
      delivery_centre: 'Place of delivery',
      seller_centre: 'Seller centre',
      csv_title: 'Export to CSV. Information',
      csv_message: 'Cannot export more than {argumento} records, please narrow your search',
      csv_details_message: 'You cannot export lines of more than 200 documents, please narrow your search',
	  total_amount: "Total amount",
    },

    recadv_entity_table_detail: {
      code: 'Code Article',
      lineNumber: 'Lin Nº',
      itemCodeSeller: 'Code. seller item',
      itemCodeBuyer: 'Cod. buyer item',
      deliveryNoteNumber: 'Delivery note',
      deliveryNoteLine: 'Delivery note line',
      description: 'Description',
      order: 'Order',
      despatch_quantity: 'Despatch quantity',
      received_quantity: 'Received quantity',
      accepted_quantity: 'Accepted quantity',
      measure: 'Unit of measurement',
      price: 'Unit price',
      currency: 'Currency',
      status: 'Status',
      options: 'Options',
      subtype: 'Subtype'
    },
    recadv_related_documents_table: {
      date: 'Relation date',
      destinationDocument: 'Document Nº',
      destinationDocumentType: 'Document type'
    },
    recadv_detail: {
      recadv_line_no_data: 'This order has no lines',
      create_invoice_buttons: 'Create',
      activate_recadv_buttons: 'Activate',
      rejected_recadv_buttons: 'Rejected',
      recadv_line_no_date: 'This recadv does not have lines',
      related_documents_no_data: 'This recadv does not have related documents',
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Download PDF recadv',
      create_invoice_buttons_tooltip: 'Create invoice',
      activate_recadv_buttons_tooltip: 'Activate recadv',
      rejected_recadv_buttons_tooltip: 'Rejected recadv',
      rejected_recadv_lineError: 'Framing line',
      download_pdfmultiple_buttons: 'Download recadv/s',
      download_pdfmultiple_buttons_tooltip: 'Download PDF reception\\s',
      create_line_buttons_tooltip: 'Create inset line',
      edit_line_buttons_tooltip: 'Edit inset line',
      related_documents: 'Related documents',
      reception_lines: 'Reception lines',
      edit: 'Edit',

      dialog_rejected_recadv: {
        title: 'Rejected recadv',
        value: 'Motive',
        placeholder: 'Motive rejected',
        motive_required: 'Motive required'
      },

      change_state: {
        label: 'Change of status',
        placeholder: 'Choose a recadv status',
        load: 'Updating recadv data ...'
      },

      dialog_new_check_line_recadv: {
        title: 'New reception line',
        title_edit: 'Edit Reception Line',
        description: 'Item Description',
        quantity: 'Quantity',
        priceUnit: 'Unit price.',
        date_required: 'Obligatory field',
        measure: 'Measure',
        measureUnit: {
          PCE: 'Pieces',
          KGM: 'Kilograms',
          MTR: 'Lineal meter',
          TNE: 'Ton',
          LTR: 'Liter',
          MTQ: 'Cubic meter',
          DMQ: 'Cubic decimeter',
          CENT: 'Hundreds',
          MILL: 'Thousands',
          MTK: 'M. squares',
          BOX: 'Box',
          BOTL: 'Botella',
          NTBK: 'Notebook',
          GRM: 'Gram',
          GRSA: 'Gross',
          SHEE: 'Sheet',
          GAME: 'Game',
          PAR: 'Pair',
          OVLL: 'Ball',
          CARR: 'Reel',
          PACK: 'Package',
          DOCE: 'Dozen',
          K: 'K',
          R: 'R',
          B: 'B',
          UN: 'Units'
        },
        search_measure: 'Choose unit of measure'
      },

      notify: {
        submit_edit_recadv_ok: 'The status of the receipt has been modified successfully',
        recadv_rejected: 'The recadv has been rejected correctlye',
        recadv_activate: 'The recadv has been activated',
        download_pdf: 'The download of the file {file} was correct.',
        recadv_new_line: 'A new line of debugging has been successfully registered',
        recadv_edit_line: 'The offset line has been successfully modified'
      },
      load: {
        recadv_rejected: 'Rejecting recadv',
        recadv_activate: 'Activating  reception'
      },
      confirm: {
        title_recadv_activate: 'The reception {recadvID},from the provider {sellerName},will be activated. do you wish to continue?',
        confirm_button_recadv_activate: 'Ok'
      }
    }
  },
  // Albaranes
  delivery: {
    number: {
      max: 'The maximum number of characters is 30'
    }
  },
  // Pedidos emitidos y recibidos
  order: {
    number: {
      max: 'The maximum number of characters is 20'
    },
    filters: {
      creation_date: {
        value: 'Registration date-hour'
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Enter 3 characters'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Enter 3 characters'
      },
      delivery_date: {
        value: 'Delivery dates range',
        placeholder: 'Delivery dates'
      },
      order_date: {
        value: 'Order dates range',
        placeholder: 'Order dates'
      },
      issue_date: {
        value: 'Issue date range',
        placeholder: 'Issue date'
      },
      order_number: {
        value: 'Order number',
        placeholder: 'Order'
      },
      deliveryNote_number: {
        value: 'Delivery note number',
        placeholder: 'Delivery note'
      },
      invoice_number: {
        value: 'Invoice number',
        placeholder: 'Invoice'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      invoice_order: {
        value: 'Invoice number',
        placeholder: 'Invoice'
      },
      orderType: {
        value: 'Type',
        placeholder: 'Order type'
      },
      orderSubType: {
        value: 'Subtype',
        placeholder: 'Order subtype'
      },
      deliveryDateFrom: {
        value: 'Delivery date from',
        placeholder: 'Delivery date from'
      },
      deliveryDateTo: {
        value: 'Delivery date to',
        placeholder: 'Delivery date to'
      },
      no_error_status: {
        value: 'Excluded status',
        placeholder: 'Excluded status',
        rejected: 'Rejected status'
      }
    },
    order_entity_table: {
      buyer: 'Buyer',
      seller: 'Seller',
      num_order: 'N.Order',
      date_creation: 'Registration D.',
      date_issue: 'Issue D.',
      status: 'Status',
      services: 'Service',
      invoice_order: 'N.Invoice',
      buyer_centre: 'Buyer centre',
      seller_centre: 'Seller centre',
      delivery_centre: 'Delivery centre',
      order_type: 'Type',
      delivery_date_from: 'Delivery date from',
      delivery_date_to: 'Delivery date to',
      csv_title: 'Export to CSV. Information',
      csv_message: 'Cannot export more than {argumento} records, please narrow your search',
      csv_details_message: 'You cannot export lines of more than 100 documents, please narrow your search'
    },
    order_entity_table_detail: {
      code: 'Cod. Article',
      lineNumber: 'Lin Nº',
      itemCode: 'Article code',
      itemCodeSeller: 'Article code seller',
      itemCodeBuyer: 'Article code buyer',
      gtin14Code: 'GTIN14 code',
      delivery_centre: 'Delivery point',
      quantity: 'Quantity',
      description: 'Description',
      order: 'Order',
      despatch_quantity: 'Despatch quantity',
      received_quantity: 'Received quantity',
      accepted_quantity: 'Accepted quantity',
      measure: 'Unit of measurement',
      unitPrice: 'Unit price',
      totalAmount: 'Total line price',
      deliveryDate: 'Delivery date',
      documentStatus: 'Line status',
      currency: 'Currency',
      status: 'Status',
      options: 'Options',
      notes: 'Notes',
      quantityTradeUnit: 'Quantity trade unit',
      measureTradeUnit: 'Unit of measurement trade unit',
      netPrice: 'Net price',
      grossPrice: 'Gross price',
      quantityRemaining: 'Remaining quantity',
      change_state: {
        title: 'Change of order line status',
        label: 'Change of line status',
        placeholder: 'Select a line status',
        load: 'Updating order line data ...'
      }
    },
    order_related_documents_table: {
      date: 'Relation date',
      destinationDocument: 'Document Nº',
      destinationDocumentType: 'Document type'
    },
    order_charges_discounts_table: {
      chargeDiscountTypeCode: 'Description',
      charge: 'Type',
      charge_code: {
        TD: 'Commercial discount',
        EAB: 'Discount for early payment',
        ABH: 'Volume or rappel discount',
        ACQ: 'Canon Authors Society',
        MC: 'Meat flour rate',
        VEJ: 'Green Point',
        AA: 'Advertising fee'
      },
      rate: 'Rate (in %)',
      baseAmount: 'Base amount',
      amount: 'Amount',
      currencyCode: 'Currency',
      sequence: 'Sequence'
    },
    order_detail: {
      create_invoice_buttons: 'Create',
      activate_order_buttons: 'Activate',
      rejected_order_buttons: 'Reject',
      order_line_no_data: 'This order does not have lines',
      related_documents_no_data: 'This order does not have related documents',
      charge_discounts_no_data: 'This order does not have charges/discounts',
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Download PDF order',
      create_invoice_buttons_tooltip: 'Create invoice',
      create_deliveryNote_buttons_tooltip: 'Create delivery note',
      activate_order_buttons_tooltip: 'Activate order',
      rejected_order_buttons_tooltip: 'Reject order',
      rejected_order_lineError: 'Framing line',
      download_pdfmultiple_buttons: 'Download order/s',
      download_pdfmultiple_buttons_tooltip: 'Download PDF order\\s',
      create_line_buttons_tooltip: 'Create inset line',
      edit_line_buttons_tooltip: 'Edit inset line',
      change_line_status_buttons_tooltip: 'Change of order line status',
      change_line_status_buttons: 'Change status',

      order_lines: 'Order lines',
      related_documents: 'Related documents',
      charge_discount: 'Charges and discounts',
      edit: 'Edit',
      order_reponse: 'Order responses',
      order_reponse_download_tooltip: 'Download response',
      order_reponse_number: 'Response No.',
      order_reponse_name: 'Name',
      order_reponse_date: 'Registration D.',
      order_response_no_data: 'This order does not have responses',

      dialog_rejected_order: {
        title: 'Reject order',
        value: 'Motive',
        placeholder: 'Motive rejected',
        motive_required: 'Motive required'
      },

      dialog_new_check_line_order: {
        title: 'New order line',
        title_edit: 'Edit Order Line',
        description: 'Item Description*',
        quantity: 'Quantity*',
        priceUnit: 'Unit price.*',
        date_required: 'Obligatory field'
      },

      dialog_accept_order: {
        title: 'Accept order and generate response',
        orderResponseNumberLabel: 'Order response number'
      },

      change_state: {
        label: 'Change of status',
        placeholder: 'Choose a order status',
        load: 'Updating order data ...'
      },
      notify: {
        submit_edit_order_ok: 'The order status has been successfully modified',
        order_rejected: 'The order has been rejected correctlye',
        order_activate: 'The order has been activated',
        download_pdf: 'The download of the file {file} was correct.',
        order_new_line: 'A new line of debugging has been successfully registered',
        order_edit_line: 'The offset line has been successfully modified',
        line_error: 'You cannot select invalid lines to create the invoice'
      },
      load: {
        order_rejected: 'Rejecting order',
        order_activate: 'Activating  order'
      },
      confirm: {
        title_order_activate: 'The order {orderID},from the provider {sellerName},will be activated. do you wish to continue?',
        title_order_reject: 'The order {orderID},from the provider {sellerName},will be rejected. do you wish to continue?',
        confirm_button_order_activate: 'Ok'
      }
    }
  },
  // reporte de ventas.
  sales_report: {
    number: {
      max: 'The report number cannot exceed 35 characters'
    },
    filters: {
      service: {
        value: 'Service',
        placeholder: 'Service'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Select a seller'
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Select a buyer'
      },
      store: {
        value: 'Point of sale',
        placeholder: 'Select a point of sale'
      },
      document_number: {
        value: 'Report No.',
        placeholder: 'Report number'
      },
      sale_date: {
        value: 'Sale date range',
        placeholder: 'Select a sale date'
      },
      article_code: {
        value: 'Item code',
        placeholder: 'Item code'
      },
      creation_date: {
        value: 'Registration date-hour'
      }
    },
    sales_report_entity_table: {
      slsrpt_number: 'Report No.',
      service: 'Service',
      seller: 'Seller',
      buyer: 'Buyer',
      centre_buyer: 'Point of sale',
      issue_date: 'Issue date',
      creation_date_time: 'Registration date',
      status: 'Status',
      expiration_date_time: 'Expiration date',
      csv_title: 'Export to CSV. Information',
      csv_message: 'You cannot export more than {argumento} records, please narrow your search'
    },
    sales_report_entity_table_detail: {
      lineNumber: 'Line No.',
      itemCode: 'Item code',
      itemDescription: 'Item description',
      quantitySales: 'Quantity sold',
      quantityReturn: 'Quantity returned',
      salesDate: 'Sale date',
      centre_buyer: 'Point of sale'
    },
    sales_report_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Download sales report PDF',
      sales_report_lines: 'Sales report lines',
      edit: 'Edit',
      related_documents: 'Related documents',
      related_documents_no_data: 'This report has no related documents',
      sales_report_line_no_data: 'This report has no lines',
      notify: {
        download_pdf: 'The file {file} was downloaded successfully.'
      },
      load: {
        download_pdf: 'Downloading sales report PDF ...'
      }
    },
    buttons: {
      download_csv_tooltip: 'Download CSV',
      download_original_tooltip: 'Download original'
    }
  },
  // reporte de inventario.
  inventory_report: {
    number: {
      max: 'The report number cannot exceed 35 characters'
    },
    filters: {
      service: {
        value: 'Service',
        placeholder: 'Service'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Select a seller'
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Select a buyer'
      },
      store: {
        value: 'Point of inventory',
        placeholder: 'Select a point of inventory'
      },
      document_number: {
        value: 'Report No.',
        placeholder: 'Report number'
      },
      quantity_incoming_date: {
        value: 'Inventory date range',
        placeholder: 'Select an inventory date'
      },
      article_code: {
        value: 'Item code',
        placeholder: 'Item code'
      },
      creation_date: {
        value: 'Registration date-hour'
      }
    },
    inventory_report_entity_table: {
      invrpt_number: 'Report No.',
      service: 'Service',
      seller: 'Seller',
      buyer: 'Buyer',
      centre_buyer: 'Point of inventory',
      issue_date: 'Issue date',
      creation_date_time: 'Registration date',
      status: 'Status',
      expiration_date_time: 'Expiration date',
      csv_title: 'Export to CSV. Information',
      csv_message: 'You cannot export more than {argumento} records, please narrow your search'
    },
    inventory_report_entity_table_detail: {
      lineNumber: 'Line No.',
      itemCode: 'Item code',
      itemDescription: 'Item description',
      quantityTarget: 'Quantity sold',
      quantityIncoming: 'Quantity returned',
      quantityStock: 'Stock quantity',
      quantityIncomingDate: 'Inventory date',
      centre_buyer: 'Point of inventory'
    },
    inventory_report_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Download inventory report PDF',
      inventory_report_lines: 'Inventory report lines',
      edit: 'Edit',
      related_documents: 'Related documents',
      related_documents_no_data: 'This report has no related documents',
      inventory_report_line_no_data: 'This report has no lines',
      notify: {
        download_pdf: 'The file {file} was downloaded successfully.'
      },
      load: {
        download_pdf: 'Downloading inventory report PDF ...'
      }
    },
    buttons: {
      download_csv_tooltip: 'Download CSV',
      download_original_tooltip: 'Download original'
    }
  },
  // REMADV Translations
  remadv: {
    buttons: {
      download_csv_tooltip: 'Download REMADV CSV',
      download_original_tooltip: 'Download original'
    },
    remadv_entity_table: {
      service: 'Service',
      seller: 'Seller',
      buyer: 'Buyer',
      invoicee_centre: 'Invoiced center',
      remadv_number: 'Settlement notice No.',
      invoice_number: 'Invoice No.',
      issue_date: 'Issue date',
      document_date: 'Document date',
      total_amount: 'Settlement amount',
      currency: 'Currency',
      creation_date_time: 'Creation date',
      status: 'Status',
      payment_date: 'Payment date',
      notes: 'Notes'
    },
    lines_remadv_entity_table: {
      line_number: 'Line No.',
      document_number: 'Document No.',
      document_date: 'Issue date',
      description: 'Description',
      centre_code: 'Invoicer',
      document_amount: 'Total',
      currency: 'Currency',
      payment_date: 'Payment date'
    },
    remadv_detail: {
      remadv_lines: 'Settlement notice lines',
      remadv_line_no_data: 'This settlement notice has no lines'
    },
    csv_title: 'Export to CSV. Information',
    csv_message: 'Cannot export more than {argumento} records, please narrow the search',
    csv_details_message: 'Cannot export lines from more than 100 documents, please narrow the search',
    filters: {
      service: {
        value: 'Service',
        placeholder: 'Service'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Select a seller'
      },
      buyer: {
        value: 'Buyer',
        placeholder: 'Select a buyer'
      },
      centre_payer: {
        value: 'Invoiced center',
        placeholder: 'Select an invoiced center'
      },
      remadv_number: {
        value: 'Settlement notice No.',
        placeholder: 'Settlement notice No.'
      },
      invoice_number: {
        value: 'Invoice number',
        placeholder: 'Invoice number'
      },
      issue_date: {
        value: 'Issue date range',
        placeholder: 'Select an issue date range'
      },
      document_date: {
        value: 'Document date range',
        placeholder: 'Select a document date range'
      },
      total_amount_from: {
        value: 'Settlement amount from',
        placeholder: 'Settlement amount from'
      },
      total_amount_to: {
        value: 'Settlement amount to',
        placeholder: 'Settlement amount to'
      },
      validation: {
        amount_range: 'The starting amount cannot be greater than the ending amount'
      },
      creation_date: {
        value: 'Registration date-time'
      }
    }
  },
  cmr: {
    cmr_entity_table_detail: {
      cargo_general_data: 'Cargo',
      cargo_general_data_tooltip: 'General cargo data',
      sent: 'Sent',
      deleteAttach: 'Delete attachment',
      general_data: 'General data',
      document_control: 'Control Document',
      cmr: 'CMR',
      cmrNumber: 'Transport document number',
      group: 'Group',
      order: 'Order',
      loadparty: 'Load company',
      load: 'Load centre',
      shipper: 'Shipper',
      buyer: 'Buyer',
      seller_centre: 'Load centre',
      buyer_centre: 'Delivery centre',
      loadcode: 'Load centre code',
      loaddirection: 'Load centre address',
      deliveryparty: 'Delivery company',
      delivery: 'Delivery centre',
      deliverycode: 'Delivery centre code',
      deliverydirection: 'Delivery centre address',
      numpackages: 'Num packages',
      weight: 'Weight',
      dateCreation: 'Creation date',
      status: 'Status',
      service: 'Service',
      cmrlines: 'Transport document lines',
      cmrObservation: 'Observations/Incidents of transport document',
      addObservationTitle: 'Add observation/incident',
      addObservationOk: 'Observation/incident added successfully to the transport document',
      observation: 'Observation/incident',
      deleteObservation: 'Delete observation/incident',
      addLineTitle: 'Add line',
      deleteLineTitle: 'Delete line',
      deleteLine: 'Delete line',
      deleteLineOk: 'Line deleted successfully',
      cannot_delete_last_line: 'Cannot delete the last line',
      must_keep_one_line: 'There must be at least one line, if you want to delete this line you must add a new line first',
      addLineOk: 'Line added successfully',
      sendlink: 'Send',
      sendlink_tooltip: 'Accept/Send link',
      sendlink_ok: 'Link sent successfully',
      sendlink_confirm: 'Do you want to confirm and send the link?',
      changeplates: 'Transport data',
      changeplates_tooltip: 'Change driver, plates and carrier data',
      changeplates_confirm: 'Do you want to change the vehicle plates?',
      changeplates_ok: 'Data updated successfully',
      changeobservations: 'Observations/Incidents',
      changeobservations_tooltip: 'Add observation/incident',
      changegeneralobservations: 'Observations',
      changegeneralobservations_tooltip: 'General observations',
      changeobservations_confirm: 'Do you want to change the observations?',
      changeobservations_ok: 'Observations/incidents updated successfully',
      updatestatus: 'Status',
      updatestatus_tooltip: 'Change status',
      updatestatus_ok: 'Status updated successfully',
      plate: 'Tractor vehicle registration',
      trailerplate: 'Semi-trailer registration',
      secondTrailerplate: 'Trailer registration',
	  id_cmr: 'Internal ID',
      cmrnolines: 'This waybill has no lines',
      cmrnoObservations: 'This transport document has no remarks/incidents',
      events: 'Events',
      download_attach: 'Downloading Attachment',
      linecode: 'Code',
      linecodeseller: 'Seller code',
      download_pdf: 'Download PDF',
      download_original: 'Original',
      download_metadata: 'Metadata',
      line: 'Line',
      description: 'Description/Nature of the goods',
      csv_message: 'Cannot export more than {argumento} records, please narrow your search',
      csv_title: 'Export to CSV. Information',
      transportist_data: 'Carrier data',
      transportist_search: {
        title: 'Search carrier',
        col_name: 'Name',
        col_nif: 'Tax ID',
        col_email: 'Email'
      },
      warn_required_fields: 'Optional data in drafts that must be completed before sending the document to the carrier',
      warn_required_fields_stop: 'This information is mandatory if no stops are included as it is a single delivery',
      charger_observations: 'Charger observations',
      transportist_observations: 'Carrier observations',
      observation_type: 'Observation/incident type',
      transportist_name: 'Carrier name',
      transportist_nif: 'Carrier NIF',
      transportist_email: 'Carrier email',
      emailTransportist: 'Carrier/driver email',
      email_conductor: 'Driver email',
      conductor: 'Driver',
      email_link_note: 'This is the email to which the pdf link will be sent',
      observation_type_values: {
        INCIDENCE: 'Incidence',
        UNPLANNEDSTOP: 'Unplanned stop',
        DELIVERYNOTES: 'Delivery notes',
        DELAY: 'Delay',
        MERCHANDISESTATUS: 'Merchandise status',
        OTHER: 'Other',
      },
      transportist_default: 'Carrier',
      send_date: 'Send date',
      send_date_long: 'Send date',
      update_cmr: 'Updating data...',
      submit_edit_ok: 'Data updated correctly',
      confirm_update_status: 'Are you sure to change the status of the transport document?',
	    confirm_sign_pdf: 'Are you sure you want to sign the PDF?',
	    confirm_sign_pdf_ok: 'PDF signed successfully',
      confirm_draft: 'Are you sure you want to send the transport document to draft?',
      load_signing: 'Signing PDF ...',
      biometric_signature: {
        title: 'Biometric signature of the document',
        no_pdf: 'No PDF document to sign',
        init_error: 'Error initializing the signature system',
        error: 'Error during the signing process',
        saving: 'Saving signed document...',
        success: 'Document signed and saved successfully'
      },
      send_tosign_tooltip: 'Send to sign',
      send_tosign: 'Send to sign',
      modify_tooltip: 'Modify transport document',
      modify: 'Modify',
      create_ecmr: 'Create transport document',
      change_state: {
        label: 'Change of state',
        placeholder: 'Choose a transport document status',
        load: 'Updating transport document data ...'
      }
    },
    cmr_event_type: {
      CHANGE_STATUS: 'Change of state',
      CHANGE_STATUS_INI: 'Initial state',
      CHANGE_STATUS_END: 'End state',
      CHANGE_STATUS_MOTIVE: 'Motive of the change',
      CHANGE_STATUS_USER: 'User of the change',
      SEND_MAIL: 'Sent by mail',
      RECEIVED: 'Received',
      ISSUED: 'Issued',
      ASSIGNED_ORDER: 'Assigned order',
      DO_NOT_DOWNLOAD: 'Does not download',
      NO_LOAD: 'Does not load',
      LOADED_PACKAGE: 'Loaded package',
      UNLOADED_PACKAGE: 'Package unloaded',
      CHANGE_DRIVER: 'Driver change',
      SEND_PDF: 'Send PDF',
      COMMENTS: 'Observations',
      INTEGRATION: 'Integration',
      CHANGE_PLATE: 'Change of plates',
      CHANGE_CARGO: 'Modification of general cargo data',
      CHANGE_AUTHORIZATION: 'Change of authorization',
      CHANGE_SEND_DATE: 'Change of send date',
      CHANGE_OBSERVATIONS: 'Change of observations/incidents'
    },
    filters: {
      num_cmr: {
        value: 'Transport document number',
        placeholder: 'Transport document number'
      },
      order: {
        value: 'Order',
        placeholder: 'Order'
      },
      group: {
        value: 'Group',
        placeholder: 'Group'
      },
      date_creation: {
        value: 'Creation date',
        placeholder: 'Creation date'
      },
      vehicle_plate: {
        value: 'Tractor vehicle registration',
        placeholder: 'Tractor vehicle registration'
      },
      trailer_plate: {
        value: 'Semi-trailer registration',
        placeholder: 'Semi-trailer registration'
      },
      second_trailer_plate: {
        value: 'Trailer registration',
        placeholder: 'Trailer registration'
      },
	  id_cmr: {
        value: 'Internal ID',
        placeholder: 'Internal ID'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      service: {
        value: 'Service',
        placeholder: 'Service'
      },
      sender_party: {
        value: 'Load company',
        placeholder: 'Enter 3 characters'
      },
      receiver_party: {
        value: 'Delivery company',
        placeholder: 'Enter 3 characters'
      },
      sender_centre: {
        value: 'Load centre',
        placeholder: 'Load centre'
      },
      receiver_centre: {
        value: 'Delivery centre',
        placeholder: 'Delivery centre'
      },
      transportist: {
        value: 'Carrier',
        placeholder: 'Carrier'
      },
      send_date: {
        value: 'Send date',
        placeholder: 'Send date'
      }
    }
  },
  coacsu: {
    coacsu_entity_table: {
      service: "Service",
      seller: "Seller",
      buyer: "Buyer",
      centre_buyer: "Centre",
      coacsu_number: "Commercial account summary No.",
      issue_date: "Issue date",
      creation_date_time: "Registration date",
      total_amount: "Total amount",
      actions: "Actions"
    },
    filters: {
      service: { value: "Service", placeholder: "Service" },
      buyer: { value: "Buyer", placeholder: "Type 3 characters" },
      seller: { value: "Seller", placeholder: "Type 3 characters" },
      coacsu_number: { value: "Commercial account summary No.", placeholder: "Number" },
      invoice_number: { value: "Invoice No.", placeholder: "Number" },
      issue_date: { value: "Issue date", placeholder: "" },
      total_amount_from: { value: "Amount", placeholder: "Settlement amount from" },
      total_amount_to: { value: "Amount up to", placeholder: "Settlement amount up to" },
      creation_date: { value: "Registration date-time", placeholder: "" }
    },
    buttons: {
      download_csv_tooltip: "Download CSV",
      download_original_tooltip: "Download original"
    },
    tooltip: {
      detail: "View details"
    },
    breadcrumb: {
      coacsu_lines_view: "Commercial account summary"
    },
    detail: {
      information: "Information",
      seller: "Seller",
      buyer: "Buyer",
      code: "Code",
      name: "Name",
      role: "Role",
      address: "Address",
      summary: "Summary",
      coacsuNumber: "COACSU No.",
      status: "Status",
      issueDate: "Issue date",
      paymentDate: "Due date",
      lineNumber: "Line No.",
      invoiceNumber: "Document No.",
      total: "Total",
      currency: "Currency",
      no_lines: "No lines",
      lines_title: "Commercial account summary lines"
    }
  },
  deliverynote: {
    filters: {
      buyer: {
        value: 'Buyer',
        placeholder: 'Buyer'
      },
      seller: {
        value: 'Seller',
        placeholder: 'Seller'
      },
      num_deliverynote: {
        value: 'N. delivery note',
        placeholder: 'N. delivery note'
      },
      date_creation: {
        value: 'Registration D.',
        placeholder: 'Registration D.'
      },
      date_issue: {
        value: 'Issue date range',
        placeholder: 'Issue date range'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      services: {
        value: 'Service',
        placeholder: 'Service'
      },
      buyer_centre: {
        value: 'Buyer centre',
        placeholder: 'Buyer centre'
      },
      seller_centre: {
        value: 'Seller centre',
        placeholder: 'Seller centre'
      },
      delivery_centre: {
        value: 'Place of delivery',
        placeholder: 'Place of delivery'
      },
      delivery_date: {
        value: 'Delivery date range',
        placeholder: 'Delivery date range'
      },
      invoice_number: {
        value: 'Invoice number',
        placeholder: 'Invoice'
      }
    },
    delivery_entity_table_detail: {
      lineNumber: 'Line N.',
      itemCode: 'Article code',
      itemCodeSeller: 'Seller article code',
      itemCodeBuyer: 'Buyer article code',
      codeCentreDeliveryPoint: 'Delivery point',
      quantity: 'Pending quantity',
      description: 'Description',
      order: 'Order number',
      despatch_quantity: 'Despatch quantity',
      received_quantity: 'Received quantity',
      accepted_quantity: 'Accepted quantity',
      measure: 'Unit of measure',
      unitPrice: 'Unit price',
      totalAmount: 'Total line price',
      documentStatus: 'Line status',
      serialNumber: 'Serial number',
      batch: 'Batch',
      expirationDate: 'Expiration date',
      currency: 'Currency',
      status: 'Status',
      options: 'Options',
      notes: 'Notes',
      quantityTradeUnit: 'Quantity trade unit',
      measureTradeUnit: 'Unit of measure trade unit',
      assignedQuantity: 'Quantity assigned',
      assignedMeasureUnit: 'Unit of measure assigned',
      netPrice: 'Net price',
      grossPrice: 'Gross price',
      gtin14Code: 'GTIN14 code'
    },
    delivery_entity_table: {
      buyer: 'Buyer',
      seller: 'Seller',
      num_deliverynote: 'N. delivery note',
      date_creation: 'Registration D.',
      date_issue: 'Issue D.',
      status: 'Status',
      delivery_type: 'Delivery note type',
      services: 'Service',
      buyer_centre: 'Buyer centre',
      seller_centre: 'Seller centre',
      delivery_centre: 'Place of delivery',
      delivery_date: 'Delivery d.',
      order_number: 'N. order',
      csv_title: 'Export to CSV. Information',
      csv_message: 'Cannot export more than {argumento} records, please narrow your search',
      csv_details_message: 'Cannot export lines of more than 100 documents, please narrow your search'
    },
    delivery_related_documents_table: {
      date: 'Relation date',
      destinationDocument: 'Document Nº',
      destinationDocumentType: 'Document type'
    },
    deliverynote_detail: {
      activate_deliverynote_buttons: 'Activate',
      rejected_deliverynote_buttons: 'Reject',
      deliverynote_line_no_date: 'This delivery note has no lines',
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Download PDF delivery note',
      activate_deliverynote_buttons_tooltip: 'Accept delivery note',
      rejected_deliverynote_buttons_tooltip: 'Reject delivery note',
      rejected_deliverynote_lineError: 'Line of imbalance',
      related_documents_no_data: 'This delivery note does not have related documents',
      source_related_documents: 'Source related documents',
      destination_related_documents: 'Destination related documents',
      deliverynote_lines: 'Delivery note lines',
      edit: 'Edit',
      send_to_draft: 'Draft',
      send_to_draft_tooltip: 'Send to draft',

      change_state: {
        label: 'Change of status',
        placeholder: 'Choose a delivery note status',
        load: 'Updating delivery note data ...'
      },

      dialog_rejected_deliverynote: {
        title: 'Rejection of the delivery note',
        value: 'Reason',
        placeholder: 'Reason for rejection',
        motive_required: 'Mandatory reason'
      },

      dialog_new_check_line_deliverynote: {
        title: 'New delivery note line',
        title_edit: 'Edit delivery note line',
        description: 'Article description *',
        quantity: 'Quantity *',
        priceUnit: 'Unit Price *',
        date_required: 'Mandatory field'
      },

      notify: {
        submit_edit_deliverynote_ok: 'The delivery note status has been successfully modified',
        deliverynote_rejected: 'The delivery note was successfully rejected',
        deliverynote_activate: 'The delivery note has been activated',
        deliverynote_new_line: 'A new unbalance line has been successfully registered',
        deliverynote_edit_line: 'The unbalance line has been successfully modified',
        delivery_point_centre_not_found: 'The center of the specified delivery location was not found'
      },
      load: {
        deliverynote_rejected: 'Rejecting delivery note',
        deliverynote_activate: 'Activating delivery note'
      },
      confirm: {
        title_deliverynote_activate: 'The delivery note {deliveryId},from the vendor {sellerName},will be activated. Do you wish to continue?',
        title_deliverynote_reject: 'The delivery note {deliveryId},from the provider {sellerName},will be rejected. Do you wish to continue?',
        confirm_button_deliverynote_activate: 'OK'
      }
    },
    package_type: {
      TRANSPORT: 'Transport',
      PALLET: 'Pallet',
      HALF_PALLET: 'Half pallet',
      BOX: 'Box'
    },
    package: {
      invalid: {
        sscc: 'The SSCC code indicated for the package is not valid. It must be made up of 18 digits',
        ssccExist: 'The SSCC code indicated for the packaging is invalid. There is already a packing slip with that SSCC code',
        delete: 'Cannot delete the package from the delivery note, because it has associated packages or lines',
        noLogistic: 'Package cannot be added to a non-logistical delivery note',
        lineCentreDeliveryPoint: 'Lines with different delivery locations cannot be associated with the same packaging',
        typeLevel: 'Cannot add a package of type {argumento} inside a package of type {argumento1}'
      },
      max: {
        levels: 'The package that you want to add exceeds the maximum number of levels for the delivery note'
      },
      all: {
        hasLines: 'All last level packages on the delivery note must have at least one associated line',
        linesHasPackage: 'All lines of the delivery note must have assined package'
      },
      line: {
        notFound: {
          package: 'The package indicated for the delivery note line was not found',
          parent: 'The parent package indicated for the package of the delivery note line was not found'
        }
      }
    }
  },
  // Genrals emitidos y recibidos
  genral: {
    filters: {
      creation_date: {
        value: 'Registration date-hour'
      },
      seller: {
        value: 'Receiver',
        placeholder: 'Enter 3 characters'
      },
      buyer: {
        value: 'Sender',
        placeholder: 'Enter 3 characters'
      },
      delivery_date: {
        value: 'Delivery dates range',
        placeholder: 'Delivery dates'
      },
      genral_date: {
        value: 'Genral dates range',
        placeholder: 'Genral dates'
      },
      issue_date: {
        value: 'Issue date range',
        placeholder: 'Issue date'
      },
      description: {
        value: 'Text',
        placeholder: 'Text'
      },
      genral_number: {
        value: 'Genral number',
        placeholder: 'Genral'
      },
      project: {
        value: 'Service',
        placeholder: 'Service'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      }
    },
    genral_entity_table: {
      seller: 'Receiver',
      buyer: 'Issuer',
      num_genral: 'N. genral',
      description: 'Text',
      date_creation: 'Registration d.',
      date_issue: 'Issue d.',
      status: 'Status',
      services: 'Service',
      csv_message: 'Cannot export more than {argumento} records, please narrow your search',
      csv_title: 'Export to CSV. Information'
    },
    genral_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Download PDF genral',
      activate_genral_buttons_tooltip: 'Activate genral',
      rejected_genral_buttons_tooltip: 'Reject genral',
      download_pdfmultiple_buttons: 'Download genral/s',
      download_pdfmultiple_buttons_tooltip: 'Download PDF genral/s',
      edit: 'Edit',

      dialog_rejected_genral: {
        title: 'Reject genral',
        value: 'Motive',
        placeholder: 'Motive rejected',
        motive_required: 'Motive required'
      },

      notify: {
        genral_rejected: 'The genral has been rejected correctlye',
        genral_activate: 'The genral has been activated',
        download_pdf: 'The download of the file {file} was correct.'
      },
      load: {
        genral_rejected: 'Rejecting genral',
        genral_activate: 'Activating  genral'
      },
      confirm: {
        title_genral_activate: 'The genral {genralID},from the provider {sellerName},will be activated. do you wish to continue?',
        title_genral_reject: 'The genral {genralID},from the provider {sellerName},will be rejected. do you wish to continue?',
        confirm_button_genral_activate: 'Ok'
      }
    }
  },
  // Coacsu
  coacsu: {
    filters: {
      service: {
        value: 'Service',
        placeholder: 'Service'
      },
      document_number: {
        value: 'Document number',
        placeholder: 'Document number'
      },
      article_code: {
        value: 'Article code',
        placeholder: 'Article code'
      },
      sale_date: {
        value: 'Sale date',
        placeholder: 'Sale date'
      }
    }
  },
  document_type: {
    INVOICE: 'Invoice',
    PURCHASEORDER: 'Order',
    DELIVERYNOTE: 'Delivery note',
    RECEIVEADVICE: 'Receive advice',
    SALES_REPORT: 'Sales report',
    INVENTORY_REPORT: 'Inventory report'
  },
  charge_type: {
    CHARGE: 'Charge',
    DISCOUNT: 'Discount'
  },
  // Validaciones genericas
  validations: {
    maxlenght: 'Max "{maxlenght}" characters',
    minlenght: 'Min "{minlenght}" characters',
    required: 'The field "{field}" is required',
    data: {
      VALIDATION_ATTACHMENT_RENFE: 'Renfe Attachments',
      VALIDATION_B2BINVOICEVALIDATION_WS: 'Customer SOAP service',
      VALIDATION_BUYER: 'Client company in the service and enabled',
      VALIDATION_BUYER_CENTRES: 'Customer center in the company and enabled',
      VALIDATION_COMMERCIAL_RELATION_CHANNEL: 'Commercial relationship with channel',
      VALIDATION_COMMERCIAL_RELATION: 'Existence of commercial relationship',
      VALIDATION_DOCUMENT_SIGN: 'Delegated Signature',
      VALIDATION_DUPLICATION: 'Duplications',
      VALIDATION_DUPLICATION_ISSUEYEAR: 'Duplications with year of issue',
      VALIDATION_EIFFAGEINVOICEVALIDATION_WS: 'Use Eiffage web service',
      VALIDATION_INTRASTAT_REQUIRED: 'Mandatory Intracommunity',
      VALIDATION_INVOICE_ACCOUNTING: 'All accounting validations of the invoice',
      VALIDATION_INVOICE_CORRECTIVE: 'Existence of mandatory rectified invoice data',
      VALIDATION_INVOICE_CORRECTIVE_MANDATORY: 'Invoice number to which it rectifies mandatory',
      VALIDATION_INVOICE_TOTAL_TAXES: 'Total taxes equal to the sum of taxes',
      VALIDATION_INVOICE_TOTAL: 'Total invoice without discounts and without general charges',
      VALIDATION_INVOICE_TOTAL_DISCOUNTS_CHARGES: 'Total invoice with discounts and general charges',
      VALIDATION_INVOICE_TOTAL_DISCOUNTS_CHARGES_TAXES: 'Total bill',
      VALIDATION_INVOICE_TOTALEXECUTABLE: 'Total executable of the invoice',
      VALIDATION_INVOICENUMBER_FORMAT: 'Invoice Number Format',
      VALIDATION_ISSUEDATE_FUTURE: 'Issue date no greater',
      VALIDATION_ISSUEDATE_PAST: 'Issue date not previous',
      VALIDATION_ISSUER_TYPE: 'Issuer Type Invoice',
      VALIDATION_ISSUER_TYPE_RENFE: 'Type sender Invoice for Renfe service',
      VALIDATION_LINE_DESCRIPTION: 'Mandatory description of invoice lines',
      VALIDATION_LINES_TOTAL: 'Total line without taxes',
      VALIDATION_LINES_TOTAL_DISCOUNTS_CHARGES: 'Line total with discounts and line charges',
      VALIDATION_MODALITY: 'Type of individual invoice',
      VALIDATION_OPERATION_AND_ISSUE_DATE: 'Accrual Date',
      VALIDATION_RECEIVER_CONTRACT: 'Mandatory ReceiverContractReference',
      VALIDATION_RECEIVER_CONTRACT_FIRSTLINE: 'Mandatory ReceiverContractReference only in first line or header',
      VALIDATION_RECEIVER_TRANSACTION_FIRSTLINE: 'Mandatory receiver order only in first line or header',
      VALIDATION_RECEIVER_CONTRACT_FORMAT: 'ReceiverContractReference format',
      VALIDATION_RECEIVER_CONTRACT_UNIQUE: 'Umique ReceiverContractReference',
      VALIDATION_RECEIVER_EXP: 'Mandatory FileReference',
      VALIDATION_RECEIVER_EXP_FIRSTLINE: 'Mandatory FileReference only in first line or header',
      VALIDATION_RECEIVER_EXP_FORMAT: 'FileReference format',
      VALIDATION_RECEIVER_EXP_UNIQUE: 'Unique FileReference',
      VALIDATION_RECEIVER_ORDER: 'Mandatory receiver order',
      VALIDATION_RECEIVER_ORDER_FORMAT: 'Receiver order format',
      VALIDATION_RECEIVER_ORDER_UNIQUE: 'Unique receiver order',
      VALIDATION_ISSUER_ORDER: 'Mandatory issuer order',
      VALIDATION_ISSUER_ORDER_FORMAT: 'Issuer order format',
      VALIDATION_ISSUER_ORDER_UNIQUE: 'Unique issuer order',
      VALIDATION_RENFE_WS: 'Use Renfe web service',
      VALIDATION_SELLER: 'Existence of a supplier company,as a supplier in the service and enabled',
      VALIDATION_SELLER_BUYER_NOSPONSOR: 'Existence of a sponsor in the client or supplier',
      VALIDATION_SELLER_CENTRES: 'Existence of a supplier center in the company,with a provider and enabled role',
      VALIDATION_UNIQUE_CENTRES_BUYER: 'Equal centers for the buyer. Unique center',
      VALIDATION_UNIQUE_CENTRES_SELLER: 'Equal centers for the seller. Single center.',
      VALIDATION_INVOICE_PUBLICORGANISM: 'Proposing Public Organization – DIR3',
      VALIDATION_LINE_CODE: 'Existence of code for each line',
      VALIDATION_LINE_ORDER_EXIST: 'Existence in BBDD of the registered order',
      VALIDATION_LINE_TRANSACTIONREFERENCE: 'Issuer or Receiver order required',
      VALIDATION_LINE_EXIST: 'Existence of lines',
      VALIDATION_CURRENCY_EXCHANGE: 'Exchange rate and date of mandatory exchange rate if currency other than the parameter',
      VALIDATION_IBAN: 'Mandatory IBAN for Transfers and Direct debits',
      VALIDATION_REGISTRATION_DATA: 'Matching of seller commercial register data with those registered in B2B',
      VALIDATION_SEQUENCE_NUMBER_BY_ORDER_FORMAT: 'Mandatory order position if order meets mask',
      VALIDATION_CORRECTIVE_SIGN: 'Positive sign on invoices with CorrectionMethod equal to parameter',
      VALIDATION_INVOICE_BUYER_CENTRE: 'Mandatory customer centre',
      VALIDATION_INVOICE_CENTRE_MASK: 'Centre mask format',
      VALIDATION_INVOICE_CENTRE_ROL: 'Centre role type',
      VALIDATION_NO_INTEGRATE_REJECTED_INVOICE: 'Rejected invoice validation not integrated',
      VALIDATION_REGISTRATION_DATA_INDRAFE: 'Matching of seller commercial register data with those registered in B2B Indrafe',
      VALIDATION_BUYER_CENTRES_ROL: 'Mandatory role type in buyer centre',
      VALIDATION_SELLER_CENTRES_ROL: 'Mandatory role type in seller centre',
      VALIDATION_BUYER_CENTRES_ROL_BYVALUES: 'Validation buyer centre contains the role',
      VALIDATION_SELLER_CENTRES_ROL_BYVALUES: 'Validation seller centre contains the role',
      VALIDATION_CENTRE_VOCENTO_WS: 'Custom Vocento: centre validation via web service',
      VALIDATION_LINE_DELIVERY_BATCH: 'Existence of batch for each delivery note line',
      VALIDATION_LINE_DELIVERY_SERIAL: 'Existence of serial number for each delivery note line',
      VALIDATION_LINE_DELIVERY_EXPIRATION: 'Existence of expiration date for each delivery note line',
      VALIDATION_LINE_DELIVERY_DATES: 'Expiration date greater than delivery date for each delivery note line',
      VALIDATION_SENDATE_FUTURE: 'Send date must be in the actual or future',
      VALIDATION_LINE_DELIVERY_QUANTITY: 'The sum of the amounts of the sublines must be equal to the amount of the parent line',
      VALIDATION_LINE_DELIVERY_SUBLINE_REQUIRED: 'Existence of a subline per delivery note line',
      VALIDATION_LINE_DOCUMENT_CANAL: 'Validation of CYII invoice documents',
      VALIDATION_VALID_IBAN: 'Invoice IBAN validation',
      VALIDATION_PAYMENT_MEAN: 'Payment mean validation',
      VALIDATION_FILE_SIZE: 'File size validation',
      VALIDATION_INVOICE_CORRECTIVE_METHOD: 'Correction methods validation in corrective invoices',
      VALIDATION_NIF_CODPAIS: 'Country code in NIF validation',
      VALIDATION_LINE_SEQUENCE_NUMBER: 'Unique sequence number validation',
      VALIDATION_PARTY_NAME: 'Company name on invoice',
      VALIDATION_INVOICE_OPERATIONDATE: 'Validate operation date against the issuance date',
      VALIDATION_INVOICE_INVOICINGPERIOD: 'Validate the end date of the billing period against the issuance date',
      VALIDATION_INVOICE_WITHHOLDINGAMOUNT: 'Warranty retention validation',
      VALIDATION_INVOICE_TRANSACTIONXORCONTRACT: 'Contract and order cannot be indicated at the same time',
      VALIDATION_INVOICE_CORRECTCONTRACTANDTRANSACTION: 'The contract and file request must correspond to the registered one',
      VALIDATION_INVOICE_EURCURRENCY: 'Currency in euros',
      VALIDATION_INVOICE_IGICINCANARY: 'IGIC tax and address in the Canary Islands mandatory',
      VALIDATION_INVOICE_IPSIINCEUTA: 'IPSI tax and address in Ceuta mandatory',
      VALIDATION_LINE_DELIVERY_PACKAGE_GTIN14: 'Same GTIN14 code for all lines associated with a delivery package',
      VALIDATION_INVOICE_ATTACHEDFILESNUMBER: 'Validate number of attachments',
      VALIDATION_INVOICE_ATTACHEDFILESEXTENSION: 'Validate attachment file extension',
      VALIDATION_INVOICE_TAXESINPROJECT: 'Validate active tax and rate in the service',
      VALIDATION_INVOICE_FILEFORMAT: 'Validation of the input file format ',
      VALIDATION_LINE_TAX0_LEGALTEXT: 'For tax 0 you must inform a legal text',
      VALIDATION_CORRECTIVE_ORDERORCONTRACT: 'Validation of order or contract required in corrective invoice',
      VALIDATION_CORRECTIVE_REQUIRED: 'The corrective block is mandatory for a corrective invoice',
      VALIDATION_PARTY_BUYER_ADDRESS_VALUE: 'Validation so that the buyers address is the same as configured',
      VALIDATION_SPECIFIC_CANARY: 'Specific validations for invoices from pure Canarian suppliers (100% Canarian)',
      VALIDATION_SPECIFIC_CEUTA: 'Specific validations for invoices from pure Ceuta suppliers (100% Ceuta)',
      VALIDATION_PHYSICAL_GLN_REQUIRED: 'Mandatory mailbox validation for sending edi formats',
      VALIDATION_INVOICE_NOIGICIVA: 'Validates that an invoice cannot have IGIC and VAT at the same time',
      VALIDATION_INVOICE_EXITSPAYMENTDETAILS: 'Validates that an invoice contains a payment method',
      VALIDATION_LINE_RECADVPRICEQUANTITYPOSITIVE: 'Validates that all the lines of a draft from a reception have a positive amount and quantity',
      VALIDATION_LINE_CORRECTIVEPRICENEGATIVE: 'Validates that all lines of a corrective draft have a negative price',
      VALIDATION_INVOICELINES_SAMETAX: 'Validates that an invoice does not contain the same tax on the same line',
      VALIDATION_INVOICELINES_NONEGATIVE: 'Validates that all the lines have a positive amount and quantity',
      VALIDATION_INVOICE_RECEIVERTRANSACTIONREFERENCE: 'Validates receiver order in invoice header or lines',
      VALIDATION_INVOICE_FROMRECADV: 'Validate the existence of the receipt indicated on the invoice',
      VALIDATION_INVOICE_DOCUMENTVALUESFROMRECADV: 'Validate that the invoice documents match those of the receipt.',
      VALIDATION_INVOICE_ADDITIONALINFOFROMRECADV: 'Customized red.es: validate that the additional invoice information contains receipt properties',
      VALIDATION_INVOICE_LINEDATAFROMRECADV: 'Validate invoice line information at reception',
      VALIDATION_CENTRE_PERMANET_ESTABLISHMENT: 'Permanent establishment according to buyer and seller for drafts',
      VALIDATION_INVOICE_ISSUEDATE_REJECTED: 'Verify that the issue date is the same as that of another existing negative invoice',
      VALIDATION_RULES_KOSIT: 'Validation of the KoSIT rules',
      VALIDATION_RULES_SCHEMATRON: 'Validation of the Schematron rules'
    }
  },

  error: {
    e400: 'Validation errors occurred on the request.',
    e400_create_invoice: 'An error occurred during the creation of the invoice,contact the administrator.',
    e401_login: 'The user and / or the password are not correct.',
    e401: 'Session expired or user unauthorized.',
    e403: 'The user doesn\'t have necessary permission to realize this action',
    e403_service: 'The user doesn\'t have necessary permission to access',
    e404: 'File not found.',
    e409: 'Media selected already exist for this user',
    e409_create_invoice: 'There is already an invoice with this invoice number for the same seller',
    e428_login: 'The user has active two-factor authentication, enter the code',
    e401_two_factor_auth: 'The code has expired or is incorrect',
    e500: 'An error has occurred. Contact your administrator.',
    e500_user: 'Error creating user. Contact your administrator.',
    default: 'Connection error server.Try again later',
    recadv_rejected: 'Unable to invoice the receptions because any is rejected',
    validation_intrastat_required: 'The goods code field and the weight field are required',
    password_expired: 'Your password has expired, you must change your password.',
    file_size: {
      exceeded: 'Size not allowed. The maximum size is {argumento}'
    },
    invalid_image: 'Invalid image',
    retry: 'An error has ocurred. Please try again later.',
    user: 'You cannot delete the user because it is associated with processes in the system related to invoices, you must disable the user'
  },

  global_error: 'An error has occurred. Contact your administrator.',
  user_not_found: 'User not found',

  // Paises
  countries: {
    country_AFG: 'Afghanistan',
    country_ALA: 'Island Islands',
    country_ALB: 'Albany',
    country_DEU: 'Germany',
    country_AND: 'Andorra',
    country_AGO: 'Angola',
    country_AIA: 'Anguilla',
    country_ATA: 'Antarctica',
    country_ATG: 'Antigua and Barbuda',
    country_SAU: 'Saudi Arabia',
    country_DZA: 'Algeria',
    country_ARG: 'Argentina',
    country_ARM: 'Armenia',
    country_ABW: 'Aruba',
    country_AUS: 'Australia',
    country_AUT: 'Austria',
    country_AZE: 'Azerbaijan',
    country_BHS: 'Bahamas (the)',
    country_BGD: 'Bangladesh',
    country_BRB: 'Barbados',
    country_BHR: 'Bahrain',
    country_BEL: 'Belgium',
    country_BLZ: 'Belize',
    country_BEN: 'Benin',
    country_BMU: 'Bermuda',
    country_BLR: 'Belarus',
    country_MMR: 'Myanmar',
    country_BOL: 'Bolivia,Plurinational State of',
    country_BIH: 'Bosnia and Herzegovina',
    country_BWA: 'Botswana',
    country_BRA: 'Brazil',
    country_BRN: 'Brunei Darussalam',
    country_BGR: 'Bulgaria',
    country_BFA: 'Burkina Faso',
    country_BDI: 'Burundi',
    country_BTN: 'Bhutan',
    country_CPV: 'Cape Verde',
    country_KHM: 'Cambodia',
    country_CMR: 'Cameroon',
    country_CAN: 'Canada',
    country_QAT: 'Qatar',
    country_BES: 'Bonaire,Sint Eustatius and Saba',
    country_TCD: 'Chad',
    country_CHL: 'Chile',
    country_CHN: 'China',
    country_CYP: 'Cyprus',
    country_COL: 'Colombia',
    country_COM: 'Comoros',
    country_PRK: 'Korea (the popular democratic republic of)',
    country_KOR: 'Korea (the republic of)',
    country_CIV: 'Côte dIvoire',
    country_CRI: 'Costa Rica',
    country_HRV: 'Croatia',
    country_CUB: 'Cuba',
    country_CUW: 'Curacao',
    country_DNK: 'Denmark',
    country_DMA: 'Dominica',
    country_ECU: 'Ecuador',
    country_EGY: 'Egypt',
    country_SLV: 'El Salvador',
    country_ARE: 'United Arab Emirates (the)',
    country_ERI: 'Eritrea',
    country_SVK: 'Slovakia',
    country_SVN: 'Slovenia',
    country_ESP: 'Spain',
    country_USA: 'USA (the)',
    country_EST: 'Estonia',
    country_ETH: 'Ethiopia',
    country_PHL: 'Philippines (the)',
    country_FIN: 'Finland',
    country_FJI: 'Fiji',
    country_FRA: 'France',
    country_GAB: 'Gabon',
    country_GMB: 'Gambia (The)',
    country_GEO: 'Georgia',
    country_GHA: 'Ghana',
    country_GIB: 'Gibraltar',
    country_GRD: 'Granada',
    country_GRC: 'Greece',
    country_GRL: 'Greenland',
    country_GLP: 'Guadalupe',
    country_GUM: 'Guam',
    country_GTM: 'Guatemala',
    country_GUF: 'French Guiana',
    country_GGY: 'Guernsey',
    country_GIN: 'Guinea',
    country_GNB: 'Guinea-Bis',
    country_GNQ: 'Equatorial Guinea',
    country_GUY: 'Guyana',
    country_HTI: 'Haiti',
    country_HND: 'Honduras',
    country_HKG: 'Hong Kong',
    country_HUN: 'Hungary',
    country_IND: 'India',
    country_IDN: 'Indonesia',
    country_IRQ: 'Iraq',
    country_IRN: 'Iran (Islamic republic of)',
    country_IRL: 'Ireland',
    country_BVT: 'Bouvet Island',
    country_IMN: 'Isle of Man',
    country_CXR: 'Christmas Island',
    country_NFK: 'Norfolk Island',
    country_ISL: 'Iceland',
    country_CYM: 'Caim Islands (the)',
    country_CCK: 'Cocos (Keeling)',
    country_COK: 'Cook Islands (the)',
    country_FRO: 'Faroe Islands (the)',
    country_SGS: 'South Georgia and South Sandwich Islands',
    country_HMD: 'Heard Island and McDonald Islands',
    country_FLK: 'Malvinas [Falkland] (the)',
    country_MNP: 'Northern Mariana Islands (the)',
    country_MHL: 'Marshall Islands (the)',
    country_PCN: 'Pitcairn',
    country_SLB: 'Solomon Islands (the)',
    country_TCA: 'Turks and Caicos Islands (the)',
    country_UMI: 'Overseas Islands United States Minor (the)',
    country_VGB: 'Virgin Islands  (British)',
    country_VIR: 'Virgin Islands (USA)',
    country_ISR: 'Israel',
    country_ITA: 'Italy',
    country_JAM: 'Jamaica',
    country_JPN: 'Japan',
    country_JEY: 'Jersey',
    country_JOR: 'Jordan',
    country_KAZ: 'Kazakhstan',
    country_KEN: 'Kenya',
    country_KGZ: 'Kyrgyzstan',
    country_KIR: 'Kiribati',
    country_KWT: 'Kuwait',
    country_LAO: 'Lao,(the) Popular Democratic Republic of',
    country_LSO: 'Lesotho',
    country_LVA: 'Latvia',
    country_LBN: 'Lebanon',
    country_LBR: 'Liberia',
    country_LBY: 'Libya',
    country_LIE: 'Liechtenstein',
    country_LTU: 'Lithuania',
    country_LUX: 'Luxembourg',
    country_MAC: 'Macao',
    country_MDG: 'Madagascar',
    country_MYS: 'Malaysia',
    country_MWI: 'Malawi',
    country_MDV: 'Maldives',
    country_MLI: 'Mali',
    country_MLT: 'Malta',
    country_MAR: 'Morocco',
    country_MTQ: 'Martinique',
    country_MUS: 'Mauricio',
    country_MRT: 'Mauritania',
    country_MYT: 'Mayotte',
    country_MEX: 'Mexico',
    country_FSM: 'Micronesia (Federated States of)',
    country_MDA: 'Moldova (Republic of)',
    country_MCO: 'Monaco',
    country_MNG: 'Mongolia',
    country_MNE: 'Montenegro',
    country_MSR: 'Montserrat',
    country_MOZ: 'Mozambique',
    country_NAM: 'Namibia',
    country_NRU: 'Nauru',
    country_NPL: 'Nepal',
    country_NIC: 'Nicaragua',
    country_NER: 'Nigeria',
    country_NGA: 'Nigeria',
    country_NIU: 'Niue',
    country_NOR: 'Norway',
    country_NCL: 'New Caledonia',
    country_NZL: 'New Zealand',
    country_OMN: 'Oman',
    country_NLD: 'Netherlands (the)',
    country_PAK: 'Pakistan',
    country_PLW: 'Palau',
    country_PSE: 'Palestine State',
    country_PAN: 'Panama',
    country_PNG: 'Papua New Guinea',
    country_PRY: 'Paraguay',
    country_PER: 'Peru',
    country_PYF: 'French Polynesia',
    country_POL: 'Poland',
    country_PRT: 'Portugal',
    country_PRI: 'Puerto Rico',
    country_GBR: 'UK (the)',
    country_CAF: 'Central African Republic (the)',
    country_CZE: 'Czech republic (the)',
    country_MKD: 'Macedonia (the former Yugoslav republic of)',
    country_COG: 'Congo',
    country_COD: 'Congo (Democratic Republic of)',
    country_DOM: 'Dominican Republic (the)',
    country_REU: 'Reuni on',
    country_RWA: 'Rwanda',
    country_ROU: 'Romania',
    country_RUS: 'Russia,(the) Federation of',
    country_ESH: 'Western Sahara',
    country_WSM: 'Samoa',
    country_ASM: 'American Samoa',
    country_BLM: 'San Bartolome',
    country_KNA: 'Saint Kitts and Nevis',
    country_SMR: 'San Marino',
    country_MAF: 'San Martin (French side)',
    country_SPM: 'San Pedro and Miquelon',
    country_VCT: 'Saint Vincent and the Grenadines',
    country_SHN: 'Saint Helena,Ascension and Tristan da Cunha',
    country_LCA: 'St_ lucia',
    country_STP: 'Sao Tome and Principe',
    country_SEN: 'Senegal',
    country_SRB: 'Serbia',
    country_SYC: 'Seychelles',
    country_SLE: 'Sierra Leone',
    country_SGP: 'Singapore',
    country_SXM: 'Sint Maarten (Dutch part)',
    country_SYR: 'Syria (the) República Árabe',
    country_SOM: 'Somalia',
    country_LKA: 'Sri Lanka',
    country_SWZ: 'Swaziland',
    country_ZAF: 'South Africa',
    country_SDN: 'Sudan',
    country_SSD: 'Sudan South',
    country_SWE: 'Sweden',
    country_CHE: 'Switzerland',
    country_SUR: 'Suriname',
    country_SJM: 'Svalbard and Jan Mayen',
    country_THA: 'Thailand',
    country_TWN: 'Taiwan (Province of China)',
    country_TZA: 'Tanzania,United Republic of',
    country_TJK: 'Tajikistan',
    country_IOT: 'British Indian Ocean Territory',
    country_ATF: 'French Southern Territories (the)',
    country_TLS: 'Timor-Leste',
    country_TGO: 'Togo',
    country_TKL: 'Tokelau',
    country_TON: 'Tonga',
    country_TTO: 'Trinidad and Tobago',
    country_TUN: 'Tunisia',
    country_TKM: 'Turkmenistan',
    country_TUR: 'Turkey',
    country_TUV: 'Tuvalu',
    country_UKR: 'Ukraine',
    country_UGA: 'Uganda',
    country_URY: 'Uruguay',
    country_UZB: 'Uzbekistan',
    country_VUT: 'Vanuatu',
    country_VAT: 'Holy See [State of the Vatican] (a)',
    country_VEN: 'Venezuela,Bolivarian Republic',
    country_VNM: 'Viet Nam',
    country_WLF: 'Wallis and Futuna',
    country_YEM: 'Yemen',
    country_DJI: 'Djibouti',
    country_ZMB: 'Zambia',
    country_ZWE: 'Zimbabwe'
  },

  // Permisos
  authorities: {
    ADMIN_GROUP: 'Center groups administration',
    ADMIN_PROFILE: 'Profiles administration',
    ADVANCED_ADMIN_USER: 'Advanced user administration',
    ADVANCED_ADMIN_PARTY: 'Advanced party administration',
    ADMIN_USER: 'User administration',
    ADMIN_CERTIFICATE: 'Certificates administration',
    ADMIN_TAX: 'Taxes administration',
    ADMIN_ARTICLE: 'Articles administration',
	ADMIN_METHODS: 'Communication methods administration',
    ADMIN_DOCUMENTATION: 'Documentation administration',
    ADMIN_QUARTZ: 'Process planned administration',
    ADMIN_MAP: 'Map administration',
    ADMIN_GROUP_PARTY: 'Party groups administration',
    ADMIN_CENTRE: 'Centers administration',
    ADMIN_PARTY: 'Parties administration',
    ADMIN_PROJECT: 'Service administration',
    AUDITORY_ACTION: 'User actions or system audit',
    AUDITORY_DOCUMENT: 'Document audit',
    BILLING_MANAGEMENT: 'Invoicing',
    DELETE_INVOICE_ATTACHMENTS: 'Delete invoice attachments',
    UPLOAD_INVOICE: 'Loading invoices by file',
    SEARCH_INVOICE_SALES: 'Search of signed sales invoices',
    SEARCH_INVOICE_PURCHASES: 'Search of signed purchase invoices',
    SEARCH_REPORT_EMITTED: 'Search of emitted reports',
    SEARCH_REPORT_RECEIVED: 'Search of received reports',
    SEARCH_INVOICE_THIRD: 'Search of third party invoices',
    SEARCH_INVOICE_DRAFT: 'Search of draft invoice',
    SEARCH_ACCOUNTING_CLOSE: 'Accounting close query',
    SEARCH_INVOICE_SENDER: 'Search of signed invoices sent',
    ADD_INVOICE_ATTACHMENTS: 'Add attachments to the invoice',
    SEARCH_INVOICE_RECEIVER: 'Search of signed invoices',
    VIEW_INVOICE_PDF: 'View PDF invoice',
    VIEW_INVOICE_ATTACHMENT: 'See invoice attachments',
    VIEW_INVOICE_EVENTS: 'View invoice events',
    VIEW_INVOICE_DOCUMENTS: 'View header documents in drafts',
    GET_PAYMENT_DATA: 'Consult invoice payment/collection data',
    CHANGE_INVOICE_STATUS: 'Change invoice status',
    SEARCH_ISSUE: 'Search incidence',
    CREATE_ISSUE: 'Creating incidence',
    STATISTICS_MANAGEMENT: 'Statistics',
    UPDATE_ISSUE: 'Refresh incidence status',
    ADD_ISSUE: 'Creating incidence',
    DELETE_ISSUE: 'Delete incidences',
    DOWNLOAD_INVOICE_WS: 'Download invoice by web service',
    DOWNLOAD_DELIVERY_NOTE_WS: 'Download delivery note by web service',
    INTEGRATION_INVOICE_WS: 'Invoice Integration by web service',
    SEARCH_STATUS_INVOICE_WS: 'Invoice status query by web service',
    ADMIN_DELIVERY_METHODS: 'Delivery parameters administration',
    CANCEL_INVOICE: 'Request invoice cancellation',
    COPY_INVOICE: 'Copy invoice',
    CREATE_PROJECT: 'Creating service',
    CREATE_PARTY: 'Creating parties',
    MODIFY_PROJECT: 'Change service',
    PROJEC_DELIVERY_METHOD: 'Management of service delivery method',
    PARTY_DELIVERY_METHOD: 'Management of party delivery method',
    PARAMS_DELIVERY_METHOD: 'Management of delivery parameters',
    CREATE_CENTRE: 'Creating centers',
    FORWARD_INVOICE_EMITTED: 'Forward emitted invoices',
    FORWARD_INVOICE_RECEIVED: 'Forward received invoices',
    CREATION_PARTY_WS: 'Creating parties',
    UPDATE_PARTY_WS: 'Updating parties',
    ADMIN_USER_WS: 'Administration users',
    CREATION_USER_WS: 'Creating users',
    UPDATE_USER_WS: 'Updating users',
    REMOVE_USER_WS: 'Erasing users',
    UNLOCK_USER_WS: 'Unlocking user',
    RESET_USER_WS: 'Reset user',
    DRAFT_ACCOUNTING_CLOSE: 'Drafts accounting close',
    CREATE_GROUP: 'Creating center groups',
    ADMIN_INDRA: 'Indra administration',
    SEARCH_ACCOUNTING_CLOSE_DRAFT: 'Search of drafts close',
    CHECK_STATUS: 'Status query online',
    SEARCH_PENDING_TASKS: 'Search pending tasks',
    CONSULT_DOCUMENTATION: 'Consult documentation',
    CONSULT_SIGNDOCUMENT: 'Consult sign document',
    UPLOAD_SIGNDOCUMENT: 'Upload sign document',
    DELETE_SIGNDOCUMENT: 'Delete sign document',
    CREATE_COVER: 'Create cover',
    SEARCH_RECADV_SENDER: 'Search of receptions sent',
    SEARCH_RECADV_RECEIVER: 'Search of receptions received',
    INVOICE_VALIDATION_WS: 'Invoice validation by web service',
    CHANGE_INVOICE_STATUS_WS: 'Change invoice status by web service',
    VIEW_INVOICE_BY_LINK: 'View invoice by external link',
    REJECT_RECADV: 'Reject recepctions',
    MODIFY_RECADV: 'Modify receptions',
    RECADV_CREATE_INVOICE: 'Create invoice by reception',
    RECADV_CREATE_INVOICE_PARCIAL: 'Create invoice by receptions that are parcially invoiced',
    SEARCH_ORDER_SENDER: 'Search of orders sent',
    SEARCH_ORDER_RECEIVER: 'Search of orders received',
    SEARCH_GENRAL_SENDER: 'Search of genrals sent',
    SEARCH_GENRAL_RECEIVER: 'Search of genrals received',
    SEARCH_SALES_REPORT_VIEW: 'search of sales report',
    SEARCH_INVENTORY_REPORT_VIEW: 'search of inventory report',
    MULTIPLE_CHANGE_STATUS: 'Multiple status changes in pending tasks',
    SEARCH_DELIVERY_SENDER: 'Search of delivery notes sent',
    SEARCH_DELIVERY_RECEIVER: 'Search of delivery notes received',
    EDIT_INVOICE_DATA: 'Modify invoice data',
    EDIT_INVOICE_NOTE: 'Modify invoice note',
    EDIT_CARRIER_CMR: 'Modify carrier transport document',
    EDIT_CHARGER_CMR: 'Modify charger transport document',
    EDIT_CENTRE_PERMANENT_ESTABLISHMENT: 'Modify and delete centers with permanent establishment',
    ADMIN_APPROVAL_FLOW_BY_LEVELS: 'Administration of approval flows by levels and users',
    USER_APPROVAL_FLOW_BY_LEVELS: 'Approve, reject and send invoices in the approval flow by levels and users',
    SEARCH_OCR_DOCUMENTS: 'Search OCR documents pending of validation',
    VIEW_INVOICE_NOTE: 'View invoice note',
    VIEW_ADMINISTRATIVE_CENTRES: 'View administrative centre columns',
    VIEW_DISTRIBUTION_CENTRES: 'Distribution view in center filter',
    DOWNLOAD_DOCUMENT_WS: 'Download document',
    UPDATE_DOCUMENT_WS: 'Update document',
    CREATE_INVOICE_DRAFT: 'Create draft invoice',
    ATTACHMENT_HIDDEN: 'Attachment hidden',
    VIEW_REQUEST_REDIGITALIZATION: 'Redigitalization request',
    VIEW_INVALID_INVOICE_COLOR: 'View status of invalid invoice in red',
    SEARCH_CHANNEL: 'Search Channel',
    VIEW_COMERCIAL_RELATION: 'View Comercial Relation',
    VIEW_RELATION_CHANNEL: 'View Comercial Relation with Channels',
    CREATE_COMERCIAL_RELATION: 'Create Comercial Relation',
    CHANGE_MASTER_DATA: 'Change master data',
    CHANGE_ROLE: 'Change role',
    NO_EDIT_DATA_USER: 'Data user without editing',
    SIGNATURE_DELEGATION: 'Signature Delegation',
    CHANGE_STATUS_PENDINGTASKS: 'Change of pending states',
    CHANGE_STATUS_ORDER: 'Change of order status',
    CHANGE_STATUS_DELIVERYNOTE: 'Change of delivery note status',
    CHANGE_STATUS_RECADV: 'Change of recadv status',
    VIEW_INVOICE_BPM_EVENTS: 'View invoice BPM events',
    CHANGE_STATUS_RECADV_WS: 'Web service Reception Change',
    CHECK_STATUS_RECADV_WS: 'Check status of web service receptions',
    INTEGRATION_RECADV_WS: 'Web service Reception Integration',
    INTEGRATION_ORDER_WS: 'Web service Order Integration',
    VIEW_METADATA: 'See metadata',
    VIEW_ORDER_METADATA: 'View order metadata',
    VIEW_RECADV_METADATA: 'View reception metadata',
    VIEW_ORDER_ORIGINAL: 'View original orders',
    VIEW_RECADV_ORIGINAL: 'View original recadvs',
    VIEW_DESADV_METADATA: 'View delivery note metadata',
    VIEW_DESADV_ORIGINAL: 'View original delivery notes',
    ORDER_CREATE_INVOICE: 'Create invoice by order',
    ORDER_CREATE_DELIVERY_NOTE: 'Create delivery note from order',
    CREATE_INVOICE_FROM_DELIVERY_NOTE: 'Create invoice by delivery note',
    VIEW_BANK_DATA: 'See bank details',
    DOWNLOAD_INVOIC_FORMATTED: 'Download guarded formatted',
    RECADV_ATTACH: 'Permitir adjuntos en recepciones',
    CHANGE_PARTY_MEDIA: 'Modify party contact data',
    VIEW_CMR: 'View transport document',
    CREATE_CMR_DRAFT: 'Create transport document',
    VIEW_CMR_DRAFT_SELLER_CENTRES: 'View seller centres in draft transport document',
    VIEW_CMR_DRAFT_BUYER_CENTRES: 'View buyer centres in draft transport document',
    CREATE_INVOICE_FROM_RECADV: 'Allows you to fill in certain fields when creating the invoice from the reception',
    CHANGE_CENTRE_ROLE: 'Change centre roles',
    MODIFY_PAYMENT_METHODS: 'Modify parties payment method',
    CREATE_CORRECTIVE_INVOICE: 'Creation of corrective invoice from issued invoice',
    NO_VIEW_INVOICE_SERIES_CODE: 'No access to serial number',
    TOTAL_IRPF: 'IRPF in invoice totals',
    NO_VIEW_RECADV_PDF: 'No access to pdf from reception',
    ADD_BUYER_CENTRE: 'Add buyer centre',
    VIEW_MENU: 'View menu options and bread crumb',
    VIEW_SALES_REPORT_ORIGINAL: 'View original sales report',
    VIEW_SALES_REPORT_METADATA: 'View sales report metadata',
    VIEW_INVENTORY_REPORT_ORIGINAL: 'View original inventory report',
    VIEW_INVENTORY_REPORT_METADATA: 'View inventory report metadata',
    SEARCH_REMADV_VIEW: 'Search remittance advice',
    VIEW_REMADV_ORIGINAL: 'View original remittance advice',
    VIEW_REMADV_METADATA: 'View remittance advice metadata',
    SEARCH_COACSU_VIEW: 'Search delivery summary',
    VIEW_COACSU_ORIGINAL: 'View original delivery summary',
    VIEW_COACSU_METADATA: 'View delivery summary metadata',
    CREATE_COACSU: 'Create commercial account summary'
  },
  authorities_module: {
    INVOICE: 'Invoice',
    ADMIN: 'Administration',
    AUDITORY: 'Audit',
    BILLING: 'Billing',
    ISSUE: 'Issue',
    STATISTICS: 'Statistics',
    WEBSERVICE: 'Web Service',
    GROUP: 'Group',
    DOCUMENTATION: 'Documentation',
    RECADV: 'Recadv',
    PURCHASEORDER: 'Order',
    ORDERRSP: 'Order response',
    DELIVERY: 'Delivery note',
    GENRAL: 'Genral',
    GENERAL: 'Genral note',
    CMR: 'DeCA',
    SALESREPORT: 'Sales report',
    INVENTORYREPORT: 'Inventory report',
    COACSU: 'Commercial account summary',
    REMADV: 'Remittance advice'
  },
  auditaction: {
    create: 'Creation',
    update: 'Update',
    delete: 'Deleted',
    resend: 'Resend',
    reprocess: 'Reprocess',
    updateStatus: 'Status update',
    sendInvoice: 'Send invoice',
    cancel: 'Cancellation',
    demand: 'Request',
    checkStatus: 'Check status',
    sendData: 'Send data',
    reject: 'Reject',
    send: 'Send'
  },
  functionalGroup: {
    ROLE: 'Profiles',
    PROJECT: 'Service',
    PARTY: 'Company',
    CENTER: 'Center',
    USER: 'User',
    TAXES: 'Taxes',
    ISSUE: 'Incidents',
    CERTIFICATE: 'Certificates',
    EMAIL: 'Customize email',
    DOCUMENTATION: 'Documentation',
    INVOICE: 'Invoice',
    ORDER: 'Order',
    GENRAL: 'Genral',
    DELIVERYNOTE: 'Delivery note',
    RECADV: 'Recadv',
    ORDERRSP: 'Order Response',
    CMR: 'DeCA',
    COMMUNICATION_METHOD: 'Communication method'
  },

  // Tipos de medio de contacto
  mediaType: {
    email: 'Email',
    telefono_fijo: 'Phone',
    telefono_movil: 'Mobile phone',
    telefono_trabajo: 'Phone from work',
    fax: 'Fax',
    email_to_report_issued: 'Sendindg reports',
    contact_person: 'Contact person'
  },

  // Impuestos
  adminTaxes: {
    tax: {
      VAT: 'VAT',
      IGIC: 'IGIC',
      IGI: 'IGIC',
      EXT: 'EXT',
      ENV: 'ENV',
      IRPF: 'IRPF',
      IPSI: 'IPSI',
      ITPAJD: 'ITPAJD',
      IE: 'IE',
      ICIO: 'ICIO',
      IPS: 'IPS',
      RLEA: 'RLEA',
      IGFEI: 'IGFEI',
      Otros: 'Others',
      Ra: 'Income customs',
      IGTECM: 'IGTECM',
      IECDPCAC: 'IECDPCAC',
      IMVDN: 'IMVDN',
      IMSN: 'IMSN',
      IMGSN: 'IMGSN',
      IMPN: 'IMPN',
      REIVA: 'REIVA',
      REIGIC: 'REIGIC',
      REIPSI: 'REIPSI',
      IVPEE: 'IVPEE',
      IPCNG: 'IPCNG',
      IACNG: 'IACNG',
      IDEC: 'IDEC',
      ILTCC: 'ILTCC',
      IRNR: 'IRNR',
      ISS: 'ISS',
      IIIMAB: 'IIIMAB',
      OTH: 'OTH',
      ITRT01: 'RT01',
      ITRT02: 'RT02',
      ACT: 'ACT'

    }
  },

  tax_type: {
    VAT: 'Value added tax',
    IGIC: 'Indirect General Tax in the Canary Islands',
    EXT: 'Exempt',
    ENV: 'Environmental tax',
    IRPF: 'Income tax of natural persons',
    IPSI: 'Tax on Production,Services and Imports',
    IGI: '@:tax_type.IGIC',
    ITPAJD: 'Transfer tax and stamp duty',
    IE: 'Special Tax',
    ICIO: 'Tax on buildings,installations and works',
    IPS: 'Tax on Production,Services and Imports',
    RLEA: 'Surcharge for financing the liquidation functions of insurance companies',
    IGFEI: 'Tax on fluorinated greenhouse gases',
    Otros: 'Others',
    Ra: 'Customs income',
    IGTECM: 'General tax on traffic companies applied in Ceuta and Melilla',
    IECDPCAC: 'Excise duty on fuels derived from petrol in the Autonomous Community Canaria',
    IIIMAB: 'Tax on facilities that affect the environment in the Balearic',
    IMVDN: 'City tax on unoccupied homes in Navarra',
    IMSN: 'Municipal Tax plots in Navarra',
    IMGSN: 'Municipal tax on luxury spending in Navarra',
    IMPN: 'Municipal tax on advertising in Navarra',
    REIVA: 'Special VAT scheme for travel agencies',
    REIGIC: 'Special IGIC scheme for travel agencies',
    REIPSI: 'Special IPSI scheme for travel agencies',
    IVPEE: 'Tax value of production of electric energy',
    IPCNG: 'Tax on the production of spent nuclear fuel and radioactive waste resulting from nuclear power generation',
    IACNG: 'Tax on storage of spent nuclear fuel and radioactive waste at centralized facilities',
    IDEC: 'Tax on deposits in credit institutions',
    ILTCC: 'Tax on manufactured snuff in the Canary Islands',
    IRNR: 'Income Tax for Non Residents',
    ISS: 'Corporate Tax',
    ITRT01: 'Fatturapa RT01 tax',
    ITRT02: 'Fatturapa RT02 tax',
    OTH: 'OTH',
    ACT: 'Alcohol tax'
  },

  // Recepciones estados
  recadv_status: {
    RECEIVED: 'Received',
    REJECTED: 'Rejected',
    REJECTED_SELLER: 'Rejected Provider',
    ERROR: 'Error',
    FULLY_INVOICED: 'Totally invoiced',
    PARTIALLY_INVOICED: 'Parcially invoiced',
    ORIGINAL: 'Original',
    MODIFIED: 'Modified'
  },
  // Recepciones subtype
  recadv_subtype: {
    GOODS: 'Goods',
    SERVICES: 'Services'
  },
  // Pedidos estados
  order_status: {
    RECEIVED: 'Received',
    REJECTED: 'Rejected',
    ACCEPTED: 'Accepted',
    REJECTED_SELLER: 'Rejected Provider',
    ERROR: 'Error',
    FULLY_INVOICED: 'Totally invoiced',
    PARTIALLY_INVOICED: 'Parcially invoiced',
    ORIGINAL: 'Original',
    MODIFIED: 'Modified',
    DISPATCHED: 'Dispatched',
    PARTIALLY_SENT: 'Partially dispatched',
    FULLY_SENT: 'Fully dispatched'
  },

  order_type: {
    ORDER: 'Normal',
    BLANKET_ORDER: 'Commercial',
    RUSH_ORDER: 'Urgent',
    CONSIGNMENT_ORDER: 'In consignment',
    CROSS_DOCKING_ORDER: 'Cross-docking',
    INFO: 'Informational'
  },

  // Subtipos de pedido
  order_subtype: {
    INVOICED_NOT_REPLENISHED: 'Invoiced not replenished',
    FULL_DELIVERY: 'Full delivery',
    REPLENISHED_NOT_INVOICED: 'Replenished not invoiced',
    REPLENISHED_INVOICED: 'Replenished invoiced'
  },

  // genrals estados
  genral_status: {
    RECEIVED: 'Received',
    REJECTED: 'Rejected',
    ACCEPTED: 'Accepted',
    REJECTED_SELLER: 'Rejected Provider',
    ERROR: 'Error',
    FULLY_INVOICED: 'Totally invoiced',
    PARTIALLY_INVOICED: 'Parcially invoiced',
    ORIGINAL: 'Original',
    MODIFIED: 'Modified'
  },
  party_gln_type: {
	GLN: 'GLN',
	EAS: 'EAS',
	SIREN: 'SIREN',
	SIRET: 'SIRET',
	ENDPOINTID: 'ENDPOINTID'
  },
  // Metodos de entrega y de recepcion
  communication_method: {
    INDRAFIN: 'Indra financieras',
    ALAVA: 'DF Alava',
    ANDALUCIA: 'Junta Andalucia',
    AOC: 'AOC',
    CANARIAS: 'Canarias',
    DIPUTACION_VIZCAYA: 'DF Vizcaya',
    EMAIL: 'Email',
    EMAIL_PDF: 'Email PDF',
    FACE: 'FACe',
    GUIPUZCOA: 'DF Guipuzcoa',
    G_VALENCIA: 'Generalitat Valenciana',
    G_VASCO_EUROBITS: 'Gobierno Vasco',
    NO_ENTREGA: 'No delivery',
    NO_ENTREGA_RECEPCION: 'No delivery',
    XUNTA_GALICIA: 'Xunta de Galicia',
    OSAKIDETZA: 'Osakidetza',
    EMAIL_SIGNED: 'Email custodied',
    EMAIL_SIGNED_ATTACH: 'Email custodied and attachments',
    EMAIL_PDF_SIGNED: 'Email custodied and PDF',
    EMAIL_PDF_SIGNED_ATTACH: 'Email custodied, PDF and attachments',
    EMAIL_PDF_ATTACH: 'Email PDF and attachments',
    EMAIL_PDF_ATTACH_MERGED: 'Email PDF merged and attachments',
    EMAIL_LINK: 'Email with link',
    PAPER: 'Paper',
    BANKIA: 'Bankia',
    CONSORCIO_AGUAS_BILBAO: 'Aguas Bilbao',
    ESPUBLICO: 'Espublico',
    AOC_WS: 'AOC web service',
    AYUNTAMIENTO_VITORIA: 'Ayuntamiento Vitoria',
    AYUNTAMIENTO_BOADILLA: 'Ayuntamiento Boadilla',
    VOCENTO: 'Vocento',
    MMA: 'Mutua',
    REE: 'Red el\u00E9ctrica',
    AYUNTAMIENTO_AMOREBIETA: 'Ayuntamiento Amorebieta',
    SENADO: 'Senado',
    WS: 'Web service',
    UPLOAD: 'Upload',
    MANUAL: 'Manual',
    AYUNTAMIENTO_TORRELODONES: 'Ayuntamiento Torrelodones',
    ADIF: 'Adif',
    RENFE: 'Renfe',
    AYUNTAMIENTO_SANTURCE: 'Ayuntamiento Santurce',
    VAN: 'RVA',
    FACEB2B: 'FaceB2B',
    SFACTURA: 'sFactura',
    DOWNLOAD: 'DOWNLOAD',
    OHLSAP: 'OHLSap',
    OHLGCONS: 'OHLGcons',
    METADATA: 'Deliver data',
    METADATA_ATTACH: 'Deliver data and and attachments',
    METADATA_ATTACH_PDF: 'Deliver data, PDF and attachments',
    ZIPALL: 'Full delivery',
    ZIPALL_FILES_NAMES_COUNT: 'Redeia Recepción',
    ERPEIFFAGE: 'Eiffage',
    ERPPACSA: 'Pacsa',
    ERPSARRION: 'Sarrion',
    ITALIA: 'Italy',
    INDRA: 'SAP Indra',
    AYUNTAMIENTO_COLMENAR_VIEJO: 'Ayuntamiento Colmenar Viejo',
    AYUNTAMIENTO_GALDAKAO: 'Ayuntamiento Galdakao',
    AYUNTAMIENTO_GORLIZ: 'Ayuntamiento Gorliz',
    ECOSYSTEM: 'Ecosystems',
    CECABANK: 'Cecabank',
    REDES: 'Redes',
    ADQUIRA: 'Adquira',
    VAN_EDICOM: 'Rva EDICOM',
    VAN_ARIBA: 'Rva ARIBA',
    VAN_SERES: 'Rva SERES',
    VAN_INDRA: 'Rva INDRA',
    PAVENTURA: 'Port Aventura',
    CANAL_ISABEL_II: 'Canal Isabel II',
    SEDEB2B: 'Sede B2B',
    VWGROUP: 'Grupo Volkswagen',
	PEPPOL: 'Peppol',
    ELECTRONET: 'Electronet',
    BSFACTURA: 'BS Factura',
    MAPFRE: 'Mapfre',
    PGN: 'PGN',
    RSI: 'RSI',
    INDRAFE: 'Indra',
    INDITEX: 'Inditex',
    INDRAFEREC: 'Indra recepción',
    B2BCONNECT: 'B2BConnect',
    TSHIFT: 'TShift',
    INDRATOVODAFONE: 'IndraToVodafone',
    COMEX: 'Comex',
    RECKITT: 'Reckitt',
    RECKITT_DELIVERYNOTE: 'Reckitt',
    LEKEITIO: 'Lekeitio',
    AYUNTAMIENTO_ORDUNA: 'Ayuntamiento Orduna',
    LEA_ARTIBAI: 'Lea Artibai',
    AYUNTAMIENTO_OROZKO: 'Ayuntamiento Orozko',
    AYUNTAMIENTO_GUENES: 'Ayuntamiento Guenes',
    AYUNTAMIENTO_SESTAO: 'Ayuntamiento Sestao',
    AYUNTAMIENTO_ESCORIAL: 'Ayuntamiento Escorial',
    AYUNTAMIENTO_MUSKIZ: 'Ayuntamiento Muskiz',
    AYUNTAMIENTO_LEMOA: 'Ayuntamiento Lemoa',
    JCM: 'Junta de Castilla La Mancha',
    FCC: 'Fcc',
    AYUNTAMIENTO_BILBAO: 'Ayuntamiento Bilbao',
    CAIXAF: 'Caixa Factura',
    CAIXA: 'Caixa web service',
    JUNTA_ANDALUCIA: 'JDA',
    DEFAULT: 'Already asigned method',
    LA_RIOJA: 'La Rioja',
    ARGENTINA: 'AFIP Argentina',
    DISANET: 'Disanet',
    FIRMAE: 'Firma-e',
    LYNTIAEMISSION: 'Lyntia',
    LYNTIARECEPTION: 'Lyntia',
    CANALRECEPTION: 'Canal',
    LYNTIA_ACCESS_EMISSION: 'Elanta',
    LYNTIA_ACCESS_RECEPTION: 'Elanta',
    RUMANIA: 'Rumania',
    FRANCE: 'France',
    INDRAFEHANA: 'IndraFE',
    INDRAFINHANA: 'IndraFin',
    COMEXHANA: 'IndraComex',
    AYUNTAMIENTO_ABADINO: 'Ayuntamiento Abadiño',
    AYUNTAMIENTO_BALMASEDA: 'Ayuntamiento Balmaseda',
    AYUNTAMIENTO_BERRIZ: 'Ayuntamiento Berriz',
    AYUNTAMIENTO_BUSTURIA: 'Ayuntamiento Busturia',
    AYUNTAMIENTO_DERIO: 'Ayuntamiento Derio',
    AYUNTAMIENTO_ERANDIO: 'Ayuntamiento Erandio',
    AYUNTAMIENTO_FORUA: 'Ayuntamiento Forua',
    AYTO_GERNIKA_LUMO: 'Ayuntamiento Gernika Lumo',
    AYUNTAMIENTO_LOIU: 'Ayuntamiento Loiu',
    AYUNTAMIENTO_SANTURTZI: 'Ayuntamiento Santurtzi',
    AYTO_GAUTEGIZ_ARTEAGA: 'Ayuntamiento Gautegiz Arteaga',
    AYUNTAMIENTO_BERRIATUA: 'Ayuntamiento Berriatua',
    AYUNTAMIENTO_TRAPAGARAN: 'Ayuntamiento Trapagaran',
    AYUNTAMIENTO_ARTEA: 'Ayuntamiento Artea',
    AYUNTAMIENTO_ABANTO: 'Ayuntamiento Abanto',
    AYUNTAMIENTO_BARRIKA: 'Ayuntamiento Barrika',
    AYUNTAMIENTO_ELORRIO: 'Ayuntamiento Elorrio',
    AYUNTAMIENTO_ERENO: 'Ayuntamiento Ereño',
    AYUNTAMIENTO_IURRETA: 'Ayuntamiento Iurreta',
    AYUNTAMIENTO_LEMOIZ: 'Ayuntamiento Lemoiz',
    AYUNTAMIENTO_LEZAMA: 'Ayuntamiento Lezama',
    AYTO_MARURI_JATABE: 'Ayuntamiento Maruri Jatabe',
    AYUNTAMIENTO_PLENTZIA: 'Ayuntamiento Plentzia',
    AYUNTAMIENTO_SOPUERTA: 'Ayuntamiento Sopuerta',
    AYUNTAMIENTO_ZALDIBAR: 'Ayuntamiento Zaldibar',
    AYUNTAMIENTO_ZAMUDIO: 'Ayuntamiento Zamudio',
    AYUNTAMIENTO_ZARATAMO: 'Ayuntamiento Zarátamo',
    AYUNTAMIENTO_ZIERBENA: 'Ayuntamiento Zierbena',
    AYUNTAMIENTO_ETXEBARRI: 'Ayuntamiento Etxebarri',
    CONSOR_TRANSPOR_BIZKAIA: 'Consorcio de Transportes de Bizkaia',
    MDAD_MERINDAD_DURANGO: 'Mancomunidad Merindad Durango',
    AYUNTAMIENTO_GORDEXOLA: 'Ayuntamiento Gordexola',
    AYUNTAMIENTO_MENDATA: 'Ayuntamiento Mendata',
    AYUNTAMIENTO_BERMEO: 'Ayuntamiento Bermeo',
    AYUNTAMIENTO_GETXO: 'Ayuntamiento Getxo',
    AULA_CULTURA_GETXO: 'Aula Cultura Getxo',
    RESIDENCIA_MPAL_GETXO: 'Residencia Getxo',
    AYUNTAMIENTO_LEIOA: 'Ayuntamiento Leioa',
    AYUNTAMIENTO_LEGAZPI: 'Ayuntamiento Legazpi',
    AYUNTAMIENTO_ZUIA: 'Ayuntamiento Zuia',
    AYUNTAMIENTO_ORTUELLA: 'Ayuntamiento Ortuella',
    PARLAMENTO_VASCO: 'Parlamento Vasco',
    AYUNTAMIENTO_ARANTZAZU: 'Ayuntamiento Arantzazu',
    AYUNTAMIENTO_BAKIO: 'Ayuntamiento Bakio',
    AYUNTAMIENTO_GARAI: 'Ayuntamiento Garai',
    AYUNTAMIENTO_SONDIKA: 'Ayuntamiento Sondika',
    AYUNTAMIENTO_URDULIZ: 'Ayuntamiento Urduliz',
    AYUNTAMIENTO_BEDIA: 'Ayuntamiento Bedia',
    AYUNTAMIENTO_ALONSOTEGI: 'Ayuntamiento Alonsotegi',
    AYUNTAMIENTO_ARAKALDO: 'Ayuntamiento Arakaldo',
    AYUNTAMIENTO_AREATZA: 'Ayuntamiento Areatza',
    AYTO_ARRIGORRIAGA: 'Ayuntamiento Arrigorriaga',
    AYUNTAMIENTO_BERANGO: 'Ayuntamiento Berango',
    AYUNTAMIENTO_DURANGO: 'Ayuntamiento Durango',
    AYUNTAMIENTO_GALDAMES: 'Ayuntamiento Galdames',
    AYUNTAMIENTO_GAMIZ_FIKA: 'Ayuntamiento Gamiz-Fika',
    AYUNTAMIENTO_ISPASTER: 'Ayuntamiento Ispaster',
    AYUNTAMIENTO_IZURTZA: 'Ayuntamiento Izurtza',
    AYUNTAMIENTO_MANARIA: 'Ayuntamiento Manaria',
    AYUNTAMIENTO_MORGA: 'Ayuntamiento Morga',
    AYUNTAMIENTO_MUXIKA: 'Ayuntamiento Muxika',
    AYTO_TRUCIOS_TURTZIOZ: 'Ayuntamiento Trucios-Turtzioz',
    AYUNTAMIENTO_UBIDE: 'Ayuntamiento Ubide',
    AYTO_UGAO_MIRABALLES: 'Ayuntamiento Ugao-Miraballes',
    MDAD_URIBE_KOSTA: 'Mancomunidad Uribe Kosta',
    AYUNTAMIENTO_ZEANURI: 'Ayuntamiento Zeanuri',
    AYUNTAMIENTO_ZEBERIO: 'Ayuntamiento Zeberio',
    AYTO_ZIORTZA_BOLIBAR: 'Ayuntamiento Ziortza-Bolibar',
    ARARTEKO: 'Ararteko',
    AYUNTAMIENTO_BASAURI: 'Ayuntamiento Basauri',
    AYUNTAMIENTO_AJANGIZ: 'Ayuntamiento Ajangiz',
    AYUNTAMIENTO_AMOROTO: 'Ayuntamiento Amoroto',
    AYTO_ARRANKUDIAGA: 'Ayuntamiento Arrankudiaga',
    ARRATIAKO_UDALEN: 'Arratiako Udalen Mankomunitatea',
    AYUNTAMIENTO_ARRATZU: 'Ayuntamiento Arratzu',
    AYUNTAMIENTO_ARRIETA: 'Ayuntamiento Arrieta',
    AYTO_ARTZENTALES: 'Ayuntamiento Artzentales',
    AYUNTAMIENTO_ATXONDO: 'Ayuntamiento Atxondo',
    AYUNTAMIENTO_AULESTI: 'Ayuntamiento Aulesti',
    AYTO_IBARRANGELU: 'Ayuntamiento Ibarrangelu',
    AYUNTAMIENTO_DIMA: 'Ayuntamiento Dima',
    AYUNTAMIENTO_EA: 'Ayuntamiento Ea',
    MDAD_ENCARTACIONES: 'Mancomunidad de las Encartaciones',
    AYUNTAMIENTO_ERRIGOITI: 'Ayuntamiento Errigoiti',
    AYUNTAMIENTO_ETXEBARRIA: 'Ayuntamiento Etxebarria',
    AYUNTAMIENTO_FRUIZ: 'Ayuntamiento Fruiz',
    AYUNTAMIENTO_GATIKA: 'Ayuntamiento Gatika',
    AYUNTAMIENTO_IGORRE: 'Ayuntamiento Igorre',
    AYTO_VALLE_CARRANZA: 'Ayuntamiento Valle de Carranza',
    AYUNTAMIENTO_KORTEZUBI: 'Ayuntamiento Kortezubi',
    AYUNTAMIENTO_LARRABETZU: 'Ayuntamiento Larrabetzu',
    AYUNTAMIENTO_LAUKIZ: 'Ayuntamiento Laukiz',
    AYUNTAMIENTO_MALLABIA: 'Ayuntamiento Mallabia',
    AYTO_MARKINA_XEMEIN: 'Ayuntamiento Markina-Xemein',
    AYUNTAMIENTO_MENDEXA: 'Ayuntamiento Mendexa',
    AYUNTAMIENTO_MENAKA: 'Ayuntamiento Menaka',
    AYUNTAMIENTO_MUNDAKA: 'Ayuntamiento Mundaka',
    AYUNTAMIENTO_MUNITIBAR: 'Ayuntamiento Munitibar',
    AYUNTAMIENTO_MURUETA: 'Ayuntamiento Murueta',
    AYUNTAMIENTO_NABARNIZ: 'Ayuntamiento Nabarniz',
    AYUNTAMIENTO_OTXANDIO: 'Ayuntamiento Otxandio',
    AYTO_SUKARRIETA_PEDERNALES: 'Ayuntamiento Sukarrieta-Pedernales',
    MDAD_TXORIERRI: 'Mancomunidad de Txorierri',
    MDAD_BUSTURIALDE: 'Mancomunidad de Busturialde',
    AYUNTAMIENTO_LANESTOSA: 'Ayuntamiento Lanestosa',
    UDAL_SAREAK: 'Udal Sareak',
    REDE_ES: 'Red.es'
  },
  // modulos estados de tareas pendientes
  module: {
    ACCOUNTING_CLOSE: 'Accounting closes',
    PENDING_TASKS_CHANGE_STATUS: 'Change status in pending tasks',
    PENDING_TASKS: 'Pending tasks',
    CMR: 'CMR',
    CONTROLDOCUMENT: 'Control document',
    CONTROLDOCUMENTLINK: 'Control document link'
  },
  job_status: {
    RUNNING: 'Running',
    NORMAL: 'Standby',
    PAUSED: 'Paused',
    NONE: 'None',
    COMPLETE: 'Complete',
    ERROR: 'Error',
    BLOCKED: 'Blocked'
  },
  // Estado de la factura
  invoice_status: {
    ANNULLED: 'Annulled',
    ERROR: 'Error',
    REJECTED: 'Rejected',
    RECEIVED: 'Received',
    CANCELLED: 'Cancelled',
    DISAGREEMENT: 'Not compliant',
    PENDING_OF_SIGNING: 'Pending of signing',
    PENDING_OF_VERIFYING: 'Pending of verifying',
    PENDING_OF_GENERATE: 'Pending of generate',
    PENDING_OF_REPORTING: 'Pending of reporting',
    REPORTED: 'Reported',
    YIELDED: 'Yielded',
    COMPENSATED: 'Compensated',
    PENDING_OF_COMPENSATION: 'Pending of compensation',
    PENDING_OF_CONFIRM: 'Pending of confirm',
    COLLECTED: 'Collected',
    PENDING: 'Pending',
    PENDING_OF_ACCEPTING: 'Pending of accepting',
    PENDING_OF_VALIDATION: 'Pending of validation',
    IN_PROCESS: 'In process',
    OPENED: 'Opened',
    SIGNED: 'Signed',
    SENDED: 'Sent',
    REGISTERED: 'Registered',
    ACCEPTED: 'Accepted',
    ACCOUNTED: 'Accounted',
    PENDING_OF_PAYMENT: 'Pending of payment',
    PARTIALLY_PAID: 'Partially paid',
    PARTIALLY_ACCEPTED: 'Partially accepted',
    PAID: 'Paid',
    RETAINED: 'Retained',
    AWAITING_PAYMENT: 'Awaiting payment',
    CONSOLIDATED: 'Consolidated',
    DELIVERED: 'Delivered',
    DELIVERYCONFIRMED: 'Delivery confirmed',
    SENT_TO_PAYMENT: 'Sent to payment',
    INVOICE_RESPONSE: 'Payment pending',
    WITHOUT_INTERNAL_STATUS: 'Without internal status',
    REJECTED_REDIGITALIZATION: 'Redigitised',
    INVOICE_SIGNATURE: 'Invoice signatures',
    PROPOSALS_SIGNATURE: 'Proposals signatures',
    SEND_PROPOSED_STATE: 'Send proposed state',
    PENDING_OF_SEND: 'Pending of send',
    SENT: 'Sent',
    WAITING_CALLBACK: 'Waiting for response',
    RETAINED_PAYMENT: 'Retained payment',
    VALIDATIONACCEPTED: 'Validation accepted',
    VALIDATIONERROR: 'Validation error',
    LOADING: 'Loading',
    FINISH: 'Finished',
    CHANGE_DRIVER: 'Driver change',
    ON_RUTE: 'On route',
    DRAFT: 'Draft',
    ACCEPT: 'Accepted',
    VISUALIZED: 'Visualized',
  },

  // Campo enviada
  invoice_sent_flag: {
    SENT: 'Sent',
    PENDING_OF_SEND: 'Pending to be sent',
    NOT_SENT: 'Not sent'
  },

  // Estado del albaran
  deliverynote_status: {
    SENT: 'Sent',
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    RECEIVED: 'Received',
    FULLY_INVOICED: 'Fully invoiced',
    PARTIALLY_INVOICED: 'Partially invoiced',
    PARTIALLY_RECEIVED: 'Partially received',
    IN_PROCESS: 'In process',
    PENDING_OF_SEND: 'Pre-issued',
    PARTIALLY_SENT: 'Partially dispatched',
    FULLY_SENT: 'Fully dispatched'
  },

  // Estado de cmr
  cmr_status: {
    PENDING_OF_SEND: 'Pending of send',
    LOADING: 'Loading',
    IN_PROCESS: 'In progress',
    FINISH: 'Finished',
    CHANGE_DRIVER: 'Driver change',
    CANCELLED: 'Cancelled',
    ANNULLED: 'Annulled',
    SENT: 'Sent',
    ON_RUTE: 'On route',
    DRAFT: 'Draft',
    REJECTED: 'Rejected',
    ACCEPT: 'Accepted',
    VISUALIZED: 'Visualized',
    ERROR: 'Error',
  },

  // Divisas
  currency: {
    AUD: 'Australian dollar',
    ALL: 'Albanian Lek',
    DZD: 'Algerian Dinar',
    ARS: 'Argentine peso',
    AWG: 'Aruban Florin',
    GBP: 'Pound sterling',
    BSD: 'Bahamas dollar',
    BHD: 'Bahrain Dinar',
    BDT: 'Taka Bangladesh',
    BBD: 'Barbados Dollars',
    BYR: 'Belarusian ruble',
    BZD: 'Belize Dollar',
    BMD: 'Bermuda Dollar',
    BTN: 'Ngultrum de Bhutan',
    BOB: 'Bolivian',
    BWP: 'Pula Botswana',
    BRL: 'Brazilian real',
    BND: 'Brunei Dollar',
    BGN: 'Bulgarian Lev',
    BIF: 'Burundi Franc',
    CAD: 'Canadian dollar',
    CNY: 'Chinese yuan',
    KHR: 'Cambodian Riel',
    CVE: 'Cape Verdean shield',
    KYD: 'Cayman Islands Dollar',
    XOF: 'Frank CFA (BCEAO)',
    XAF: 'Frank CFA (BEAC)',
    CLP: 'Chilean peso',
    COP: 'Colombian peso',
    KMF: 'Franco comorano',
    CRC: 'Costa Rican Colon',
    HRK: 'Croatian kuna',
    CUP: 'Cuban peso',
    CZK: 'Czech koruna',
    DKK: 'Danish crown',
    DJF: 'Djiboutian Franco',
    DOP: 'Dominican peso',
    EUR: 'Euro',
    XCD: 'East Caribbean Dollar',
    EGP: 'Egyptian pound',
    SVC: 'The Colon of El Salvador',
    EEK: 'Estonian kroon',
    ETB: 'Ethiopian Birr',
    FKP: 'Malawian pound',
    FJD: 'Fiji dollar',
    GMD: 'Gambian Dalasi',
    GTQ: 'Guatemala Quetza',
    GNF: 'Guinean franc',
    GYD: 'Guyanese dollar',
    GHS: 'Cedi ghanes',
    HKD: 'Hong Kong dollar',
    HTG: 'Haitian Gourde',
    HNL: 'Honduran Lempira',
    HUF: 'Hungarian Forint',
    IDR: 'Indonesian rupee',
    INR: 'Indian rupee',
    ISK: 'Icelandic krona',
    IRR: 'Iranian rial',
    IQD: 'Iraqi Dinar',
    ILS: 'Israeli Shekel',
    JPY: 'Japanese Yen',
    JOD: 'Jordanian Dinar',
    KZT: 'Tenge kazako',
    KES: 'Chelín keniano',
    KRW: 'Won coreano',
    KWD: 'Dinar kuwaití',
    KGS: 'Kirguistán Som',
    MOP: 'Pataca de Macao',
    MKD: 'Dinar macedonio',
    MWK: 'Kwacha malawiano',
    MYR: 'Ringgit malayo',
    MVR: 'Rupia de Maldivas',
    MRO: 'Ouguiya de Mauritania',
    MUR: 'Rupia mauricia',
    MXN: 'Peso mexicano',
    MDL: 'Leu moldavo',
    MNT: 'Tugrik mongol',
    MAD: 'Dirham marroquí',
    MMK: 'Kyat de Myanmar',
    NAD: 'Dólar de Namibia',
    NPR: 'Rupia nepalí',
    ANG: 'Guilder antillano',
    NZD: 'Dólar neozelandés',
    NIO: 'Córdoba nicaragüense',
    NGN: 'Naira nigeriano',
    KPW: 'Won de Corea del Norte',
    NOK: 'Corona noruega',
    OMR: 'Rial omaní',
    XPF: 'Franco CFP',
    PKR: 'Pakistani rupee',
    PAB: 'Panamanian Balboa',
    PGK: 'Kina of Papua New Guinea',
    PYG: 'Paraguayan Guarani',
    PEN: 'New Sun peruan',
    PHP: 'Philippine Peso',
    PLN: 'Polish Zloty',
    QAR: 'Qatar Riyal',
    RON: 'Read Romanian',
    RUB: 'Russian ruble',
    RWF: 'Rwandan franc',
    CHF: 'Swiss franc',
    WST: 'Samoa Tala',
    STD: 'Dobra of San Tomé',
    SAR: 'Saudi Riyal',
    SCR: 'Seychelles Rupee',
    SLL: 'Leone from Sierra Leone',
    SGD: 'Singapore Dollars',
    SKK: 'Slovak koruna',
    SBD: 'Solomon Islands Dollar',
    SOS: 'Somali Shilling',
    ZAR: 'South African Rand',
    LKR: 'Sri Lanka Rupee',
    SHP: 'Saint Helena Pound',
    SDG: 'Sudanese pound',
    SZL: 'Lilangeni from Swaziland',
    SEK: 'Swedish krona',
    SYP: 'Syrian pound',
    THB: 'Thai Baht',
    TRY: 'Turkish Lira',
    TWD: 'Taiwan Dollars',
    TZS: 'Tanzanian shilling',
    TOP: 'Paubanga the Tongan dollar',
    TTD: 'Trinidad and Tobago Dollar',
    TND: 'Tunisian Dinar',
    USD: 'American dollar',
    AED: 'United Arab Emirates Dirham',
    UGX: 'Ugandan shilling',
    UAH: 'Grivnia from Ukraine',
    UYU: 'Uruguayan Peso',
    UZS: 'Uzbekistan Sum',
    VUV: 'Vanuatu Vatu',
    VND: 'Dong of Vietnam',
    VES: 'Venezuelan Bolívar',
    YER: 'Yemeni rial',
    ZMK: 'Zambian kwacha',
    PES: 'Peso',
    JMD: 'Jamaican dollar'
  },

  // Estados de auditoría
  auditory_status: {
    DELIVERED: 'Delivered',
    DELIVERYCONFIRMED: 'Delivery confirmed',
    DIVIDED: 'Divided',
    ERROR: 'Error',
    DELETED: 'Deleted',
    CREATED: 'Created',
    UPDATED: 'Updated',
    EXTRACTED: 'Extracted',
    GENERATED: 'Generated',
    INCOMINGERROR: 'Incoming error',
    INTEGRATED: 'Integrated',
    PENDINGOFDELIVERY: 'Pending of delivery',
    DISCARDED: 'Discarded',
    RECEIVED: 'Received',
    RECOGNIZED: 'Recognized',
    SIGNED: 'Signed',
    DISAGREEMENT: 'Not compliant',
    PENDING_OF_SIGNING: 'Pending of signature',
    TRANSFORMED: 'Transformed',
    ERROR_WS_DOCUMENT: 'Error in the service of integration document',
    ERROR_WS_NOTIFICATION: 'Error in the service of integration notifications',
    SENT_TO_PAYMENT: 'Sent to payment',
    PENDING_OF_SEND: 'Pending of send',
    WAITING_CALLBACK: 'Waiting for response',
    WARNING: 'Warning',
    VALIDATIONACCEPTED: 'Validation accepted',
    VALIDATIONERROR: 'Validation error'
  },

  // Tipo de documento auditoría
  auditory_doc_type: {
    INVOICE: 'Invoice',
    DIGITIZEDINVOICE: 'Digitized invoice',
    ATTACHMENT: 'Attachments',
    UPDATE_STATUS: 'Invoice status',
    UPDATE_INTERNAL_STATUS: 'Invoice internal status',
    INVOICE_RESPONSE: 'Invoice file response',
    BATCHFILE: 'Batch',
    RECADV: 'Recadv',
    OTHER: 'Others',
    RECEIVEADVICE: 'Reception',
    PURCHASEORDER: 'Order',
    ORDER: 'Order',
    DELIVERYNOTE: 'Delivery note',
    GENERAL: 'Genral note',
    CMR: 'CMR',
    USER: 'Users',
    PARTY: 'Parties',
    STATUS: 'Status',
    SALESREPORT: 'Sales report',
    INVENTORYREPORT: 'Inventory report',
    REMADV: "Settlement notice",
    COACSU: "Commercial account summary",
    CONTROLDOCUMENT: "Control document",
  },

  // Tipos de formatos de documentos auditoria
  auditory_doc_format: {
    FACTURAE32: 'FACTURAE32',
    FACTURAE321: 'FACTURAE321',
    INVOIC_D96A: 'INVOIC_D96A',
    INVOIC_D97A: 'INVOIC_D97A',
    INVOIC_D93A: 'INVOIC_D93A',
    XML_AECOC: 'XML_AECOC',
    PDF: 'PDF',
    PDF_A: 'PDF-A',
    UBL20: 'UBL20',
    ZIP: 'ZIP',
    CSV: 'CSV',
    PLAIN_ALTCLI: 'HIGH CUSTOMER PLANE',
    XML_ENVEST: 'XML SHIPPING STATES',
    TXT: 'TXT',
    PLAIN_ENVRES: 'FLAT SHIPPING ANSWER',
    XML_SANTILLANA: 'XML SANTILLANA',
    XML_B2B_RECADV: 'XML B2B RECEPTION',
    INVOIC_D01B: 'INVOIC_D01B',
    PLAIN_ALTPRO: 'PLAIN_ALTPRO',
    FACTURAE322: 'FACTURAE322',
    FATTURAPA12: 'FATTURAPA12',
    FATTURAPA_SEMPLIFICATA: 'FATTURAPA_SEMPLIFICATA',
    FATTURAPA12_CADES: 'FATTURAPA12_CADES',
    FATTURAPA_SEMPLIFICATA_CADES: 'FATTURAPA_SEMPLIFICATA_CADES',
    XML_B2B_ORDER: 'XML B2B ORDER',
    XML_B2B_ORDERRSP: 'XML B2B ORDER RESPONSE',
    XML_B2B_DELIVERYNOTE: 'XML B2B DELIVERY NOTE',
    XML_B2B_INVOICE: 'XML B2B METADATA',
    GENRAL_D96A: 'GENRAL D96A',
    CSV_B2B_PARTY: 'CSV Parties',
    DIGITALIZED_DELIVERYNOTE: 'Digitalized delivery note',
    CXML_INVOICE: 'CXML',
    FEV1: 'FEV1',
    FATTURAPA11: 'FATTURAPA11',
    FATTURAPA10: 'FATTURAPA10',
    FISI: 'FISI',
    UBL21: 'UBL21',
    ORDERS_D96A: 'ORDERS_D96A',
    FACTURAE30: 'FACTURAE30',
    FACTURAE31: 'FACTURAE31',
    XCBL40: 'XCBL40',
    '3C3': 'RosettaNet',
    XML_B2B_CMR: 'XML_B2B_CMR',
    DESADV_D96A: 'DESADV_D96A',
    XML_B2B_GENRAL: 'XML_B2B_GENRAL',
    CSV_B2B_USER: 'CSV_B2B_USER',
    XML_B2B_INVOICE_STATUS: 'XML_B2B_INVOICE_STATUS',
    XML_B2B_RECADV_STATUS: 'XML_B2B_RECADV_STATUS',
    XML_B2B_SLSRPT: 'XML_B2B_SLSRPT',
    CII: 'CII',
    XML_CANONICAL_B2B_INVOICE: 'CANONICAL B2B INVOICE',
  },

  // Protocolos de comunicación en auditoría
  auditory_communication_protocol: {
    SSH_FTP: 'SFTP',
    WS: 'Web service',
    AS2: 'AS2',
    EMAIL: 'Electronic mail',
    OTX: 'VAN',
    FILESYSTEM: 'Internal Delivery',
    VALIDATION_WS: 'Web service validation',
    REST: 'Rest service',
    WEB: 'Web portal'
  },

  // Modulos  auditoria
  auditory_module: {
    EXCHANGE_WS_SEND: 'Sending invoices',
    EXCHANGE_WS_STATUS: 'Status query',
    EXCHANGE_WS_CHANGE: 'Status change',
    EXCHANGE_WS_DOWNLOAD: 'Download',
    MASSIVE_PARTY: 'Mass parties load',
    PARTY: 'Party',
    CENTRE: 'Centres',
    PAYMENT: 'Payment data',
    USER: 'User',
    WS_VALIDATION: 'Validation web service',
    RECADV: 'Reception',
    EDITRACK_DOCUMENT_INTEGRATION: 'Editrack integration',
    EDITRACK_DOCUMENT_NOTIFICATION: 'Editrack notification',
    CMR: 'DeCA',
    ORDER: 'Order',
    DELIVERY_NOTE: 'Delivery note',
    SIGNATURE_PLATFORM: 'Signature platform'
  },

  // Categorias de documentos
  documentation_category: {
    EXAMPLE: 'Example',
    FUNCTIONAL_ANALYSIS: 'Functional analysis',
    INTEGRATION_DOCUMENT: 'Integration document',
    OFFER: 'Offer',
    USER_MANUAL: 'User manual',
    INFORMATIVE_DOCUMENT: 'Informative document',
    USER_INFORMATION: 'Information for the user'
  },

  // Idioma documentos
  documentation_language: {
    spanish: 'Spanish',
    english: 'English',
    italian: 'Italian',
    portuguese: 'Portuguese',
    french: 'French'
  },

  // Estados de cierres contables
  status_accounting_close: {
    Abierto: 'Opened',
    Cerrado: 'Closed'
  },

  // Clases de documento
  document_class: {
    COPY: 'Copy',
    ORIGINAL: 'Original',
    DUPLICATE: 'Duplicate',
    ADDITIONAL_TRANSMISSION: 'Additional',
    REPLACE: 'Replace',
    ADDITION: 'Addition'
  },

  // Clases de ciclos de documentos
  document_cycle_class: {
    DELIVERY_VALIDATION_PACKAGE_GTIN14: 'Validation of GTIN14 for delivery package lines',
    INVOICE_LINES_EDITABLE_FIELDS: 'Validates according to the subtype of the reception lines if the lines have to be created and if they are editable',
    INVOICE_FROM_ORDER_TYPE_SUBTYPE: 'Validates the type and/or subtype of the order to create an invoice with some non-editable fields',
    VALIDATION_ORDER_RESPONSE_REQUIRED: 'Validation of existence of previous order response'
  },

  // Tipos de factura
  invoice_type: {
    PROFORMA: 'Proforma',
    COMMERCIAL: 'Commercial',
    CREDIT_NOTE: 'Feed',
    DEBIT_NOTE: 'Debit note',
    CONSOLIDATED: 'Consolidated',
    SELF_BILLED: 'Self invoice'
  },

  // Tipo de documento de factura
  invoice_document_type: {
    FC: 'Full Invoice',
    FA: 'Abreviatted Invoice',
    AF: 'Self invoice',
    AN: 'Advance invoice',
    PF: 'Proforma invoice',
    NL: 'Not logistic'
  },

  delivery_note_type: {
    NO_LOGISTIC: 'Not logistic',
    LOGISTIC_TWO_LEVELS: '2-level logistics. General merchandise',
    LOGISTIC_THREE_LEVELS: '3-level logistics. Mass consumption'
  },

  // Tipos de servicios
  project_type: {
    seller: 'Emission',
    buyer: 'Reception',
    both: 'Both'
  },

  // Tipos de empresa
  party_type: {
    seller: 'Seller',
    buyer: 'Buyer',
    third: 'Third',
    both: 'Both'
  },
  // Método de entrega
  party_type_meth: {
    emission: 'Emission',
    reception: 'Reception',
    both: 'Both'
  },

  // Método de entrega project
  project_type_meth: {
    emission: 'Emission',
    reception: 'Reception'
  },

  chart_legend: {
    from_others: 'Invoices',
    from_orders: 'Invoices of orders',
    from_recadvs: 'Invoices of receptions',
    from_deliverynotes: 'Invoices of delivery notes',
    invoices_emitted: 'Invoices send',
    invoices_received: 'Invoices received',
    parties_registered: 'Parties registered',
    invoices_redigitized: 'Invoices redigitized',
    invoices_rejected: 'Invoices rejected'
  },
  // Tipos de tabla
  chart_type: {
    title: 'Table type',
    economic: 'Economic Volume',
    invoice: 'Number of invoices'
  },
  // Tipos de persona
  person_type: {
    physical: 'Physical',
    legal: 'Legal'
  },
  // Forma de pago
  paymentmethod: {
    CASH: 'Cash',
    CHECK: 'Check',
    CONFIRMING: 'Confirming',
    TRANSFER: 'Transfer'
  },

  // Formato de document
  document: {
    format: {
      FACTURAE32: 'FACTURAE32',
      FACTURAE321: 'FACTURAE321',
      FACTURAE322: 'FACTURAE322',
      FATTURAPA12: 'FATTURAPA12',
      FATTURAPA_SEMPLIFICATA: 'FATTURAPA_SEMPLIFICATA',
      FATTURAPA12_CADES: 'FATTURAPA12_CADES',
      FATTURAPA_SEMPLIFICATA_CADES: 'FATTURAPA_SEMPLIFICATA_CADES',
      INVOIC_D96A: 'INVOIC_D96A',
      INVOIC_D97A: 'INVOIC_D97A',
      INVOIC_D93A: 'INVOIC_D93A',
      XML_AECOC: 'XML_AECOC',
      PDF: 'PDF',
      PDF_A: 'PDF-A',
      ZIP: 'ZIP',
      CSV: 'CSV',
      UBL20: 'UBL20',
      PLAIN_ALTCLI: 'Plain register clients',
      XML_ENVEST: 'Sending XML status',
      PLAIN_ENVRES: 'Sending plain response',
      XML_SANTILLANA: 'XML SANTILLANA',
      XML_B2B_RECADV: 'XML B2B RECEPTION',
      INVOIC_D01B: 'INVOIC_D01B',
      PLAIN_ALTPRO: 'PLAIN_ALTPRO',
      XML_B2B_ORDER: 'XML B2B ORDER',
      XML_B2B_ORDERRSP: 'XML B2B ORDER RESPONSE',
      XML_B2B_DELIVERYNOTE: 'XML B2B DELIVERY NOTE',
      XML_B2B_INVOICE: 'XML B2B METADATA',
      GENRAL_D96A: 'GENRAL D96A',
      CSV_B2B_PARTY: 'CSV Parties',
      DIGITALIZED_DELIVERYNOTE: 'Digitalized delivery note',
      CXML_INVOICE: 'CXML',
      FEV1: 'FEV1',
      FATTURAPA11: 'FATTURAPA11',
      FATTURAPA10: 'FATTURAPA10',
      FISI: 'FISI',
      UBL21: 'UBL21',
      ORDERS_D96A: 'ORDERS_D96A',
      FACTURAE30: 'FACTURAE30',
      FACTURAE31: 'FACTURAE31',
      XCBL40: 'XCBL40',
      XML_B2B_SLSRPT: 'XML_B2B_SLSRPT',
      CII: 'CII',
      XML_CANONICAL_B2B_INVOICE: 'CANONICAL B2B INVOICE'
    }
  },
  categories: {
    OTHERS: 'Others',
    AUTOMATIC: 'Automatic',
    INCORRECT_ATTACHS: 'Attachments: Missing documentation or incorrect',
    INCORRECT_CENTER: 'Wrong center',
    INCORRECT_DETAIL: 'Incorrect concept or lack of detail',
    PARTY_CONTRACTING: 'Company contracting',
    INCORRECT_FISCAL: 'Incorrect fiscal data',
    INCORRECT_RELATION: 'Incorrect related documents',
    ACCOUNTING_NOT_EXIST: 'Invoice to which you correct not accounted or does not exist',
    DUPLICATED_INVOICE: 'Duplicated invoice',
    INCORRECT_DELIVERY_DATE: 'Incorrect service delivery date / period',
    INCORRECT_AMOUNTS: 'Incorrect amounts',
    REDIGITALIZATION: 'Redigitalization',
    INCORRECT_ENTRY: 'Incorrect entry requirements',
    PAPER: 'Transcribed on paper',
    WRONG_CAPTURED: 'Field miscaptured',
    NO_CAPTURED: 'Field no captured',
    WRONG_FIELD_CAPTURED: 'Field captured incorrect',
    NO_CATEGORY: 'No category',
    INCORRECT_OCR_DATA: 'OCR validation'
  },

  // Tipo de extension de factura
  extension_type: {
    FACEB2B: 'FACe B2B extension'
  },

  // Roles para centros
  centre_role_type: {
    payer: 'Payer/tramitadora unit',
    payee: 'Change receiver',
    invoicee: 'Invoicee',
    finalclient: 'Final buyer',
    ship_to: 'Delivery point',
    ship_from: 'Sending from',
    receiver: 'Receiver/managing body',
    buyer: 'Buyer/proposing body',
    collector: 'Collector',
    seller: 'Seller',
    payment_receiver: 'Payee',
    collection_receiver: 'Charging receiver',
    issuer: 'Issuer',
    fiscal: 'Fiscal/accounting office'
  },
  centre_role_type_order: {
    payer: 'Payer',
    payee: 'Change receiver',
    invoicee: 'Invoicee',
    finalclient: 'Final buyer',
    ship_to: 'Delivery point',
    ship_from: 'Sending from',
    receiver: 'Receiver',
    buyer: 'Buyer/proposing body',
    collector: 'Collector',
    seller: 'Seller',
    payment_receiver: 'Payee',
    collection_receiver: 'Charging receiver',
    issuer: 'Issuer',
    fiscal: 'Fiscal'
  },
  // Estadísticas
  statistic: {
    emitted_title: 'Volume of invoices issued',
    received_title: 'Volume of invoices received',
    other_title: 'Invoices generated from another document, order, receipt or delivery note',
    topseller_title: 'Top 20 suppliers by economic volume and number of invoices',
    parties_title: 'Volume of parties registered',
    rejected_invoice_title: 'Invoices: Types of rejections and reasons for redigitization',
    symbol: 'Invoices',
    party_type: 'Parties type',
    party_sponsor: 'Sponsor',
    invoice_status_title: 'Invoice status',
    total_party: 'Total accumulated parties'
  },
  // Documentacion
  documentation: {
    documentation_entity_table: {
      project: 'Service',
      name: 'Name',
      category: 'Category',
      language: 'Language'
    },
    buttons: {
      new_document: 'Upload',
      download_multiple: 'Download',
      new_document_tooltip: 'Upload document',
      download_multiple_tooltip: 'Download document/s'
    },
    dialog_add_documentation: {
      title: 'Add documentation',
      deletefile: 'Delete documentation file',
      updatetitle: 'Update documentation',
      project: {
        label: 'Service',
        placeholder: 'Select a service'
      },
      categoria: {
        label: 'Category',
        placeholder: 'Select a category'
      },
      nombre: {
        label: 'Documentation name'
      },
      url: {
        label: 'URL'
      },
      idioma: {
        label: 'Language',
        placeholder: 'Select a language'
      },
      urlorfile_required: 'URL or file is required'
    },
    error: {
      validation: {
        parametro_obligatorio_idioma: 'Language is mandatory',
        parametro_obligatorio_nombre: 'Name is mandatory',
        parametro_obligatorio_documentation: 'File or url is mandatory',
        duplicated: 'The documentation for the service already exists',
        size_exceeded: 'The file size exceeds the allowed limit of 10 MB',
      },
      error_generico: 'An error has ocurred uploading the file'
    }
  },

  documentation_detail: {
    buttons: {
      document: 'Document',
      eraseDocument: 'Delete'
    },
    documentation_detail_form: {
      project: 'Service',
      name: 'Name',
      category: 'Category',
      language: 'Language'
    },
    confirm: {
      title_delete_documentation: 'Are you sure to delete this document?',
      confirm_button_delete_documentation: 'Delete',
      title_upload_documentation: 'Are you sure to replace this document?',
      confirm_button_upload_documentation: 'Replace'
    },
    notify: {
      delete_document_ok: 'Document deleted correctly.',
      upload_document_ok: 'The documentation has been updated successfully.'
    },
    load: {
      download: 'Downloading document ...',
      delete_document: 'Deleting document ...',
      upload_document: 'Uploading document ...'
    }
  },
  NO_PENDING_TASK_STATUS: 'No configurated states were found for the selected service.',
  display_documents: {
    PDF_INDRA: 'Indra PDF',
    PDF_OHL_PERU: 'OHL Perú PDF',
    PDF_RENFE: 'Renfe PDF',
    PDF_INDRAFE: 'IndraFE PDF',
    PDF_SARQUAVITAE: 'Sarquavitae PDF',
    PDF_RENFE_RECADV: 'Renfe reception PDF',
    PDF_CATEGORY: 'Attached PDF categorized',
    PDF_TOYOTA: 'Toyota Canarias PDF',
    PDF_IDCSALUD: 'IDC Salud PDF',
    PDF_RECADV: 'PDF receptions',
    PDF_ENDESA: 'Endesa PDF',
    PDF_QUIRON_RECADV: 'Quiron PDF',
    PDF_ORDER: 'Order PDF',
    PDF_QUIRON_ORDER: 'Order PDF Quiron',
    PDF_DELIVERYNOTE: 'Delivery note PDF',
    PDF_GENRAL: 'Genral PDF',
    PDF_RENFE_SUPPLIER_DATA: 'Renfe supplier data PDF',
    PDF_RENFE_SOCIETIES_RECADV: 'Renfe societies recadv PDF',
    PDF_REDSYS: 'Redsys PDF',
    PDF_GNUBILA: 'Gnubila PDF',
    PDF_OHL: 'OHL PDF',
    PDF_ORDER_INDRA: 'Order PDF Indra',
    PDF_NISSAN: 'Nissan PDF',
    PDF_GONVARRI: 'Gonvarri PDF',
    PDF_CONSUM: 'Consum PDF',
    PDF_TELEFONICATECH: 'Telefonica tech PDF',
    PDF_DRAFT_INDRA: 'Temporary draft PDF',
    PDF_OTIS: 'Otis PDF',
    PDF_LYNTIA_GLOBAL: 'Lyntia Global Fontibre PDF',
    PDF_LYNTIA_CODINET: 'Lyntia Codinet PDF',
    PDF_LYNTIA_NETWORKS: 'Lyntia Networks PDF',
    PDF_LYNTIA_TOWERNET: 'Lyntia Towernet PDF',
    PDF_LYNTIA_ELANTA: 'Lyntia Elanta PDF',
    PDF_CANAL: 'Canal PDF',
    PDF_REDEIA: 'REDEIA PDF',
    PDF_RENFE_AMERICA: 'Renfe of America PDF',
    PDF_CORREOS_EXPRESS: 'Correos Express PDF',
    PDF_CMR_MAHOU: 'CMR Mahou PDF',
    PDF_CMR_TKAS: 'CMR TKAS PDF',
    PDF_CMR_ECMR: 'Transport document PDF',
    PDF_ACCIONA_ENERGIA: 'Acciona Energia PDF',
    PDF_ABOGACIA: 'Abogacia PDF',
    PDF_DOCUMENTO_CONTROL_MAHOU: 'Mahou control document PDF',

  },

  display_labels: {
    PDF_DELIVERYNOTE_LABEL: 'Delivery note generic labels PDF',
    PDF_ALCAMPO_DELIVERYNOTE_LABEL: 'Alcampo delivery note labels PDF',
    PDF_CARREFOUR_DELIVERYNOTE_LABEL: 'Carrefour delivery note labels PDF',
    PDF_BONPREU_DELIVERYNOTE_LABEL: 'Bon Preu delivery note labels PDF',
    PDF_ECI_DELIVERYNOTE_LABEL: 'ECI delivery note labels PDF'
  },

  email_type: {
    NEW_USER: 'New username and password',
    RESET_PASSWORD: 'Recover password',
    NEW_INVOICE: 'Informative email new invoice',
    EMAIL_PDF_ATTACH: 'Email PDF and attachments',
    EMAIL_PDF_ATTACH_MERGED: 'Email PDF merged and attachments',
    EMAIL_SHIPPER_CMR: 'Email for sending the control document PDF to the shipper',
    EMAIL_SIGNED: 'Guarded email',
    EMAIL_PDF_SIGNED: 'Email PDF and guarded',
    EMAIL_PDF_SIGNED_ATTACH: 'Email PDF, guarded and attachments',
    EMAIL_LINK: 'Email with link',
    INVOICE_ERROR_DELIVERY_METHOD: 'Delivery method not contracted',
    BILLING_REPORT_SERVICE: 'Service notification',
    ACK_EMAIL_ERROR: 'Error sending ACK email',
    ERROR_CMR: 'Notification email of errors in control document',
    ANNULLED_CMR: 'Notification email of annulled control document',
    INVALID_STATUS: 'Shipping Error',
    RESUMEN_BOLETAS_ERROR: 'CDR in summary of ballots',
    NEW_RECADV: 'New reception',
    NEW_ORDER: 'New order',
    ERROR_RRVV: 'Email with error notification for valued receptions',
    ERROR_ORDER: 'Email with error notification for orders',
    BILLINGINACTIVE_REPORT: 'Inactive invoices report',
    NEW_INVOICE_PENDING_ACCEPTANCE: 'New invoice pending acceptance',
    ANEXO_DOCUMENTATION: 'New payment proposal',
    INVALID_INVOICE_NOTE_URL: 'Notification of wrong access via url to invoice inquiry',
    REDIGITALIZATION_REQUEST: 'Redigitalization Request',
    BILLING_REPORT_SERVICES: 'Notification of multiple services',
    ERROR: 'Error notification email for support',
    VALIDATE_FORMAT_ERROR: 'Integration error with email type',
    EMAIL_PDF: 'Email PDF',
    INTEGRATION_REJECTED: 'Email for suppliers when the invoice with rejected status is integrated',
    INVOICE_TIME_EXCEED_NOTIFICATION_EMISSION: 'Email for providers when the SDI cannot deliver the invoice',
    INVOICE_TIME_EXCEED_NOTIFICATION_RECEPTION: 'Email for recipients when the SDI has not received notifications',
    CHANGE_STATUS_ERROR: 'Email to warn that it is not possible to change the status',
    NEW_DELIVERY_NOTE: 'New delivery note',
    CHANGE_STATUS_DELIVERYNOTE: 'Change of delivery note status',
    CHANGE_STATUS_RECADV: 'Change of recadv status',
    WS_DOCUMENT: 'Sending of party documents by web service',
    PARTY_DATA: 'Sending of party documents by email',
    EMAIL_TO_REPORT_ISSUED: 'Email to send the CSV report of issued invoices',
    INTEGRATION_OCR_ERROR: 'Notification email of integration errors in OCR invoices',
    EMAIL_NOTIFICATION_CUSTOMER: 'Email that is sent in the call to the client to send the invoice',
    EMAIL: 'Email',
    EMAIL_SIGNED_ATTACH: 'Email original guarded and attachments',
    EMAIL_INVOICE_NO_OCR: 'Centralized sending of electronic invoice notifications',
    EMAIL_THIRDPARTY: 'Email for sending invoices to third parties',
    ERROR_CENTRE: 'Notification email of errors in integration centres',
    VERIFY_2FA: 'Email to notify the code for two-factor authentication',
    APPROVAL_FLOW: 'Email to notify the approval flow',
    EMAIL_BILLING_REPORT: 'Email with the billing report from Indra and Telefónica',
    REDES_NOTIFICATION: 'Error notification on the red.es receptions website',
    SHIPMENT_NOTIFICATION: 'Notification to the buyer of the invoice being sent to the destination web service'
  },

  configuration_table: {
    GENERATE_ACK: 'Ack file generation',
    GENERATE_ENVEST: 'Generation of invoice statement submission file (ENVEST)',
    GENERATE_ENVRES: 'Generation of invoice batch response submission file',
    GENERATE_ACK_EMAIL: 'Sending Email with ack',
    GENERATE_ACK_ERROR_EMAIL: 'Sending the ack file without attachments',
    GENERATE_ACK_ERROR_EMAIL_WITHOUT_ATTACH: 'Sending the ack file without attachments',
    GENERATE_ACK_EMAIL_WITHOUT_ATTACH: 'Sending the ack file without attachments',
    GENERATE_PDF417: 'Code generation for signed invoices',
    GET_CHANNEL: 'Channel Obtaining',
    MANUAL_SEND: 'Manual delivery from pending tasks',
    GENERATE_PARTY_REPORT: 'Sending company files to Digitalization',
    SEND_ALL_INVOICES: 'Sending all invoices regardless of status',
    PENDING_INVOICES_XML_REPORT: 'XML Report Creation with invoices in non-final status',
    SEND_EMAIL_INVOICE_RECEIVED: 'Sending email indicating that a new invoice has been received',
    STATUS_RECADV_FILE: 'Generation of the xml file of reception states',
    NO_INTEGRATE_REJECTED_INVOICE_EMISION: 'Invoices issued do not integrate rejected',
    NO_INTEGRATE_DUPLICATED_INVOICE: 'Do not integrate duplicated invoices',
    SET_SPONSOR: 'When creating or modifying a service company,it will be assigned the sponsor role',
    NEW_PARTY_CREATE_CENTRE: 'Create the center of the company even if it does not want itself as a sponsor',
    GENERATE_ORDRSP: 'Generation of order response file',
    GENERATE_B2B_STATUS: 'Generation of the invoice status file',
    DELIVERY_INVOICE_TO_ISSUER: 'Delivery of the invoice to the issuer by configuration',
    STATUS_RETAINED_INVOICE: 'Do not send invoices until the issue date',
    CHANGE_SIGNED_TO_OPENED: 'Status change to open when consulting a signed invoice,PDF or guarded',
    GENERATE_REPORT_ISSUED: 'CSV report of invoices issued updated since the last execution',
    NO_DELIVER_INVOICE: 'Do not send invoices registered with delivery method',
    STATUS_SIGNED_FROM_INVOICE_RECEIVED: 'Invoices signed and received from Editrack (RVA) remain in the signed state',
    SET_EMISSION_NULL_IF_SPONSOR: 'Invoice integration with the emission flag set to null if both parties are sponsors',
    SET_EMISSION_NULL_IF_SPONSOR_AF: 'Autoinvoice integration with the emission flag set to null if both parties are sponsors',
    PENDING_TASK_REJECT_VALIDATION: 'Validation for the rejection of pending tasks',
    PENDING_TASK_SEND_VALIDATION: 'Validation for sending an invoice to sap from pending tasks',
    CREATE_USER_NO_SPONSOR_PARTY: 'Create a company user in the contracting of the non-sponsor company from invoice integration',
    CREATE_USER_THIRD_PARTY: 'Create a third-party user in the contracting of the third party from invoice integration',
    SEND_TO_THIRDPARTY: 'Job sending invoices by email to third parties',
    INVOICE_RECADV_MISSING_ORDER_VALIDATION: 'Validation of the order data for the creation of an invoice from a reception',
    HIDDEN_INVOICE_EXTENSION: 'Delete extension in drafts view',
    NOT_SEND_INTEGRATION_NOTIFICATION: 'The integration notification and document status (RECADV and/or ORDER) are not sent.',
    ADD_COUNTRY_PARTY_TO_MANUAL_INVOICE: 'Add the country to the NIFs of the parties from the manual creation',
    SEND_EMAIL_WITH_COPY_TO_ORIGIN: 'Send a copy of the email for the configured email type to the configured origin',
    UPDATE_FLAG_OTP_AUTHENTICATION: 'Activate OTP authentication',
    APPROVAL_FLOW_BY_LEVELS_AND_USERS: 'Approval flow by levels and users',
    SEE_ONLY_GENERAL_SIGN_DOCUMENT: 'View only general delegated signature documents',
    GET_PERMANENT_ESTABLISHMENT: 'See those centers that are permanent establishments',
    GET_TAXES_PROJECT: 'View the taxes associated with the service',
    GET_TAXES_BUSINESS_RULE_REE: 'View taxes based on business rules for REE taxes',
    GENERATE_TEXT_COLLECTION_ADDITIONAL_INFO: 'Fixed text in additional payment method information in drafts',
    INVOICE_INTEGRATION_NO_CERTIFICATE_VALIDATION: 'Contract invoices for integration enter without going through certification-order validation',
    GENERATE_TEXT_WITHHOLDING_REASON: 'Fixed text for draft withholding reasons',
    DRAFT_CORRECTIVE_INVOICE_ONLY: 'From drafts only corrective invoice can be created',
    DRAFT_INVOICE_DOCUMENT_FILTER: 'Document types limited at the general level and at the line level in a service',
    INVOICE_REJECT_RELEASE_RECADV: 'Release certification when rejecting an invoice',
    CREATE_DOCUMENT_RELATION: 'Create a relation between documents',
    INVOICE_STATUS_RECADV_INVOICED: 'Invoice from receipt, invoiced status depending on price per quantity',
    CALCULATE_NEGATIVE_RETENTION: 'Retentions on negative invoices will be added to the total executable amount',
    RECADV_SUBTYPE_DEFAULT_GOODS: 'In receipts of default goods in the case of not being informed of anything in the type received',
    HIDDEN_COMMUNICATION_METHOD: 'Remove display of shipping methods in drafts',
    DRAFT_DOCUMENTS_HEADER: 'Get the documents at header level from the lines',
    INVOICE_INSTALLMENTS_DATERANGE: 'Due date (in months) for service drafts',
    GENERATE_INVOICE_INSTALLMENTS: 'Load expiration data into draft totals by default',
    ATTACHMENTS_REPOSITORY: 'Attach the repository documents whose name meets a certain pattern',
    ATTACHMENTS_REPOSITORY_SUBDIRECTORY_DATE: 'Attach repository documents whose name meets a certain pattern contained in date subdirectory',
    CHANGE_OPERATION_PERIOD_DATES: 'Allows you to modify the operation dates and tax period in drafts',
    NOTIFY_ERROR_TO_PROJECT_PARTY_EMAIL_CONTACT: "In addition to notifying the issuer, if it appears on the invoice, to the email configured in the party's administration in the service",
    DRAFT_NO_CHANGE_CURRENCY: 'Can not change the currency in the draft',
    ALLOWED_EMAIL_DOMAINS: 'Allowed email domains',
    WITHHOLDINGAMOUNT_ABSOLUTE_TO_ACCOUNTING: 'Absolute retention amount in accounting',
    REQUIRED_FIELDS_FOR_FIRST_LEVEL_APPROVAL: 'Additional fields for the first level of approval',
    VOCENTO_VALIDATION_WS: 'Custom Vocento: Validation for additional data from Vocento',
    VOCENTO_CENTRE_VALIDATION_WS: 'Centre validation for Vocento invoices by web service',
    SHIPMENT_NOTIFICATION: 'Notification to the buyer of the invoice being sent to the destination web service',
    UPDATE_ALL_STATUS_INVOICENOTE: 'Update of negative states by NPV',
    NO_INTEGRATE_DOCUMENT_ERROR: 'No integrate the document with error status',
    CONFIGURATION_CONTROLDOCUMENT_SENDLINK: 'For automatic sending of control document',
    CONFIGURATION_BILLING_SPONSOR_REPORT: 'Add sponsor companies to the billing report',
    METADATA_FROM_PATH: 'Obtain metadata file from path. Not generate it again',
    REPLACE_NIF: 'Replace source NIF with the configured NIF',
    EXTERNAL_PDF: "External PDF. Not generated by Ecosystems B2B",
    EMAIL_SHIPPER_CMR: 'Email for sending the control document PDF to the shipper',
  },
  recaptcha: {
    error: 'You must check the CAPTCHA box',
    text: 'You have made several unsuccessful attempts to login. Please check the CAPTCHA to continue'
  },
  mailServer: {
    new: 'New mail server',
    notify: {
      add_mailServer: 'Mail server created correctly',
      delete_mailServer: 'Mail server deleted correctly.',
      save_changes: 'Mail server updated corectly'
    },
    confirm: {
      delete_mailServer: 'Are you sure to delete the mail server?'
    },
    load: {
      add_mailServer: 'Adding mail server ...',
      delete_mailServer: 'Removing mail server ...'
    },
    mailServer_table: {
      host: 'Host',
      user: 'User',
      password: 'Password',
      mailfrom: 'Mail address from',
      port: 'Port',
      auth: 'Auth',
      protocol: 'Protocol',
      idClient: 'Client ID',
      idTenant: 'Organization ID',
      clientSecret: 'Client Secret',
      validityDateTo: 'Access validity date',
      saveToSentItems: 'Save Sent Emails'
    },
    test_error: 'Connection with mail server failed',
    test_ok: 'Connection with mail server ok',
    auth_error: 'Authentication failed',
    delete_mailServer: 'Delete',
    delete_mailServer_tooltip: 'Delete mail server',
    test_tooltip: 'Test connection',
    test: 'Test',
    duplicate_error: 'There is already a mail server with this data',
    password_too_long: 'The password is too long. Please use a shorter password',
    data_integrity_error: 'Data integrity error while saving the mail server'
  },
  unit_of_measure: {
    title: 'Unit of measure',
    UND: 'Units',
    HUR: 'Hours',
    KGM: 'Kilograms',
    LTR: 'Liters',
    OTR: 'Other',
    BOX: 'Boxes',
    BDJ: 'Trays',
    BID: 'Drums',
    BOL: 'Bags',
    BOM: 'Carboys',
    BTL: 'Bottles',
    BOT: 'Pot',
    CLT: 'Centiliters',
    CMT: 'Centimeters',
    GAR: 'Carafes',
    GRM: 'Grams',
    KMT: 'Kilometres',
    MTR: 'Meters',
    MMT: 'Millimeters',
    PKG: 'Packages',
    ROL: 'Rolls',
    SOB: 'Envelopes',
    MT3: 'Cubic meter',
    WAT: 'Watt',
    HOJ: 'Sheets',
    JUG: 'Games',
    CEN: 'Hundreds',
    PAR: 'Torque',
    CAR: 'Reel',
    NTB: 'Notebook',
    MT2: 'Square meter',
    PCE: 'Piece',
    XCA: 'Box of 100',
    TNE: 'Tons'
  }

}
